
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree4fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree4fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("bkRhq", function(module, exports) {
"use strict";
var $840ae441457fd529$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $840ae441457fd529$var$PostgrestQueryBuilder_1 = $840ae441457fd529$var$__importDefault((parcelRequire("j9Ami")));

const $840ae441457fd529$var$PostgrestFilterBuilder_1 = $840ae441457fd529$var$__importDefault((parcelRequire("1Wp8i")));

var $aTgHg = parcelRequire("aTgHg");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $840ae441457fd529$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $aTgHg.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $840ae441457fd529$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $840ae441457fd529$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $840ae441457fd529$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $840ae441457fd529$var$PostgrestClient;

});
parcelRegister("j9Ami", function(module, exports) {
"use strict";
var $df1b0faa8e815118$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $df1b0faa8e815118$var$PostgrestFilterBuilder_1 = $df1b0faa8e815118$var$__importDefault((parcelRequire("1Wp8i")));
class $df1b0faa8e815118$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $df1b0faa8e815118$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $df1b0faa8e815118$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $df1b0faa8e815118$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $df1b0faa8e815118$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $df1b0faa8e815118$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $df1b0faa8e815118$var$PostgrestQueryBuilder;

});
parcelRegister("1Wp8i", function(module, exports) {
"use strict";
var $169eb416d1967e2c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $169eb416d1967e2c$var$PostgrestTransformBuilder_1 = $169eb416d1967e2c$var$__importDefault((parcelRequire("LNOGP")));
class $169eb416d1967e2c$var$PostgrestFilterBuilder extends $169eb416d1967e2c$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $169eb416d1967e2c$var$PostgrestFilterBuilder;

});
parcelRegister("LNOGP", function(module, exports) {
"use strict";
var $08fb086f7ad2a826$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $08fb086f7ad2a826$var$PostgrestBuilder_1 = $08fb086f7ad2a826$var$__importDefault((parcelRequire("aB6y5")));
class $08fb086f7ad2a826$var$PostgrestTransformBuilder extends $08fb086f7ad2a826$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        return this;
    }
}
module.exports.default = $08fb086f7ad2a826$var$PostgrestTransformBuilder;

});
parcelRegister("aB6y5", function(module, exports) {
"use strict";
var $7b72708caffeaf5e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $7b72708caffeaf5e$var$node_fetch_1 = $7b72708caffeaf5e$var$__importDefault((parcelRequire("jxJFs")));

const $7b72708caffeaf5e$var$PostgrestError_1 = $7b72708caffeaf5e$var$__importDefault((parcelRequire("cuctA")));
class $7b72708caffeaf5e$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $7b72708caffeaf5e$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $7b72708caffeaf5e$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
     * Override the type of the returned `data` field in the response.
     *
     * @typeParam NewResult - The new type to cast the response data to
     * @typeParam Options - Optional type configuration (defaults to { merge: true })
     * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
     * @example
     * ```typescript
     * // Merge with existing types (default behavior)
     * const query = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ custom_field: string }>()
     *
     * // Replace existing types completely
     * const replaceQuery = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
     * ```
     * @returns A PostgrestBuilder instance with the new type
     */ overrideTypes() {
        return this;
    }
}
module.exports.default = $7b72708caffeaf5e$var$PostgrestBuilder;

});
parcelRegister("jxJFs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $e3a48609baad29a4$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $e3a48609baad29a4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $e3a48609baad29a4$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $e3a48609baad29a4$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $e3a48609baad29a4$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $e3a48609baad29a4$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $e3a48609baad29a4$var$globalObject = $e3a48609baad29a4$var$getGlobal();
const $e3a48609baad29a4$export$e7aa7bc5c1b3cfb3 = $e3a48609baad29a4$var$globalObject.fetch;
var $e3a48609baad29a4$export$2e2bcd8739ae039 = $e3a48609baad29a4$var$globalObject.fetch.bind($e3a48609baad29a4$var$globalObject);
const $e3a48609baad29a4$export$79b704688b15c0f4 = $e3a48609baad29a4$var$globalObject.Headers;
const $e3a48609baad29a4$export$7fa6c5b6f8193917 = $e3a48609baad29a4$var$globalObject.Request;
const $e3a48609baad29a4$export$9f633d56d7ec90d3 = $e3a48609baad29a4$var$globalObject.Response;

});

parcelRegister("cuctA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $9171f6df47ae5769$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $9171f6df47ae5769$var$PostgrestError;

});





parcelRegister("aTgHg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $98myl = parcelRequire("98myl");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$98myl.version}`
};

});
parcelRegister("98myl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("2j1O5", function(module, exports) {
module.exports = $parcel$import("50JJJ").then(()=>parcelRequire('n7Qh0'));

});

parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("9gBlp", function(module, exports) {

var $1DySm = parcelRequire("1DySm");

var $1Wbuo = parcelRequire("1Wbuo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1DySm.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Wbuo;
module.exports = isBuffer;

});
parcelRegister("1DySm", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $8X2yT || $13147c93e8511c05$var$freeSelf || Function('return this')();
module.exports = $13147c93e8511c05$var$root;

});
parcelRegister("8X2yT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $6845d21fa7e75b3b$var$freeGlobal;

});


parcelRegister("1Wbuo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $16941ebaddae1967$var$stubFalse() {
    return false;
}
module.exports = $16941ebaddae1967$var$stubFalse;

});


parcelRegister("iU8uW", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8X2yT.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("i6bbH", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d2d1772d9e552fde$export$a7c73072b1a182ae; }, function (v) { return $d2d1772d9e552fde$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d2d1772d9e552fde$export$9f27bc3417b4524d; }, function (v) { return $d2d1772d9e552fde$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d2d1772d9e552fde$export$db77ccec0bb4ccac; }, function (v) { return $d2d1772d9e552fde$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d2d1772d9e552fde$export$8392c0c9d3dcbd35; }, function (v) { return $d2d1772d9e552fde$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d2d1772d9e552fde$export$ffb0004e005737fa; }, function (v) { return $d2d1772d9e552fde$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d2d1772d9e552fde$export$b624eff549462981; }, function (v) { return $d2d1772d9e552fde$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d2d1772d9e552fde$export$7897aa7841a5380c; }, function (v) { return $d2d1772d9e552fde$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d2d1772d9e552fde$export$602eac185826482c; }, function (v) { return $d2d1772d9e552fde$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d2d1772d9e552fde$export$e2c29f18771995cb; }, function (v) { return $d2d1772d9e552fde$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d2d1772d9e552fde$export$5f8d39834fd61797; }, function (v) { return $d2d1772d9e552fde$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d2d1772d9e552fde$export$74bf444e3cd11ea5; }, function (v) { return $d2d1772d9e552fde$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d2d1772d9e552fde$export$998bcd577473dd93; }, function (v) { return $d2d1772d9e552fde$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d2d1772d9e552fde$export$92387174baf9b227; }, function (v) { return $d2d1772d9e552fde$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d2d1772d9e552fde$export$ec112efeb987d9c6; }, function (v) { return $d2d1772d9e552fde$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d2d1772d9e552fde$export$b706b080d889d2c9; }, function (v) { return $d2d1772d9e552fde$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d2d1772d9e552fde$export$5be5a87408f70ddc; }, function (v) { return $d2d1772d9e552fde$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d2d1772d9e552fde$export$45a5e7f76e0caa8d; }, function (v) { return $d2d1772d9e552fde$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d2d1772d9e552fde$export$455c2e768291efa6; }, function (v) { return $d2d1772d9e552fde$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d2d1772d9e552fde$export$9522e17588c12572; }, function (v) { return $d2d1772d9e552fde$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d2d1772d9e552fde$export$2110ac352bb060b9; }, function (v) { return $d2d1772d9e552fde$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d2d1772d9e552fde$export$56885ab8b9c456ab; }, function (v) { return $d2d1772d9e552fde$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d2d1772d9e552fde$export$d927fcb6adf8f9de; }, function (v) { return $d2d1772d9e552fde$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d2d1772d9e552fde$export$b82d16f27459e05a; }, function (v) { return $d2d1772d9e552fde$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d2d1772d9e552fde$export$522c17b4f5e123e8; }, function (v) { return $d2d1772d9e552fde$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d2d1772d9e552fde$export$1aabd8a0274ecfd6; }, function (v) { return $d2d1772d9e552fde$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d2d1772d9e552fde$export$3d6c20d97e46b957; }, function (v) { return $d2d1772d9e552fde$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d2d1772d9e552fde$export$9b621391a187a31a; }, function (v) { return $d2d1772d9e552fde$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d2d1772d9e552fde$export$f5bbd400c2f4426f; }, function (v) { return $d2d1772d9e552fde$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2d1772d9e552fde$export$a7c73072b1a182ae;
var $d2d1772d9e552fde$export$9f27bc3417b4524d;
var $d2d1772d9e552fde$export$db77ccec0bb4ccac;
var $d2d1772d9e552fde$export$8392c0c9d3dcbd35;
var $d2d1772d9e552fde$export$ffb0004e005737fa;
var $d2d1772d9e552fde$export$b624eff549462981;
var $d2d1772d9e552fde$export$7897aa7841a5380c;
var $d2d1772d9e552fde$export$602eac185826482c;
var $d2d1772d9e552fde$export$e2c29f18771995cb;
var $d2d1772d9e552fde$export$5f8d39834fd61797;
var $d2d1772d9e552fde$export$74bf444e3cd11ea5;
var $d2d1772d9e552fde$export$998bcd577473dd93;
var $d2d1772d9e552fde$export$92387174baf9b227;
var $d2d1772d9e552fde$export$ec112efeb987d9c6;
var $d2d1772d9e552fde$export$b706b080d889d2c9;
var $d2d1772d9e552fde$export$5be5a87408f70ddc;
var $d2d1772d9e552fde$export$45a5e7f76e0caa8d;
var $d2d1772d9e552fde$export$455c2e768291efa6;
var $d2d1772d9e552fde$export$9522e17588c12572;
var $d2d1772d9e552fde$export$2110ac352bb060b9;
var $d2d1772d9e552fde$export$56885ab8b9c456ab;
var $d2d1772d9e552fde$export$d927fcb6adf8f9de;
var $d2d1772d9e552fde$export$b82d16f27459e05a;
var $d2d1772d9e552fde$export$522c17b4f5e123e8;
var $d2d1772d9e552fde$export$1aabd8a0274ecfd6;
var $d2d1772d9e552fde$export$3d6c20d97e46b957;
var $d2d1772d9e552fde$export$9b621391a187a31a;
var $d2d1772d9e552fde$export$f5bbd400c2f4426f;
'use strict';
var $d2d1772d9e552fde$var$b = Symbol.for("react.element"), $d2d1772d9e552fde$var$c = Symbol.for("react.portal"), $d2d1772d9e552fde$var$d = Symbol.for("react.fragment"), $d2d1772d9e552fde$var$e = Symbol.for("react.strict_mode"), $d2d1772d9e552fde$var$f = Symbol.for("react.profiler"), $d2d1772d9e552fde$var$g = Symbol.for("react.provider"), $d2d1772d9e552fde$var$h = Symbol.for("react.context"), $d2d1772d9e552fde$var$k = Symbol.for("react.server_context"), $d2d1772d9e552fde$var$l = Symbol.for("react.forward_ref"), $d2d1772d9e552fde$var$m = Symbol.for("react.suspense"), $d2d1772d9e552fde$var$n = Symbol.for("react.suspense_list"), $d2d1772d9e552fde$var$p = Symbol.for("react.memo"), $d2d1772d9e552fde$var$q = Symbol.for("react.lazy"), $d2d1772d9e552fde$var$t = Symbol.for("react.offscreen"), $d2d1772d9e552fde$var$u;
$d2d1772d9e552fde$var$u = Symbol.for("react.module.reference");
function $d2d1772d9e552fde$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d2d1772d9e552fde$var$b:
                switch(a = a.type, a){
                    case $d2d1772d9e552fde$var$d:
                    case $d2d1772d9e552fde$var$f:
                    case $d2d1772d9e552fde$var$e:
                    case $d2d1772d9e552fde$var$m:
                    case $d2d1772d9e552fde$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d2d1772d9e552fde$var$k:
                            case $d2d1772d9e552fde$var$h:
                            case $d2d1772d9e552fde$var$l:
                            case $d2d1772d9e552fde$var$q:
                            case $d2d1772d9e552fde$var$p:
                            case $d2d1772d9e552fde$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d2d1772d9e552fde$var$c:
                return r;
        }
    }
}
$d2d1772d9e552fde$export$a7c73072b1a182ae = $d2d1772d9e552fde$var$h;
$d2d1772d9e552fde$export$9f27bc3417b4524d = $d2d1772d9e552fde$var$g;
$d2d1772d9e552fde$export$db77ccec0bb4ccac = $d2d1772d9e552fde$var$b;
$d2d1772d9e552fde$export$8392c0c9d3dcbd35 = $d2d1772d9e552fde$var$l;
$d2d1772d9e552fde$export$ffb0004e005737fa = $d2d1772d9e552fde$var$d;
$d2d1772d9e552fde$export$b624eff549462981 = $d2d1772d9e552fde$var$q;
$d2d1772d9e552fde$export$7897aa7841a5380c = $d2d1772d9e552fde$var$p;
$d2d1772d9e552fde$export$602eac185826482c = $d2d1772d9e552fde$var$c;
$d2d1772d9e552fde$export$e2c29f18771995cb = $d2d1772d9e552fde$var$f;
$d2d1772d9e552fde$export$5f8d39834fd61797 = $d2d1772d9e552fde$var$e;
$d2d1772d9e552fde$export$74bf444e3cd11ea5 = $d2d1772d9e552fde$var$m;
$d2d1772d9e552fde$export$998bcd577473dd93 = $d2d1772d9e552fde$var$n;
$d2d1772d9e552fde$export$92387174baf9b227 = function() {
    return !1;
};
$d2d1772d9e552fde$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d2d1772d9e552fde$export$b706b080d889d2c9 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$h;
};
$d2d1772d9e552fde$export$5be5a87408f70ddc = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$g;
};
$d2d1772d9e552fde$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d2d1772d9e552fde$var$b;
};
$d2d1772d9e552fde$export$455c2e768291efa6 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$l;
};
$d2d1772d9e552fde$export$9522e17588c12572 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$d;
};
$d2d1772d9e552fde$export$2110ac352bb060b9 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$q;
};
$d2d1772d9e552fde$export$56885ab8b9c456ab = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$p;
};
$d2d1772d9e552fde$export$d927fcb6adf8f9de = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$c;
};
$d2d1772d9e552fde$export$b82d16f27459e05a = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$f;
};
$d2d1772d9e552fde$export$522c17b4f5e123e8 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$e;
};
$d2d1772d9e552fde$export$1aabd8a0274ecfd6 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$m;
};
$d2d1772d9e552fde$export$3d6c20d97e46b957 = function(a) {
    return $d2d1772d9e552fde$var$v(a) === $d2d1772d9e552fde$var$n;
};
$d2d1772d9e552fde$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d2d1772d9e552fde$var$d || a === $d2d1772d9e552fde$var$f || a === $d2d1772d9e552fde$var$e || a === $d2d1772d9e552fde$var$m || a === $d2d1772d9e552fde$var$n || a === $d2d1772d9e552fde$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d2d1772d9e552fde$var$q || a.$$typeof === $d2d1772d9e552fde$var$p || a.$$typeof === $d2d1772d9e552fde$var$g || a.$$typeof === $d2d1772d9e552fde$var$h || a.$$typeof === $d2d1772d9e552fde$var$l || a.$$typeof === $d2d1772d9e552fde$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d2d1772d9e552fde$export$f5bbd400c2f4426f = $d2d1772d9e552fde$var$v;

});

parcelRegister("3kQXm", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("8R7yp"));

});
parcelRegister("8R7yp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $6729220e2c6ee091$var$_tickFormat.default;
    }
});

var $6729220e2c6ee091$var$_band = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("5r6E7")));

var $6729220e2c6ee091$var$_identity = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("jIfCN")));

var $6729220e2c6ee091$var$_linear = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("4FaxR")));

var $6729220e2c6ee091$var$_log = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("flmZz")));

var $6729220e2c6ee091$var$_symlog = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("ag3bX")));

var $6729220e2c6ee091$var$_ordinal = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("h52bg")));

var $6729220e2c6ee091$var$_pow = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("hGubV")));

var $6729220e2c6ee091$var$_radial = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("lcGR9")));

var $6729220e2c6ee091$var$_quantile = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("cOhVl")));

var $6729220e2c6ee091$var$_quantize = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("gAc3H")));

var $6729220e2c6ee091$var$_threshold = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("g6pLk")));

var $6729220e2c6ee091$var$_time = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("liuou")));

var $6729220e2c6ee091$var$_utcTime = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("7owcD")));

var $6729220e2c6ee091$var$_sequential = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("eI3Nr")));

var $6729220e2c6ee091$var$_sequentialQuantile = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("het6D")));

var $6729220e2c6ee091$var$_diverging = $6729220e2c6ee091$var$_interopRequireWildcard((parcelRequire("3tpu0")));

var $6729220e2c6ee091$var$_tickFormat = $6729220e2c6ee091$var$_interopRequireDefault((parcelRequire("k0wsE")));
function $6729220e2c6ee091$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6729220e2c6ee091$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6729220e2c6ee091$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6729220e2c6ee091$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6729220e2c6ee091$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("5r6E7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f54a12a49a408b8$var$band;
module.exports.point = $3f54a12a49a408b8$var$point;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");

var $3f54a12a49a408b8$var$_ordinal = $3f54a12a49a408b8$var$_interopRequireDefault((parcelRequire("h52bg")));
function $3f54a12a49a408b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f54a12a49a408b8$var$band() {
    var scale = (0, $3f54a12a49a408b8$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $4GZnA.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $3f54a12a49a408b8$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $2ynOw.initRange.apply(rescale(), arguments);
}
function $3f54a12a49a408b8$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $3f54a12a49a408b8$var$pointish(copy());
    };
    return scale;
}
function $3f54a12a49a408b8$var$point() {
    return $3f54a12a49a408b8$var$pointish($3f54a12a49a408b8$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("4GZnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $a99Jc.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $hhirN.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $hhirN.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $a99Jc.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $a99Jc.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $36aab2530ad1af8c$var$_zip.default;
    }
});

var $36aab2530ad1af8c$var$_bisect = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("4M7Uz")));

var $36aab2530ad1af8c$var$_ascending = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $36aab2530ad1af8c$var$_bisector = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dkE5I")));

var $36aab2530ad1af8c$var$_count = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $36aab2530ad1af8c$var$_cross = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("4xqnz")));

var $36aab2530ad1af8c$var$_cumsum = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ctqkx")));

var $36aab2530ad1af8c$var$_descending = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dm1k6")));

var $36aab2530ad1af8c$var$_deviation = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ceJJg")));

var $36aab2530ad1af8c$var$_extent = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3npVv")));

var $a99Jc = parcelRequire("a99Jc");

var $36aab2530ad1af8c$var$_group = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("bSznb")));

var $36aab2530ad1af8c$var$_groupSort = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("kR7qy")));

var $36aab2530ad1af8c$var$_bin = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("aqqXO")));

var $36aab2530ad1af8c$var$_freedmanDiaconis = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8P0oX")));

var $36aab2530ad1af8c$var$_scott = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("vtl6K")));

var $36aab2530ad1af8c$var$_sturges = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hksbO")));

var $36aab2530ad1af8c$var$_max = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("vbPSg")));

var $36aab2530ad1af8c$var$_maxIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("7xRpL")));

var $36aab2530ad1af8c$var$_mean = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("Gwq9r")));

var $36aab2530ad1af8c$var$_median = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("4bAsu")));

var $36aab2530ad1af8c$var$_merge = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("2ZjwD")));

var $36aab2530ad1af8c$var$_min = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("1hOTq")));

var $36aab2530ad1af8c$var$_minIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("eFUjb")));

var $36aab2530ad1af8c$var$_mode = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("bB075")));

var $36aab2530ad1af8c$var$_nice = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("1h8vr")));

var $36aab2530ad1af8c$var$_pairs = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3nwtE")));

var $36aab2530ad1af8c$var$_permute = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("gTjer")));

var $36aab2530ad1af8c$var$_quantile = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("bhvsA")));

var $36aab2530ad1af8c$var$_quickselect = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("dxKAb")));

var $36aab2530ad1af8c$var$_range = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("d5xzE")));

var $36aab2530ad1af8c$var$_rank = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("ehEFf")));

var $36aab2530ad1af8c$var$_least = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("j03gz")));

var $36aab2530ad1af8c$var$_leastIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("bEZCr")));

var $36aab2530ad1af8c$var$_greatest = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("3JjDZ")));

var $36aab2530ad1af8c$var$_greatestIndex = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8H1FG")));

var $36aab2530ad1af8c$var$_scan = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hYxed")));

var $36aab2530ad1af8c$var$_shuffle = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("82rhF")));

var $36aab2530ad1af8c$var$_sum = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("xtV25")));

var $36aab2530ad1af8c$var$_ticks = $36aab2530ad1af8c$var$_interopRequireWildcard((parcelRequire("kOhXV")));

var $36aab2530ad1af8c$var$_transpose = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("kDL1M")));

var $36aab2530ad1af8c$var$_variance = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("fW2SY")));

var $36aab2530ad1af8c$var$_zip = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("k40UO")));

var $36aab2530ad1af8c$var$_every = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("Y6qD3")));

var $36aab2530ad1af8c$var$_some = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("gd6yj")));

var $36aab2530ad1af8c$var$_filter = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("iRlqI")));

var $36aab2530ad1af8c$var$_map = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("9E9DK")));

var $36aab2530ad1af8c$var$_reduce = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("eZC5Z")));

var $36aab2530ad1af8c$var$_reverse = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hG6O3")));

var $36aab2530ad1af8c$var$_sort = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("hgC45")));

var $36aab2530ad1af8c$var$_difference = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("b6Lvf")));

var $36aab2530ad1af8c$var$_disjoint = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("en2ry")));

var $36aab2530ad1af8c$var$_intersection = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("i2gjq")));

var $36aab2530ad1af8c$var$_subset = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("f4rHD")));

var $36aab2530ad1af8c$var$_superset = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8VkGe")));

var $36aab2530ad1af8c$var$_union = $36aab2530ad1af8c$var$_interopRequireDefault((parcelRequire("8bE4f")));

var $hhirN = parcelRequire("hhirN");
function $36aab2530ad1af8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36aab2530ad1af8c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36aab2530ad1af8c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36aab2530ad1af8c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36aab2530ad1af8c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("4M7Uz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $37a1c82852dde731$var$_ascending = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $37a1c82852dde731$var$_bisector = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("dkE5I")));

var $37a1c82852dde731$var$_number = $37a1c82852dde731$var$_interopRequireDefault((parcelRequire("7i5Zp")));
function $37a1c82852dde731$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $37a1c82852dde731$var$ascendingBisect = (0, $37a1c82852dde731$var$_bisector.default)($37a1c82852dde731$var$_ascending.default);
const $37a1c82852dde731$var$bisectRight = $37a1c82852dde731$var$ascendingBisect.right;
module.exports.bisectRight = $37a1c82852dde731$var$bisectRight;
const $37a1c82852dde731$var$bisectLeft = $37a1c82852dde731$var$ascendingBisect.left;
module.exports.bisectLeft = $37a1c82852dde731$var$bisectLeft;
const $37a1c82852dde731$var$bisectCenter = (0, $37a1c82852dde731$var$_bisector.default)($37a1c82852dde731$var$_number.default).center;
module.exports.bisectCenter = $37a1c82852dde731$var$bisectCenter;
var $37a1c82852dde731$var$_default = $37a1c82852dde731$var$bisectRight;
module.exports.default = $37a1c82852dde731$var$_default;

});
parcelRegister("2lEQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b5d3b6847600917$var$ascending;
function $1b5d3b6847600917$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("dkE5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b4c3de18292214c$var$bisector;

var $9b4c3de18292214c$var$_ascending = $9b4c3de18292214c$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $9b4c3de18292214c$var$_descending = $9b4c3de18292214c$var$_interopRequireDefault((parcelRequire("dm1k6")));
function $9b4c3de18292214c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b4c3de18292214c$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $9b4c3de18292214c$var$_ascending.default;
        compare2 = (d, x)=>(0, $9b4c3de18292214c$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $9b4c3de18292214c$var$_ascending.default || f === $9b4c3de18292214c$var$_descending.default ? f : $9b4c3de18292214c$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $9b4c3de18292214c$var$zero() {
    return 0;
}

});
parcelRegister("dm1k6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b8e5b36101417ff$var$descending;
function $9b8e5b36101417ff$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("7i5Zp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54eedc354d42d77a$var$number;
module.exports.numbers = $54eedc354d42d77a$var$numbers;
function $54eedc354d42d77a$var$number(x) {
    return x === null ? NaN : +x;
}
function* $54eedc354d42d77a$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("hRGKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0188c04fdffb31d$var$count;
function $d0188c04fdffb31d$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("4xqnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34deb4dd747ec6fa$var$cross;
function $34deb4dd747ec6fa$var$length(array) {
    return array.length | 0;
}
function $34deb4dd747ec6fa$var$empty(length) {
    return !(length > 0);
}
function $34deb4dd747ec6fa$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $34deb4dd747ec6fa$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $34deb4dd747ec6fa$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $34deb4dd747ec6fa$var$reducer(values.pop());
    values = values.map($34deb4dd747ec6fa$var$arrayify);
    const lengths = values.map($34deb4dd747ec6fa$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($34deb4dd747ec6fa$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("ctqkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $914c9e21f2d92e7b$var$cumsum;
function $914c9e21f2d92e7b$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("ceJJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e8a43aeed62cf45$var$deviation;

var $8e8a43aeed62cf45$var$_variance = $8e8a43aeed62cf45$var$_interopRequireDefault((parcelRequire("fW2SY")));
function $8e8a43aeed62cf45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8e8a43aeed62cf45$var$deviation(values, valueof) {
    const v = (0, $8e8a43aeed62cf45$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("fW2SY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b99e82d2da32169b$var$variance;
function $b99e82d2da32169b$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3npVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2757a189477a9784$var$extent;
function $2757a189477a9784$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("a99Jc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $76324a701e783bf0$var$fcumsum;
module.exports.fsum = $76324a701e783bf0$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $76324a701e783bf0$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $76324a701e783bf0$var$Adder;
function $76324a701e783bf0$var$fsum(values, valueof) {
    const adder = new $76324a701e783bf0$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $76324a701e783bf0$var$fcumsum(values, valueof) {
    const adder = new $76324a701e783bf0$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("bSznb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a602d299971b506$var$group;
module.exports.flatGroup = $8a602d299971b506$var$flatGroup;
module.exports.flatRollup = $8a602d299971b506$var$flatRollup;
module.exports.groups = $8a602d299971b506$var$groups;
module.exports.index = $8a602d299971b506$var$index;
module.exports.indexes = $8a602d299971b506$var$indexes;
module.exports.rollup = $8a602d299971b506$var$rollup;
module.exports.rollups = $8a602d299971b506$var$rollups;

var $hhirN = parcelRequire("hhirN");

var $8a602d299971b506$var$_identity = $8a602d299971b506$var$_interopRequireDefault((parcelRequire("jERUI")));
function $8a602d299971b506$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a602d299971b506$var$group(values, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, $8a602d299971b506$var$_identity.default, keys);
}
function $8a602d299971b506$var$groups(values, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, $8a602d299971b506$var$_identity.default, keys);
}
function $8a602d299971b506$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8a602d299971b506$var$flatGroup(values, ...keys) {
    return $8a602d299971b506$var$flatten($8a602d299971b506$var$groups(values, ...keys), keys);
}
function $8a602d299971b506$var$flatRollup(values, reduce, ...keys) {
    return $8a602d299971b506$var$flatten($8a602d299971b506$var$rollups(values, reduce, ...keys), keys);
}
function $8a602d299971b506$var$rollup(values, reduce, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, reduce, keys);
}
function $8a602d299971b506$var$rollups(values, reduce, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, reduce, keys);
}
function $8a602d299971b506$var$index(values, ...keys) {
    return $8a602d299971b506$var$nest(values, $8a602d299971b506$var$_identity.default, $8a602d299971b506$var$unique, keys);
}
function $8a602d299971b506$var$indexes(values, ...keys) {
    return $8a602d299971b506$var$nest(values, Array.from, $8a602d299971b506$var$unique, keys);
}
function $8a602d299971b506$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8a602d299971b506$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $hhirN.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("hhirN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $033f0160e9b7bb24$var$InternMap extends Map {
    constructor(entries, key = $033f0160e9b7bb24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($033f0160e9b7bb24$var$intern_get(this, key));
    }
    has(key) {
        return super.has($033f0160e9b7bb24$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($033f0160e9b7bb24$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($033f0160e9b7bb24$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $033f0160e9b7bb24$var$InternMap;
class $033f0160e9b7bb24$var$InternSet extends Set {
    constructor(values, key = $033f0160e9b7bb24$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($033f0160e9b7bb24$var$intern_get(this, value));
    }
    add(value) {
        return super.add($033f0160e9b7bb24$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($033f0160e9b7bb24$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $033f0160e9b7bb24$var$InternSet;
function $033f0160e9b7bb24$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $033f0160e9b7bb24$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $033f0160e9b7bb24$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $033f0160e9b7bb24$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("jERUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4fb92dffce86d8a$var$identity;
function $e4fb92dffce86d8a$var$identity(x) {
    return x;
}

});


parcelRegister("kR7qy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2ee84cf0f5d5024$var$groupSort;

var $f2ee84cf0f5d5024$var$_ascending = $f2ee84cf0f5d5024$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $f2ee84cf0f5d5024$var$_group = $f2ee84cf0f5d5024$var$_interopRequireWildcard((parcelRequire("bSznb")));

var $f2ee84cf0f5d5024$var$_sort = $f2ee84cf0f5d5024$var$_interopRequireDefault((parcelRequire("hgC45")));
function $f2ee84cf0f5d5024$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2ee84cf0f5d5024$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2ee84cf0f5d5024$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2ee84cf0f5d5024$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f2ee84cf0f5d5024$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2ee84cf0f5d5024$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $f2ee84cf0f5d5024$var$_sort.default)((0, $f2ee84cf0f5d5024$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $f2ee84cf0f5d5024$var$_ascending.default)(av, bv) || (0, $f2ee84cf0f5d5024$var$_ascending.default)(ak, bk)) : (0, $f2ee84cf0f5d5024$var$_sort.default)((0, $f2ee84cf0f5d5024$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $f2ee84cf0f5d5024$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("hgC45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $033e79a1d1467d65$var$ascendingDefined;
module.exports.compareDefined = $033e79a1d1467d65$var$compareDefined;
module.exports.default = $033e79a1d1467d65$var$sort;

var $033e79a1d1467d65$var$_ascending = $033e79a1d1467d65$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $033e79a1d1467d65$var$_permute = $033e79a1d1467d65$var$_interopRequireDefault((parcelRequire("gTjer")));
function $033e79a1d1467d65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $033e79a1d1467d65$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $033e79a1d1467d65$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$033e79a1d1467d65$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $033e79a1d1467d65$var$_permute.default)(values, index);
    }
    return values.sort($033e79a1d1467d65$var$compareDefined(f));
}
function $033e79a1d1467d65$var$compareDefined(compare = $033e79a1d1467d65$var$_ascending.default) {
    if (compare === $033e79a1d1467d65$var$_ascending.default) return $033e79a1d1467d65$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $033e79a1d1467d65$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("gTjer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4c0b3735af93600$var$permute;
function $c4c0b3735af93600$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("aqqXO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79713f82feaa4be7$var$bin;

var $2MAwv = parcelRequire("2MAwv");

var $79713f82feaa4be7$var$_bisect = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("4M7Uz")));

var $79713f82feaa4be7$var$_constant = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("bGo2G")));

var $79713f82feaa4be7$var$_extent = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("3npVv")));

var $79713f82feaa4be7$var$_identity = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("jERUI")));

var $79713f82feaa4be7$var$_nice = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("1h8vr")));

var $79713f82feaa4be7$var$_ticks = $79713f82feaa4be7$var$_interopRequireWildcard((parcelRequire("kOhXV")));

var $79713f82feaa4be7$var$_sturges = $79713f82feaa4be7$var$_interopRequireDefault((parcelRequire("hksbO")));
function $79713f82feaa4be7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($79713f82feaa4be7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $79713f82feaa4be7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $79713f82feaa4be7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $79713f82feaa4be7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79713f82feaa4be7$var$bin() {
    var value = $79713f82feaa4be7$var$_identity.default, domain = $79713f82feaa4be7$var$_extent.default, threshold = $79713f82feaa4be7$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $79713f82feaa4be7$var$_extent.default) [x0, x1] = (0, $79713f82feaa4be7$var$_nice.default)(x0, x1, tn);
            tz = (0, $79713f82feaa4be7$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $79713f82feaa4be7$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $79713f82feaa4be7$var$_extent.default) {
                    const step = (0, $79713f82feaa4be7$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $79713f82feaa4be7$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $79713f82feaa4be7$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $79713f82feaa4be7$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $79713f82feaa4be7$var$_constant.default)($2MAwv.slice.call(_)) : (0, $79713f82feaa4be7$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("2MAwv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $206c653bb511c5d8$var$array = Array.prototype;
var $206c653bb511c5d8$var$slice = $206c653bb511c5d8$var$array.slice;
module.exports.slice = $206c653bb511c5d8$var$slice;
var $206c653bb511c5d8$var$map = $206c653bb511c5d8$var$array.map;
module.exports.map = $206c653bb511c5d8$var$map;

});

parcelRegister("bGo2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88164442c1958e67$var$constant;
function $88164442c1958e67$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("1h8vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0eddfa20e4e2d516$var$nice;

var $kOhXV = parcelRequire("kOhXV");
function $0eddfa20e4e2d516$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $kOhXV.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("kOhXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f26669c3fa600501$var$ticks;
module.exports.tickIncrement = $f26669c3fa600501$var$tickIncrement;
module.exports.tickStep = $f26669c3fa600501$var$tickStep;
var $f26669c3fa600501$var$e10 = Math.sqrt(50), $f26669c3fa600501$var$e5 = Math.sqrt(10), $f26669c3fa600501$var$e2 = Math.sqrt(2);
function $f26669c3fa600501$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $f26669c3fa600501$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $f26669c3fa600501$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $f26669c3fa600501$var$e10 ? 10 : error >= $f26669c3fa600501$var$e5 ? 5 : error >= $f26669c3fa600501$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $f26669c3fa600501$var$e10 ? 10 : error >= $f26669c3fa600501$var$e5 ? 5 : error >= $f26669c3fa600501$var$e2 ? 2 : 1);
}
function $f26669c3fa600501$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $f26669c3fa600501$var$e10) step1 *= 10;
    else if (error >= $f26669c3fa600501$var$e5) step1 *= 5;
    else if (error >= $f26669c3fa600501$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("hksbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9da2bc89b5a15f8$var$thresholdSturges;

var $c9da2bc89b5a15f8$var$_count = $c9da2bc89b5a15f8$var$_interopRequireDefault((parcelRequire("hRGKw")));
function $c9da2bc89b5a15f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9da2bc89b5a15f8$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $c9da2bc89b5a15f8$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("8P0oX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66c365e8c897f2dc$var$thresholdFreedmanDiaconis;

var $66c365e8c897f2dc$var$_count = $66c365e8c897f2dc$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $66c365e8c897f2dc$var$_quantile = $66c365e8c897f2dc$var$_interopRequireDefault((parcelRequire("bhvsA")));
function $66c365e8c897f2dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $66c365e8c897f2dc$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $66c365e8c897f2dc$var$_quantile.default)(values, 0.75) - (0, $66c365e8c897f2dc$var$_quantile.default)(values, 0.25)) * Math.pow((0, $66c365e8c897f2dc$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("bhvsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8369af8e0b9f9379$var$quantile;
module.exports.quantileSorted = $8369af8e0b9f9379$var$quantileSorted;

var $8369af8e0b9f9379$var$_max = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("vbPSg")));

var $8369af8e0b9f9379$var$_min = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("1hOTq")));

var $8369af8e0b9f9379$var$_quickselect = $8369af8e0b9f9379$var$_interopRequireDefault((parcelRequire("dxKAb")));

var $8369af8e0b9f9379$var$_number = $8369af8e0b9f9379$var$_interopRequireWildcard((parcelRequire("7i5Zp")));
function $8369af8e0b9f9379$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8369af8e0b9f9379$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8369af8e0b9f9379$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8369af8e0b9f9379$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8369af8e0b9f9379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8369af8e0b9f9379$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $8369af8e0b9f9379$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $8369af8e0b9f9379$var$_min.default)(values);
    if (p >= 1) return (0, $8369af8e0b9f9379$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $8369af8e0b9f9379$var$_max.default)((0, $8369af8e0b9f9379$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $8369af8e0b9f9379$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $8369af8e0b9f9379$var$quantileSorted(values, p, valueof = $8369af8e0b9f9379$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("vbPSg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05dc13af475ff7cb$var$max;
function $05dc13af475ff7cb$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("1hOTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0efedb439da19086$var$min;
function $0efedb439da19086$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("dxKAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dc27dc6445ab9e8$var$quickselect;

var $hgC45 = parcelRequire("hgC45");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $9dc27dc6445ab9e8$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $hgC45.ascendingDefined : (0, $hgC45.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $9dc27dc6445ab9e8$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $9dc27dc6445ab9e8$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $9dc27dc6445ab9e8$var$swap(array, left, right);
        while(i < j){
            $9dc27dc6445ab9e8$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $9dc27dc6445ab9e8$var$swap(array, left, j);
        else ++j, $9dc27dc6445ab9e8$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $9dc27dc6445ab9e8$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("vtl6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05e9a791a39a53a5$var$thresholdScott;

var $05e9a791a39a53a5$var$_count = $05e9a791a39a53a5$var$_interopRequireDefault((parcelRequire("hRGKw")));

var $05e9a791a39a53a5$var$_deviation = $05e9a791a39a53a5$var$_interopRequireDefault((parcelRequire("ceJJg")));
function $05e9a791a39a53a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05e9a791a39a53a5$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $05e9a791a39a53a5$var$_count.default)(values)) / (3.49 * (0, $05e9a791a39a53a5$var$_deviation.default)(values)));
}

});

parcelRegister("7xRpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57e50c7b5f45144c$var$maxIndex;
function $57e50c7b5f45144c$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("Gwq9r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07fd1274087ca853$var$mean;
function $07fd1274087ca853$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("4bAsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30c478680551cdd7$var$median;

var $30c478680551cdd7$var$_quantile = $30c478680551cdd7$var$_interopRequireDefault((parcelRequire("bhvsA")));
function $30c478680551cdd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30c478680551cdd7$var$median(values, valueof) {
    return (0, $30c478680551cdd7$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("2ZjwD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22d06c9e9e3c5040$var$merge;
function* $22d06c9e9e3c5040$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $22d06c9e9e3c5040$var$merge(arrays) {
    return Array.from($22d06c9e9e3c5040$var$flatten(arrays));
}

});

parcelRegister("eFUjb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aaf092b80f23fae3$var$minIndex;
function $aaf092b80f23fae3$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("bB075", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87133ceb39874fd1$var$mode;

var $hhirN = parcelRequire("hhirN");
function $87133ceb39874fd1$var$mode(values, valueof) {
    const counts = new $hhirN.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("3nwtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $275cb6627da79e21$var$pairs;
module.exports.pair = $275cb6627da79e21$var$pair;
function $275cb6627da79e21$var$pairs(values, pairof = $275cb6627da79e21$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $275cb6627da79e21$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("d5xzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9875c915027cc5b4$var$range;
function $9875c915027cc5b4$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ehEFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a66232503b32746d$var$rank;

var $a66232503b32746d$var$_ascending = $a66232503b32746d$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $hgC45 = parcelRequire("hgC45");
function $a66232503b32746d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a66232503b32746d$var$rank(values, valueof = $a66232503b32746d$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $a66232503b32746d$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $a66232503b32746d$var$_ascending.default ? (i, j)=>(0, $hgC45.ascendingDefined)(V[i], V[j]) : (0, $hgC45.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("j03gz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd508d08dceb6479$var$least;

var $dd508d08dceb6479$var$_ascending = $dd508d08dceb6479$var$_interopRequireDefault((parcelRequire("2lEQV")));
function $dd508d08dceb6479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd508d08dceb6479$var$least(values, compare = $dd508d08dceb6479$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $dd508d08dceb6479$var$_ascending.default)(value, minValue) < 0 : (0, $dd508d08dceb6479$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("bEZCr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87d33a5da3f0ca4f$var$leastIndex;

var $87d33a5da3f0ca4f$var$_ascending = $87d33a5da3f0ca4f$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $87d33a5da3f0ca4f$var$_minIndex = $87d33a5da3f0ca4f$var$_interopRequireDefault((parcelRequire("eFUjb")));
function $87d33a5da3f0ca4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $87d33a5da3f0ca4f$var$leastIndex(values, compare = $87d33a5da3f0ca4f$var$_ascending.default) {
    if (compare.length === 1) return (0, $87d33a5da3f0ca4f$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("3JjDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b74cff9bd6ebfaa$var$greatest;

var $2b74cff9bd6ebfaa$var$_ascending = $2b74cff9bd6ebfaa$var$_interopRequireDefault((parcelRequire("2lEQV")));
function $2b74cff9bd6ebfaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2b74cff9bd6ebfaa$var$greatest(values, compare = $2b74cff9bd6ebfaa$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $2b74cff9bd6ebfaa$var$_ascending.default)(value, maxValue) > 0 : (0, $2b74cff9bd6ebfaa$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("8H1FG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6543a2c6b692da2d$var$greatestIndex;

var $6543a2c6b692da2d$var$_ascending = $6543a2c6b692da2d$var$_interopRequireDefault((parcelRequire("2lEQV")));

var $6543a2c6b692da2d$var$_maxIndex = $6543a2c6b692da2d$var$_interopRequireDefault((parcelRequire("7xRpL")));
function $6543a2c6b692da2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6543a2c6b692da2d$var$greatestIndex(values, compare = $6543a2c6b692da2d$var$_ascending.default) {
    if (compare.length === 1) return (0, $6543a2c6b692da2d$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("hYxed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d161d0b6657a65bd$var$scan;

var $d161d0b6657a65bd$var$_leastIndex = $d161d0b6657a65bd$var$_interopRequireDefault((parcelRequire("bEZCr")));
function $d161d0b6657a65bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d161d0b6657a65bd$var$scan(values, compare) {
    const index = (0, $d161d0b6657a65bd$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("82rhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $5da3acad04524181$var$shuffler;
var $5da3acad04524181$var$_default = $5da3acad04524181$var$shuffler(Math.random);
module.exports.default = $5da3acad04524181$var$_default;
function $5da3acad04524181$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("xtV25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $064a4a72ceabc92d$var$sum;
function $064a4a72ceabc92d$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("kDL1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f06bede725d46639$var$transpose;

var $f06bede725d46639$var$_min = $f06bede725d46639$var$_interopRequireDefault((parcelRequire("1hOTq")));
function $f06bede725d46639$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f06bede725d46639$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f06bede725d46639$var$_min.default)(matrix, $f06bede725d46639$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f06bede725d46639$var$length(d) {
    return d.length;
}

});

parcelRegister("k40UO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9b4e41c1f1c3269$var$zip;

var $e9b4e41c1f1c3269$var$_transpose = $e9b4e41c1f1c3269$var$_interopRequireDefault((parcelRequire("kDL1M")));
function $e9b4e41c1f1c3269$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9b4e41c1f1c3269$var$zip() {
    return (0, $e9b4e41c1f1c3269$var$_transpose.default)(arguments);
}

});

parcelRegister("Y6qD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b4a9746ee71c635$var$every;
function $0b4a9746ee71c635$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("gd6yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcd2f16f9fa05fcb$var$some;
function $bcd2f16f9fa05fcb$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("iRlqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbadccc7df010b81$var$filter;
function $dbadccc7df010b81$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("9E9DK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $705f53ca570d5396$var$map;
function $705f53ca570d5396$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("eZC5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aea450313d534631$var$reduce;
function $aea450313d534631$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("hG6O3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdeba38505919fca$var$reverse;
function $cdeba38505919fca$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("b6Lvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81651a59e36a351d$var$difference;

var $hhirN = parcelRequire("hhirN");
function $81651a59e36a351d$var$difference(values, ...others) {
    values = new $hhirN.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("en2ry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7651be7664c341c$var$disjoint;

var $hhirN = parcelRequire("hhirN");
function $a7651be7664c341c$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $hhirN.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("i2gjq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2151130835778ed$var$intersection;

var $hhirN = parcelRequire("hhirN");
function $d2151130835778ed$var$intersection(values, ...others) {
    values = new $hhirN.InternSet(values);
    others = others.map($d2151130835778ed$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $d2151130835778ed$var$set(values) {
    return values instanceof $hhirN.InternSet ? values : new $hhirN.InternSet(values);
}

});

parcelRegister("f4rHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af8cb7f1ba53bcc0$var$subset;

var $af8cb7f1ba53bcc0$var$_superset = $af8cb7f1ba53bcc0$var$_interopRequireDefault((parcelRequire("8VkGe")));
function $af8cb7f1ba53bcc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $af8cb7f1ba53bcc0$var$subset(values, other) {
    return (0, $af8cb7f1ba53bcc0$var$_superset.default)(other, values);
}

});
parcelRegister("8VkGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67f3b0441a9d5c76$var$superset;
function $67f3b0441a9d5c76$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $67f3b0441a9d5c76$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $67f3b0441a9d5c76$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $67f3b0441a9d5c76$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("8bE4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f5e6e66c5756b5e$var$union;

var $hhirN = parcelRequire("hhirN");
function $5f5e6e66c5756b5e$var$union(...others) {
    const set = new $hhirN.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("2ynOw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $1dc13ab4490075d6$var$initInterpolator;
module.exports.initRange = $1dc13ab4490075d6$var$initRange;
function $1dc13ab4490075d6$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1dc13ab4490075d6$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("h52bg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6f4985c245b8576$var$ordinal;
module.exports.implicit = void 0;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
const $c6f4985c245b8576$var$implicit = Symbol("implicit");
module.exports.implicit = $c6f4985c245b8576$var$implicit;
function $c6f4985c245b8576$var$ordinal() {
    var index = new $4GZnA.InternMap(), domain = [], range = [], unknown = $c6f4985c245b8576$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $c6f4985c245b8576$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $4GZnA.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c6f4985c245b8576$var$ordinal(domain, range).unknown(unknown);
    };
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("jIfCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e59e3f1fcb9d7f56$var$identity;

var $4FaxR = parcelRequire("4FaxR");

var $e59e3f1fcb9d7f56$var$_number = $e59e3f1fcb9d7f56$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $e59e3f1fcb9d7f56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e59e3f1fcb9d7f56$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $e59e3f1fcb9d7f56$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $e59e3f1fcb9d7f56$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $e59e3f1fcb9d7f56$var$_number.default) : [
        0,
        1
    ];
    return (0, $4FaxR.linearish)(scale);
}

});
parcelRegister("4FaxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36532bd00b31e75f$var$linear;
module.exports.linearish = $36532bd00b31e75f$var$linearish;

var $4GZnA = parcelRequire("4GZnA");

var $36532bd00b31e75f$var$_continuous = $36532bd00b31e75f$var$_interopRequireWildcard((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $36532bd00b31e75f$var$_tickFormat = $36532bd00b31e75f$var$_interopRequireDefault((parcelRequire("k0wsE")));
function $36532bd00b31e75f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36532bd00b31e75f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36532bd00b31e75f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36532bd00b31e75f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36532bd00b31e75f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $36532bd00b31e75f$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $4GZnA.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $36532bd00b31e75f$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $4GZnA.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $36532bd00b31e75f$var$linear() {
    var scale = (0, $36532bd00b31e75f$var$_continuous.default)();
    scale.copy = function() {
        return (0, $36532bd00b31e75f$var$_continuous.copy)(scale, $36532bd00b31e75f$var$linear());
    };
    $2ynOw.initRange.apply(scale, arguments);
    return $36532bd00b31e75f$var$linearish(scale);
}

});
parcelRegister("3biM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $2510f628bcc35e7c$var$copy;
module.exports.default = $2510f628bcc35e7c$var$continuous;
module.exports.identity = $2510f628bcc35e7c$var$identity;
module.exports.transformer = $2510f628bcc35e7c$var$transformer;

var $4GZnA = parcelRequire("4GZnA");

var $bz0rV = parcelRequire("bz0rV");

var $2510f628bcc35e7c$var$_constant = $2510f628bcc35e7c$var$_interopRequireDefault((parcelRequire("8pt7I")));

var $2510f628bcc35e7c$var$_number = $2510f628bcc35e7c$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $2510f628bcc35e7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2510f628bcc35e7c$var$unit = [
    0,
    1
];
function $2510f628bcc35e7c$var$identity(x) {
    return x;
}
function $2510f628bcc35e7c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $2510f628bcc35e7c$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $2510f628bcc35e7c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $2510f628bcc35e7c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $2510f628bcc35e7c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $2510f628bcc35e7c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $2510f628bcc35e7c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $2510f628bcc35e7c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $4GZnA.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $2510f628bcc35e7c$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $2510f628bcc35e7c$var$transformer() {
    var domain = $2510f628bcc35e7c$var$unit, range = $2510f628bcc35e7c$var$unit, interpolate = $bz0rV.interpolate, transform, untransform, unknown, clamp = $2510f628bcc35e7c$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $2510f628bcc35e7c$var$identity) clamp = $2510f628bcc35e7c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $2510f628bcc35e7c$var$polymap : $2510f628bcc35e7c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $bz0rV.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $2510f628bcc35e7c$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $bz0rV.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $2510f628bcc35e7c$var$identity, rescale()) : clamp !== $2510f628bcc35e7c$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $2510f628bcc35e7c$var$continuous() {
    return $2510f628bcc35e7c$var$transformer()($2510f628bcc35e7c$var$identity, $2510f628bcc35e7c$var$identity);
}

});
parcelRegister("bz0rV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $9DSJ2.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $9DSJ2.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $86b34fd171bfa729$var$_quantize.default;
    }
});

var $86b34fd171bfa729$var$_value = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("krToF")));

var $86b34fd171bfa729$var$_array = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("hqZ5Y")));

var $86b34fd171bfa729$var$_basis = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("6Uq4F")));

var $86b34fd171bfa729$var$_basisClosed = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("7Sfex")));

var $86b34fd171bfa729$var$_date = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("liOzy")));

var $86b34fd171bfa729$var$_discrete = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("gHnr2")));

var $86b34fd171bfa729$var$_hue = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("bbChc")));

var $86b34fd171bfa729$var$_number = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $86b34fd171bfa729$var$_numberArray = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("aasbI")));

var $86b34fd171bfa729$var$_object = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("8YYHC")));

var $86b34fd171bfa729$var$_round = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("6mXAE")));

var $86b34fd171bfa729$var$_string = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("iWrr1")));

var $9DSJ2 = parcelRequire("9DSJ2");

var $86b34fd171bfa729$var$_zoom = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("dCTOn")));

var $86b34fd171bfa729$var$_rgb = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("juHTK")));

var $86b34fd171bfa729$var$_hsl = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("1BBX0")));

var $86b34fd171bfa729$var$_lab = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("2yIWn")));

var $86b34fd171bfa729$var$_hcl = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("13cFy")));

var $86b34fd171bfa729$var$_cubehelix = $86b34fd171bfa729$var$_interopRequireWildcard((parcelRequire("kDPUk")));

var $86b34fd171bfa729$var$_piecewise = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("4M1Jk")));

var $86b34fd171bfa729$var$_quantize = $86b34fd171bfa729$var$_interopRequireDefault((parcelRequire("2F9Z0")));
function $86b34fd171bfa729$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($86b34fd171bfa729$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $86b34fd171bfa729$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $86b34fd171bfa729$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $86b34fd171bfa729$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("krToF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee314cee8b851bb7$var$_default;

var $7nMqJ = parcelRequire("7nMqJ");

var $ee314cee8b851bb7$var$_rgb = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("juHTK")));

var $hqZ5Y = parcelRequire("hqZ5Y");

var $ee314cee8b851bb7$var$_date = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("liOzy")));

var $ee314cee8b851bb7$var$_number = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $ee314cee8b851bb7$var$_object = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("8YYHC")));

var $ee314cee8b851bb7$var$_string = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("iWrr1")));

var $ee314cee8b851bb7$var$_constant = $ee314cee8b851bb7$var$_interopRequireDefault((parcelRequire("jOQo6")));

var $ee314cee8b851bb7$var$_numberArray = $ee314cee8b851bb7$var$_interopRequireWildcard((parcelRequire("aasbI")));
function $ee314cee8b851bb7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ee314cee8b851bb7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ee314cee8b851bb7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ee314cee8b851bb7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ee314cee8b851bb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee314cee8b851bb7$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ee314cee8b851bb7$var$_constant.default)(b) : (t === "number" ? $ee314cee8b851bb7$var$_number.default : t === "string" ? (c = (0, $7nMqJ.color)(b)) ? (b = c, $ee314cee8b851bb7$var$_rgb.default) : $ee314cee8b851bb7$var$_string.default : b instanceof $7nMqJ.color ? $ee314cee8b851bb7$var$_rgb.default : b instanceof Date ? $ee314cee8b851bb7$var$_date.default : (0, $ee314cee8b851bb7$var$_numberArray.isNumberArray)(b) ? $ee314cee8b851bb7$var$_numberArray.default : Array.isArray(b) ? $hqZ5Y.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $ee314cee8b851bb7$var$_object.default : $ee314cee8b851bb7$var$_number.default)(a, b);
}

});
parcelRegister("7nMqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $56003f985569a82b$var$_color.rgb;
    }
});

var $56003f985569a82b$var$_color = $56003f985569a82b$var$_interopRequireWildcard((parcelRequire("jst6s")));

var $56003f985569a82b$var$_lab = $56003f985569a82b$var$_interopRequireWildcard((parcelRequire("hYvKz")));

var $56003f985569a82b$var$_cubehelix = $56003f985569a82b$var$_interopRequireDefault((parcelRequire("hcDPw")));
function $56003f985569a82b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56003f985569a82b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($56003f985569a82b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $56003f985569a82b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $56003f985569a82b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jst6s", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("gkBHR")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("gkBHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be3bc355a3a2784d$var$_default;
module.exports.extend = $be3bc355a3a2784d$var$extend;
function $be3bc355a3a2784d$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $be3bc355a3a2784d$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("hYvKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $d160ab31cd9c50d2$var$Hcl;
module.exports.Lab = $d160ab31cd9c50d2$var$Lab;
module.exports.default = $d160ab31cd9c50d2$var$lab;
module.exports.gray = $d160ab31cd9c50d2$var$gray;
module.exports.hcl = $d160ab31cd9c50d2$var$hcl;
module.exports.lch = $d160ab31cd9c50d2$var$lch;

var $d160ab31cd9c50d2$var$_define = $d160ab31cd9c50d2$var$_interopRequireWildcard((parcelRequire("gkBHR")));

var $jst6s = parcelRequire("jst6s");

var $jD5Rl = parcelRequire("jD5Rl");
function $d160ab31cd9c50d2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d160ab31cd9c50d2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d160ab31cd9c50d2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d160ab31cd9c50d2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $d160ab31cd9c50d2$var$K = 18, $d160ab31cd9c50d2$var$Xn = 0.96422, $d160ab31cd9c50d2$var$Yn = 1, $d160ab31cd9c50d2$var$Zn = 0.82521, $d160ab31cd9c50d2$var$t0 = 4 / 29, $d160ab31cd9c50d2$var$t1 = 6 / 29, $d160ab31cd9c50d2$var$t2 = 3 * $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1, $d160ab31cd9c50d2$var$t3 = $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1 * $d160ab31cd9c50d2$var$t1;
function $d160ab31cd9c50d2$var$labConvert(o) {
    if (o instanceof $d160ab31cd9c50d2$var$Lab) return new $d160ab31cd9c50d2$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $d160ab31cd9c50d2$var$Hcl) return $d160ab31cd9c50d2$var$hcl2lab(o);
    if (!(o instanceof $jst6s.Rgb)) o = (0, $jst6s.rgbConvert)(o);
    var r = $d160ab31cd9c50d2$var$rgb2lrgb(o.r), g = $d160ab31cd9c50d2$var$rgb2lrgb(o.g), b = $d160ab31cd9c50d2$var$rgb2lrgb(o.b), y = $d160ab31cd9c50d2$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $d160ab31cd9c50d2$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $d160ab31cd9c50d2$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $d160ab31cd9c50d2$var$Xn);
        z = $d160ab31cd9c50d2$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $d160ab31cd9c50d2$var$Zn);
    }
    return new $d160ab31cd9c50d2$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $d160ab31cd9c50d2$var$gray(l, opacity) {
    return new $d160ab31cd9c50d2$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$labConvert(l) : new $d160ab31cd9c50d2$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $d160ab31cd9c50d2$var$_define.default)($d160ab31cd9c50d2$var$Lab, $d160ab31cd9c50d2$var$lab, (0, $d160ab31cd9c50d2$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        return new $d160ab31cd9c50d2$var$Lab(this.l + $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $d160ab31cd9c50d2$var$Lab(this.l - $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $d160ab31cd9c50d2$var$Xn * $d160ab31cd9c50d2$var$lab2xyz(x);
        y = $d160ab31cd9c50d2$var$Yn * $d160ab31cd9c50d2$var$lab2xyz(y);
        z = $d160ab31cd9c50d2$var$Zn * $d160ab31cd9c50d2$var$lab2xyz(z);
        return new $jst6s.Rgb($d160ab31cd9c50d2$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $d160ab31cd9c50d2$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $d160ab31cd9c50d2$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $d160ab31cd9c50d2$var$xyz2lab(t) {
    return t > $d160ab31cd9c50d2$var$t3 ? Math.pow(t, 1 / 3) : t / $d160ab31cd9c50d2$var$t2 + $d160ab31cd9c50d2$var$t0;
}
function $d160ab31cd9c50d2$var$lab2xyz(t) {
    return t > $d160ab31cd9c50d2$var$t1 ? t * t * t : $d160ab31cd9c50d2$var$t2 * (t - $d160ab31cd9c50d2$var$t0);
}
function $d160ab31cd9c50d2$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $d160ab31cd9c50d2$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $d160ab31cd9c50d2$var$hclConvert(o) {
    if (o instanceof $d160ab31cd9c50d2$var$Hcl) return new $d160ab31cd9c50d2$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $d160ab31cd9c50d2$var$Lab)) o = $d160ab31cd9c50d2$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $d160ab31cd9c50d2$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $jD5Rl.degrees;
    return new $d160ab31cd9c50d2$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $d160ab31cd9c50d2$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$hclConvert(l) : new $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $d160ab31cd9c50d2$var$hclConvert(h) : new $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $d160ab31cd9c50d2$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $d160ab31cd9c50d2$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $d160ab31cd9c50d2$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $jD5Rl.radians;
    return new $d160ab31cd9c50d2$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $d160ab31cd9c50d2$var$_define.default)($d160ab31cd9c50d2$var$Hcl, $d160ab31cd9c50d2$var$hcl, (0, $d160ab31cd9c50d2$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        return new $d160ab31cd9c50d2$var$Hcl(this.h, this.c, this.l + $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $d160ab31cd9c50d2$var$Hcl(this.h, this.c, this.l - $d160ab31cd9c50d2$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $d160ab31cd9c50d2$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("jD5Rl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $e4a6346126171274$var$radians = Math.PI / 180;
module.exports.radians = $e4a6346126171274$var$radians;
const $e4a6346126171274$var$degrees = 180 / Math.PI;
module.exports.degrees = $e4a6346126171274$var$degrees;

});


parcelRegister("hcDPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $c862741113fdf2e7$var$Cubehelix;
module.exports.default = $c862741113fdf2e7$var$cubehelix;

var $c862741113fdf2e7$var$_define = $c862741113fdf2e7$var$_interopRequireWildcard((parcelRequire("gkBHR")));

var $jst6s = parcelRequire("jst6s");

var $jD5Rl = parcelRequire("jD5Rl");
function $c862741113fdf2e7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c862741113fdf2e7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c862741113fdf2e7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c862741113fdf2e7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c862741113fdf2e7$var$A = -0.14861, $c862741113fdf2e7$var$B = 1.78277, $c862741113fdf2e7$var$C = -0.29227, $c862741113fdf2e7$var$D = -0.90649, $c862741113fdf2e7$var$E = 1.97294, $c862741113fdf2e7$var$ED = $c862741113fdf2e7$var$E * $c862741113fdf2e7$var$D, $c862741113fdf2e7$var$EB = $c862741113fdf2e7$var$E * $c862741113fdf2e7$var$B, $c862741113fdf2e7$var$BC_DA = $c862741113fdf2e7$var$B * $c862741113fdf2e7$var$C - $c862741113fdf2e7$var$D * $c862741113fdf2e7$var$A;
function $c862741113fdf2e7$var$cubehelixConvert(o) {
    if (o instanceof $c862741113fdf2e7$var$Cubehelix) return new $c862741113fdf2e7$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $jst6s.Rgb)) o = (0, $jst6s.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($c862741113fdf2e7$var$BC_DA * b + $c862741113fdf2e7$var$ED * r - $c862741113fdf2e7$var$EB * g) / ($c862741113fdf2e7$var$BC_DA + $c862741113fdf2e7$var$ED - $c862741113fdf2e7$var$EB), bl = b - l, k = ($c862741113fdf2e7$var$E * (g - l) - $c862741113fdf2e7$var$C * bl) / $c862741113fdf2e7$var$D, s = Math.sqrt(k * k + bl * bl) / ($c862741113fdf2e7$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $jD5Rl.degrees - 120 : NaN;
    return new $c862741113fdf2e7$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $c862741113fdf2e7$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $c862741113fdf2e7$var$cubehelixConvert(h) : new $c862741113fdf2e7$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $c862741113fdf2e7$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $c862741113fdf2e7$var$_define.default)($c862741113fdf2e7$var$Cubehelix, $c862741113fdf2e7$var$cubehelix, (0, $c862741113fdf2e7$var$_define.extend)($jst6s.Color, {
    brighter (k) {
        k = k == null ? $jst6s.brighter : Math.pow($jst6s.brighter, k);
        return new $c862741113fdf2e7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $jst6s.darker : Math.pow($jst6s.darker, k);
        return new $c862741113fdf2e7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $jD5Rl.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $jst6s.Rgb(255 * (l + a * ($c862741113fdf2e7$var$A * cosh + $c862741113fdf2e7$var$B * sinh)), 255 * (l + a * ($c862741113fdf2e7$var$C * cosh + $c862741113fdf2e7$var$D * sinh)), 255 * (l + a * ($c862741113fdf2e7$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("juHTK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $e312dee9e21fb749$var$_basis = $e312dee9e21fb749$var$_interopRequireDefault((parcelRequire("6Uq4F")));

var $e312dee9e21fb749$var$_basisClosed = $e312dee9e21fb749$var$_interopRequireDefault((parcelRequire("7Sfex")));

var $e312dee9e21fb749$var$_color = $e312dee9e21fb749$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $e312dee9e21fb749$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e312dee9e21fb749$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e312dee9e21fb749$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e312dee9e21fb749$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e312dee9e21fb749$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e312dee9e21fb749$var$_default = function rgbGamma(y) {
    var color = (0, $e312dee9e21fb749$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7nMqJ.rgb)(start)).r, (end = (0, $7nMqJ.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $e312dee9e21fb749$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $e312dee9e21fb749$var$_default;
function $e312dee9e21fb749$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7nMqJ.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e312dee9e21fb749$var$rgbBasis = $e312dee9e21fb749$var$rgbSpline($e312dee9e21fb749$var$_basis.default);
module.exports.rgbBasis = $e312dee9e21fb749$var$rgbBasis;
var $e312dee9e21fb749$var$rgbBasisClosed = $e312dee9e21fb749$var$rgbSpline($e312dee9e21fb749$var$_basisClosed.default);
module.exports.rgbBasisClosed = $e312dee9e21fb749$var$rgbBasisClosed;

});
parcelRegister("6Uq4F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $507c32dd6d405317$var$basis;
module.exports.default = $507c32dd6d405317$var$_default;
function $507c32dd6d405317$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $507c32dd6d405317$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $507c32dd6d405317$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7Sfex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5bb96499a60f4742$var$_default;

var $6Uq4F = parcelRequire("6Uq4F");
function $5bb96499a60f4742$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6Uq4F.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("fBD2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5c898eeabbd4f34$var$nogamma;
module.exports.gamma = $b5c898eeabbd4f34$var$gamma;
module.exports.hue = $b5c898eeabbd4f34$var$hue;

var $b5c898eeabbd4f34$var$_constant = $b5c898eeabbd4f34$var$_interopRequireDefault((parcelRequire("jOQo6")));
function $b5c898eeabbd4f34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5c898eeabbd4f34$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $b5c898eeabbd4f34$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $b5c898eeabbd4f34$var$hue(a, b) {
    var d = b - a;
    return d ? $b5c898eeabbd4f34$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
}
function $b5c898eeabbd4f34$var$gamma(y) {
    return (y = +y) === 1 ? $b5c898eeabbd4f34$var$nogamma : function(a, b) {
        return b - a ? $b5c898eeabbd4f34$var$exponential(a, b, y) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $b5c898eeabbd4f34$var$nogamma(a, b) {
    var d = b - a;
    return d ? $b5c898eeabbd4f34$var$linear(a, d) : (0, $b5c898eeabbd4f34$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("jOQo6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e6db52f1e1498ecd$var$_default = (x)=>()=>x;
module.exports.default = $e6db52f1e1498ecd$var$_default;

});



parcelRegister("hqZ5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb1441a2fd2df01e$var$_default;
module.exports.genericArray = $cb1441a2fd2df01e$var$genericArray;

var $cb1441a2fd2df01e$var$_value = $cb1441a2fd2df01e$var$_interopRequireDefault((parcelRequire("krToF")));

var $cb1441a2fd2df01e$var$_numberArray = $cb1441a2fd2df01e$var$_interopRequireWildcard((parcelRequire("aasbI")));
function $cb1441a2fd2df01e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cb1441a2fd2df01e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cb1441a2fd2df01e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cb1441a2fd2df01e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cb1441a2fd2df01e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb1441a2fd2df01e$var$_default(a, b) {
    return ((0, $cb1441a2fd2df01e$var$_numberArray.isNumberArray)(b) ? $cb1441a2fd2df01e$var$_numberArray.default : $cb1441a2fd2df01e$var$genericArray)(a, b);
}
function $cb1441a2fd2df01e$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $cb1441a2fd2df01e$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("aasbI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01e90b29a675ec69$var$_default;
module.exports.isNumberArray = $01e90b29a675ec69$var$isNumberArray;
function $01e90b29a675ec69$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $01e90b29a675ec69$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("liOzy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f822820c65d6518b$var$_default;
function $f822820c65d6518b$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("j6Yv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de9d81ecd97de908$var$_default;
function $de9d81ecd97de908$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("8YYHC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68a3039a2958df79$var$_default;

var $68a3039a2958df79$var$_value = $68a3039a2958df79$var$_interopRequireDefault((parcelRequire("krToF")));
function $68a3039a2958df79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68a3039a2958df79$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $68a3039a2958df79$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("iWrr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dca2ecc010113468$var$_default;

var $dca2ecc010113468$var$_number = $dca2ecc010113468$var$_interopRequireDefault((parcelRequire("j6Yv4")));
function $dca2ecc010113468$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dca2ecc010113468$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $dca2ecc010113468$var$reB = new RegExp($dca2ecc010113468$var$reA.source, "g");
function $dca2ecc010113468$var$zero(b) {
    return function() {
        return b;
    };
}
function $dca2ecc010113468$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $dca2ecc010113468$var$_default(a, b) {
    var bi = $dca2ecc010113468$var$reA.lastIndex = $dca2ecc010113468$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $dca2ecc010113468$var$reA.exec(a)) && (bm = $dca2ecc010113468$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $dca2ecc010113468$var$_number.default)(am, bm)
            });
        }
        bi = $dca2ecc010113468$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $dca2ecc010113468$var$one(q[0].x) : $dca2ecc010113468$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("gHnr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c282d73c25c942d9$var$_default;
function $c282d73c25c942d9$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("bbChc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $824e69b3e0110570$var$_default;

var $fBD2K = parcelRequire("fBD2K");
function $824e69b3e0110570$var$_default(a, b) {
    var i = (0, $fBD2K.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("6mXAE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a3305827e38b263$var$_default;
function $4a3305827e38b263$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9DSJ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $705234ec199f0b5b$var$_number = $705234ec199f0b5b$var$_interopRequireDefault((parcelRequire("j6Yv4")));

var $kOb2X = parcelRequire("kOb2X");
function $705234ec199f0b5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $705234ec199f0b5b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $705234ec199f0b5b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $705234ec199f0b5b$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $705234ec199f0b5b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $705234ec199f0b5b$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $705234ec199f0b5b$var$interpolateTransformCss = $705234ec199f0b5b$var$interpolateTransform($kOb2X.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $705234ec199f0b5b$var$interpolateTransformCss;
var $705234ec199f0b5b$var$interpolateTransformSvg = $705234ec199f0b5b$var$interpolateTransform($kOb2X.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $705234ec199f0b5b$var$interpolateTransformSvg;

});
parcelRegister("kOb2X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $f2610bd1ef2f5885$var$parseCss;
module.exports.parseSvg = $f2610bd1ef2f5885$var$parseSvg;

var $f2610bd1ef2f5885$var$_decompose = $f2610bd1ef2f5885$var$_interopRequireWildcard((parcelRequire("dMHn8")));
function $f2610bd1ef2f5885$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2610bd1ef2f5885$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2610bd1ef2f5885$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2610bd1ef2f5885$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $f2610bd1ef2f5885$var$svgNode;
/* eslint-disable no-undef */ function $f2610bd1ef2f5885$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $f2610bd1ef2f5885$var$_decompose.identity : (0, $f2610bd1ef2f5885$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $f2610bd1ef2f5885$var$parseSvg(value) {
    if (value == null) return $f2610bd1ef2f5885$var$_decompose.identity;
    if (!$f2610bd1ef2f5885$var$svgNode) $f2610bd1ef2f5885$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $f2610bd1ef2f5885$var$svgNode.setAttribute("transform", value);
    if (!(value = $f2610bd1ef2f5885$var$svgNode.transform.baseVal.consolidate())) return $f2610bd1ef2f5885$var$_decompose.identity;
    value = value.matrix;
    return (0, $f2610bd1ef2f5885$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("dMHn8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a09166e25dfdcba9$var$_default;
module.exports.identity = void 0;
var $a09166e25dfdcba9$var$degrees = 180 / Math.PI;
var $a09166e25dfdcba9$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $a09166e25dfdcba9$var$identity;
function $a09166e25dfdcba9$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $a09166e25dfdcba9$var$degrees,
        skewX: Math.atan(skewX) * $a09166e25dfdcba9$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("dCTOn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9eba1df5c12e8184$var$epsilon2 = 1e-12;
function $9eba1df5c12e8184$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $9eba1df5c12e8184$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $9eba1df5c12e8184$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $9eba1df5c12e8184$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $9eba1df5c12e8184$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $9eba1df5c12e8184$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $9eba1df5c12e8184$var$tanh(rho * s + r0) - $9eba1df5c12e8184$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $9eba1df5c12e8184$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $9eba1df5c12e8184$var$_default;

});

parcelRegister("1BBX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $12b6af5a694aca58$var$_color = $12b6af5a694aca58$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $12b6af5a694aca58$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($12b6af5a694aca58$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $12b6af5a694aca58$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $12b6af5a694aca58$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $12b6af5a694aca58$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7nMqJ.hsl)(start)).h, (end = (0, $7nMqJ.hsl)(end)).h), s = (0, $12b6af5a694aca58$var$_color.default)(start.s, end.s), l = (0, $12b6af5a694aca58$var$_color.default)(start.l, end.l), opacity = (0, $12b6af5a694aca58$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $12b6af5a694aca58$var$_default = $12b6af5a694aca58$var$hsl($12b6af5a694aca58$var$_color.hue);
module.exports.default = $12b6af5a694aca58$var$_default;
var $12b6af5a694aca58$var$hslLong = $12b6af5a694aca58$var$hsl($12b6af5a694aca58$var$_color.default);
module.exports.hslLong = $12b6af5a694aca58$var$hslLong;

});

parcelRegister("2yIWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dd19dffc683f201$var$lab;

var $7nMqJ = parcelRequire("7nMqJ");

var $1dd19dffc683f201$var$_color = $1dd19dffc683f201$var$_interopRequireDefault((parcelRequire("fBD2K")));
function $1dd19dffc683f201$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1dd19dffc683f201$var$lab(start, end) {
    var l = (0, $1dd19dffc683f201$var$_color.default)((start = (0, $7nMqJ.lab)(start)).l, (end = (0, $7nMqJ.lab)(end)).l), a = (0, $1dd19dffc683f201$var$_color.default)(start.a, end.a), b = (0, $1dd19dffc683f201$var$_color.default)(start.b, end.b), opacity = (0, $1dd19dffc683f201$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("13cFy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $0c3fe61bcf596cba$var$_color = $0c3fe61bcf596cba$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $0c3fe61bcf596cba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0c3fe61bcf596cba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0c3fe61bcf596cba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0c3fe61bcf596cba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0c3fe61bcf596cba$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $7nMqJ.hcl)(start)).h, (end = (0, $7nMqJ.hcl)(end)).h), c = (0, $0c3fe61bcf596cba$var$_color.default)(start.c, end.c), l = (0, $0c3fe61bcf596cba$var$_color.default)(start.l, end.l), opacity = (0, $0c3fe61bcf596cba$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0c3fe61bcf596cba$var$_default = $0c3fe61bcf596cba$var$hcl($0c3fe61bcf596cba$var$_color.hue);
module.exports.default = $0c3fe61bcf596cba$var$_default;
var $0c3fe61bcf596cba$var$hclLong = $0c3fe61bcf596cba$var$hcl($0c3fe61bcf596cba$var$_color.default);
module.exports.hclLong = $0c3fe61bcf596cba$var$hclLong;

});

parcelRegister("kDPUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $7nMqJ = parcelRequire("7nMqJ");

var $f06fb6ebc8929a60$var$_color = $f06fb6ebc8929a60$var$_interopRequireWildcard((parcelRequire("fBD2K")));
function $f06fb6ebc8929a60$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f06fb6ebc8929a60$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f06fb6ebc8929a60$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f06fb6ebc8929a60$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f06fb6ebc8929a60$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $7nMqJ.cubehelix)(start)).h, (end = (0, $7nMqJ.cubehelix)(end)).h), s = (0, $f06fb6ebc8929a60$var$_color.default)(start.s, end.s), l = (0, $f06fb6ebc8929a60$var$_color.default)(start.l, end.l), opacity = (0, $f06fb6ebc8929a60$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $f06fb6ebc8929a60$var$_default = $f06fb6ebc8929a60$var$cubehelix($f06fb6ebc8929a60$var$_color.hue);
module.exports.default = $f06fb6ebc8929a60$var$_default;
var $f06fb6ebc8929a60$var$cubehelixLong = $f06fb6ebc8929a60$var$cubehelix($f06fb6ebc8929a60$var$_color.default);
module.exports.cubehelixLong = $f06fb6ebc8929a60$var$cubehelixLong;

});

parcelRegister("4M1Jk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $379cfca9f678715d$var$piecewise;

var $379cfca9f678715d$var$_value = $379cfca9f678715d$var$_interopRequireDefault((parcelRequire("krToF")));
function $379cfca9f678715d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $379cfca9f678715d$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $379cfca9f678715d$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("2F9Z0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f0727849e9b558d$var$_default;
function $1f0727849e9b558d$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("8pt7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61f73fd39961967a$var$constants;
function $61f73fd39961967a$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("7lxKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5594ad34133bb211$var$number;
function $5594ad34133bb211$var$number(x) {
    return +x;
}

});


parcelRegister("k0wsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e90cfcd9d440e77b$var$tickFormat;

var $4GZnA = parcelRequire("4GZnA");

var $iu2fv = parcelRequire("iu2fv");
function $e90cfcd9d440e77b$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $4GZnA.tickStep)(start, stop, count), precision;
    specifier = (0, $iu2fv.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $iu2fv.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $iu2fv.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $iu2fv.format)(specifier);
}

});
parcelRegister("iu2fv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $d74cc5f1f4bf5c68$var$_precisionRound.default;
    }
});

var $d74cc5f1f4bf5c68$var$_defaultLocale = $d74cc5f1f4bf5c68$var$_interopRequireWildcard((parcelRequire("VtQmC")));

var $d74cc5f1f4bf5c68$var$_locale = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("kveGI")));

var $d74cc5f1f4bf5c68$var$_formatSpecifier = $d74cc5f1f4bf5c68$var$_interopRequireWildcard((parcelRequire("5oDyj")));

var $d74cc5f1f4bf5c68$var$_precisionFixed = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("4Vhlo")));

var $d74cc5f1f4bf5c68$var$_precisionPrefix = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("bi9b1")));

var $d74cc5f1f4bf5c68$var$_precisionRound = $d74cc5f1f4bf5c68$var$_interopRequireDefault((parcelRequire("7sZ1T")));
function $d74cc5f1f4bf5c68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d74cc5f1f4bf5c68$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d74cc5f1f4bf5c68$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d74cc5f1f4bf5c68$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d74cc5f1f4bf5c68$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("VtQmC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0acc794c9056a273$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $0acc794c9056a273$var$_locale = $0acc794c9056a273$var$_interopRequireDefault((parcelRequire("kveGI")));
function $0acc794c9056a273$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0acc794c9056a273$var$locale;
var $0acc794c9056a273$var$format;
module.exports.format = $0acc794c9056a273$var$format;
var $0acc794c9056a273$var$formatPrefix;
module.exports.formatPrefix = $0acc794c9056a273$var$formatPrefix;
$0acc794c9056a273$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $0acc794c9056a273$var$defaultLocale(definition) {
    $0acc794c9056a273$var$locale = (0, $0acc794c9056a273$var$_locale.default)(definition);
    module.exports.format = $0acc794c9056a273$var$format = $0acc794c9056a273$var$locale.format;
    module.exports.formatPrefix = $0acc794c9056a273$var$formatPrefix = $0acc794c9056a273$var$locale.formatPrefix;
    return $0acc794c9056a273$var$locale;
}

});
parcelRegister("kveGI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eed2189d51001e9d$var$_default;

var $eed2189d51001e9d$var$_exponent = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("6aXnW")));

var $eed2189d51001e9d$var$_formatGroup = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("8HiWC")));

var $eed2189d51001e9d$var$_formatNumerals = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("gltmT")));

var $eed2189d51001e9d$var$_formatSpecifier = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("5oDyj")));

var $eed2189d51001e9d$var$_formatTrim = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("eRShH")));

var $eed2189d51001e9d$var$_formatTypes = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("dHAst")));

var $6U7P4 = parcelRequire("6U7P4");

var $eed2189d51001e9d$var$_identity = $eed2189d51001e9d$var$_interopRequireDefault((parcelRequire("cy8R9")));
function $eed2189d51001e9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eed2189d51001e9d$var$map = Array.prototype.map, $eed2189d51001e9d$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $eed2189d51001e9d$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $eed2189d51001e9d$var$_identity.default : (0, $eed2189d51001e9d$var$_formatGroup.default)($eed2189d51001e9d$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $eed2189d51001e9d$var$_identity.default : (0, $eed2189d51001e9d$var$_formatNumerals.default)($eed2189d51001e9d$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $eed2189d51001e9d$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$eed2189d51001e9d$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $eed2189d51001e9d$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $eed2189d51001e9d$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $eed2189d51001e9d$var$prefixes[8 + $6U7P4.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $eed2189d51001e9d$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $eed2189d51001e9d$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $eed2189d51001e9d$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("6aXnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47f1bde8fe5d07b8$var$_default;

var $8795b = parcelRequire("8795b");
function $47f1bde8fe5d07b8$var$_default(x) {
    return x = (0, $8795b.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("8795b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e8605c69fa1d0e0$var$_default;
module.exports.formatDecimalParts = $5e8605c69fa1d0e0$var$formatDecimalParts;
function $5e8605c69fa1d0e0$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $5e8605c69fa1d0e0$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("8HiWC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $655108d9cb0353fe$var$_default;
function $655108d9cb0353fe$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("gltmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be65636d4b319db0$var$_default;
function $be65636d4b319db0$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("5oDyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $3edddfe92a5cb96a$var$FormatSpecifier;
module.exports.default = $3edddfe92a5cb96a$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $3edddfe92a5cb96a$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $3edddfe92a5cb96a$var$formatSpecifier(specifier) {
    if (!(match = $3edddfe92a5cb96a$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $3edddfe92a5cb96a$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$3edddfe92a5cb96a$var$formatSpecifier.prototype = $3edddfe92a5cb96a$var$FormatSpecifier.prototype; // instanceof
function $3edddfe92a5cb96a$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$3edddfe92a5cb96a$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("eRShH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad301fab84749b83$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $ad301fab84749b83$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("dHAst", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f9b925f823c468a$var$_formatDecimal = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("8795b")));

var $9f9b925f823c468a$var$_formatPrefixAuto = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("6U7P4")));

var $9f9b925f823c468a$var$_formatRounded = $9f9b925f823c468a$var$_interopRequireDefault((parcelRequire("3HqvL")));
function $9f9b925f823c468a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9f9b925f823c468a$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $9f9b925f823c468a$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $9f9b925f823c468a$var$_formatRounded.default)(x * 100, p),
    "r": $9f9b925f823c468a$var$_formatRounded.default,
    "s": $9f9b925f823c468a$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $9f9b925f823c468a$var$_default;

});
parcelRegister("6U7P4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $506e0a7c5780768a$var$_default;
module.exports.prefixExponent = void 0;

var $8795b = parcelRequire("8795b");
var $506e0a7c5780768a$var$prefixExponent;
module.exports.prefixExponent = $506e0a7c5780768a$var$prefixExponent;
function $506e0a7c5780768a$var$_default(x, p) {
    var d = (0, $8795b.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $506e0a7c5780768a$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $8795b.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("3HqvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b19f3d267add45a$var$_default;

var $8795b = parcelRequire("8795b");
function $2b19f3d267add45a$var$_default(x, p) {
    var d = (0, $8795b.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cy8R9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $922f87b24a082dd8$var$_default;
function $922f87b24a082dd8$var$_default(x) {
    return x;
}

});



parcelRegister("4Vhlo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3959f07794f973d4$var$_default;

var $3959f07794f973d4$var$_exponent = $3959f07794f973d4$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $3959f07794f973d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3959f07794f973d4$var$_default(step) {
    return Math.max(0, -(0, $3959f07794f973d4$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("bi9b1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83887e7bb3549342$var$_default;

var $83887e7bb3549342$var$_exponent = $83887e7bb3549342$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $83887e7bb3549342$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $83887e7bb3549342$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $83887e7bb3549342$var$_exponent.default)(value) / 3))) * 3 - (0, $83887e7bb3549342$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("7sZ1T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56fa7d21d861321e$var$_default;

var $56fa7d21d861321e$var$_exponent = $56fa7d21d861321e$var$_interopRequireDefault((parcelRequire("6aXnW")));
function $56fa7d21d861321e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56fa7d21d861321e$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $56fa7d21d861321e$var$_exponent.default)(max) - (0, $56fa7d21d861321e$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("flmZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2baa6eb7899db10$var$log;
module.exports.loggish = $b2baa6eb7899db10$var$loggish;

var $4GZnA = parcelRequire("4GZnA");

var $iu2fv = parcelRequire("iu2fv");

var $b2baa6eb7899db10$var$_nice = $b2baa6eb7899db10$var$_interopRequireDefault((parcelRequire("e1xvL")));

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $b2baa6eb7899db10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2baa6eb7899db10$var$transformLog(x) {
    return Math.log(x);
}
function $b2baa6eb7899db10$var$transformExp(x) {
    return Math.exp(x);
}
function $b2baa6eb7899db10$var$transformLogn(x) {
    return -Math.log(-x);
}
function $b2baa6eb7899db10$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $b2baa6eb7899db10$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $b2baa6eb7899db10$var$powp(base) {
    return base === 10 ? $b2baa6eb7899db10$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $b2baa6eb7899db10$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $b2baa6eb7899db10$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $b2baa6eb7899db10$var$loggish(transform) {
    const scale = transform($b2baa6eb7899db10$var$transformLog, $b2baa6eb7899db10$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $b2baa6eb7899db10$var$logp(base), pows = $b2baa6eb7899db10$var$powp(base);
        if (domain()[0] < 0) {
            logs = $b2baa6eb7899db10$var$reflect(logs), pows = $b2baa6eb7899db10$var$reflect(pows);
            transform($b2baa6eb7899db10$var$transformLogn, $b2baa6eb7899db10$var$transformExpn);
        } else transform($b2baa6eb7899db10$var$transformLog, $b2baa6eb7899db10$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $4GZnA.ticks)(u, v, n);
        } else z = (0, $4GZnA.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $iu2fv.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $iu2fv.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $b2baa6eb7899db10$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $b2baa6eb7899db10$var$log() {
    const scale = $b2baa6eb7899db10$var$loggish((0, $3biM0.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $3biM0.copy)(scale, $b2baa6eb7899db10$var$log()).base(scale.base());
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("e1xvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35b2756e0b1bbda$var$nice;
function $a35b2756e0b1bbda$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("ag3bX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $777ddfd1aa877f09$var$symlog;
module.exports.symlogish = $777ddfd1aa877f09$var$symlogish;

var $4FaxR = parcelRequire("4FaxR");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $777ddfd1aa877f09$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $777ddfd1aa877f09$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $777ddfd1aa877f09$var$symlogish(transform) {
    var c = 1, scale = transform($777ddfd1aa877f09$var$transformSymlog(c), $777ddfd1aa877f09$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($777ddfd1aa877f09$var$transformSymlog(c = +_), $777ddfd1aa877f09$var$transformSymexp(c)) : c;
    };
    return (0, $4FaxR.linearish)(scale);
}
function $777ddfd1aa877f09$var$symlog() {
    var scale = $777ddfd1aa877f09$var$symlogish((0, $3biM0.transformer)());
    scale.copy = function() {
        return (0, $3biM0.copy)(scale, $777ddfd1aa877f09$var$symlog()).constant(scale.constant());
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("hGubV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdfdc74eb2c00924$var$pow;
module.exports.powish = $cdfdc74eb2c00924$var$powish;
module.exports.sqrt = $cdfdc74eb2c00924$var$sqrt;

var $4FaxR = parcelRequire("4FaxR");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $cdfdc74eb2c00924$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $cdfdc74eb2c00924$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $cdfdc74eb2c00924$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $cdfdc74eb2c00924$var$powish(transform) {
    var scale = transform($3biM0.identity, $3biM0.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($3biM0.identity, $3biM0.identity) : exponent === 0.5 ? transform($cdfdc74eb2c00924$var$transformSqrt, $cdfdc74eb2c00924$var$transformSquare) : transform($cdfdc74eb2c00924$var$transformPow(exponent), $cdfdc74eb2c00924$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4FaxR.linearish)(scale);
}
function $cdfdc74eb2c00924$var$pow() {
    var scale = $cdfdc74eb2c00924$var$powish((0, $3biM0.transformer)());
    scale.copy = function() {
        return (0, $3biM0.copy)(scale, $cdfdc74eb2c00924$var$pow()).exponent(scale.exponent());
    };
    $2ynOw.initRange.apply(scale, arguments);
    return scale;
}
function $cdfdc74eb2c00924$var$sqrt() {
    return $cdfdc74eb2c00924$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("lcGR9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6fbf650578f84fb$var$radial;

var $f6fbf650578f84fb$var$_continuous = $f6fbf650578f84fb$var$_interopRequireDefault((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $f6fbf650578f84fb$var$_number = $f6fbf650578f84fb$var$_interopRequireDefault((parcelRequire("7lxKK")));
function $f6fbf650578f84fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6fbf650578f84fb$var$square(x) {
    return Math.sign(x) * x * x;
}
function $f6fbf650578f84fb$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $f6fbf650578f84fb$var$radial() {
    var squared = (0, $f6fbf650578f84fb$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $f6fbf650578f84fb$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($f6fbf650578f84fb$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $f6fbf650578f84fb$var$_number.default)).map($f6fbf650578f84fb$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f6fbf650578f84fb$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $2ynOw.initRange.apply(scale, arguments);
    return (0, $4FaxR.linearish)(scale);
}

});

parcelRegister("cOhVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95380ee05b1658a2$var$quantile;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
function $95380ee05b1658a2$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $4GZnA.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $4GZnA.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($4GZnA.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $95380ee05b1658a2$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("gAc3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1295cbc119c6c8f$var$quantize;

var $4GZnA = parcelRequire("4GZnA");

var $4FaxR = parcelRequire("4FaxR");

var $2ynOw = parcelRequire("2ynOw");
function $c1295cbc119c6c8f$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4GZnA.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $c1295cbc119c6c8f$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply((0, $4FaxR.linearish)(scale), arguments);
}

});

parcelRegister("g6pLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb9130bc7ad2d518$var$threshold;

var $4GZnA = parcelRequire("4GZnA");

var $2ynOw = parcelRequire("2ynOw");
function $bb9130bc7ad2d518$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4GZnA.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bb9130bc7ad2d518$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $2ynOw.initRange.apply(scale, arguments);
}

});

parcelRegister("liuou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $f812db0c35c64a41$var$calendar;
module.exports.default = $f812db0c35c64a41$var$time;

var $5hUYw = parcelRequire("5hUYw");

var $2ew5Z = parcelRequire("2ew5Z");

var $f812db0c35c64a41$var$_continuous = $f812db0c35c64a41$var$_interopRequireWildcard((parcelRequire("3biM0")));

var $2ynOw = parcelRequire("2ynOw");

var $f812db0c35c64a41$var$_nice = $f812db0c35c64a41$var$_interopRequireDefault((parcelRequire("e1xvL")));
function $f812db0c35c64a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f812db0c35c64a41$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f812db0c35c64a41$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f812db0c35c64a41$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f812db0c35c64a41$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f812db0c35c64a41$var$date(t) {
    return new Date(t);
}
function $f812db0c35c64a41$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $f812db0c35c64a41$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f812db0c35c64a41$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $f812db0c35c64a41$var$number)) : domain().map($f812db0c35c64a41$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $f812db0c35c64a41$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f812db0c35c64a41$var$_continuous.copy)(scale, $f812db0c35c64a41$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $f812db0c35c64a41$var$time() {
    return $2ynOw.initRange.apply($f812db0c35c64a41$var$calendar($5hUYw.timeTicks, $5hUYw.timeTickInterval, $5hUYw.timeYear, $5hUYw.timeMonth, $5hUYw.timeWeek, $5hUYw.timeDay, $5hUYw.timeHour, $5hUYw.timeMinute, $5hUYw.timeSecond, $2ew5Z.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("5hUYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $ah8ax.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $ah8ax.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $ah8ax.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $ah8ax.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $ah8ax.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $ah8ax.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $ah8ax.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $ah8ax.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $tUMUf.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $tUMUf.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $ah8ax.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $ah8ax.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $ah8ax.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $ah8ax.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $ah8ax.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $tUMUf.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $tUMUf.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $k4peM.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $k4peM.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $k4peM.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $3d9abc5caa349abb$var$_utcYear.utcYears;
    }
});

var $3d9abc5caa349abb$var$_interval = $3d9abc5caa349abb$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $3d9abc5caa349abb$var$_millisecond = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("cK28E")));

var $3d9abc5caa349abb$var$_second = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("jeQEd")));

var $3d9abc5caa349abb$var$_minute = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("kQUOO")));

var $3d9abc5caa349abb$var$_hour = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("6xt90")));

var $3d9abc5caa349abb$var$_day = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("iEyEO")));

var $ah8ax = parcelRequire("ah8ax");

var $3d9abc5caa349abb$var$_month = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("b5xm0")));

var $3d9abc5caa349abb$var$_year = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("hrPSp")));

var $3d9abc5caa349abb$var$_utcMinute = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("d9Trb")));

var $3d9abc5caa349abb$var$_utcHour = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("6XsZh")));

var $3d9abc5caa349abb$var$_utcDay = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("8vTWn")));

var $k4peM = parcelRequire("k4peM");

var $3d9abc5caa349abb$var$_utcMonth = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("lhWn5")));

var $3d9abc5caa349abb$var$_utcYear = $3d9abc5caa349abb$var$_interopRequireWildcard((parcelRequire("4w90J")));

var $tUMUf = parcelRequire("tUMUf");
function $3d9abc5caa349abb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3d9abc5caa349abb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3d9abc5caa349abb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3d9abc5caa349abb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3d9abc5caa349abb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("5UfBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44ce484d430577ea$var$newInterval;
var $44ce484d430577ea$var$t0 = new Date(), $44ce484d430577ea$var$t1 = new Date();
function $44ce484d430577ea$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $44ce484d430577ea$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $44ce484d430577ea$var$t0.setTime(+start), $44ce484d430577ea$var$t1.setTime(+end);
            floori($44ce484d430577ea$var$t0), floori($44ce484d430577ea$var$t1);
            return Math.floor(count($44ce484d430577ea$var$t0, $44ce484d430577ea$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("cK28E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $946b7093b1f356c8$var$_interval = $946b7093b1f356c8$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $946b7093b1f356c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $946b7093b1f356c8$var$millisecond = (0, $946b7093b1f356c8$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$946b7093b1f356c8$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $946b7093b1f356c8$var$millisecond;
    return (0, $946b7093b1f356c8$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $946b7093b1f356c8$var$_default = $946b7093b1f356c8$var$millisecond;
module.exports.default = $946b7093b1f356c8$var$_default;
var $946b7093b1f356c8$var$milliseconds = $946b7093b1f356c8$var$millisecond.range;
module.exports.milliseconds = $946b7093b1f356c8$var$milliseconds;

});

parcelRegister("jeQEd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e01829d60cf3b45c$var$_interval = $e01829d60cf3b45c$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $e01829d60cf3b45c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e01829d60cf3b45c$var$second = (0, $e01829d60cf3b45c$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationSecond);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e01829d60cf3b45c$var$_default = $e01829d60cf3b45c$var$second;
module.exports.default = $e01829d60cf3b45c$var$_default;
var $e01829d60cf3b45c$var$seconds = $e01829d60cf3b45c$var$second.range;
module.exports.seconds = $e01829d60cf3b45c$var$seconds;

});
parcelRegister("eX1Lo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $ae27f18f92bd2054$var$durationSecond = 1000;
module.exports.durationSecond = $ae27f18f92bd2054$var$durationSecond;
const $ae27f18f92bd2054$var$durationMinute = $ae27f18f92bd2054$var$durationSecond * 60;
module.exports.durationMinute = $ae27f18f92bd2054$var$durationMinute;
const $ae27f18f92bd2054$var$durationHour = $ae27f18f92bd2054$var$durationMinute * 60;
module.exports.durationHour = $ae27f18f92bd2054$var$durationHour;
const $ae27f18f92bd2054$var$durationDay = $ae27f18f92bd2054$var$durationHour * 24;
module.exports.durationDay = $ae27f18f92bd2054$var$durationDay;
const $ae27f18f92bd2054$var$durationWeek = $ae27f18f92bd2054$var$durationDay * 7;
module.exports.durationWeek = $ae27f18f92bd2054$var$durationWeek;
const $ae27f18f92bd2054$var$durationMonth = $ae27f18f92bd2054$var$durationDay * 30;
module.exports.durationMonth = $ae27f18f92bd2054$var$durationMonth;
const $ae27f18f92bd2054$var$durationYear = $ae27f18f92bd2054$var$durationDay * 365;
module.exports.durationYear = $ae27f18f92bd2054$var$durationYear;

});


parcelRegister("kQUOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $f2e4bcfb5452915b$var$_interval = $f2e4bcfb5452915b$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $f2e4bcfb5452915b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f2e4bcfb5452915b$var$minute = (0, $f2e4bcfb5452915b$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eX1Lo.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationMinute);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $f2e4bcfb5452915b$var$_default = $f2e4bcfb5452915b$var$minute;
module.exports.default = $f2e4bcfb5452915b$var$_default;
var $f2e4bcfb5452915b$var$minutes = $f2e4bcfb5452915b$var$minute.range;
module.exports.minutes = $f2e4bcfb5452915b$var$minutes;

});

parcelRegister("6xt90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $4c2c6e9859205f83$var$_interval = $4c2c6e9859205f83$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $4c2c6e9859205f83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c2c6e9859205f83$var$hour = (0, $4c2c6e9859205f83$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $eX1Lo.durationSecond - date.getMinutes() * $eX1Lo.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationHour);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationHour;
}, function(date) {
    return date.getHours();
});
var $4c2c6e9859205f83$var$_default = $4c2c6e9859205f83$var$hour;
module.exports.default = $4c2c6e9859205f83$var$_default;
var $4c2c6e9859205f83$var$hours = $4c2c6e9859205f83$var$hour.range;
module.exports.hours = $4c2c6e9859205f83$var$hours;

});

parcelRegister("iEyEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $d946d89e1c77f855$var$_interval = $d946d89e1c77f855$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $d946d89e1c77f855$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d946d89e1c77f855$var$day = (0, $d946d89e1c77f855$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eX1Lo.durationMinute) / $eX1Lo.durationDay, (date)=>date.getDate() - 1);
var $d946d89e1c77f855$var$_default = $d946d89e1c77f855$var$day;
module.exports.default = $d946d89e1c77f855$var$_default;
var $d946d89e1c77f855$var$days = $d946d89e1c77f855$var$day.range;
module.exports.days = $d946d89e1c77f855$var$days;

});

parcelRegister("ah8ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $77b1d41ad42b9c2e$var$_interval = $77b1d41ad42b9c2e$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $77b1d41ad42b9c2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $77b1d41ad42b9c2e$var$weekday(i) {
    return (0, $77b1d41ad42b9c2e$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $eX1Lo.durationMinute) / $eX1Lo.durationWeek;
    });
}
var $77b1d41ad42b9c2e$var$sunday = $77b1d41ad42b9c2e$var$weekday(0);
module.exports.sunday = $77b1d41ad42b9c2e$var$sunday;
var $77b1d41ad42b9c2e$var$monday = $77b1d41ad42b9c2e$var$weekday(1);
module.exports.monday = $77b1d41ad42b9c2e$var$monday;
var $77b1d41ad42b9c2e$var$tuesday = $77b1d41ad42b9c2e$var$weekday(2);
module.exports.tuesday = $77b1d41ad42b9c2e$var$tuesday;
var $77b1d41ad42b9c2e$var$wednesday = $77b1d41ad42b9c2e$var$weekday(3);
module.exports.wednesday = $77b1d41ad42b9c2e$var$wednesday;
var $77b1d41ad42b9c2e$var$thursday = $77b1d41ad42b9c2e$var$weekday(4);
module.exports.thursday = $77b1d41ad42b9c2e$var$thursday;
var $77b1d41ad42b9c2e$var$friday = $77b1d41ad42b9c2e$var$weekday(5);
module.exports.friday = $77b1d41ad42b9c2e$var$friday;
var $77b1d41ad42b9c2e$var$saturday = $77b1d41ad42b9c2e$var$weekday(6);
module.exports.saturday = $77b1d41ad42b9c2e$var$saturday;
var $77b1d41ad42b9c2e$var$sundays = $77b1d41ad42b9c2e$var$sunday.range;
module.exports.sundays = $77b1d41ad42b9c2e$var$sundays;
var $77b1d41ad42b9c2e$var$mondays = $77b1d41ad42b9c2e$var$monday.range;
module.exports.mondays = $77b1d41ad42b9c2e$var$mondays;
var $77b1d41ad42b9c2e$var$tuesdays = $77b1d41ad42b9c2e$var$tuesday.range;
module.exports.tuesdays = $77b1d41ad42b9c2e$var$tuesdays;
var $77b1d41ad42b9c2e$var$wednesdays = $77b1d41ad42b9c2e$var$wednesday.range;
module.exports.wednesdays = $77b1d41ad42b9c2e$var$wednesdays;
var $77b1d41ad42b9c2e$var$thursdays = $77b1d41ad42b9c2e$var$thursday.range;
module.exports.thursdays = $77b1d41ad42b9c2e$var$thursdays;
var $77b1d41ad42b9c2e$var$fridays = $77b1d41ad42b9c2e$var$friday.range;
module.exports.fridays = $77b1d41ad42b9c2e$var$fridays;
var $77b1d41ad42b9c2e$var$saturdays = $77b1d41ad42b9c2e$var$saturday.range;
module.exports.saturdays = $77b1d41ad42b9c2e$var$saturdays;

});

parcelRegister("b5xm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $812a08bcacbfff65$var$_interval = $812a08bcacbfff65$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $812a08bcacbfff65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $812a08bcacbfff65$var$month = (0, $812a08bcacbfff65$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $812a08bcacbfff65$var$_default = $812a08bcacbfff65$var$month;
module.exports.default = $812a08bcacbfff65$var$_default;
var $812a08bcacbfff65$var$months = $812a08bcacbfff65$var$month.range;
module.exports.months = $812a08bcacbfff65$var$months;

});

parcelRegister("hrPSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $cb3d32e37fc2d75c$var$_interval = $cb3d32e37fc2d75c$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $cb3d32e37fc2d75c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cb3d32e37fc2d75c$var$year = (0, $cb3d32e37fc2d75c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$cb3d32e37fc2d75c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cb3d32e37fc2d75c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $cb3d32e37fc2d75c$var$_default = $cb3d32e37fc2d75c$var$year;
module.exports.default = $cb3d32e37fc2d75c$var$_default;
var $cb3d32e37fc2d75c$var$years = $cb3d32e37fc2d75c$var$year.range;
module.exports.years = $cb3d32e37fc2d75c$var$years;

});

parcelRegister("d9Trb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $99471e540da24c53$var$_interval = $99471e540da24c53$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $99471e540da24c53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $99471e540da24c53$var$utcMinute = (0, $99471e540da24c53$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationMinute);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $99471e540da24c53$var$_default = $99471e540da24c53$var$utcMinute;
module.exports.default = $99471e540da24c53$var$_default;
var $99471e540da24c53$var$utcMinutes = $99471e540da24c53$var$utcMinute.range;
module.exports.utcMinutes = $99471e540da24c53$var$utcMinutes;

});

parcelRegister("6XsZh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $510ebd0d7d95ad5a$var$_interval = $510ebd0d7d95ad5a$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $510ebd0d7d95ad5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $510ebd0d7d95ad5a$var$utcHour = (0, $510ebd0d7d95ad5a$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $eX1Lo.durationHour);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $510ebd0d7d95ad5a$var$_default = $510ebd0d7d95ad5a$var$utcHour;
module.exports.default = $510ebd0d7d95ad5a$var$_default;
var $510ebd0d7d95ad5a$var$utcHours = $510ebd0d7d95ad5a$var$utcHour.range;
module.exports.utcHours = $510ebd0d7d95ad5a$var$utcHours;

});

parcelRegister("8vTWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $632c9c9a11501eaf$var$_interval = $632c9c9a11501eaf$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $632c9c9a11501eaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $632c9c9a11501eaf$var$utcDay = (0, $632c9c9a11501eaf$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $eX1Lo.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $632c9c9a11501eaf$var$_default = $632c9c9a11501eaf$var$utcDay;
module.exports.default = $632c9c9a11501eaf$var$_default;
var $632c9c9a11501eaf$var$utcDays = $632c9c9a11501eaf$var$utcDay.range;
module.exports.utcDays = $632c9c9a11501eaf$var$utcDays;

});

parcelRegister("k4peM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $e9c7c1fdf84a26e0$var$_interval = $e9c7c1fdf84a26e0$var$_interopRequireDefault((parcelRequire("5UfBb")));

var $eX1Lo = parcelRequire("eX1Lo");
function $e9c7c1fdf84a26e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9c7c1fdf84a26e0$var$utcWeekday(i) {
    return (0, $e9c7c1fdf84a26e0$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $eX1Lo.durationWeek;
    });
}
var $e9c7c1fdf84a26e0$var$utcSunday = $e9c7c1fdf84a26e0$var$utcWeekday(0);
module.exports.utcSunday = $e9c7c1fdf84a26e0$var$utcSunday;
var $e9c7c1fdf84a26e0$var$utcMonday = $e9c7c1fdf84a26e0$var$utcWeekday(1);
module.exports.utcMonday = $e9c7c1fdf84a26e0$var$utcMonday;
var $e9c7c1fdf84a26e0$var$utcTuesday = $e9c7c1fdf84a26e0$var$utcWeekday(2);
module.exports.utcTuesday = $e9c7c1fdf84a26e0$var$utcTuesday;
var $e9c7c1fdf84a26e0$var$utcWednesday = $e9c7c1fdf84a26e0$var$utcWeekday(3);
module.exports.utcWednesday = $e9c7c1fdf84a26e0$var$utcWednesday;
var $e9c7c1fdf84a26e0$var$utcThursday = $e9c7c1fdf84a26e0$var$utcWeekday(4);
module.exports.utcThursday = $e9c7c1fdf84a26e0$var$utcThursday;
var $e9c7c1fdf84a26e0$var$utcFriday = $e9c7c1fdf84a26e0$var$utcWeekday(5);
module.exports.utcFriday = $e9c7c1fdf84a26e0$var$utcFriday;
var $e9c7c1fdf84a26e0$var$utcSaturday = $e9c7c1fdf84a26e0$var$utcWeekday(6);
module.exports.utcSaturday = $e9c7c1fdf84a26e0$var$utcSaturday;
var $e9c7c1fdf84a26e0$var$utcSundays = $e9c7c1fdf84a26e0$var$utcSunday.range;
module.exports.utcSundays = $e9c7c1fdf84a26e0$var$utcSundays;
var $e9c7c1fdf84a26e0$var$utcMondays = $e9c7c1fdf84a26e0$var$utcMonday.range;
module.exports.utcMondays = $e9c7c1fdf84a26e0$var$utcMondays;
var $e9c7c1fdf84a26e0$var$utcTuesdays = $e9c7c1fdf84a26e0$var$utcTuesday.range;
module.exports.utcTuesdays = $e9c7c1fdf84a26e0$var$utcTuesdays;
var $e9c7c1fdf84a26e0$var$utcWednesdays = $e9c7c1fdf84a26e0$var$utcWednesday.range;
module.exports.utcWednesdays = $e9c7c1fdf84a26e0$var$utcWednesdays;
var $e9c7c1fdf84a26e0$var$utcThursdays = $e9c7c1fdf84a26e0$var$utcThursday.range;
module.exports.utcThursdays = $e9c7c1fdf84a26e0$var$utcThursdays;
var $e9c7c1fdf84a26e0$var$utcFridays = $e9c7c1fdf84a26e0$var$utcFriday.range;
module.exports.utcFridays = $e9c7c1fdf84a26e0$var$utcFridays;
var $e9c7c1fdf84a26e0$var$utcSaturdays = $e9c7c1fdf84a26e0$var$utcSaturday.range;
module.exports.utcSaturdays = $e9c7c1fdf84a26e0$var$utcSaturdays;

});

parcelRegister("lhWn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $f7f876d9c48e45cf$var$_interval = $f7f876d9c48e45cf$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $f7f876d9c48e45cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f7f876d9c48e45cf$var$utcMonth = (0, $f7f876d9c48e45cf$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $f7f876d9c48e45cf$var$_default = $f7f876d9c48e45cf$var$utcMonth;
module.exports.default = $f7f876d9c48e45cf$var$_default;
var $f7f876d9c48e45cf$var$utcMonths = $f7f876d9c48e45cf$var$utcMonth.range;
module.exports.utcMonths = $f7f876d9c48e45cf$var$utcMonths;

});

parcelRegister("4w90J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $34a123f17451a027$var$_interval = $34a123f17451a027$var$_interopRequireDefault((parcelRequire("5UfBb")));
function $34a123f17451a027$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34a123f17451a027$var$utcYear = (0, $34a123f17451a027$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$34a123f17451a027$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $34a123f17451a027$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $34a123f17451a027$var$_default = $34a123f17451a027$var$utcYear;
module.exports.default = $34a123f17451a027$var$_default;
var $34a123f17451a027$var$utcYears = $34a123f17451a027$var$utcYear.range;
module.exports.utcYears = $34a123f17451a027$var$utcYears;

});

parcelRegister("tUMUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $4GZnA = parcelRequire("4GZnA");

var $eX1Lo = parcelRequire("eX1Lo");

var $059ec26ca7291d3f$var$_millisecond = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("cK28E")));

var $059ec26ca7291d3f$var$_second = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("jeQEd")));

var $059ec26ca7291d3f$var$_minute = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("kQUOO")));

var $059ec26ca7291d3f$var$_hour = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("6xt90")));

var $059ec26ca7291d3f$var$_day = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("iEyEO")));

var $ah8ax = parcelRequire("ah8ax");

var $059ec26ca7291d3f$var$_month = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("b5xm0")));

var $059ec26ca7291d3f$var$_year = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("hrPSp")));

var $059ec26ca7291d3f$var$_utcMinute = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("d9Trb")));

var $059ec26ca7291d3f$var$_utcHour = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("6XsZh")));

var $059ec26ca7291d3f$var$_utcDay = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("8vTWn")));

var $k4peM = parcelRequire("k4peM");

var $059ec26ca7291d3f$var$_utcMonth = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("lhWn5")));

var $059ec26ca7291d3f$var$_utcYear = $059ec26ca7291d3f$var$_interopRequireDefault((parcelRequire("4w90J")));
function $059ec26ca7291d3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $059ec26ca7291d3f$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $059ec26ca7291d3f$var$_second.default,
            1,
            $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            5,
            5 * $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            15,
            15 * $eX1Lo.durationSecond
        ],
        [
            $059ec26ca7291d3f$var$_second.default,
            30,
            30 * $eX1Lo.durationSecond
        ],
        [
            minute,
            1,
            $eX1Lo.durationMinute
        ],
        [
            minute,
            5,
            5 * $eX1Lo.durationMinute
        ],
        [
            minute,
            15,
            15 * $eX1Lo.durationMinute
        ],
        [
            minute,
            30,
            30 * $eX1Lo.durationMinute
        ],
        [
            hour,
            1,
            $eX1Lo.durationHour
        ],
        [
            hour,
            3,
            3 * $eX1Lo.durationHour
        ],
        [
            hour,
            6,
            6 * $eX1Lo.durationHour
        ],
        [
            hour,
            12,
            12 * $eX1Lo.durationHour
        ],
        [
            day,
            1,
            $eX1Lo.durationDay
        ],
        [
            day,
            2,
            2 * $eX1Lo.durationDay
        ],
        [
            week,
            1,
            $eX1Lo.durationWeek
        ],
        [
            month,
            1,
            $eX1Lo.durationMonth
        ],
        [
            month,
            3,
            3 * $eX1Lo.durationMonth
        ],
        [
            year,
            1,
            $eX1Lo.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $4GZnA.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $4GZnA.tickStep)(start / $eX1Lo.durationYear, stop / $eX1Lo.durationYear, count));
        if (i === 0) return $059ec26ca7291d3f$var$_millisecond.default.every(Math.max((0, $4GZnA.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$059ec26ca7291d3f$var$utcTicks, $059ec26ca7291d3f$var$utcTickInterval] = $059ec26ca7291d3f$var$ticker($059ec26ca7291d3f$var$_utcYear.default, $059ec26ca7291d3f$var$_utcMonth.default, $k4peM.utcSunday, $059ec26ca7291d3f$var$_utcDay.default, $059ec26ca7291d3f$var$_utcHour.default, $059ec26ca7291d3f$var$_utcMinute.default);
module.exports.utcTickInterval = $059ec26ca7291d3f$var$utcTickInterval;
module.exports.utcTicks = $059ec26ca7291d3f$var$utcTicks;
const [$059ec26ca7291d3f$var$timeTicks, $059ec26ca7291d3f$var$timeTickInterval] = $059ec26ca7291d3f$var$ticker($059ec26ca7291d3f$var$_year.default, $059ec26ca7291d3f$var$_month.default, $ah8ax.sunday, $059ec26ca7291d3f$var$_day.default, $059ec26ca7291d3f$var$_hour.default, $059ec26ca7291d3f$var$_minute.default);
module.exports.timeTickInterval = $059ec26ca7291d3f$var$timeTickInterval;
module.exports.timeTicks = $059ec26ca7291d3f$var$timeTicks;

});


parcelRegister("2ew5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $1a05c914172ea909$var$_defaultLocale.utcParse;
    }
});

var $1a05c914172ea909$var$_defaultLocale = $1a05c914172ea909$var$_interopRequireWildcard((parcelRequire("fpsX8")));

var $1a05c914172ea909$var$_locale = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("5OdpA")));

var $1a05c914172ea909$var$_isoFormat = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("1b1Mb")));

var $1a05c914172ea909$var$_isoParse = $1a05c914172ea909$var$_interopRequireDefault((parcelRequire("b6iYw")));
function $1a05c914172ea909$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a05c914172ea909$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1a05c914172ea909$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1a05c914172ea909$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1a05c914172ea909$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("fpsX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b37fa63933b96409$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $b37fa63933b96409$var$_locale = $b37fa63933b96409$var$_interopRequireDefault((parcelRequire("5OdpA")));
function $b37fa63933b96409$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b37fa63933b96409$var$locale;
var $b37fa63933b96409$var$timeFormat;
module.exports.timeFormat = $b37fa63933b96409$var$timeFormat;
var $b37fa63933b96409$var$timeParse;
module.exports.timeParse = $b37fa63933b96409$var$timeParse;
var $b37fa63933b96409$var$utcFormat;
module.exports.utcFormat = $b37fa63933b96409$var$utcFormat;
var $b37fa63933b96409$var$utcParse;
module.exports.utcParse = $b37fa63933b96409$var$utcParse;
$b37fa63933b96409$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $b37fa63933b96409$var$defaultLocale(definition) {
    $b37fa63933b96409$var$locale = (0, $b37fa63933b96409$var$_locale.default)(definition);
    module.exports.timeFormat = $b37fa63933b96409$var$timeFormat = $b37fa63933b96409$var$locale.format;
    module.exports.timeParse = $b37fa63933b96409$var$timeParse = $b37fa63933b96409$var$locale.parse;
    module.exports.utcFormat = $b37fa63933b96409$var$utcFormat = $b37fa63933b96409$var$locale.utcFormat;
    module.exports.utcParse = $b37fa63933b96409$var$utcParse = $b37fa63933b96409$var$locale.utcParse;
    return $b37fa63933b96409$var$locale;
}

});
parcelRegister("5OdpA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $43ac068a3cc4c089$var$formatLocale;

var $5hUYw = parcelRequire("5hUYw");
function $43ac068a3cc4c089$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $43ac068a3cc4c089$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $43ac068a3cc4c089$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $43ac068a3cc4c089$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $43ac068a3cc4c089$var$formatRe(locale_periods), periodLookup = $43ac068a3cc4c089$var$formatLookup(locale_periods), weekdayRe = $43ac068a3cc4c089$var$formatRe(locale_weekdays), weekdayLookup = $43ac068a3cc4c089$var$formatLookup(locale_weekdays), shortWeekdayRe = $43ac068a3cc4c089$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $43ac068a3cc4c089$var$formatLookup(locale_shortWeekdays), monthRe = $43ac068a3cc4c089$var$formatRe(locale_months), monthLookup = $43ac068a3cc4c089$var$formatLookup(locale_months), shortMonthRe = $43ac068a3cc4c089$var$formatRe(locale_shortMonths), shortMonthLookup = $43ac068a3cc4c089$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $43ac068a3cc4c089$var$formatDayOfMonth,
        "e": $43ac068a3cc4c089$var$formatDayOfMonth,
        "f": $43ac068a3cc4c089$var$formatMicroseconds,
        "g": $43ac068a3cc4c089$var$formatYearISO,
        "G": $43ac068a3cc4c089$var$formatFullYearISO,
        "H": $43ac068a3cc4c089$var$formatHour24,
        "I": $43ac068a3cc4c089$var$formatHour12,
        "j": $43ac068a3cc4c089$var$formatDayOfYear,
        "L": $43ac068a3cc4c089$var$formatMilliseconds,
        "m": $43ac068a3cc4c089$var$formatMonthNumber,
        "M": $43ac068a3cc4c089$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $43ac068a3cc4c089$var$formatUnixTimestamp,
        "s": $43ac068a3cc4c089$var$formatUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$formatSeconds,
        "u": $43ac068a3cc4c089$var$formatWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$formatWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$formatWeekNumberISO,
        "w": $43ac068a3cc4c089$var$formatWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $43ac068a3cc4c089$var$formatYear,
        "Y": $43ac068a3cc4c089$var$formatFullYear,
        "Z": $43ac068a3cc4c089$var$formatZone,
        "%": $43ac068a3cc4c089$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $43ac068a3cc4c089$var$formatUTCDayOfMonth,
        "e": $43ac068a3cc4c089$var$formatUTCDayOfMonth,
        "f": $43ac068a3cc4c089$var$formatUTCMicroseconds,
        "g": $43ac068a3cc4c089$var$formatUTCYearISO,
        "G": $43ac068a3cc4c089$var$formatUTCFullYearISO,
        "H": $43ac068a3cc4c089$var$formatUTCHour24,
        "I": $43ac068a3cc4c089$var$formatUTCHour12,
        "j": $43ac068a3cc4c089$var$formatUTCDayOfYear,
        "L": $43ac068a3cc4c089$var$formatUTCMilliseconds,
        "m": $43ac068a3cc4c089$var$formatUTCMonthNumber,
        "M": $43ac068a3cc4c089$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $43ac068a3cc4c089$var$formatUnixTimestamp,
        "s": $43ac068a3cc4c089$var$formatUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$formatUTCSeconds,
        "u": $43ac068a3cc4c089$var$formatUTCWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$formatUTCWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$formatUTCWeekNumberISO,
        "w": $43ac068a3cc4c089$var$formatUTCWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $43ac068a3cc4c089$var$formatUTCYear,
        "Y": $43ac068a3cc4c089$var$formatUTCFullYear,
        "Z": $43ac068a3cc4c089$var$formatUTCZone,
        "%": $43ac068a3cc4c089$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $43ac068a3cc4c089$var$parseDayOfMonth,
        "e": $43ac068a3cc4c089$var$parseDayOfMonth,
        "f": $43ac068a3cc4c089$var$parseMicroseconds,
        "g": $43ac068a3cc4c089$var$parseYear,
        "G": $43ac068a3cc4c089$var$parseFullYear,
        "H": $43ac068a3cc4c089$var$parseHour24,
        "I": $43ac068a3cc4c089$var$parseHour24,
        "j": $43ac068a3cc4c089$var$parseDayOfYear,
        "L": $43ac068a3cc4c089$var$parseMilliseconds,
        "m": $43ac068a3cc4c089$var$parseMonthNumber,
        "M": $43ac068a3cc4c089$var$parseMinutes,
        "p": parsePeriod,
        "q": $43ac068a3cc4c089$var$parseQuarter,
        "Q": $43ac068a3cc4c089$var$parseUnixTimestamp,
        "s": $43ac068a3cc4c089$var$parseUnixTimestampSeconds,
        "S": $43ac068a3cc4c089$var$parseSeconds,
        "u": $43ac068a3cc4c089$var$parseWeekdayNumberMonday,
        "U": $43ac068a3cc4c089$var$parseWeekNumberSunday,
        "V": $43ac068a3cc4c089$var$parseWeekNumberISO,
        "w": $43ac068a3cc4c089$var$parseWeekdayNumberSunday,
        "W": $43ac068a3cc4c089$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $43ac068a3cc4c089$var$parseYear,
        "Y": $43ac068a3cc4c089$var$parseFullYear,
        "Z": $43ac068a3cc4c089$var$parseZone,
        "%": $43ac068a3cc4c089$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $43ac068a3cc4c089$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $43ac068a3cc4c089$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $43ac068a3cc4c089$var$utcDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $5hUYw.utcMonday.ceil(week) : (0, $5hUYw.utcMonday)(week);
                    week = $5hUYw.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $43ac068a3cc4c089$var$localDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $5hUYw.timeMonday.ceil(week) : (0, $5hUYw.timeMonday)(week);
                    week = $5hUYw.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $43ac068a3cc4c089$var$utcDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)).getUTCDay() : $43ac068a3cc4c089$var$localDate($43ac068a3cc4c089$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $43ac068a3cc4c089$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $43ac068a3cc4c089$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $43ac068a3cc4c089$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $43ac068a3cc4c089$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $43ac068a3cc4c089$var$numberRe = /^\s*\d+/, // note: ignores next directive
$43ac068a3cc4c089$var$percentRe = /^%/, $43ac068a3cc4c089$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $43ac068a3cc4c089$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $43ac068a3cc4c089$var$requote(s) {
    return s.replace($43ac068a3cc4c089$var$requoteRe, "\\$&");
}
function $43ac068a3cc4c089$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($43ac068a3cc4c089$var$requote).join("|") + ")", "i");
}
function $43ac068a3cc4c089$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $43ac068a3cc4c089$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberSunday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberISO(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseWeekNumberMonday(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseFullYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseQuarter(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMonthNumber(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseDayOfMonth(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseDayOfYear(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseHour24(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMinutes(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseSeconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMilliseconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseMicroseconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseLiteralPercent(d, string, i) {
    var n = $43ac068a3cc4c089$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $43ac068a3cc4c089$var$parseUnixTimestamp(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $43ac068a3cc4c089$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $43ac068a3cc4c089$var$formatDayOfMonth(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getDate(), p, 2);
}
function $43ac068a3cc4c089$var$formatHour24(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getHours(), p, 2);
}
function $43ac068a3cc4c089$var$formatHour12(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $43ac068a3cc4c089$var$formatDayOfYear(d, p) {
    return $43ac068a3cc4c089$var$pad(1 + $5hUYw.timeDay.count((0, $5hUYw.timeYear)(d), d), p, 3);
}
function $43ac068a3cc4c089$var$formatMilliseconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMilliseconds(), p, 3);
}
function $43ac068a3cc4c089$var$formatMicroseconds(d, p) {
    return $43ac068a3cc4c089$var$formatMilliseconds(d, p) + "000";
}
function $43ac068a3cc4c089$var$formatMonthNumber(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMonth() + 1, p, 2);
}
function $43ac068a3cc4c089$var$formatMinutes(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getMinutes(), p, 2);
}
function $43ac068a3cc4c089$var$formatSeconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getSeconds(), p, 2);
}
function $43ac068a3cc4c089$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $43ac068a3cc4c089$var$formatWeekNumberSunday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.timeSunday.count((0, $5hUYw.timeYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $5hUYw.timeThursday)(d) : $5hUYw.timeThursday.ceil(d);
}
function $43ac068a3cc4c089$var$formatWeekNumberISO(d, p) {
    d = $43ac068a3cc4c089$var$dISO(d);
    return $43ac068a3cc4c089$var$pad($5hUYw.timeThursday.count((0, $5hUYw.timeYear)(d), d) + ((0, $5hUYw.timeYear)(d).getDay() === 4), p, 2);
}
function $43ac068a3cc4c089$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $43ac068a3cc4c089$var$formatWeekNumberMonday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.timeMonday.count((0, $5hUYw.timeYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$formatYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatYearISO(d, p) {
    d = $43ac068a3cc4c089$var$dISO(d);
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatFullYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $5hUYw.timeThursday)(d) : $5hUYw.timeThursday.ceil(d);
    return $43ac068a3cc4c089$var$pad(d.getFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $43ac068a3cc4c089$var$pad(z / 60 | 0, "0", 2) + $43ac068a3cc4c089$var$pad(z % 60, "0", 2);
}
function $43ac068a3cc4c089$var$formatUTCDayOfMonth(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCDate(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCHour24(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCHours(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCHour12(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCDayOfYear(d, p) {
    return $43ac068a3cc4c089$var$pad(1 + $5hUYw.utcDay.count((0, $5hUYw.utcYear)(d), d), p, 3);
}
function $43ac068a3cc4c089$var$formatUTCMilliseconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $43ac068a3cc4c089$var$formatUTCMicroseconds(d, p) {
    return $43ac068a3cc4c089$var$formatUTCMilliseconds(d, p) + "000";
}
function $43ac068a3cc4c089$var$formatUTCMonthNumber(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCMinutes(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCMinutes(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCSeconds(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCSeconds(), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberSunday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.utcSunday.count((0, $5hUYw.utcYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $5hUYw.utcThursday)(d) : $5hUYw.utcThursday.ceil(d);
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberISO(d, p) {
    d = $43ac068a3cc4c089$var$UTCdISO(d);
    return $43ac068a3cc4c089$var$pad($5hUYw.utcThursday.count((0, $5hUYw.utcYear)(d), d) + ((0, $5hUYw.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $43ac068a3cc4c089$var$formatUTCWeekNumberMonday(d, p) {
    return $43ac068a3cc4c089$var$pad($5hUYw.utcMonday.count((0, $5hUYw.utcYear)(d) - 1, d), p, 2);
}
function $43ac068a3cc4c089$var$formatUTCYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCYearISO(d, p) {
    d = $43ac068a3cc4c089$var$UTCdISO(d);
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $43ac068a3cc4c089$var$formatUTCFullYear(d, p) {
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $5hUYw.utcThursday)(d) : $5hUYw.utcThursday.ceil(d);
    return $43ac068a3cc4c089$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $43ac068a3cc4c089$var$formatUTCZone() {
    return "+0000";
}
function $43ac068a3cc4c089$var$formatLiteralPercent() {
    return "%";
}
function $43ac068a3cc4c089$var$formatUnixTimestamp(d) {
    return +d;
}
function $43ac068a3cc4c089$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("1b1Mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $fpsX8 = parcelRequire("fpsX8");
var $0db8323d2d47ca89$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $0db8323d2d47ca89$var$isoSpecifier;
function $0db8323d2d47ca89$var$formatIsoNative(date) {
    return date.toISOString();
}
var $0db8323d2d47ca89$var$formatIso = Date.prototype.toISOString ? $0db8323d2d47ca89$var$formatIsoNative : (0, $fpsX8.utcFormat)($0db8323d2d47ca89$var$isoSpecifier);
var $0db8323d2d47ca89$var$_default = $0db8323d2d47ca89$var$formatIso;
module.exports.default = $0db8323d2d47ca89$var$_default;

});

parcelRegister("b6iYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b1Mb = parcelRequire("1b1Mb");

var $fpsX8 = parcelRequire("fpsX8");
function $814ef9521af54613$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $814ef9521af54613$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $814ef9521af54613$var$parseIsoNative : (0, $fpsX8.utcParse)($1b1Mb.isoSpecifier);
var $814ef9521af54613$var$_default = $814ef9521af54613$var$parseIso;
module.exports.default = $814ef9521af54613$var$_default;

});



parcelRegister("7owcD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5623c11cad01957e$var$utcTime;

var $5hUYw = parcelRequire("5hUYw");

var $2ew5Z = parcelRequire("2ew5Z");

var $liuou = parcelRequire("liuou");

var $2ynOw = parcelRequire("2ynOw");
function $5623c11cad01957e$var$utcTime() {
    return $2ynOw.initRange.apply((0, $liuou.calendar)($5hUYw.utcTicks, $5hUYw.utcTickInterval, $5hUYw.utcYear, $5hUYw.utcMonth, $5hUYw.utcWeek, $5hUYw.utcDay, $5hUYw.utcHour, $5hUYw.utcMinute, $5hUYw.utcSecond, $2ew5Z.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("eI3Nr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $ab581ea304ac323d$var$copy;
module.exports.default = $ab581ea304ac323d$var$sequential;
module.exports.sequentialLog = $ab581ea304ac323d$var$sequentialLog;
module.exports.sequentialPow = $ab581ea304ac323d$var$sequentialPow;
module.exports.sequentialSqrt = $ab581ea304ac323d$var$sequentialSqrt;
module.exports.sequentialSymlog = $ab581ea304ac323d$var$sequentialSymlog;

var $bz0rV = parcelRequire("bz0rV");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $flmZz = parcelRequire("flmZz");

var $ag3bX = parcelRequire("ag3bX");

var $hGubV = parcelRequire("hGubV");
function $ab581ea304ac323d$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $3biM0.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($bz0rV.interpolate);
    scale.rangeRound = range($bz0rV.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $ab581ea304ac323d$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $ab581ea304ac323d$var$sequential() {
    var scale = (0, $4FaxR.linearish)($ab581ea304ac323d$var$transformer()($3biM0.identity));
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequential());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialLog() {
    var scale = (0, $flmZz.loggish)($ab581ea304ac323d$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialLog()).base(scale.base());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialSymlog() {
    var scale = (0, $ag3bX.symlogish)($ab581ea304ac323d$var$transformer());
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialSymlog()).constant(scale.constant());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialPow() {
    var scale = (0, $hGubV.powish)($ab581ea304ac323d$var$transformer());
    scale.copy = function() {
        return $ab581ea304ac323d$var$copy(scale, $ab581ea304ac323d$var$sequentialPow()).exponent(scale.exponent());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $ab581ea304ac323d$var$sequentialSqrt() {
    return $ab581ea304ac323d$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("het6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8ba525192978e45$var$sequentialQuantile;

var $4GZnA = parcelRequire("4GZnA");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");
function $c8ba525192978e45$var$sequentialQuantile() {
    var domain = [], interpolator = $3biM0.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $4GZnA.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($4GZnA.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $4GZnA.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $c8ba525192978e45$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("3tpu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2877d8e7670f63da$var$diverging;
module.exports.divergingLog = $2877d8e7670f63da$var$divergingLog;
module.exports.divergingPow = $2877d8e7670f63da$var$divergingPow;
module.exports.divergingSqrt = $2877d8e7670f63da$var$divergingSqrt;
module.exports.divergingSymlog = $2877d8e7670f63da$var$divergingSymlog;

var $bz0rV = parcelRequire("bz0rV");

var $3biM0 = parcelRequire("3biM0");

var $2ynOw = parcelRequire("2ynOw");

var $4FaxR = parcelRequire("4FaxR");

var $flmZz = parcelRequire("flmZz");

var $eI3Nr = parcelRequire("eI3Nr");

var $ag3bX = parcelRequire("ag3bX");

var $hGubV = parcelRequire("hGubV");
function $2877d8e7670f63da$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $3biM0.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $bz0rV.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($bz0rV.interpolate);
    scale.rangeRound = range($bz0rV.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $2877d8e7670f63da$var$diverging() {
    var scale = (0, $4FaxR.linearish)($2877d8e7670f63da$var$transformer()($3biM0.identity));
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$diverging());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingLog() {
    var scale = (0, $flmZz.loggish)($2877d8e7670f63da$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingLog()).base(scale.base());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingSymlog() {
    var scale = (0, $ag3bX.symlogish)($2877d8e7670f63da$var$transformer());
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingSymlog()).constant(scale.constant());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingPow() {
    var scale = (0, $hGubV.powish)($2877d8e7670f63da$var$transformer());
    scale.copy = function() {
        return (0, $eI3Nr.copy)(scale, $2877d8e7670f63da$var$divergingPow()).exponent(scale.exponent());
    };
    return $2ynOw.initInterpolator.apply(scale, arguments);
}
function $2877d8e7670f63da$var$divergingSqrt() {
    return $2877d8e7670f63da$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("7L7R7", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("6pud6"));

});
parcelRegister("6pud6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $4Yn4E.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $4Yn4E.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $hCVBb.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $hCVBb.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $7YO12.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $7YO12.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $7YO12.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $7YO12.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $4aac8301f976ca8e$var$_symbol.symbolsStroke;
    }
});

var $4aac8301f976ca8e$var$_arc = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kl2vr")));

var $4aac8301f976ca8e$var$_area = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("jGAyt")));

var $4aac8301f976ca8e$var$_line = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("htDHw")));

var $4aac8301f976ca8e$var$_pie = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("c04R4")));

var $4aac8301f976ca8e$var$_areaRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7E7UH")));

var $4aac8301f976ca8e$var$_lineRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("by6KN")));

var $4aac8301f976ca8e$var$_pointRadial = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("aq3nR")));

var $7YO12 = parcelRequire("7YO12");

var $4aac8301f976ca8e$var$_symbol = $4aac8301f976ca8e$var$_interopRequireWildcard((parcelRequire("kasLt")));

var $4aac8301f976ca8e$var$_asterisk = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kiHGx")));

var $4aac8301f976ca8e$var$_circle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("g0D51")));

var $4aac8301f976ca8e$var$_cross = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("hQIus")));

var $4aac8301f976ca8e$var$_diamond = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("bo4UX")));

var $4aac8301f976ca8e$var$_diamond2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fzOQV")));

var $4aac8301f976ca8e$var$_plus = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("khQ6z")));

var $4aac8301f976ca8e$var$_square = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("8sNtG")));

var $4aac8301f976ca8e$var$_square2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("59KED")));

var $4aac8301f976ca8e$var$_star = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7v7Tn")));

var $4aac8301f976ca8e$var$_triangle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("Pah0X")));

var $4aac8301f976ca8e$var$_triangle2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("gCNbI")));

var $4aac8301f976ca8e$var$_wye = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("kIjqz")));

var $4aac8301f976ca8e$var$_x = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("hYg78")));

var $4aac8301f976ca8e$var$_basisClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("ay5fE")));

var $4aac8301f976ca8e$var$_basisOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("jpU7n")));

var $4aac8301f976ca8e$var$_basis = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("80A8B")));

var $4Yn4E = parcelRequire("4Yn4E");

var $4aac8301f976ca8e$var$_bundle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("ghvUH")));

var $4aac8301f976ca8e$var$_cardinalClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fdmsb")));

var $4aac8301f976ca8e$var$_cardinalOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("1GDiO")));

var $4aac8301f976ca8e$var$_cardinal = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("7uyVd")));

var $4aac8301f976ca8e$var$_catmullRomClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("fO1Lc")));

var $4aac8301f976ca8e$var$_catmullRomOpen = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("f5m8h")));

var $4aac8301f976ca8e$var$_catmullRom = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("iA1KK")));

var $4aac8301f976ca8e$var$_linearClosed = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("4MkXx")));

var $4aac8301f976ca8e$var$_linear = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("agyVG")));

var $hCVBb = parcelRequire("hCVBb");

var $4aac8301f976ca8e$var$_natural = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("c3UhF")));

var $4aac8301f976ca8e$var$_step = $4aac8301f976ca8e$var$_interopRequireWildcard((parcelRequire("kfzkQ")));

var $4aac8301f976ca8e$var$_stack = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("g1Flh")));

var $4aac8301f976ca8e$var$_expand = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("arwOB")));

var $4aac8301f976ca8e$var$_diverging = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("1e8r2")));

var $4aac8301f976ca8e$var$_none = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("3lLHy")));

var $4aac8301f976ca8e$var$_silhouette = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("4UXaU")));

var $4aac8301f976ca8e$var$_wiggle = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("dD9Jn")));

var $4aac8301f976ca8e$var$_appearance = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("04gi8")));

var $4aac8301f976ca8e$var$_ascending = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("frzzp")));

var $4aac8301f976ca8e$var$_descending = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("5YYHh")));

var $4aac8301f976ca8e$var$_insideOut = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("zSdMD")));

var $4aac8301f976ca8e$var$_none2 = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("cBi4y")));

var $4aac8301f976ca8e$var$_reverse = $4aac8301f976ca8e$var$_interopRequireDefault((parcelRequire("gCYnW")));
function $4aac8301f976ca8e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4aac8301f976ca8e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4aac8301f976ca8e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4aac8301f976ca8e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4aac8301f976ca8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("kl2vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ece7b67664089e10$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $ece7b67664089e10$var$_constant = $ece7b67664089e10$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $8sqRt = parcelRequire("8sqRt");
function $ece7b67664089e10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ece7b67664089e10$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $ece7b67664089e10$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $ece7b67664089e10$var$arcStartAngle(d) {
    return d.startAngle;
}
function $ece7b67664089e10$var$arcEndAngle(d) {
    return d.endAngle;
}
function $ece7b67664089e10$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $ece7b67664089e10$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $8sqRt.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $ece7b67664089e10$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8sqRt.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8sqRt.sqrt)((0, $8sqRt.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $ece7b67664089e10$var$_default() {
    var innerRadius = $ece7b67664089e10$var$arcInnerRadius, outerRadius = $ece7b67664089e10$var$arcOuterRadius, cornerRadius = (0, $ece7b67664089e10$var$_constant.default)(0), padRadius = null, startAngle = $ece7b67664089e10$var$arcStartAngle, endAngle = $ece7b67664089e10$var$arcEndAngle, padAngle = $ece7b67664089e10$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $8sqRt.halfPi, a1 = endAngle.apply(this, arguments) - $8sqRt.halfPi, da = (0, $8sqRt.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $eHOaT.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $8sqRt.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $8sqRt.tau - $8sqRt.epsilon) {
            context.moveTo(r1 * (0, $8sqRt.cos)(a0), r1 * (0, $8sqRt.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $8sqRt.epsilon) {
                context.moveTo(r0 * (0, $8sqRt.cos)(a1), r0 * (0, $8sqRt.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $8sqRt.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $8sqRt.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8sqRt.min)((0, $8sqRt.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $8sqRt.epsilon) {
                var p0 = (0, $8sqRt.asin)(rp / r0 * (0, $8sqRt.sin)(ap)), p1 = (0, $8sqRt.asin)(rp / r1 * (0, $8sqRt.sin)(ap));
                if ((da0 -= p0 * 2) > $8sqRt.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $8sqRt.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8sqRt.cos)(a01), y01 = r1 * (0, $8sqRt.sin)(a01), x10 = r0 * (0, $8sqRt.cos)(a10), y10 = r0 * (0, $8sqRt.sin)(a10); // Apply rounded corners?
            if (rc > $8sqRt.epsilon) {
                var x11 = r1 * (0, $8sqRt.cos)(a11), y11 = r1 * (0, $8sqRt.sin)(a11), x00 = r0 * (0, $8sqRt.cos)(a00), y00 = r0 * (0, $8sqRt.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $8sqRt.pi && (oc = $ece7b67664089e10$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8sqRt.sin)((0, $8sqRt.acos)((ax * bx + ay * by) / ((0, $8sqRt.sqrt)(ax * ax + ay * ay) * (0, $8sqRt.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8sqRt.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8sqRt.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8sqRt.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $8sqRt.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $8sqRt.epsilon) {
                t0 = $ece7b67664089e10$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $ece7b67664089e10$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8sqRt.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8sqRt.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8sqRt.atan2)(t1.y11, t1.x11), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $8sqRt.epsilon) || !(da0 > $8sqRt.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $8sqRt.epsilon) {
                t0 = $ece7b67664089e10$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $ece7b67664089e10$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8sqRt.atan2)(t0.y01, t0.x01), (0, $8sqRt.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8sqRt.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8sqRt.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8sqRt.atan2)(t1.y11, t1.x11), (0, $8sqRt.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $8sqRt.pi / 2;
        return [
            (0, $8sqRt.cos)(a) * r,
            (0, $8sqRt.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $ece7b67664089e10$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("eHOaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $ab4c00801d0558d1$var$_path.default;
    }
});

var $ab4c00801d0558d1$var$_path = $ab4c00801d0558d1$var$_interopRequireDefault((parcelRequire("2E2TP")));
function $ab4c00801d0558d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2E2TP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $1ed190f6c26c53bc$var$pi = Math.PI, $1ed190f6c26c53bc$var$tau = 2 * $1ed190f6c26c53bc$var$pi, $1ed190f6c26c53bc$var$epsilon = 1e-6, $1ed190f6c26c53bc$var$tauEpsilon = $1ed190f6c26c53bc$var$tau - $1ed190f6c26c53bc$var$epsilon;
function $1ed190f6c26c53bc$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $1ed190f6c26c53bc$var$path() {
    return new $1ed190f6c26c53bc$var$Path();
}
$1ed190f6c26c53bc$var$Path.prototype = $1ed190f6c26c53bc$var$path.prototype = {
    constructor: $1ed190f6c26c53bc$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $1ed190f6c26c53bc$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $1ed190f6c26c53bc$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($1ed190f6c26c53bc$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $1ed190f6c26c53bc$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $1ed190f6c26c53bc$var$epsilon || Math.abs(this._y1 - y0) > $1ed190f6c26c53bc$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $1ed190f6c26c53bc$var$tau + $1ed190f6c26c53bc$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $1ed190f6c26c53bc$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $1ed190f6c26c53bc$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $1ed190f6c26c53bc$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $1ed190f6c26c53bc$var$_default = $1ed190f6c26c53bc$var$path;
module.exports.default = $1ed190f6c26c53bc$var$_default;

});


parcelRegister("1IHDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $140bbed001c70dbe$var$_default;
function $140bbed001c70dbe$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("8sqRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $6285c6685753927d$var$acos;
module.exports.asin = $6285c6685753927d$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $6285c6685753927d$var$abs = Math.abs;
module.exports.abs = $6285c6685753927d$var$abs;
const $6285c6685753927d$var$atan2 = Math.atan2;
module.exports.atan2 = $6285c6685753927d$var$atan2;
const $6285c6685753927d$var$cos = Math.cos;
module.exports.cos = $6285c6685753927d$var$cos;
const $6285c6685753927d$var$max = Math.max;
module.exports.max = $6285c6685753927d$var$max;
const $6285c6685753927d$var$min = Math.min;
module.exports.min = $6285c6685753927d$var$min;
const $6285c6685753927d$var$sin = Math.sin;
module.exports.sin = $6285c6685753927d$var$sin;
const $6285c6685753927d$var$sqrt = Math.sqrt;
module.exports.sqrt = $6285c6685753927d$var$sqrt;
const $6285c6685753927d$var$epsilon = 1e-12;
module.exports.epsilon = $6285c6685753927d$var$epsilon;
const $6285c6685753927d$var$pi = Math.PI;
module.exports.pi = $6285c6685753927d$var$pi;
const $6285c6685753927d$var$halfPi = $6285c6685753927d$var$pi / 2;
module.exports.halfPi = $6285c6685753927d$var$halfPi;
const $6285c6685753927d$var$tau = 2 * $6285c6685753927d$var$pi;
module.exports.tau = $6285c6685753927d$var$tau;
function $6285c6685753927d$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $6285c6685753927d$var$pi : Math.acos(x);
}
function $6285c6685753927d$var$asin(x) {
    return x >= 1 ? $6285c6685753927d$var$halfPi : x <= -1 ? -$6285c6685753927d$var$halfPi : Math.asin(x);
}

});


parcelRegister("jGAyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e54e4b9c9682336a$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $e54e4b9c9682336a$var$_array = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("02pi9")));

var $e54e4b9c9682336a$var$_constant = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $e54e4b9c9682336a$var$_linear = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("agyVG")));

var $e54e4b9c9682336a$var$_line = $e54e4b9c9682336a$var$_interopRequireDefault((parcelRequire("htDHw")));

var $ehs93 = parcelRequire("ehs93");
function $e54e4b9c9682336a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e54e4b9c9682336a$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $e54e4b9c9682336a$var$_constant.default)(true), context = null, curve = $e54e4b9c9682336a$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ehs93.x : (0, $e54e4b9c9682336a$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e54e4b9c9682336a$var$_constant.default)(0) : (0, $e54e4b9c9682336a$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ehs93.y : (0, $e54e4b9c9682336a$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $e54e4b9c9682336a$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $e54e4b9c9682336a$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e54e4b9c9682336a$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("02pi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0073ce7100ec5fea$var$_default;
module.exports.slice = void 0;
var $0073ce7100ec5fea$var$slice = Array.prototype.slice;
module.exports.slice = $0073ce7100ec5fea$var$slice;
function $0073ce7100ec5fea$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("agyVG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $77967e463370f151$var$_default;
function $77967e463370f151$var$Linear(context) {
    this._context = context;
}
$77967e463370f151$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $77967e463370f151$var$_default(context) {
    return new $77967e463370f151$var$Linear(context);
}

});

parcelRegister("htDHw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb93f0e79c8b00d6$var$_default;

var $eHOaT = parcelRequire("eHOaT");

var $cb93f0e79c8b00d6$var$_array = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("02pi9")));

var $cb93f0e79c8b00d6$var$_constant = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $cb93f0e79c8b00d6$var$_linear = $cb93f0e79c8b00d6$var$_interopRequireDefault((parcelRequire("agyVG")));

var $ehs93 = parcelRequire("ehs93");
function $cb93f0e79c8b00d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb93f0e79c8b00d6$var$_default(x, y) {
    var defined = (0, $cb93f0e79c8b00d6$var$_constant.default)(true), context = null, curve = $cb93f0e79c8b00d6$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ehs93.x : (0, $cb93f0e79c8b00d6$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ehs93.y : (0, $cb93f0e79c8b00d6$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $cb93f0e79c8b00d6$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $cb93f0e79c8b00d6$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ehs93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $a6587c38a0b2a0e4$var$x;
module.exports.y = $a6587c38a0b2a0e4$var$y;
function $a6587c38a0b2a0e4$var$x(p) {
    return p[0];
}
function $a6587c38a0b2a0e4$var$y(p) {
    return p[1];
}

});



parcelRegister("c04R4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bc9403dbd6fca96$var$_default;

var $8bc9403dbd6fca96$var$_array = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("02pi9")));

var $8bc9403dbd6fca96$var$_constant = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $8bc9403dbd6fca96$var$_descending = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("ikEF1")));

var $8bc9403dbd6fca96$var$_identity = $8bc9403dbd6fca96$var$_interopRequireDefault((parcelRequire("lsuiq")));

var $8sqRt = parcelRequire("8sqRt");
function $8bc9403dbd6fca96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc9403dbd6fca96$var$_default() {
    var value = $8bc9403dbd6fca96$var$_identity.default, sortValues = $8bc9403dbd6fca96$var$_descending.default, sort = null, startAngle = (0, $8bc9403dbd6fca96$var$_constant.default)(0), endAngle = (0, $8bc9403dbd6fca96$var$_constant.default)($8sqRt.tau), padAngle = (0, $8bc9403dbd6fca96$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $8bc9403dbd6fca96$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($8sqRt.tau, Math.max(-$8sqRt.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $8bc9403dbd6fca96$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("ikEF1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d589a2a10e7fb4e9$var$_default;
function $d589a2a10e7fb4e9$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("lsuiq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9f3b6adb0340953$var$_default;
function $f9f3b6adb0340953$var$_default(d) {
    return d;
}

});


parcelRegister("7E7UH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59126847c663c507$var$_default;

var $59126847c663c507$var$_radial = $59126847c663c507$var$_interopRequireWildcard((parcelRequire("deEsU")));

var $59126847c663c507$var$_area = $59126847c663c507$var$_interopRequireDefault((parcelRequire("jGAyt")));

var $by6KN = parcelRequire("by6KN");
function $59126847c663c507$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59126847c663c507$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59126847c663c507$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59126847c663c507$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59126847c663c507$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $59126847c663c507$var$_default() {
    var a = (0, $59126847c663c507$var$_area.default)().curve($59126847c663c507$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $by6KN.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $by6KN.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $by6KN.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $by6KN.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $59126847c663c507$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("deEsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9a2bf8b690bcc18e$var$curveRadial;

var $9a2bf8b690bcc18e$var$_linear = $9a2bf8b690bcc18e$var$_interopRequireDefault((parcelRequire("agyVG")));
function $9a2bf8b690bcc18e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9a2bf8b690bcc18e$var$curveRadialLinear = $9a2bf8b690bcc18e$var$curveRadial($9a2bf8b690bcc18e$var$_linear.default);
module.exports.curveRadialLinear = $9a2bf8b690bcc18e$var$curveRadialLinear;
function $9a2bf8b690bcc18e$var$Radial(curve) {
    this._curve = curve;
}
$9a2bf8b690bcc18e$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9a2bf8b690bcc18e$var$curveRadial(curve) {
    function radial(context) {
        return new $9a2bf8b690bcc18e$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("by6KN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86881bda33151dda$var$_default;
module.exports.lineRadial = $86881bda33151dda$var$lineRadial;

var $86881bda33151dda$var$_radial = $86881bda33151dda$var$_interopRequireWildcard((parcelRequire("deEsU")));

var $86881bda33151dda$var$_line = $86881bda33151dda$var$_interopRequireDefault((parcelRequire("htDHw")));
function $86881bda33151dda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86881bda33151dda$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($86881bda33151dda$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $86881bda33151dda$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $86881bda33151dda$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $86881bda33151dda$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $86881bda33151dda$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $86881bda33151dda$var$_default() {
    return $86881bda33151dda$var$lineRadial((0, $86881bda33151dda$var$_line.default)().curve($86881bda33151dda$var$_radial.curveRadialLinear));
}

});


parcelRegister("aq3nR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $795ef50988f7751a$var$_default;
function $795ef50988f7751a$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("7YO12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $5cf4ef0fe6d88181$var$link;
module.exports.linkHorizontal = $5cf4ef0fe6d88181$var$linkHorizontal;
module.exports.linkRadial = $5cf4ef0fe6d88181$var$linkRadial;
module.exports.linkVertical = $5cf4ef0fe6d88181$var$linkVertical;

var $eHOaT = parcelRequire("eHOaT");

var $02pi9 = parcelRequire("02pi9");

var $5cf4ef0fe6d88181$var$_constant = $5cf4ef0fe6d88181$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $4Yn4E = parcelRequire("4Yn4E");

var $ehs93 = parcelRequire("ehs93");
function $5cf4ef0fe6d88181$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5cf4ef0fe6d88181$var$linkSource(d) {
    return d.source;
}
function $5cf4ef0fe6d88181$var$linkTarget(d) {
    return d.target;
}
function $5cf4ef0fe6d88181$var$link(curve) {
    let source = $5cf4ef0fe6d88181$var$linkSource;
    let target = $5cf4ef0fe6d88181$var$linkTarget;
    let x = $ehs93.x;
    let y = $ehs93.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $02pi9.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $eHOaT.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5cf4ef0fe6d88181$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5cf4ef0fe6d88181$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $5cf4ef0fe6d88181$var$linkHorizontal() {
    return $5cf4ef0fe6d88181$var$link($4Yn4E.bumpX);
}
function $5cf4ef0fe6d88181$var$linkVertical() {
    return $5cf4ef0fe6d88181$var$link($4Yn4E.bumpY);
}
function $5cf4ef0fe6d88181$var$linkRadial() {
    const l = $5cf4ef0fe6d88181$var$link($4Yn4E.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("4Yn4E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $39eeaa07ef6e11bb$var$bumpRadial;
module.exports.bumpX = $39eeaa07ef6e11bb$var$bumpX;
module.exports.bumpY = $39eeaa07ef6e11bb$var$bumpY;

var $39eeaa07ef6e11bb$var$_pointRadial = $39eeaa07ef6e11bb$var$_interopRequireDefault((parcelRequire("aq3nR")));
function $39eeaa07ef6e11bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $39eeaa07ef6e11bb$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $39eeaa07ef6e11bb$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $39eeaa07ef6e11bb$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $39eeaa07ef6e11bb$var$bumpX(context) {
    return new $39eeaa07ef6e11bb$var$Bump(context, true);
}
function $39eeaa07ef6e11bb$var$bumpY(context) {
    return new $39eeaa07ef6e11bb$var$Bump(context, false);
}
function $39eeaa07ef6e11bb$var$bumpRadial(context) {
    return new $39eeaa07ef6e11bb$var$BumpRadial(context);
}

});


parcelRegister("kasLt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eaeb0de66ae9c254$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $eHOaT = parcelRequire("eHOaT");

var $eaeb0de66ae9c254$var$_constant = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $eaeb0de66ae9c254$var$_asterisk = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("kiHGx")));

var $eaeb0de66ae9c254$var$_circle = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("g0D51")));

var $eaeb0de66ae9c254$var$_cross = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("hQIus")));

var $eaeb0de66ae9c254$var$_diamond = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("bo4UX")));

var $eaeb0de66ae9c254$var$_diamond2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("fzOQV")));

var $eaeb0de66ae9c254$var$_plus = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("khQ6z")));

var $eaeb0de66ae9c254$var$_square = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("8sNtG")));

var $eaeb0de66ae9c254$var$_square2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("59KED")));

var $eaeb0de66ae9c254$var$_star = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("7v7Tn")));

var $eaeb0de66ae9c254$var$_triangle = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("Pah0X")));

var $eaeb0de66ae9c254$var$_triangle2 = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("gCNbI")));

var $eaeb0de66ae9c254$var$_wye = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("kIjqz")));

var $eaeb0de66ae9c254$var$_x = $eaeb0de66ae9c254$var$_interopRequireDefault((parcelRequire("hYg78")));
function $eaeb0de66ae9c254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $eaeb0de66ae9c254$var$symbolsFill = [
    $eaeb0de66ae9c254$var$_circle.default,
    $eaeb0de66ae9c254$var$_cross.default,
    $eaeb0de66ae9c254$var$_diamond.default,
    $eaeb0de66ae9c254$var$_square.default,
    $eaeb0de66ae9c254$var$_star.default,
    $eaeb0de66ae9c254$var$_triangle.default,
    $eaeb0de66ae9c254$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $eaeb0de66ae9c254$var$symbolsFill;
const $eaeb0de66ae9c254$var$symbolsStroke = [
    $eaeb0de66ae9c254$var$_circle.default,
    $eaeb0de66ae9c254$var$_plus.default,
    $eaeb0de66ae9c254$var$_x.default,
    $eaeb0de66ae9c254$var$_triangle2.default,
    $eaeb0de66ae9c254$var$_asterisk.default,
    $eaeb0de66ae9c254$var$_square2.default,
    $eaeb0de66ae9c254$var$_diamond2.default
];
module.exports.symbolsStroke = $eaeb0de66ae9c254$var$symbolsStroke;
function $eaeb0de66ae9c254$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $eaeb0de66ae9c254$var$_constant.default)(type || $eaeb0de66ae9c254$var$_circle.default);
    size = typeof size === "function" ? size : (0, $eaeb0de66ae9c254$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $eHOaT.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $eaeb0de66ae9c254$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $eaeb0de66ae9c254$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("kiHGx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $ec77600d052ca50f$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $ec77600d052ca50f$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size + (0, $8sqRt.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $ec77600d052ca50f$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $ec77600d052ca50f$var$_default;

});

parcelRegister("g0D51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $ba7af5e75b2015a4$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / $8sqRt.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $8sqRt.tau);
    }
};
module.exports.default = $ba7af5e75b2015a4$var$_default;

});

parcelRegister("hQIus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $cfe9cdd43a4cfd19$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $cfe9cdd43a4cfd19$var$_default;

});

parcelRegister("bo4UX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $84a5c024b727ed84$var$tan30 = (0, $8sqRt.sqrt)(1 / 3);
const $84a5c024b727ed84$var$tan30_2 = $84a5c024b727ed84$var$tan30 * 2;
var $84a5c024b727ed84$var$_default = {
    draw (context, size) {
        const y = (0, $8sqRt.sqrt)(size / $84a5c024b727ed84$var$tan30_2);
        const x = y * $84a5c024b727ed84$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $84a5c024b727ed84$var$_default;

});

parcelRegister("fzOQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $b571922a462d91b4$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $b571922a462d91b4$var$_default;

});

parcelRegister("khQ6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $ec4dd0241f3ddc46$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size - (0, $8sqRt.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $ec4dd0241f3ddc46$var$_default;

});

parcelRegister("8sNtG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $6297517f739c41c6$var$_default = {
    draw (context, size) {
        const w = (0, $8sqRt.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $6297517f739c41c6$var$_default;

});

parcelRegister("59KED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $3c11fb9628daf769$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $3c11fb9628daf769$var$_default;

});

parcelRegister("7v7Tn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $57618cda1a24a70a$var$ka = 0.89081309152928522810;
const $57618cda1a24a70a$var$kr = (0, $8sqRt.sin)($8sqRt.pi / 10) / (0, $8sqRt.sin)(7 * $8sqRt.pi / 10);
const $57618cda1a24a70a$var$kx = (0, $8sqRt.sin)($8sqRt.tau / 10) * $57618cda1a24a70a$var$kr;
const $57618cda1a24a70a$var$ky = -(0, $8sqRt.cos)($8sqRt.tau / 10) * $57618cda1a24a70a$var$kr;
var $57618cda1a24a70a$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size * $57618cda1a24a70a$var$ka);
        const x = $57618cda1a24a70a$var$kx * r;
        const y = $57618cda1a24a70a$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $8sqRt.tau * i / 5;
            const c = (0, $8sqRt.cos)(a);
            const s = (0, $8sqRt.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $57618cda1a24a70a$var$_default;

});

parcelRegister("Pah0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $099cbb9f98da7333$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $099cbb9f98da7333$var$_default = {
    draw (context, size) {
        const y = -(0, $8sqRt.sqrt)(size / ($099cbb9f98da7333$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$099cbb9f98da7333$var$sqrt3 * y, -y);
        context.lineTo($099cbb9f98da7333$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $099cbb9f98da7333$var$_default;

});

parcelRegister("gCNbI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $c1a659a465768725$var$sqrt3 = (0, $8sqRt.sqrt)(3);
var $c1a659a465768725$var$_default = {
    draw (context, size) {
        const s = (0, $8sqRt.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $c1a659a465768725$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $c1a659a465768725$var$_default;

});

parcelRegister("kIjqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
const $f146fc9a2e510f06$var$c = -0.5;
const $f146fc9a2e510f06$var$s = (0, $8sqRt.sqrt)(3) / 2;
const $f146fc9a2e510f06$var$k = 1 / (0, $8sqRt.sqrt)(12);
const $f146fc9a2e510f06$var$a = ($f146fc9a2e510f06$var$k / 2 + 1) * 3;
var $f146fc9a2e510f06$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size / $f146fc9a2e510f06$var$a);
        const x0 = r / 2, y0 = r * $f146fc9a2e510f06$var$k;
        const x1 = x0, y1 = r * $f146fc9a2e510f06$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($f146fc9a2e510f06$var$c * x0 - $f146fc9a2e510f06$var$s * y0, $f146fc9a2e510f06$var$s * x0 + $f146fc9a2e510f06$var$c * y0);
        context.lineTo($f146fc9a2e510f06$var$c * x1 - $f146fc9a2e510f06$var$s * y1, $f146fc9a2e510f06$var$s * x1 + $f146fc9a2e510f06$var$c * y1);
        context.lineTo($f146fc9a2e510f06$var$c * x2 - $f146fc9a2e510f06$var$s * y2, $f146fc9a2e510f06$var$s * x2 + $f146fc9a2e510f06$var$c * y2);
        context.lineTo($f146fc9a2e510f06$var$c * x0 + $f146fc9a2e510f06$var$s * y0, $f146fc9a2e510f06$var$c * y0 - $f146fc9a2e510f06$var$s * x0);
        context.lineTo($f146fc9a2e510f06$var$c * x1 + $f146fc9a2e510f06$var$s * y1, $f146fc9a2e510f06$var$c * y1 - $f146fc9a2e510f06$var$s * x1);
        context.lineTo($f146fc9a2e510f06$var$c * x2 + $f146fc9a2e510f06$var$s * y2, $f146fc9a2e510f06$var$c * y2 - $f146fc9a2e510f06$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $f146fc9a2e510f06$var$_default;

});

parcelRegister("hYg78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8sqRt = parcelRequire("8sqRt");
var $d1548a2d68fe530a$var$_default = {
    draw (context, size) {
        const r = (0, $8sqRt.sqrt)(size - (0, $8sqRt.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $d1548a2d68fe530a$var$_default;

});


parcelRegister("ay5fE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ae12728b04d5625$var$_default;

var $7ae12728b04d5625$var$_noop = $7ae12728b04d5625$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $80A8B = parcelRequire("80A8B");
function $7ae12728b04d5625$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ae12728b04d5625$var$BasisClosed(context) {
    this._context = context;
}
$7ae12728b04d5625$var$BasisClosed.prototype = {
    areaStart: $7ae12728b04d5625$var$_noop.default,
    areaEnd: $7ae12728b04d5625$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $80A8B.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7ae12728b04d5625$var$_default(context) {
    return new $7ae12728b04d5625$var$BasisClosed(context);
}

});
parcelRegister("3uxUV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28ae7ba8744bfca2$var$_default;
function $28ae7ba8744bfca2$var$_default() {}

});

parcelRegister("80A8B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $5d4a5b0586bcf64a$var$Basis;
module.exports.default = $5d4a5b0586bcf64a$var$_default;
module.exports.point = $5d4a5b0586bcf64a$var$point;
function $5d4a5b0586bcf64a$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $5d4a5b0586bcf64a$var$Basis(context) {
    this._context = context;
}
$5d4a5b0586bcf64a$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $5d4a5b0586bcf64a$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $5d4a5b0586bcf64a$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5d4a5b0586bcf64a$var$_default(context) {
    return new $5d4a5b0586bcf64a$var$Basis(context);
}

});


parcelRegister("jpU7n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e22be1f5d12a4d94$var$_default;

var $80A8B = parcelRequire("80A8B");
function $e22be1f5d12a4d94$var$BasisOpen(context) {
    this._context = context;
}
$e22be1f5d12a4d94$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $80A8B.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $e22be1f5d12a4d94$var$_default(context) {
    return new $e22be1f5d12a4d94$var$BasisOpen(context);
}

});

parcelRegister("ghvUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80A8B = parcelRequire("80A8B");
function $bda6fd378d42be19$var$Bundle(context, beta) {
    this._basis = new $80A8B.Basis(context);
    this._beta = beta;
}
$bda6fd378d42be19$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $bda6fd378d42be19$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $80A8B.Basis(context) : new $bda6fd378d42be19$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $bda6fd378d42be19$var$_default;

});

parcelRegister("fdmsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $b1397cb8deedcc73$var$CardinalClosed;
module.exports.default = void 0;

var $b1397cb8deedcc73$var$_noop = $b1397cb8deedcc73$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $7uyVd = parcelRequire("7uyVd");
function $b1397cb8deedcc73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1397cb8deedcc73$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b1397cb8deedcc73$var$CardinalClosed.prototype = {
    areaStart: $b1397cb8deedcc73$var$_noop.default,
    areaEnd: $b1397cb8deedcc73$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $7uyVd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b1397cb8deedcc73$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $b1397cb8deedcc73$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $b1397cb8deedcc73$var$_default;

});
parcelRegister("7uyVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $57466c7c1136f8d8$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $57466c7c1136f8d8$var$point;
function $57466c7c1136f8d8$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $57466c7c1136f8d8$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$57466c7c1136f8d8$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $57466c7c1136f8d8$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $57466c7c1136f8d8$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $57466c7c1136f8d8$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $57466c7c1136f8d8$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $57466c7c1136f8d8$var$_default;

});


parcelRegister("1GDiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $13a833525c2a2b71$var$CardinalOpen;
module.exports.default = void 0;

var $7uyVd = parcelRequire("7uyVd");
function $13a833525c2a2b71$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$13a833525c2a2b71$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $7uyVd.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $13a833525c2a2b71$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $13a833525c2a2b71$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $13a833525c2a2b71$var$_default;

});

parcelRegister("fO1Lc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdmsb = parcelRequire("fdmsb");

var $b81ce4102c6d02ab$var$_noop = $b81ce4102c6d02ab$var$_interopRequireDefault((parcelRequire("3uxUV")));

var $iA1KK = parcelRequire("iA1KK");
function $b81ce4102c6d02ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b81ce4102c6d02ab$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$b81ce4102c6d02ab$var$CatmullRomClosed.prototype = {
    areaStart: $b81ce4102c6d02ab$var$_noop.default,
    areaEnd: $b81ce4102c6d02ab$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iA1KK.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b81ce4102c6d02ab$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $b81ce4102c6d02ab$var$CatmullRomClosed(context, alpha) : new $fdmsb.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $b81ce4102c6d02ab$var$_default;

});
parcelRegister("iA1KK", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $8sqRt = parcelRequire("8sqRt");

var $7uyVd = parcelRequire("7uyVd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $8sqRt.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $8sqRt.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $7uyVd.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("f5m8h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1GDiO = parcelRequire("1GDiO");

var $iA1KK = parcelRequire("iA1KK");
function $afb87daecdf11967$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$afb87daecdf11967$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $iA1KK.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $afb87daecdf11967$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $afb87daecdf11967$var$CatmullRomOpen(context, alpha) : new $1GDiO.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $afb87daecdf11967$var$_default;

});

parcelRegister("4MkXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37abe72de26638cf$var$_default;

var $37abe72de26638cf$var$_noop = $37abe72de26638cf$var$_interopRequireDefault((parcelRequire("3uxUV")));
function $37abe72de26638cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37abe72de26638cf$var$LinearClosed(context) {
    this._context = context;
}
$37abe72de26638cf$var$LinearClosed.prototype = {
    areaStart: $37abe72de26638cf$var$_noop.default,
    areaEnd: $37abe72de26638cf$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $37abe72de26638cf$var$_default(context) {
    return new $37abe72de26638cf$var$LinearClosed(context);
}

});

parcelRegister("hCVBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $cd52aa2edc8e71c1$var$monotoneX;
module.exports.monotoneY = $cd52aa2edc8e71c1$var$monotoneY;
function $cd52aa2edc8e71c1$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cd52aa2edc8e71c1$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cd52aa2edc8e71c1$var$sign(s0) + $cd52aa2edc8e71c1$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $cd52aa2edc8e71c1$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cd52aa2edc8e71c1$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cd52aa2edc8e71c1$var$MonotoneX(context) {
    this._context = context;
}
$cd52aa2edc8e71c1$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cd52aa2edc8e71c1$var$point(this, this._t0, $cd52aa2edc8e71c1$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cd52aa2edc8e71c1$var$point(this, $cd52aa2edc8e71c1$var$slope2(this, t1 = $cd52aa2edc8e71c1$var$slope3(this, x, y)), t1);
                break;
            default:
                $cd52aa2edc8e71c1$var$point(this, this._t0, t1 = $cd52aa2edc8e71c1$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cd52aa2edc8e71c1$var$MonotoneY(context) {
    this._context = new $cd52aa2edc8e71c1$var$ReflectContext(context);
}
($cd52aa2edc8e71c1$var$MonotoneY.prototype = Object.create($cd52aa2edc8e71c1$var$MonotoneX.prototype)).point = function(x, y) {
    $cd52aa2edc8e71c1$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cd52aa2edc8e71c1$var$ReflectContext(context) {
    this._context = context;
}
$cd52aa2edc8e71c1$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cd52aa2edc8e71c1$var$monotoneX(context) {
    return new $cd52aa2edc8e71c1$var$MonotoneX(context);
}
function $cd52aa2edc8e71c1$var$monotoneY(context) {
    return new $cd52aa2edc8e71c1$var$MonotoneY(context);
}

});

parcelRegister("c3UhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c816caf23d6aa90$var$_default;
function $8c816caf23d6aa90$var$Natural(context) {
    this._context = context;
}
$8c816caf23d6aa90$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $8c816caf23d6aa90$var$controlPoints(x), py = $8c816caf23d6aa90$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $8c816caf23d6aa90$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $8c816caf23d6aa90$var$_default(context) {
    return new $8c816caf23d6aa90$var$Natural(context);
}

});

parcelRegister("kfzkQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebe09e38718963e6$var$_default;
module.exports.stepAfter = $ebe09e38718963e6$var$stepAfter;
module.exports.stepBefore = $ebe09e38718963e6$var$stepBefore;
function $ebe09e38718963e6$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$ebe09e38718963e6$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $ebe09e38718963e6$var$_default(context) {
    return new $ebe09e38718963e6$var$Step(context, 0.5);
}
function $ebe09e38718963e6$var$stepBefore(context) {
    return new $ebe09e38718963e6$var$Step(context, 0);
}
function $ebe09e38718963e6$var$stepAfter(context) {
    return new $ebe09e38718963e6$var$Step(context, 1);
}

});

parcelRegister("g1Flh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $baaccf104d1882d1$var$_default;

var $baaccf104d1882d1$var$_array = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("02pi9")));

var $baaccf104d1882d1$var$_constant = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("1IHDd")));

var $baaccf104d1882d1$var$_none = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("3lLHy")));

var $baaccf104d1882d1$var$_none2 = $baaccf104d1882d1$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $baaccf104d1882d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $baaccf104d1882d1$var$stackValue(d, key) {
    return d[key];
}
function $baaccf104d1882d1$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $baaccf104d1882d1$var$_default() {
    var keys = (0, $baaccf104d1882d1$var$_constant.default)([]), order = $baaccf104d1882d1$var$_none2.default, offset = $baaccf104d1882d1$var$_none.default, value = $baaccf104d1882d1$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $baaccf104d1882d1$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $baaccf104d1882d1$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $baaccf104d1882d1$var$_none2.default : typeof _ === "function" ? _ : (0, $baaccf104d1882d1$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $baaccf104d1882d1$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("3lLHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $270855c54030ca6c$var$_default;
function $270855c54030ca6c$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("cBi4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92c6f5866308065d$var$_default;
function $92c6f5866308065d$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("arwOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79a5e1645cb2e014$var$_default;

var $79a5e1645cb2e014$var$_none = $79a5e1645cb2e014$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $79a5e1645cb2e014$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79a5e1645cb2e014$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $79a5e1645cb2e014$var$_none.default)(series, order);
}

});

parcelRegister("1e8r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e4da44a140a0318$var$_default;
function $0e4da44a140a0318$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4UXaU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $394a4b4b05691a26$var$_default;

var $394a4b4b05691a26$var$_none = $394a4b4b05691a26$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $394a4b4b05691a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $394a4b4b05691a26$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $394a4b4b05691a26$var$_none.default)(series, order);
}

});

parcelRegister("dD9Jn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ec6773c97a19344$var$_default;

var $9ec6773c97a19344$var$_none = $9ec6773c97a19344$var$_interopRequireDefault((parcelRequire("3lLHy")));
function $9ec6773c97a19344$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ec6773c97a19344$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $9ec6773c97a19344$var$_none.default)(series, order);
}

});

parcelRegister("04gi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00cd030253fcb90b$var$_default;

var $00cd030253fcb90b$var$_none = $00cd030253fcb90b$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $00cd030253fcb90b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $00cd030253fcb90b$var$_default(series) {
    var peaks = series.map($00cd030253fcb90b$var$peak);
    return (0, $00cd030253fcb90b$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $00cd030253fcb90b$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("frzzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3e4f8231c023254$var$_default;
module.exports.sum = $b3e4f8231c023254$var$sum;

var $b3e4f8231c023254$var$_none = $b3e4f8231c023254$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $b3e4f8231c023254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3e4f8231c023254$var$_default(series) {
    var sums = series.map($b3e4f8231c023254$var$sum);
    return (0, $b3e4f8231c023254$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $b3e4f8231c023254$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("5YYHh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45b1a38313034e43$var$_default;

var $45b1a38313034e43$var$_ascending = $45b1a38313034e43$var$_interopRequireDefault((parcelRequire("frzzp")));
function $45b1a38313034e43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $45b1a38313034e43$var$_default(series) {
    return (0, $45b1a38313034e43$var$_ascending.default)(series).reverse();
}

});

parcelRegister("zSdMD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06bd5438e85e0f42$var$_default;

var $06bd5438e85e0f42$var$_appearance = $06bd5438e85e0f42$var$_interopRequireDefault((parcelRequire("04gi8")));

var $frzzp = parcelRequire("frzzp");
function $06bd5438e85e0f42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06bd5438e85e0f42$var$_default(series) {
    var n = series.length, i, j, sums = series.map($frzzp.sum), order = (0, $06bd5438e85e0f42$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("gCYnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1af09290d860e32$var$_default;

var $c1af09290d860e32$var$_none = $c1af09290d860e32$var$_interopRequireDefault((parcelRequire("cBi4y")));
function $c1af09290d860e32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c1af09290d860e32$var$_default(series) {
    return (0, $c1af09290d860e32$var$_none.default)(series).reverse();
}

});



var $6b76b616b2785a51$exports = {};
$parcel$extendImportMap({
    "50JJJ": "browser.410e73bc.js"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


parcelRequire("7fPBF");
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;



parcelRequire("7fPBF");
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $7fPBF = parcelRequire("7fPBF");
// filepath: /Users/sird/Downloads/QrButler-330eb0312a86783b6eba24778b016ec58ad434ea/src/services/supabase.js

const $09d0b1d4f904427e$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("jxJFs"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $aec3df229cd88c5b$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $aec3df229cd88c5b$export$14f2b6540d498ce extends $aec3df229cd88c5b$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $aec3df229cd88c5b$export$d08a45df86040161 extends $aec3df229cd88c5b$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $aec3df229cd88c5b$export$761f8c0e0fa4624f extends $aec3df229cd88c5b$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $aec3df229cd88c5b$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($aec3df229cd88c5b$export$9b19f1a5abf91e06 || ($aec3df229cd88c5b$export$9b19f1a5abf91e06 = {}));


var $7b1b7568825f5055$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $7b1b7568825f5055$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $aec3df229cd88c5b$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $09d0b1d4f904427e$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $7b1b7568825f5055$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $aec3df229cd88c5b$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $aec3df229cd88c5b$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $aec3df229cd88c5b$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


var $1b8fac7368d73b03$exports = {};
"use strict";
var $1b8fac7368d73b03$var$__importDefault = $1b8fac7368d73b03$exports && $1b8fac7368d73b03$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1b8fac7368d73b03$exports, "__esModule", {
    value: true
});
$1b8fac7368d73b03$exports.PostgrestError = $1b8fac7368d73b03$exports.PostgrestBuilder = $1b8fac7368d73b03$exports.PostgrestTransformBuilder = $1b8fac7368d73b03$exports.PostgrestFilterBuilder = $1b8fac7368d73b03$exports.PostgrestQueryBuilder = $1b8fac7368d73b03$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $1b8fac7368d73b03$var$PostgrestClient_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("bkRhq")));
$1b8fac7368d73b03$exports.PostgrestClient = $1b8fac7368d73b03$var$PostgrestClient_1.default;

const $1b8fac7368d73b03$var$PostgrestQueryBuilder_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("j9Ami")));
$1b8fac7368d73b03$exports.PostgrestQueryBuilder = $1b8fac7368d73b03$var$PostgrestQueryBuilder_1.default;

const $1b8fac7368d73b03$var$PostgrestFilterBuilder_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("1Wp8i")));
$1b8fac7368d73b03$exports.PostgrestFilterBuilder = $1b8fac7368d73b03$var$PostgrestFilterBuilder_1.default;

const $1b8fac7368d73b03$var$PostgrestTransformBuilder_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("LNOGP")));
$1b8fac7368d73b03$exports.PostgrestTransformBuilder = $1b8fac7368d73b03$var$PostgrestTransformBuilder_1.default;

const $1b8fac7368d73b03$var$PostgrestBuilder_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("aB6y5")));
$1b8fac7368d73b03$exports.PostgrestBuilder = $1b8fac7368d73b03$var$PostgrestBuilder_1.default;

const $1b8fac7368d73b03$var$PostgrestError_1 = $1b8fac7368d73b03$var$__importDefault((parcelRequire("cuctA")));
$1b8fac7368d73b03$exports.PostgrestError = $1b8fac7368d73b03$var$PostgrestError_1.default;
$1b8fac7368d73b03$exports.default = {
    PostgrestClient: $1b8fac7368d73b03$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $1b8fac7368d73b03$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $1b8fac7368d73b03$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $1b8fac7368d73b03$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $1b8fac7368d73b03$var$PostgrestBuilder_1.default,
    PostgrestError: $1b8fac7368d73b03$var$PostgrestError_1.default
};


const { PostgrestClient: $5423e4dd4c21e962$export$796f32e2ee984aaa, PostgrestQueryBuilder: $5423e4dd4c21e962$export$a81993b50ca081ad, PostgrestFilterBuilder: $5423e4dd4c21e962$export$3158317c13bdc93a, PostgrestTransformBuilder: $5423e4dd4c21e962$export$7b4361bb87e3030c, PostgrestBuilder: $5423e4dd4c21e962$export$3106e21688a06353, PostgrestError: $5423e4dd4c21e962$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($1b8fac7368d73b03$exports)));
var // compatibility with CJS output
$5423e4dd4c21e962$export$2e2bcd8739ae039 = {
    PostgrestClient: $5423e4dd4c21e962$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $5423e4dd4c21e962$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $5423e4dd4c21e962$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $5423e4dd4c21e962$export$7b4361bb87e3030c,
    PostgrestBuilder: $5423e4dd4c21e962$export$3106e21688a06353,
    PostgrestError: $5423e4dd4c21e962$export$445b7e3a323f992f
};


const $5e4e2b3a34434938$export$83d89fbfd8236492 = '2.11.2';


const $4edd9bbfc7193438$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $5e4e2b3a34434938$export$83d89fbfd8236492)}`
};
const $4edd9bbfc7193438$export$df3f558bb9a9c991 = '1.0.0';
const $4edd9bbfc7193438$export$7bd623b29ec8e1eb = 10000;
const $4edd9bbfc7193438$export$5e80cf62e56a877b = 1000;
var $4edd9bbfc7193438$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($4edd9bbfc7193438$export$a6d0320a1563d49e || ($4edd9bbfc7193438$export$a6d0320a1563d49e = {}));
var $4edd9bbfc7193438$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($4edd9bbfc7193438$export$b83816118db74fe7 || ($4edd9bbfc7193438$export$b83816118db74fe7 = {}));
var $4edd9bbfc7193438$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($4edd9bbfc7193438$export$8db7548e65d6ea55 || ($4edd9bbfc7193438$export$8db7548e65d6ea55 = {}));
var $4edd9bbfc7193438$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($4edd9bbfc7193438$export$b2688bfb999f5751 || ($4edd9bbfc7193438$export$b2688bfb999f5751 = {}));
var $4edd9bbfc7193438$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($4edd9bbfc7193438$export$deda39003d27273 || ($4edd9bbfc7193438$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $695bbf2c7ef19900$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $bbfe0d1ea5530127$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $ee00cd7d477ca243$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($ee00cd7d477ca243$export$4d213a7d364021dc || ($ee00cd7d477ca243$export$4d213a7d364021dc = {}));
const $ee00cd7d477ca243$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $ee00cd7d477ca243$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $ee00cd7d477ca243$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $ee00cd7d477ca243$export$3df02a362b86a91(colType, value);
    return $ee00cd7d477ca243$var$noop(value);
};
const $ee00cd7d477ca243$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $ee00cd7d477ca243$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $ee00cd7d477ca243$export$4d213a7d364021dc.bool:
            return $ee00cd7d477ca243$export$3c2e6d1b7583eee6(value);
        case $ee00cd7d477ca243$export$4d213a7d364021dc.float4:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.float8:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.int2:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.int4:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.int8:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.numeric:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.oid:
            return $ee00cd7d477ca243$export$a0a81dc3380ce7d3(value);
        case $ee00cd7d477ca243$export$4d213a7d364021dc.json:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.jsonb:
            return $ee00cd7d477ca243$export$d5b7a8bf56ee1fe2(value);
        case $ee00cd7d477ca243$export$4d213a7d364021dc.timestamp:
            return $ee00cd7d477ca243$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $ee00cd7d477ca243$export$4d213a7d364021dc.abstime:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.date:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.daterange:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.int4range:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.int8range:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.money:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.reltime:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.text:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.time:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.timestamptz:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.timetz:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.tsrange:
        case $ee00cd7d477ca243$export$4d213a7d364021dc.tstzrange:
            return $ee00cd7d477ca243$var$noop(value);
        default:
            // Return the value for remaining types
            return $ee00cd7d477ca243$var$noop(value);
    }
};
const $ee00cd7d477ca243$var$noop = (value)=>{
    return value;
};
const $ee00cd7d477ca243$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $ee00cd7d477ca243$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $ee00cd7d477ca243$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $ee00cd7d477ca243$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$ee00cd7d477ca243$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $ee00cd7d477ca243$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $ee00cd7d477ca243$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $cdc72cbf23762224$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $4edd9bbfc7193438$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $df0bad55dee0e602$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($df0bad55dee0e602$export$f1ce049df2794fb4 || ($df0bad55dee0e602$export$f1ce049df2794fb4 = {}));
class $df0bad55dee0e602$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $df0bad55dee0e602$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $df0bad55dee0e602$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $df0bad55dee0e602$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $8fb9c29263f6f948$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($8fb9c29263f6f948$export$bc171c571098b6c4 || ($8fb9c29263f6f948$export$bc171c571098b6c4 = {}));
var $8fb9c29263f6f948$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($8fb9c29263f6f948$export$9e3fe8e487ef792e || ($8fb9c29263f6f948$export$9e3fe8e487ef792e = {}));
var $8fb9c29263f6f948$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($8fb9c29263f6f948$export$a6885b926af646a2 || ($8fb9c29263f6f948$export$a6885b926af646a2 = {}));
const $8fb9c29263f6f948$export$154db638d9c0559e = (0, $4edd9bbfc7193438$export$b83816118db74fe7);
class $8fb9c29263f6f948$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $cdc72cbf23762224$export$2e2bcd8739ae039)(this, (0, $4edd9bbfc7193438$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $bbfe0d1ea5530127$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $df0bad55dee0e602$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $ee00cd7d477ca243$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($8fb9c29263f6f948$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($8fb9c29263f6f948$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($8fb9c29263f6f948$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback === null || callback === void 0 || callback($8fb9c29263f6f948$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($8fb9c29263f6f948$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                callback === null || callback === void 0 || callback($8fb9c29263f6f948$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($8fb9c29263f6f948$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $cdc72cbf23762224$export$2e2bcd8739ae039)(this, (0, $4edd9bbfc7193438$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $cdc72cbf23762224$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $4edd9bbfc7193438$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $4edd9bbfc7193438$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $4edd9bbfc7193438$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $4edd9bbfc7193438$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $4edd9bbfc7193438$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $8fb9c29263f6f948$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $4edd9bbfc7193438$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $ee00cd7d477ca243$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $ee00cd7d477ca243$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $25eb1491e5bc5f9e$var$noop = ()=>{};
const $25eb1491e5bc5f9e$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const $25eb1491e5bc5f9e$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;


class $25eb1491e5bc5f9e$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $4edd9bbfc7193438$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $4edd9bbfc7193438$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $25eb1491e5bc5f9e$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $695bbf2c7ef19900$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("jxJFs"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $4edd9bbfc7193438$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $ee00cd7d477ca243$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $bbfe0d1ea5530127$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($25eb1491e5bc5f9e$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this.endpointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $25eb1491e5bc5f9e$var$WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("2j1O5")).then(({ default: WS })=>{
            this.conn = new WS(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $4edd9bbfc7193438$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $4edd9bbfc7193438$export$a6d0320a1563d49e).connecting:
                return (0, $4edd9bbfc7193438$export$deda39003d27273).Connecting;
            case (0, $4edd9bbfc7193438$export$a6d0320a1563d49e).open:
                return (0, $4edd9bbfc7193438$export$deda39003d27273).Open;
            case (0, $4edd9bbfc7193438$export$a6d0320a1563d49e).closing:
                return (0, $4edd9bbfc7193438$export$deda39003d27273).Closing;
            default:
                return (0, $4edd9bbfc7193438$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $4edd9bbfc7193438$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $8fb9c29263f6f948$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (tokenToSend) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                }
            }
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $4edd9bbfc7193438$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth();
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $4edd9bbfc7193438$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $25eb1491e5bc5f9e$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
class $25eb1491e5bc5f9e$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $4edd9bbfc7193438$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $3aa16b7c75505ef5$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $3aa16b7c75505ef5$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $3aa16b7c75505ef5$export$ca9ecfd959b3871c extends $3aa16b7c75505ef5$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $3aa16b7c75505ef5$export$29127ca2e1a271d extends $3aa16b7c75505ef5$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $3e62223bec62dc6e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $3e62223bec62dc6e$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("jxJFs"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $3e62223bec62dc6e$export$ace1d6afc438cf26 = ()=>$3e62223bec62dc6e$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("jxJFs")))).Response;
        return Response;
    });
const $3e62223bec62dc6e$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$3e62223bec62dc6e$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $3e62223bec62dc6e$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $a0195f3bfac2f467$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a0195f3bfac2f467$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $a0195f3bfac2f467$var$handleError = (error, reject, options)=>$a0195f3bfac2f467$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $3e62223bec62dc6e$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $3aa16b7c75505ef5$export$ca9ecfd959b3871c)($a0195f3bfac2f467$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $3aa16b7c75505ef5$export$29127ca2e1a271d)($a0195f3bfac2f467$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $3aa16b7c75505ef5$export$29127ca2e1a271d)($a0195f3bfac2f467$var$_getErrorMessage(error), error));
    });
const $a0195f3bfac2f467$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $a0195f3bfac2f467$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $a0195f3bfac2f467$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$a0195f3bfac2f467$var$handleError(error, reject, options));
        });
    });
}
function $a0195f3bfac2f467$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return $a0195f3bfac2f467$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $a0195f3bfac2f467$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return $a0195f3bfac2f467$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $a0195f3bfac2f467$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return $a0195f3bfac2f467$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $a0195f3bfac2f467$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return $a0195f3bfac2f467$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $a0195f3bfac2f467$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $a0195f3bfac2f467$var$__awaiter(this, void 0, void 0, function*() {
        return $a0195f3bfac2f467$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $27564b8a0078aa3d$export$6100ba28696e12de(buf);
    else return $27564b8a0078aa3d$export$6100ba28696e12de(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $27564b8a0078aa3d$export$d622b2ad8d90c771($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $0732100f81c28948$require$Buffer = $82a04c4ec6982288$export$a143d493d941bafc;
var $0732100f81c28948$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $0732100f81c28948$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $0732100f81c28948$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $0732100f81c28948$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $3e62223bec62dc6e$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $0732100f81c28948$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $0732100f81c28948$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $3aa16b7c75505ef5$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $a0195f3bfac2f467$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $a0195f3bfac2f467$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $3e62223bec62dc6e$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $a0195f3bfac2f467$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error) && error instanceof (0, $3aa16b7c75505ef5$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $0732100f81c28948$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $0732100f81c28948$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $0732100f81c28948$require$Buffer !== 'undefined') return $0732100f81c28948$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $55770fb33fd79130$export$83d89fbfd8236492 = '2.7.1';


const $9a7657631a6078ab$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $55770fb33fd79130$export$83d89fbfd8236492)}`
};





var $bf7908f5b9d5af5f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $bf7908f5b9d5af5f$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $9a7657631a6078ab$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $3e62223bec62dc6e$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $bf7908f5b9d5af5f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $a0195f3bfac2f467$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $3aa16b7c75505ef5$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $c696f818f9a73d96$export$6c85f5032e75eff9 extends (0, $bf7908f5b9d5af5f$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $0732100f81c28948$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $79109c413e4682c2$export$83d89fbfd8236492 = '2.49.4';


let $4b9c91ef8a961676$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $4b9c91ef8a961676$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $4b9c91ef8a961676$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $4b9c91ef8a961676$var$JS_ENV = 'react-native';
else $4b9c91ef8a961676$var$JS_ENV = 'node';
const $4b9c91ef8a961676$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$4b9c91ef8a961676$var$JS_ENV}/${(0, $79109c413e4682c2$export$83d89fbfd8236492)}`
};
const $4b9c91ef8a961676$export$b63a5c3a2e5becd2 = {
    headers: $4b9c91ef8a961676$export$88a84136db6a4b64
};
const $4b9c91ef8a961676$export$b31378ae815bea6b = {
    schema: 'public'
};
const $4b9c91ef8a961676$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $4b9c91ef8a961676$export$59685507ca0a3912 = {};



var $jxJFs = parcelRequire("jxJFs");
var $cf2b518fa2567860$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf2b518fa2567860$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $jxJFs.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $cf2b518fa2567860$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $jxJFs.Headers;
    return Headers;
};
const $cf2b518fa2567860$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $cf2b518fa2567860$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $cf2b518fa2567860$export$3d2cf54f85b7fc8a();
    return (input, init)=>$cf2b518fa2567860$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $504803040a2579f2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $504803040a2579f2$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $504803040a2579f2$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
const $504803040a2579f2$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $504803040a2579f2$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>$504803040a2579f2$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $e65a26507e4ec691$export$83d89fbfd8236492 = '2.69.1';


const $7547639a607dd8b2$export$a4558fee79d6c8ae = 30000;
const $7547639a607dd8b2$export$f20a97df8f5fe223 = 3;
const $7547639a607dd8b2$export$a36ad0026e55ac00 = $7547639a607dd8b2$export$f20a97df8f5fe223 * $7547639a607dd8b2$export$a4558fee79d6c8ae;
const $7547639a607dd8b2$export$7fedf552187f0c3d = 'http://localhost:9999';
const $7547639a607dd8b2$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $7547639a607dd8b2$export$2f9161bad044dacb = '';
const $7547639a607dd8b2$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $e65a26507e4ec691$export$83d89fbfd8236492)}`
};
const $7547639a607dd8b2$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $7547639a607dd8b2$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $7547639a607dd8b2$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $7547639a607dd8b2$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $7547639a607dd8b2$export$5bd768495200f133 = 600000; // 10 minutes



class $46e750dae2611590$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $46e750dae2611590$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $46e750dae2611590$export$45fde0b55b14f37b extends $46e750dae2611590$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $46e750dae2611590$export$4fe744aeb810d543(error) {
    return $46e750dae2611590$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $46e750dae2611590$export$f7559805d4a50078 extends $46e750dae2611590$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $46e750dae2611590$export$823c745ae0673c5e extends $46e750dae2611590$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $46e750dae2611590$export$403b3fc0d3ad5f0c extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $46e750dae2611590$export$3e849aa4db565c1d(error) {
    return $46e750dae2611590$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $46e750dae2611590$export$7e277b620449c1b4 extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $46e750dae2611590$export$9ef583f0381b4cc extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $46e750dae2611590$export$bf5df8e043856ef5 extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $46e750dae2611590$export$45edea3999507afd(error) {
    return $46e750dae2611590$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $46e750dae2611590$export$39583657eb2a7027 extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $46e750dae2611590$export$2423b763f68be1b4 extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $46e750dae2611590$export$a77af358da5fb874(error) {
    return $46e750dae2611590$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $46e750dae2611590$export$b034076aa04913a6 extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $46e750dae2611590$export$dac36143fd8a46ef(error) {
    return $46e750dae2611590$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $46e750dae2611590$export$d04cb18528f2043e extends $46e750dae2611590$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}


/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $9578a0ba8688392b$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $9578a0ba8688392b$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $9578a0ba8688392b$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $9578a0ba8688392b$var$IGNORE_BASE64URL.length; i += 1)charMap[$9578a0ba8688392b$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $9578a0ba8688392b$var$TO_BASE64URL.length; i += 1)charMap[$9578a0ba8688392b$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $9578a0ba8688392b$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($9578a0ba8688392b$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($9578a0ba8688392b$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $9578a0ba8688392b$export$403e86c86002a137(charCode, state, emit) {
    const bits = $9578a0ba8688392b$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $9578a0ba8688392b$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $9578a0ba8688392b$export$caccae6095ceb6da(str, (byte)=>{
        $9578a0ba8688392b$export$744f452403189a3e(byte, state, emitter);
    });
    $9578a0ba8688392b$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $9578a0ba8688392b$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $9578a0ba8688392b$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$9578a0ba8688392b$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $9578a0ba8688392b$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $9578a0ba8688392b$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $9578a0ba8688392b$export$d203cd9136753332(codepoint, emit);
    }
}
function $9578a0ba8688392b$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $9578a0ba8688392b$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$9578a0ba8688392b$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $9578a0ba8688392b$export$a098e7b533f96db3(str) {
    const result = [];
    $9578a0ba8688392b$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}


function $2063e2c40cd283b3$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $2063e2c40cd283b3$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $2063e2c40cd283b3$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $2063e2c40cd283b3$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $2063e2c40cd283b3$export$9ec034ee80211814 = ()=>{
    if (!$2063e2c40cd283b3$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($2063e2c40cd283b3$var$localStorageWriteTests.tested) return $2063e2c40cd283b3$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $2063e2c40cd283b3$var$localStorageWriteTests.tested = true;
        $2063e2c40cd283b3$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $2063e2c40cd283b3$var$localStorageWriteTests.tested = true;
        $2063e2c40cd283b3$var$localStorageWriteTests.writable = false;
    }
    return $2063e2c40cd283b3$var$localStorageWriteTests.writable;
};
function $2063e2c40cd283b3$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $2063e2c40cd283b3$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("jxJFs"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $2063e2c40cd283b3$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $2063e2c40cd283b3$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $2063e2c40cd283b3$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $2063e2c40cd283b3$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $2063e2c40cd283b3$export$85f6557964517f1a {
    constructor(){
        this.promise = new $2063e2c40cd283b3$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$2063e2c40cd283b3$export$85f6557964517f1a.promiseConstructor = Promise;
function $2063e2c40cd283b3$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $46e750dae2611590$export$d04cb18528f2043e)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $7547639a607dd8b2$export$7a68c9e70b9d3911).test(parts[i])) throw new (0, $46e750dae2611590$export$d04cb18528f2043e)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $9578a0ba8688392b$export$bd5d476f823ea024)(parts[0])),
        payload: JSON.parse((0, $9578a0ba8688392b$export$bd5d476f823ea024)(parts[1])),
        signature: (0, $9578a0ba8688392b$export$9cae2cd6076b8fb6)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $2063e2c40cd283b3$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $2063e2c40cd283b3$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $2063e2c40cd283b3$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $2063e2c40cd283b3$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $2063e2c40cd283b3$var$dec2hex).join('');
}
async function $2063e2c40cd283b3$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $2063e2c40cd283b3$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $2063e2c40cd283b3$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $2063e2c40cd283b3$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $2063e2c40cd283b3$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $2063e2c40cd283b3$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $2063e2c40cd283b3$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $2063e2c40cd283b3$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $2063e2c40cd283b3$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $7547639a607dd8b2$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($2063e2c40cd283b3$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $2063e2c40cd283b3$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $2063e2c40cd283b3$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}



var $925ba6dd483bb6b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $925ba6dd483bb6b4$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $925ba6dd483bb6b4$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $925ba6dd483bb6b4$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $2063e2c40cd283b3$export$e8ad6599be1036a7)(error)) throw new (0, $46e750dae2611590$export$2423b763f68be1b4)($925ba6dd483bb6b4$var$_getErrorMessage(error), 0);
    if ($925ba6dd483bb6b4$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $46e750dae2611590$export$2423b763f68be1b4)($925ba6dd483bb6b4$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $46e750dae2611590$export$f7559805d4a50078)($925ba6dd483bb6b4$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $2063e2c40cd283b3$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $7547639a607dd8b2$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $46e750dae2611590$export$b034076aa04913a6)($925ba6dd483bb6b4$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $46e750dae2611590$export$b034076aa04913a6)($925ba6dd483bb6b4$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
    throw new (0, $46e750dae2611590$export$45fde0b55b14f37b)($925ba6dd483bb6b4$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $925ba6dd483bb6b4$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $925ba6dd483bb6b4$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $7547639a607dd8b2$export$e4f5507f88977535]) headers[0, $7547639a607dd8b2$export$e4f5507f88977535] = (0, $7547639a607dd8b2$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $925ba6dd483bb6b4$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $925ba6dd483bb6b4$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $925ba6dd483bb6b4$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $46e750dae2611590$export$2423b763f68be1b4)($925ba6dd483bb6b4$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $925ba6dd483bb6b4$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $925ba6dd483bb6b4$export$d3da1ecaf1206c58(e);
    }
}
function $925ba6dd483bb6b4$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($925ba6dd483bb6b4$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $2063e2c40cd283b3$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $925ba6dd483bb6b4$export$db83aade1c2922c7(data) {
    const response = $925ba6dd483bb6b4$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $925ba6dd483bb6b4$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $925ba6dd483bb6b4$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $925ba6dd483bb6b4$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $925ba6dd483bb6b4$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $925ba6dd483bb6b4$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $925ba6dd483bb6b4$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $00ff8596afaf09dd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $00ff8596afaf09dd$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $2063e2c40cd283b3$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $00ff8596afaf09dd$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $925ba6dd483bb6b4$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $925ba6dd483bb6b4$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}








const $0cd392c48de98699$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $2063e2c40cd283b3$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $2063e2c40cd283b3$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $2063e2c40cd283b3$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $0cd392c48de98699$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $b420ba3b2adbb1e7$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $efc0e00f2c69dce5$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $2063e2c40cd283b3$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $efc0e00f2c69dce5$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $efc0e00f2c69dce5$export$4aa56776043a4631 extends $efc0e00f2c69dce5$export$23e9464cc010dff9 {
}
class $efc0e00f2c69dce5$export$4b982ee840d3d915 extends $efc0e00f2c69dce5$export$23e9464cc010dff9 {
}
async function $efc0e00f2c69dce5$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $efc0e00f2c69dce5$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($efc0e00f2c69dce5$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $efc0e00f2c69dce5$var$PROCESS_LOCKS = {};
async function $efc0e00f2c69dce5$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $efc0e00f2c69dce5$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $efc0e00f2c69dce5$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $efc0e00f2c69dce5$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}



(0, $b420ba3b2adbb1e7$export$ad067ce270531206)(); // Make "globalThis" available
const $f2ddf9f0f6ad6fbf$var$DEFAULT_OPTIONS = {
    url: (0, $7547639a607dd8b2$export$7fedf552187f0c3d),
    storageKey: (0, $7547639a607dd8b2$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $7547639a607dd8b2$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
async function $f2ddf9f0f6ad6fbf$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $f2ddf9f0f6ad6fbf$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $f2ddf9f0f6ad6fbf$export$2e2bcd8739ae039.nextInstanceID;
        $f2ddf9f0f6ad6fbf$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $2063e2c40cd283b3$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $f2ddf9f0f6ad6fbf$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $00ff8596afaf09dd$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $2063e2c40cd283b3$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $f2ddf9f0f6ad6fbf$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $efc0e00f2c69dce5$export$f4ff21938fb7af3c);
        else this.lock = $f2ddf9f0f6ad6fbf$var$lockNoOp;
        this.jwks = {
            keys: []
        };
        this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $2063e2c40cd283b3$export$9ec034ee80211814)()) this.storage = (0, $0cd392c48de98699$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $0cd392c48de98699$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $0cd392c48de98699$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $e65a26507e4ec691$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $2063e2c40cd283b3$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $46e750dae2611590$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $46e750dae2611590$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
                });
            } else throw new (0, $46e750dae2611590$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $925ba6dd483bb6b4$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $925ba6dd483bb6b4$export$db83aade1c2922c7)
                });
            } else throw new (0, $46e750dae2611590$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $46e750dae2611590$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $2063e2c40cd283b3$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
            });
            await (0, $2063e2c40cd283b3$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $46e750dae2611590$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $46e750dae2611590$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $46e750dae2611590$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $925ba6dd483bb6b4$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $46e750dae2611590$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $2063e2c40cd283b3$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $7547639a607dd8b2$export$a36ad0026e55ac00) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) {
                if ((0, $46e750dae2611590$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $2063e2c40cd283b3$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $925ba6dd483bb6b4$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $2063e2c40cd283b3$export$9a62e6c0a30e00bc)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $2063e2c40cd283b3$export$4e09c449d6c407f7)()) throw new (0, $46e750dae2611590$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $46e750dae2611590$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $46e750dae2611590$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $46e750dae2611590$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $46e750dae2611590$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $46e750dae2611590$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $7547639a607dd8b2$export$a4558fee79d6c8ae)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $2063e2c40cd283b3$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $46e750dae2611590$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $2063e2c40cd283b3$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $2063e2c40cd283b3$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $2063e2c40cd283b3$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $2063e2c40cd283b3$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $925ba6dd483bb6b4$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $46e750dae2611590$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $7547639a607dd8b2$export$a4558fee79d6c8ae);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $2063e2c40cd283b3$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) * 1000 - Date.now() < (0, $7547639a607dd8b2$export$a36ad0026e55ac00);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $7547639a607dd8b2$export$a36ad0026e55ac00)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $46e750dae2611590$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $2063e2c40cd283b3$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $46e750dae2611590$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $46e750dae2611590$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $2063e2c40cd283b3$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $2063e2c40cd283b3$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $7547639a607dd8b2$export$a4558fee79d6c8ae));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $7547639a607dd8b2$export$a4558fee79d6c8ae));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $7547639a607dd8b2$export$a4558fee79d6c8ae)}ms, refresh threshold is ${(0, $7547639a607dd8b2$export$f20a97df8f5fe223)} ticks`);
                            if (expiresInTicks <= (0, $7547639a607dd8b2$export$f20a97df8f5fe223)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $efc0e00f2c69dce5$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $2063e2c40cd283b3$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $2063e2c40cd283b3$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const { payload: payload } = (0, $2063e2c40cd283b3$export$9a62e6c0a30e00bc)(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $7547639a607dd8b2$export$5bd768495200f133) > Date.now()) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $925ba6dd483bb6b4$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) throw new (0, $46e750dae2611590$export$d04cb18528f2043e)('JWKS is empty');
        this.jwks = data;
        this.jwks_cached_at = Date.now();
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) throw new (0, $46e750dae2611590$export$d04cb18528f2043e)('No matching signing key found in JWKS');
        return jwk;
    }
    /**
     * @experimental This method may change in future versions.
     * @description Gets the claims from a JWT. If the JWT is symmetric JWTs, it will call getUser() to verify against the server. If the JWT is asymmetric, it will be verified against the JWKS using the WebCrypto API.
     */ async getClaims(jwt, jwks = {
        keys: []
    }) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return {
                    data: null,
                    error: error
                };
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $2063e2c40cd283b3$export$9a62e6c0a30e00bc)(token);
            // Reject expired JWTs
            (0, $2063e2c40cd283b3$export$a5850868adeb9253)(payload.exp);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!header.kid || header.alg === 'HS256' || !('crypto' in globalThis && 'subtle' in globalThis.crypto)) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $2063e2c40cd283b3$export$fa59f625ab60cb91)(header.alg);
            const signingKey = await this.fetchJwk(header.kid, jwks);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $9578a0ba8688392b$export$a098e7b533f96db3)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $46e750dae2611590$export$d04cb18528f2043e)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $46e750dae2611590$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}
$f2ddf9f0f6ad6fbf$export$2e2bcd8739ae039.nextInstanceID = 0;



const $03fa282c64272501$var$AuthAdminApi = (0, $00ff8596afaf09dd$export$2e2bcd8739ae039);
var $03fa282c64272501$export$2e2bcd8739ae039 = $03fa282c64272501$var$AuthAdminApi;



const $8fb9fbc07d11cfdf$var$AuthClient = (0, $f2ddf9f0f6ad6fbf$export$2e2bcd8739ae039);
var $8fb9fbc07d11cfdf$export$2e2bcd8739ae039 = $8fb9fbc07d11cfdf$var$AuthClient;








class $ff8eabeef0a670b9$export$8199a418bb09bd56 extends (0, $8fb9fbc07d11cfdf$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $a163807cb8fc3e74$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $a163807cb8fc3e74$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $504803040a2579f2$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $4b9c91ef8a961676$export$b31378ae815bea6b),
            realtime: (0, $4b9c91ef8a961676$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $4b9c91ef8a961676$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $4b9c91ef8a961676$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $504803040a2579f2$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $cf2b518fa2567860$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $5423e4dd4c21e962$export$796f32e2ee984aaa)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $7b1b7568825f5055$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $c696f818f9a73d96$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $a163807cb8fc3e74$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $ff8eabeef0a670b9$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $25eb1491e5bc5f9e$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}






const $107e9832481295ca$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $a163807cb8fc3e74$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


// For React apps using Create React App:
const $ca7b91da655d9662$var$supabaseUrl = "https://qpiwquzczftkchtnkuai.supabase.co";
const $ca7b91da655d9662$var$supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwaXdxdXpjemZ0a2NodG5rdWFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1NjIzNzMsImV4cCI6MjA2MDEzODM3M30.aYQqo6MaipE450z6Hk251CBDnq-gmrS7uqi_dvnXDUM";
const $ca7b91da655d9662$export$a0b632a28672d3c0 = (0, $107e9832481295ca$export$5d730b7aed1a3eb0)($ca7b91da655d9662$var$supabaseUrl, $ca7b91da655d9662$var$supabaseAnonKey);


const $fa441f73aa1797a9$var$AuthContext = /*#__PURE__*/ (0, $7fPBF.createContext)();
const $fa441f73aa1797a9$export$87091915187a1a85 = ({ children: children })=>{
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        // Check for active session
        const getSession = async ()=>{
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.getSession();
            if (data?.session) setUser(data.session.user);
            setLoading(false);
        };
        getSession();
        // Set up auth state listener
        const { data: { subscription: subscription } } = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.onAuthStateChange((_event, session)=>{
            setUser(session?.user || null);
            setLoading(false);
        });
        return ()=>{
            subscription?.unsubscribe();
        };
    }, []);
    // Add signOut function
    const signOut = async ()=>{
        try {
            await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signOut();
            setUser(null);
        } catch (error) {
            console.error("Error signing out:", error);
            throw error;
        }
    };
    const value = {
        user: user,
        loading: loading,
        signIn: (data)=>(0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signInWithPassword(data),
        signUp: (data)=>(0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signUp(data),
        signOut: signOut
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fa441f73aa1797a9$var$AuthContext.Provider, {
        value: value,
        children: children
    });
};
const $fa441f73aa1797a9$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $7fPBF.useContext)($fa441f73aa1797a9$var$AuthContext);
    if (context === undefined) throw new Error("useAuth must be used within an AuthProvider");
    return context;
};




var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");

var $c963d942e9344119$exports = {};

$parcel$export($c963d942e9344119$exports, "logo-color-default", function () { return $c963d942e9344119$export$fde46214c6040371; }, function (v) { return $c963d942e9344119$export$fde46214c6040371 = v; });
$parcel$export($c963d942e9344119$exports, "logo-color-primary", function () { return $c963d942e9344119$export$7791560fbc895514; }, function (v) { return $c963d942e9344119$export$7791560fbc895514 = v; });
$parcel$export($c963d942e9344119$exports, "logo-color-white", function () { return $c963d942e9344119$export$5cfab68eb2b2a740; }, function (v) { return $c963d942e9344119$export$5cfab68eb2b2a740 = v; });
$parcel$export($c963d942e9344119$exports, "logo-container", function () { return $c963d942e9344119$export$11d2cbce11bae360; }, function (v) { return $c963d942e9344119$export$11d2cbce11bae360 = v; });
$parcel$export($c963d942e9344119$exports, "logo-icon", function () { return $c963d942e9344119$export$87becb60b7ee6861; }, function (v) { return $c963d942e9344119$export$87becb60b7ee6861 = v; });
$parcel$export($c963d942e9344119$exports, "logo-size-large", function () { return $c963d942e9344119$export$9a364dee8b788dbe; }, function (v) { return $c963d942e9344119$export$9a364dee8b788dbe = v; });
$parcel$export($c963d942e9344119$exports, "logo-size-medium", function () { return $c963d942e9344119$export$49e0d57a20b0a6ec; }, function (v) { return $c963d942e9344119$export$49e0d57a20b0a6ec = v; });
$parcel$export($c963d942e9344119$exports, "logo-size-small", function () { return $c963d942e9344119$export$2709d79fdba10854; }, function (v) { return $c963d942e9344119$export$2709d79fdba10854 = v; });
var $c963d942e9344119$export$fde46214c6040371;
var $c963d942e9344119$export$7791560fbc895514;
var $c963d942e9344119$export$5cfab68eb2b2a740;
var $c963d942e9344119$export$11d2cbce11bae360;
var $c963d942e9344119$export$87becb60b7ee6861;
var $c963d942e9344119$export$9a364dee8b788dbe;
var $c963d942e9344119$export$49e0d57a20b0a6ec;
var $c963d942e9344119$export$2709d79fdba10854;
$c963d942e9344119$export$fde46214c6040371 = `z6udQa_logo-color-default`;
$c963d942e9344119$export$7791560fbc895514 = `z6udQa_logo-color-primary`;
$c963d942e9344119$export$5cfab68eb2b2a740 = `z6udQa_logo-color-white`;
$c963d942e9344119$export$11d2cbce11bae360 = `z6udQa_logo-container`;
$c963d942e9344119$export$87becb60b7ee6861 = `z6udQa_logo-icon`;
$c963d942e9344119$export$9a364dee8b788dbe = `z6udQa_logo-size-large`;
$c963d942e9344119$export$49e0d57a20b0a6ec = `z6udQa_logo-size-medium`;
$c963d942e9344119$export$2709d79fdba10854 = `z6udQa_logo-size-small`;


const $e1a939115c3410dd$var$Logo = ({ linkTo: linkTo = "/", color: color = "default", size: size = "medium" })=>{
    const getColorClass = ()=>{
        if (color === "white") return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-color-white"];
        if (color === "primary") return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-color-primary"];
        return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-color-default"];
    };
    const getSizeClass = ()=>{
        if (size === "small") return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-size-small"];
        if (size === "large") return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-size-large"];
        return (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-size-medium"];
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
        to: linkTo,
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-container"]} ${getColorClass()} ${getSizeClass()}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                className: `fas fa-qrcode ${(0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-icon"]}`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c963d942e9344119$exports)))["logo-text"],
                children: "QR Butler"
            })
        ]
    });
};
var $e1a939115c3410dd$export$2e2bcd8739ae039 = $e1a939115c3410dd$var$Logo;


// THIS FILE IS AUTO GENERATED
var $6942f570b2482f98$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "MIT",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $f97cf88e92451917$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $f97cf88e92451917$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($f97cf88e92451917$export$4a4ef469214f8641);


var $5d3ad115d001cb84$var$_excluded = [
    "attr",
    "size",
    "title"
];
function $5d3ad115d001cb84$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5d3ad115d001cb84$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5d3ad115d001cb84$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5d3ad115d001cb84$var$_extends() {
    $5d3ad115d001cb84$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d3ad115d001cb84$var$_extends.apply(this, arguments);
}
function $5d3ad115d001cb84$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d3ad115d001cb84$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d3ad115d001cb84$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5d3ad115d001cb84$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d3ad115d001cb84$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d3ad115d001cb84$var$_defineProperty(obj, key, value) {
    key = $5d3ad115d001cb84$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5d3ad115d001cb84$var$_toPropertyKey(t) {
    var i = $5d3ad115d001cb84$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5d3ad115d001cb84$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5d3ad115d001cb84$var$Tree2Element(tree) {
    return tree && tree.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(node.tag, $5d3ad115d001cb84$var$_objectSpread({
            key: i
        }, node.attr), $5d3ad115d001cb84$var$Tree2Element(node.child)));
}
function $5d3ad115d001cb84$export$6fce6cce1e9a936d(data) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5d3ad115d001cb84$export$a188ecdd443fe91a, $5d3ad115d001cb84$var$_extends({
            attr: $5d3ad115d001cb84$var$_objectSpread({}, data.attr)
        }, props), $5d3ad115d001cb84$var$Tree2Element(data.child));
}
function $5d3ad115d001cb84$export$a188ecdd443fe91a(props) {
    var elem = (conf)=>{
        var { attr: attr, size: size, title: title } = props, svgProps = $5d3ad115d001cb84$var$_objectWithoutProperties(props, $5d3ad115d001cb84$var$_excluded);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $5d3ad115d001cb84$var$_extends({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $5d3ad115d001cb84$var$_objectSpread($5d3ad115d001cb84$var$_objectSpread({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title), props.children);
    };
    return (0, $f97cf88e92451917$export$a49f528ae1a4d0ed) !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f97cf88e92451917$export$a49f528ae1a4d0ed).Consumer, null, (conf)=>elem(conf)) : elem((0, $f97cf88e92451917$export$4a4ef469214f8641));
}





function $224220bec829c8cd$export$267f6a665e00ab4f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 18 12 15 21 9 3 6 12 2 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f15509c0f38da8af(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 15 17 21 7 21 12 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8e5723405180c9a9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dbcde33461007065(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e155fac140286da3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$95a4188b594d565e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "10",
                    "x2": "6",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "18",
                    "x2": "6",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2eb341b7ea186bea(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8917cc30b8759ee1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$97ded619a1b970b7(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "7",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "7",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f9204ad967d5d65e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H2a10 10 0 0 0 20 0h-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a7e9a61a7dec6d79(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "8",
                    "x2": "20.05",
                    "y2": "17.94"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "8",
                    "x2": "21.17",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7.38",
                    "y1": "12",
                    "x2": "13.12",
                    "y2": "2.06"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "16",
                    "x2": "3.95",
                    "y2": "6.06"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "16",
                    "x2": "2.83",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.62",
                    "y1": "12",
                    "x2": "10.88",
                    "y2": "21.94"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b2485051e564fce1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 8 21 21 3 21 3 8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "22",
                    "height": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "12",
                    "x2": "14",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dd3f3c5a1d53d77e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 12 12 16 16 12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1c4fa461fc2194d3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "7",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 17 7 17 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$34909c4d498f141d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "17",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 7 17 17 7 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fe357b1c469bec96(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 12 12 19 5 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9004e83bb5a50648(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 8 8 12 12 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "12",
                    "x2": "8",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$7d058c8fc42b3484(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "12",
                    "x2": "5",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 19 5 12 12 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$eba7d9ce28178b15(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 16 16 12 12 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a305b640abe8c4e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 5 19 12 12 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d80098591ae56d4d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 12 12 8 8 12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5ee40d2503752d98(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "7",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 17 7 7 17 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e2b35aa7c05e571c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "17",
                    "x2": "17",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 7 17 7 17 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$de137450acf89135(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 12 12 5 19 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d06ac557cb156c7d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b16440d451f09912(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$13af84db5d19481e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$563c74cc78537c0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$77d74f3b256203a6(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 6 7 12 13 12 9 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dbf8d6020cf07ed9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "6",
                    "width": "18",
                    "height": "12",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9bf443402bff5176(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.63 13A17.89 17.89 0 0 1 18 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a6 6 0 0 0-9.33-5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$daf9245cff6c3210(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5b16f71cb5b67dde(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$98a4866a23333521(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$898b357cbb3f5d73(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$44ad51dbc660c15f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4e077b34ae10f582(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a30da76548081d26(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ce1c504ffe508904(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$10d5cacd9501bbfa(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "2",
                    "x2": "16",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "10",
                    "x2": "21",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$182c5362e9e947b9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a5d4befc3914f30d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3344d3255389e578(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "20",
                    "x2": "2.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2a34cadb9c7fec6d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 4 12 14.01 9 11.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$10e5555822717586(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 11 12 14 22 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$12b035227cf9389b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 6 9 17 4 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ea5380252b30a193(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 12 15 18 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b69eb2f9a0945674(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 18 9 12 15 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a8d72316988d19f1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 18 15 12 9 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4bd212f78cb84d52(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 15 12 9 6 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a3a94d20ee4ea213(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 13 12 18 17 13"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 6 12 11 17 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c1724d494c6a158(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 17 6 12 11 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 17 13 12 18 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fcbcb5f8e4c2cdc9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 17 18 12 13 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 17 11 12 6 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a9318b47104fc04c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 12 6 7 11"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 12 13 7 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$689268c79dea320b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21.17",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3.95",
                    "y1": "6.06",
                    "x2": "8.54",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10.88",
                    "y1": "21.94",
                    "x2": "15.46",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$688d8c1a5580bd89(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$718f31b68f165ef9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "2",
                    "width": "8",
                    "height": "4",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b8ec2cad8fdf41a5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f8e48da087d8be8a(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "19",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "19",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$72cf629fb485b05b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 11 9 17 15 17 11 23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dc6782f64d5d7013(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$712e01a64a6f77b9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$85ca6c13dc79416(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "16",
                    "x2": "8.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "20",
                    "x2": "8.01",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12.01",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "16",
                    "x2": "16.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "20",
                    "x2": "16.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$df461c3a33a72420(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c13019c948ecce83(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 18 22 12 16 6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 2 12 8 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f02be8db599c1e5e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "15.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8.5 12 15.5 2 8.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 15.5 12 8.5 22 15.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "8.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a950ee04ed5abdb0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 4.21 12 6.81 16.5 4.21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 19.79 7.5 14.6 3 12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 12 16.5 14.6 16.5 19.79"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2711c7e04972826d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h1a4 4 0 0 1 0 8h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "1",
                    "x2": "6",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "1",
                    "x2": "10",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "1",
                    "x2": "14",
                    "y2": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$82d4ac863d8199c6(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$7936c63f41b1a738(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$37f1a632f3f1e184(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d343a2f87ee72e20(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "13",
                    "height": "13",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$530c7651f0e4ae78(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 10 4 15 9 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v7a4 4 0 0 1-4 4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e6e1cd3d1c9d6915(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 10 20 15 15 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v7a4 4 0 0 0 4 4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4d34c0a7548c0109(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 15 9 20 4 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-7a4 4 0 0 0-4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$bb2c53af7dc04770(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 9 9 4 4 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20h-7a4 4 0 0 1-4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2d36a8e2d41456f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 15 15 20 20 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7a4 4 0 0 1 4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$aed74f5f80ec8ca8(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 15 4 20 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h7a4 4 0 0 0 4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$805d9902e2ab469c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 14 4 9 9 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-7a4 4 0 0 0-4-4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2d853753f202e10b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 14 20 9 15 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20v-7a4 4 0 0 1 4-4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4848b5bec045556f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "4",
                    "width": "16",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "1",
                    "x2": "9",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "1",
                    "x2": "15",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "9",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "20",
                    "x2": "15",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "9",
                    "x2": "23",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "14",
                    "x2": "23",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "9",
                    "x2": "4",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "4",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5d6c3f93b1569306(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "4",
                    "width": "22",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "10",
                    "x2": "23",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9e0e87fd57502d8d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.13 1L6 16a2 2 0 0 0 2 2h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.13L16 6a2 2 0 0 1 2 2v15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$49dcd8c24ba6abdc(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "18",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$93556a14caec4876(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1a0218dab79e6acd(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "9",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "18",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d4210adab954a159(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$87a88561efeb5120(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e2dff6a1006d5778(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$12ec33f352eb0e16(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4eea32b38871a225(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5cc2db742c978330(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 17 12 21 16 17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d455598edb9cdf88(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 10 12 15 17 10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$663255e234895e9b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b93929b4cf937656(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$72c1672405f8cac2(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3160a2892d0a1e20(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$54abe8530fbf9c81(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dd412c17c542d388(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "14",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$83d97bd7471aa8d8(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f601afa691591de3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f32046460092cd1d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d8fce91115a92d98(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 19 22 12 13 5 13 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "2 19 11 12 2 5 2 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$27382a65ccd06d6e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "15",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$afd3026aee940215(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f7397199414900f2(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8e5e18b0d5d02ea1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$19d242ec0e154174(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "8",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "17",
                    "x2": "8",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 9 9 8 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dc61d91398194410(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 2 13 9 20 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$7f2e92e34dfb7902(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "2.18",
                    "ry": "2.18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "2",
                    "x2": "7",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "2",
                    "x2": "17",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "7",
                    "x2": "7",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "17",
                    "x2": "7",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "22",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "22",
                    "y2": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ebb93a1afb2fac1e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$64fe6fee89cd58a9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "22",
                    "x2": "4",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f07ffcc4d8a2c8ce(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$eb2e7a79d02ed668(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "11",
                    "x2": "12",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3b7b3b63ca44d1fb(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ed9f7cf4f0026f09(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2da71e1804b6f1aa(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fa0c86613abdbc41(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 12 20 22 4 22 4 12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f17cfdf6fa84f40d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "3",
                    "x2": "6",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a9 9 0 0 1-9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$57ae875db121999c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1.05",
                    "y1": "12",
                    "x2": "7",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.01",
                    "y1": "12",
                    "x2": "22.96",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$89028bc8fe9485e4(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21V9a9 9 0 0 0 9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$345bfaac6794bcf3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "9",
                    "x2": "6",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b45303d4b027680(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$89ad6403022d3567(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9532411a3b87e58c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c436bd52326ef6(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$795bedee3407657b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "16",
                    "x2": "6.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "16",
                    "x2": "10.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a6234e125b97d4f9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "9",
                    "x2": "20",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "15",
                    "x2": "20",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "3",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "3",
                    "x2": "14",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1ccadd16d8cae7ff(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18v-6a9 9 0 0 1 18 0v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$967ac3e653e15c7c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$42bfa0ad96d58c78(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5a63c278e9612374(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2dbad18710467f1a(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 22 9 12 15 12 15 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a5e7deed97e8be52(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 15 16 10 5 21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8df41d1420605672(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 16 12 14 15 10 15 8 12 2 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6d8c744810a836d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12.01",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ebdbf4f9f5cef570(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "5",
                    "ry": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "6.5",
                    "x2": "17.51",
                    "y2": "6.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f3e51bbe4b2254b7(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "4",
                    "x2": "10",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "20",
                    "x2": "5",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "4",
                    "x2": "9",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e1edceb9a27803ae(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ead8715503aa206e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 2 7 12 12 22 7 12 2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 17 12 22 22 17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 12 12 17 22 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c5159196dfb06325(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "9",
                    "x2": "21",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "21",
                    "x2": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4b89084dd540ab27(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "9.17",
                    "y2": "9.17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "14.83",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "19.07",
                    "y2": "4.93"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "18.36",
                    "y2": "5.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "9.17",
                    "y2": "14.83"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$437fb001e3a1dc1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c2c3e635615f60e2(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$61316a66a2680992(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "9",
                    "width": "4",
                    "height": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f35e526aef9384c3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "3.01",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "3.01",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "3.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a2a03a7f204c9a2b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "7.76",
                    "y2": "7.76"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "16.24",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "6",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "7.76",
                    "y2": "16.24"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "7.76",
                    "x2": "19.07",
                    "y2": "4.93"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fc54281b4f076899(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 10 0v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ba59ace88551b501(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 17 15 12 10 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fa648a1b1cd7252e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 21 12 16 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "9",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$27a522d77d3d2d0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22,6 12,13 2,6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ab316e04c4fb96fa(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8333c1459f09a858(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "6",
                    "x2": "16",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$852110258456823(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 21 3 21 3 15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "3",
                    "x2": "14",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$adff177e257c8166(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$abc08bc5980688a1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "15",
                    "x2": "16",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b50769225058330c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$91d40ccadbcaa6dc(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$49a9e42c2a6ffece(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2ea53e42be78e72b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$348220c4b7f2d758(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v2a7 7 0 0 1-14 0v-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$52e68ba7bb634014(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 14 10 14 10 20"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 10 14 10 14 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "10",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$476509ebc2f26d6e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$bba246dcbc7870e4(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$35534d1daae973a9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6a0f8a0147922bb7(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$105b514200bcb0d7(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "21",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fd61d60a57b49c46(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9abca6f764c0a1ca(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$e7d9baa187481367(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5d53b998636c728f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13l6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$725c09aded7eb198(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 9 2 12 5 15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 5 12 2 15 5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 19 12 22 9 19"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 9 22 12 19 15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b0938e003378ab3e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$af9f6bab4a948d5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 19 21 12 17 5 21 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$16d74993c11e543(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "3 11 22 2 13 21 11 13 3 11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$33b10801cd3af8ff(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3081f0b32ed3dc59(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16.5",
                    "y1": "9.4",
                    "x2": "7.5",
                    "y2": "4.21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c00bb0cc5868b468(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cbd3dba13ee255b0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "15",
                    "x2": "10",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "15",
                    "x2": "14",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3d4a4fdeb949ce6f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3d8b351359898bf5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19l7-7 3 3-7 7-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2l7.586 7.586"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$57628665534438ae(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "5",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5dafa2a769059963(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$efe11b9a623f0a7c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 1 23 5 19 9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "5",
                    "x2": "23",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fb25afe8b8765154(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 2 16 8 22 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "16",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cdce28fb1c312b97(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "17",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "1",
                    "x2": "23",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$95defb4444eec2fe(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "1",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8f53edd09d52625d(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 7 23 1 17 1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "23",
                    "y2": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fbcc38cc432837ad(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cf5c74f5c9e34b73(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12A10 10 0 0 0 12 2v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$63ac2a4ccaccfbd1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10 8 16 12 10 16 10 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$af6bc9d78ff8665b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 3 19 12 5 21 5 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$23b33cecb582b8d5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ece0f5709a547496(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$689fe09b4199e823(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$a5bf41cb81ae473(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 10 12 14 16 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2606d8589e7177aa(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 6.64a9 9 0 1 1-12.73 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$95dd116dec35b14(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 6 2 18 2 18 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "12",
                    "height": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b82f164df0732a68(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1ca0fe7999deb8e7(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 20 23 14 17 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2d21aa9a27745075(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 20 1 14 7 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6f57f453a8536a97(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 1 21 5 17 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11V9a4 4 0 0 1 4-4h14"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 23 3 19 7 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v2a4 4 0 0 1-4 4H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d056b1c3d8b74afa(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 19 2 12 11 5 11 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 19 13 12 22 5 22 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$70f49501e9e85938(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b2facb794a39aa57(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$7118af05ee41ff35(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a9 9 0 0 1 9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a16 16 0 0 1 16 16"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1104f45674df9c12(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 21 17 13 7 13 7 21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 3 7 8 15 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$97278c76d25f8f7c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "4",
                    "x2": "8.12",
                    "y2": "15.88"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.47",
                    "y1": "14.48",
                    "x2": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.12",
                    "y1": "8.12",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ec3b49c1346d2396(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3ab14b0b4740d7e5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "2",
                    "x2": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 2 15 22 11 13 2 9 22 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cede40f6fd34759f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "6.01",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "18",
                    "x2": "6.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5a7e50116f3b6280(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1a2d68aa2edcf6c8(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.59",
                    "y1": "13.51",
                    "x2": "15.42",
                    "y2": "17.49"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15.41",
                    "y1": "6.51",
                    "x2": "8.59",
                    "y2": "10.49"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$884092218eeb6b2c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 6 12 2 8 6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cb94a82ec553b02e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$8514cd806705464b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4f5d42594a6c344f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a4 4 0 0 1-8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9a07702d62565b4e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$41f2813d6fc8a26f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 3 21 3 21 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "20",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 16 21 21 16 21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "15",
                    "x2": "21",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "4",
                    "x2": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fbf6091c5d0aeb56(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "3",
                    "x2": "9",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$89616b0dc34e6f79(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "19 20 9 12 19 4 19 20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "19",
                    "x2": "5",
                    "y2": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$110e06cce8a5f711(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 4 15 12 5 20 5 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "19",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1d3569727e8ef180(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6abd105ba43862d9(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2f24368ca37a6c53(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "4",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "10",
                    "x2": "4",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "21",
                    "x2": "20",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "12",
                    "x2": "20",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "7",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "8",
                    "x2": "15",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "16",
                    "x2": "23",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$22573315dbd4b066(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "14",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$228e79cc490856f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6710316ad223d692(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12.01",
                    "y2": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$596dbbbe7ed59d47(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3d417a135f5d8fd0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4eb91858b35e3dd6(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$132f6d87d53531ee(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "4.22",
                    "x2": "5.64",
                    "y2": "5.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "18.36",
                    "x2": "19.78",
                    "y2": "19.78"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "23",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "19.78",
                    "x2": "5.64",
                    "y2": "18.36"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "5.64",
                    "x2": "19.78",
                    "y2": "4.22"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f1a9fd2222396582(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 12 2 16 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$920bec0eaee4bc30(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 5 12 9 8 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4530543bf3fdafc8(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$11489db666064400(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5f4e44affcbbc4c0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "7.01",
                    "y2": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d1792b6fedabf003(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cb8a6df29ab3beda(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 17 10 11 4 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "20",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5b457b75d920e5c1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$efaae75895b388ae(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ce560eeab2610ecf(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4e4f04acb0afbbf1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9a1cab46f20a3451(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5a8a3c19116af3f1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b45f06eb58143962(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "11",
                    "x2": "10",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "11",
                    "x2": "14",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d150dffb65638cb4(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2b6e5173960f7231(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "3",
                    "height": "9"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "7",
                    "width": "3",
                    "height": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$473b4c32cb9c123a(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 18 13.5 8.5 8.5 13.5 1 6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 23 18 23 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$fad9644d3e8957ad(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 6 13.5 15.5 8.5 10.5 1 18"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 6 23 6 23 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4bec88612e1cf49a(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$83296ef4c01a23c2(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "15",
                    "height": "13"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16 8 20 8 23 11 23 16 16 16 16 8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "18.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "18.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$54e22194544dafeb(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "15",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 2 12 7 7 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$901b594beb98342(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$1a4a79d50651dc0c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$6fd390f7231931c3(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 7 4 4 20 4 20 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "15",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "4",
                    "x2": "12",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$778ecbc768cf0497(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$21435156dc525c9c(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "20",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$51e31213368dc22f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 9.9-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$dda53dfc047e1e57(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$21d8ed3329b3bc94(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 8 12 3 7 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "3",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$982c731970b14d26(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 19 13 23 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$946a68f031019c38(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$d29888d481fb4bb2(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "8",
                    "x2": "20",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b89e2f833f36ed1e(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "8",
                    "x2": "23",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "8",
                    "x2": "18",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$db323b26626af533(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$b91acdc2f2196abd(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21v-2a4 4 0 0 0-3-3.87"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.13a4 4 0 0 1 0 7.75"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2f017e47d1904bf5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4b873a4f38d0e312(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "23 7 16 12 23 17 23 7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "15",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$89a19527ac4bea7a(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "11.5",
                    "r": "4.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "11.5",
                    "r": "4.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5.5",
                    "y1": "16",
                    "x2": "18.5",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2562182dbe6f48f1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$2aa37add4f006aa4(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$5211546efb69b8b1(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "9",
                    "x2": "17",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "9",
                    "x2": "23",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c245550c7099bcea(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ba9fedcf93fa9af0(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 9 12 12 13.5 13.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$f11e8a486cd09251(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.71 5.05A16 16 0 0 1 22.58 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4f808f790823e5a5(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a11 11 0 0 1 14.08 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a16 16 0 0 1 21.16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$cddc74169eed0643(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$7b1b0eab235ada3f(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c94b846d8eff96de(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$ac22140d9ac7df07(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$c7222af9b49907b4(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "6",
                    "x2": "6",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$9f5af188e5de0552(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$feec27b6ec0ed725(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "12.41 6.75 13 2 10.57 4.92"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18.57 12.91 21 10 15.66 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 3 14 12 14 11 22 16 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$4d144bd0444c3a46(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$38f6b9da82fb823b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "y1": "8",
                    "x2": "11",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $224220bec829c8cd$export$3d3849badba7351b(props) {
    return (0, $5d3ad115d001cb84$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}


var $89aad616130e02bd$exports = {};

$parcel$export($89aad616130e02bd$exports, "active", function () { return $89aad616130e02bd$export$89da14300d534261; }, function (v) { return $89aad616130e02bd$export$89da14300d534261 = v; });
$parcel$export($89aad616130e02bd$exports, "authButtons", function () { return $89aad616130e02bd$export$2be0a6a358329fc0; }, function (v) { return $89aad616130e02bd$export$2be0a6a358329fc0 = v; });
$parcel$export($89aad616130e02bd$exports, "authContainer", function () { return $89aad616130e02bd$export$8e5abf1bd3c2f426; }, function (v) { return $89aad616130e02bd$export$8e5abf1bd3c2f426 = v; });
$parcel$export($89aad616130e02bd$exports, "chevron", function () { return $89aad616130e02bd$export$980c1089c0604ea3; }, function (v) { return $89aad616130e02bd$export$980c1089c0604ea3 = v; });
$parcel$export($89aad616130e02bd$exports, "container", function () { return $89aad616130e02bd$export$34e0f9847d4c02dd; }, function (v) { return $89aad616130e02bd$export$34e0f9847d4c02dd = v; });
$parcel$export($89aad616130e02bd$exports, "desktopNav", function () { return $89aad616130e02bd$export$1c293fe90c1b78e3; }, function (v) { return $89aad616130e02bd$export$1c293fe90c1b78e3 = v; });
$parcel$export($89aad616130e02bd$exports, "fadeIn", function () { return $89aad616130e02bd$export$82e6205b15e6c637; }, function (v) { return $89aad616130e02bd$export$82e6205b15e6c637 = v; });
$parcel$export($89aad616130e02bd$exports, "header", function () { return $89aad616130e02bd$export$38e42c68cf43b5d4; }, function (v) { return $89aad616130e02bd$export$38e42c68cf43b5d4 = v; });
$parcel$export($89aad616130e02bd$exports, "loginButton", function () { return $89aad616130e02bd$export$7abe78e1eda562aa; }, function (v) { return $89aad616130e02bd$export$7abe78e1eda562aa = v; });
$parcel$export($89aad616130e02bd$exports, "logoContainer", function () { return $89aad616130e02bd$export$a1fe6a2d7788354f; }, function (v) { return $89aad616130e02bd$export$a1fe6a2d7788354f = v; });
$parcel$export($89aad616130e02bd$exports, "logoLink", function () { return $89aad616130e02bd$export$ca5ab360c5bee0b1; }, function (v) { return $89aad616130e02bd$export$ca5ab360c5bee0b1 = v; });
$parcel$export($89aad616130e02bd$exports, "logoText", function () { return $89aad616130e02bd$export$19ee943b107f7e95; }, function (v) { return $89aad616130e02bd$export$19ee943b107f7e95 = v; });
$parcel$export($89aad616130e02bd$exports, "menuDivider", function () { return $89aad616130e02bd$export$af4d115529f6cc30; }, function (v) { return $89aad616130e02bd$export$af4d115529f6cc30 = v; });
$parcel$export($89aad616130e02bd$exports, "menuItem", function () { return $89aad616130e02bd$export$c176f998e71d0f08; }, function (v) { return $89aad616130e02bd$export$c176f998e71d0f08 = v; });
$parcel$export($89aad616130e02bd$exports, "mobileAuthButton", function () { return $89aad616130e02bd$export$d9a915885d39cf41; }, function (v) { return $89aad616130e02bd$export$d9a915885d39cf41 = v; });
$parcel$export($89aad616130e02bd$exports, "mobileMenu", function () { return $89aad616130e02bd$export$a9dde863f8eded58; }, function (v) { return $89aad616130e02bd$export$a9dde863f8eded58 = v; });
$parcel$export($89aad616130e02bd$exports, "mobileMenuButton", function () { return $89aad616130e02bd$export$968c20181fa03784; }, function (v) { return $89aad616130e02bd$export$968c20181fa03784 = v; });
$parcel$export($89aad616130e02bd$exports, "mobileNav", function () { return $89aad616130e02bd$export$30353f014439f27a; }, function (v) { return $89aad616130e02bd$export$30353f014439f27a = v; });
$parcel$export($89aad616130e02bd$exports, "mobileNavLink", function () { return $89aad616130e02bd$export$76d4f712841a012f; }, function (v) { return $89aad616130e02bd$export$76d4f712841a012f = v; });
$parcel$export($89aad616130e02bd$exports, "mobileSignOutButton", function () { return $89aad616130e02bd$export$a41cad9abe1b12a5; }, function (v) { return $89aad616130e02bd$export$a41cad9abe1b12a5 = v; });
$parcel$export($89aad616130e02bd$exports, "navLink", function () { return $89aad616130e02bd$export$6ee01cf16d42268d; }, function (v) { return $89aad616130e02bd$export$6ee01cf16d42268d = v; });
$parcel$export($89aad616130e02bd$exports, "rotated", function () { return $89aad616130e02bd$export$7d2b4e7a5a4801f2; }, function (v) { return $89aad616130e02bd$export$7d2b4e7a5a4801f2 = v; });
$parcel$export($89aad616130e02bd$exports, "scrolled", function () { return $89aad616130e02bd$export$da0322cb8fa36d8e; }, function (v) { return $89aad616130e02bd$export$da0322cb8fa36d8e = v; });
$parcel$export($89aad616130e02bd$exports, "signOutButton", function () { return $89aad616130e02bd$export$bd201a40ead18b35; }, function (v) { return $89aad616130e02bd$export$bd201a40ead18b35 = v; });
$parcel$export($89aad616130e02bd$exports, "signupButton", function () { return $89aad616130e02bd$export$9a1ac15632b664ab; }, function (v) { return $89aad616130e02bd$export$9a1ac15632b664ab = v; });
$parcel$export($89aad616130e02bd$exports, "slideDown", function () { return $89aad616130e02bd$export$abdd11a06a163232; }, function (v) { return $89aad616130e02bd$export$abdd11a06a163232 = v; });
$parcel$export($89aad616130e02bd$exports, "userAvatar", function () { return $89aad616130e02bd$export$7db60fb4c6d4a032; }, function (v) { return $89aad616130e02bd$export$7db60fb4c6d4a032 = v; });
$parcel$export($89aad616130e02bd$exports, "userEmail", function () { return $89aad616130e02bd$export$d96dcee7e2ec2627; }, function (v) { return $89aad616130e02bd$export$d96dcee7e2ec2627 = v; });
$parcel$export($89aad616130e02bd$exports, "userFullName", function () { return $89aad616130e02bd$export$21d4130193645110; }, function (v) { return $89aad616130e02bd$export$21d4130193645110 = v; });
$parcel$export($89aad616130e02bd$exports, "userInfo", function () { return $89aad616130e02bd$export$94e4009ecfbf7408; }, function (v) { return $89aad616130e02bd$export$94e4009ecfbf7408 = v; });
$parcel$export($89aad616130e02bd$exports, "userMenu", function () { return $89aad616130e02bd$export$5d559278e17df9c5; }, function (v) { return $89aad616130e02bd$export$5d559278e17df9c5 = v; });
$parcel$export($89aad616130e02bd$exports, "userMenuButton", function () { return $89aad616130e02bd$export$bcd75998bfcba385; }, function (v) { return $89aad616130e02bd$export$bcd75998bfcba385 = v; });
$parcel$export($89aad616130e02bd$exports, "userMenuContainer", function () { return $89aad616130e02bd$export$42080da595cdc675; }, function (v) { return $89aad616130e02bd$export$42080da595cdc675 = v; });
$parcel$export($89aad616130e02bd$exports, "userName", function () { return $89aad616130e02bd$export$c86d3ca66f38ed60; }, function (v) { return $89aad616130e02bd$export$c86d3ca66f38ed60 = v; });
var $89aad616130e02bd$export$89da14300d534261;
var $89aad616130e02bd$export$2be0a6a358329fc0;
var $89aad616130e02bd$export$8e5abf1bd3c2f426;
var $89aad616130e02bd$export$980c1089c0604ea3;
var $89aad616130e02bd$export$34e0f9847d4c02dd;
var $89aad616130e02bd$export$1c293fe90c1b78e3;
var $89aad616130e02bd$export$82e6205b15e6c637;
var $89aad616130e02bd$export$38e42c68cf43b5d4;
var $89aad616130e02bd$export$7abe78e1eda562aa;
var $89aad616130e02bd$export$a1fe6a2d7788354f;
var $89aad616130e02bd$export$ca5ab360c5bee0b1;
var $89aad616130e02bd$export$19ee943b107f7e95;
var $89aad616130e02bd$export$af4d115529f6cc30;
var $89aad616130e02bd$export$c176f998e71d0f08;
var $89aad616130e02bd$export$d9a915885d39cf41;
var $89aad616130e02bd$export$a9dde863f8eded58;
var $89aad616130e02bd$export$968c20181fa03784;
var $89aad616130e02bd$export$30353f014439f27a;
var $89aad616130e02bd$export$76d4f712841a012f;
var $89aad616130e02bd$export$a41cad9abe1b12a5;
var $89aad616130e02bd$export$6ee01cf16d42268d;
var $89aad616130e02bd$export$7d2b4e7a5a4801f2;
var $89aad616130e02bd$export$da0322cb8fa36d8e;
var $89aad616130e02bd$export$bd201a40ead18b35;
var $89aad616130e02bd$export$9a1ac15632b664ab;
var $89aad616130e02bd$export$abdd11a06a163232;
var $89aad616130e02bd$export$7db60fb4c6d4a032;
var $89aad616130e02bd$export$d96dcee7e2ec2627;
var $89aad616130e02bd$export$21d4130193645110;
var $89aad616130e02bd$export$94e4009ecfbf7408;
var $89aad616130e02bd$export$5d559278e17df9c5;
var $89aad616130e02bd$export$bcd75998bfcba385;
var $89aad616130e02bd$export$42080da595cdc675;
var $89aad616130e02bd$export$c86d3ca66f38ed60;
$89aad616130e02bd$export$89da14300d534261 = `A05i1W_active`;
$89aad616130e02bd$export$2be0a6a358329fc0 = `A05i1W_authButtons`;
$89aad616130e02bd$export$8e5abf1bd3c2f426 = `A05i1W_authContainer`;
$89aad616130e02bd$export$980c1089c0604ea3 = `A05i1W_chevron`;
$89aad616130e02bd$export$34e0f9847d4c02dd = `A05i1W_container`;
$89aad616130e02bd$export$1c293fe90c1b78e3 = `A05i1W_desktopNav`;
$89aad616130e02bd$export$82e6205b15e6c637 = `A05i1W_fadeIn`;
$89aad616130e02bd$export$82e6205b15e6c637;
$89aad616130e02bd$export$38e42c68cf43b5d4 = `A05i1W_header`;
$89aad616130e02bd$export$7abe78e1eda562aa = `A05i1W_loginButton`;
$89aad616130e02bd$export$a1fe6a2d7788354f = `A05i1W_logoContainer`;
$89aad616130e02bd$export$ca5ab360c5bee0b1 = `A05i1W_logoLink`;
$89aad616130e02bd$export$19ee943b107f7e95 = `A05i1W_logoText`;
$89aad616130e02bd$export$af4d115529f6cc30 = `A05i1W_menuDivider`;
$89aad616130e02bd$export$c176f998e71d0f08 = `A05i1W_menuItem`;
$89aad616130e02bd$export$d9a915885d39cf41 = `A05i1W_mobileAuthButton`;
$89aad616130e02bd$export$a9dde863f8eded58 = `A05i1W_mobileMenu`;
$89aad616130e02bd$export$968c20181fa03784 = `A05i1W_mobileMenuButton`;
$89aad616130e02bd$export$30353f014439f27a = `A05i1W_mobileNav`;
$89aad616130e02bd$export$76d4f712841a012f = `A05i1W_mobileNavLink`;
$89aad616130e02bd$export$a41cad9abe1b12a5 = `A05i1W_mobileSignOutButton`;
$89aad616130e02bd$export$6ee01cf16d42268d = `A05i1W_navLink`;
$89aad616130e02bd$export$7d2b4e7a5a4801f2 = `A05i1W_rotated`;
$89aad616130e02bd$export$da0322cb8fa36d8e = `A05i1W_scrolled`;
$89aad616130e02bd$export$bd201a40ead18b35 = `A05i1W_signOutButton`;
$89aad616130e02bd$export$9a1ac15632b664ab = `A05i1W_signupButton`;
$89aad616130e02bd$export$abdd11a06a163232 = `A05i1W_slideDown`;
$89aad616130e02bd$export$abdd11a06a163232;
$89aad616130e02bd$export$7db60fb4c6d4a032 = `A05i1W_userAvatar`;
$89aad616130e02bd$export$d96dcee7e2ec2627 = `A05i1W_userEmail`;
$89aad616130e02bd$export$21d4130193645110 = `A05i1W_userFullName`;
$89aad616130e02bd$export$94e4009ecfbf7408 = `A05i1W_userInfo`;
$89aad616130e02bd$export$5d559278e17df9c5 = `A05i1W_userMenu`;
$89aad616130e02bd$export$bcd75998bfcba385 = `A05i1W_userMenuButton`;
$89aad616130e02bd$export$42080da595cdc675 = `A05i1W_userMenuContainer`;
$89aad616130e02bd$export$c86d3ca66f38ed60 = `A05i1W_userName`;


const $c44bf71e6667174d$var$Header = ()=>{
    const { user: user, signOut: signOut } = (0, $fa441f73aa1797a9$export$1d39dc5b47e56ff0)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [mobileMenuOpen, setMobileMenuOpen] = (0, $7fPBF.useState)(false);
    const [userMenuOpen, setUserMenuOpen] = (0, $7fPBF.useState)(false);
    const [scrolled, setScrolled] = (0, $7fPBF.useState)(false);
    // Handle scroll effects for header
    (0, $7fPBF.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY > 10) setScrolled(true);
            else setScrolled(false);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    // Close mobile menu when route changes
    (0, $7fPBF.useEffect)(()=>{
        setMobileMenuOpen(false);
        setUserMenuOpen(false);
    }, [
        location.pathname
    ]);
    const handleSignOut = async ()=>{
        try {
            await signOut();
            navigate('/');
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };
    const handleToggleMobileMenu = ()=>{
        setMobileMenuOpen((prev)=>!prev);
        // Close user menu if open
        if (userMenuOpen) setUserMenuOpen(false);
    };
    const handleToggleUserMenu = ()=>{
        setUserMenuOpen((prev)=>!prev);
    };
    const isActive = (path)=>{
        return location.pathname.startsWith(path);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("header", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).header} ${scrolled ? (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).scrolled : ''}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).container,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).logoContainer,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).logoLink,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {
                                    color: scrolled ? "primary" : "white",
                                    size: "medium"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).logoText,
                                    children: "QR Butler"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).desktopNav,
                        children: user ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/dashboard",
                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).navLink} ${isActive('/dashboard') ? (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).active : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$c436bd52326ef6), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: "Dashboard"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/analytics",
                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).navLink} ${isActive('/analytics') ? (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).active : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$13af84db5d19481e), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: "Analytics"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/features",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).navLink,
                                    children: "Features"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/pricing",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).navLink,
                                    children: "Pricing"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/contact",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).navLink,
                                    children: "Contact"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).authContainer,
                        children: user ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userMenuContainer,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userMenuButton,
                                    onClick: handleToggleUserMenu,
                                    "aria-expanded": userMenuOpen,
                                    "aria-label": "User menu",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userAvatar,
                                            children: user.email ? user.email.charAt(0).toUpperCase() : 'U'
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userName,
                                            children: user.email?.split('@')[0] || 'User'
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$ea5380252b30a193), {
                                            size: 16,
                                            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).chevron} ${userMenuOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).rotated : ''}`
                                        })
                                    ]
                                }),
                                userMenuOpen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userMenu,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userInfo,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userAvatar,
                                                    children: user.email ? user.email.charAt(0).toUpperCase() : 'U'
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userFullName,
                                                            children: user.email?.split('@')[0] || 'User'
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).userEmail,
                                                            children: user.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).menuDivider
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/dashboard",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).menuItem,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$c436bd52326ef6), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: "Dashboard"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/account",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).menuItem,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$db323b26626af533), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: "Account"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/settings",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).menuItem,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$5a7e50116f3b6280), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: "Settings"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).menuDivider
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            onClick: handleSignOut,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).signOutButton,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$fa648a1b1cd7252e), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: "Sign Out"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).authButtons,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/login",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).loginButton,
                                    children: "Log In"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/signup",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).signupButton,
                                    children: "Sign Up"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileMenuButton,
                        onClick: handleToggleMobileMenu,
                        "aria-expanded": mobileMenuOpen,
                        "aria-label": "Menu",
                        children: mobileMenuOpen ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$c7222af9b49907b4), {
                            size: 24
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$b50769225058330c), {
                            size: 24
                        })
                    })
                ]
            }),
            mobileMenuOpen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileMenu,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNav,
                    children: user ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/dashboard",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$c436bd52326ef6), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "Dashboard"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/analytics",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$13af84db5d19481e), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "Analytics"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/account",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$db323b26626af533), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "Account"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/settings",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$5a7e50116f3b6280), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "Settings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                onClick: handleSignOut,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileSignOutButton,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$fa648a1b1cd7252e), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "Sign Out"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/features",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: "Features"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/pricing",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileNavLink,
                                children: "Log In"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($89aad616130e02bd$exports))).mobileAuthButton,
                                children: "Sign Up"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $c44bf71e6667174d$export$2e2bcd8739ae039 = $c44bf71e6667174d$var$Header;



parcelRequire("7fPBF");


var $83ff51a28e66636d$export$adb608be33961c98;
var $83ff51a28e66636d$export$a4d8e41c19a0ba80;
var $83ff51a28e66636d$export$a65ca8467dbb209e;
var $83ff51a28e66636d$export$479d2866b0c2b2a9;
var $83ff51a28e66636d$export$970c6d219c1734d3;
var $83ff51a28e66636d$export$414b294861789270;
var $83ff51a28e66636d$export$d658018a9147579e;
var $83ff51a28e66636d$export$cae72505676c6ee7;
$83ff51a28e66636d$export$adb608be33961c98 = `hDvRhG_footer`;
$83ff51a28e66636d$export$a4d8e41c19a0ba80 = `hDvRhG_footerBottom`;
$83ff51a28e66636d$export$a65ca8467dbb209e = `hDvRhG_footerContent`;
$83ff51a28e66636d$export$479d2866b0c2b2a9 = `hDvRhG_footerLink`;
$83ff51a28e66636d$export$970c6d219c1734d3 = `hDvRhG_footerLinks`;
$83ff51a28e66636d$export$414b294861789270 = `hDvRhG_footerSection`;
$83ff51a28e66636d$export$d658018a9147579e = `hDvRhG_heart`;
$83ff51a28e66636d$export$cae72505676c6ee7 = `hDvRhG_heartbeat`;
$83ff51a28e66636d$export$cae72505676c6ee7;


const $d17877a8c203f8b6$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("footer", {
        className: $83ff51a28e66636d$export$adb608be33961c98,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: $83ff51a28e66636d$export$a65ca8467dbb209e,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $83ff51a28e66636d$export$414b294861789270,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "QR Butler"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Streamline your restaurant's ordering process with QR code technology."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $83ff51a28e66636d$export$414b294861789270,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                children: "Quick Links"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                className: $83ff51a28e66636d$export$970c6d219c1734d3,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/dashboard",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/login",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Login"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/signup",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Sign Up"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $83ff51a28e66636d$export$414b294861789270,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                children: "Legal"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                className: $83ff51a28e66636d$export$970c6d219c1734d3,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/terms",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Terms of Service"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/privacy",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Privacy Policy"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $83ff51a28e66636d$export$414b294861789270,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                children: "Support"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                className: $83ff51a28e66636d$export$970c6d219c1734d3,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                            href: "mailto:support@qrbutler.com",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Contact Support"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                            href: "tel:+1-555-0123",
                                            className: $83ff51a28e66636d$export$479d2866b0c2b2a9,
                                            children: "Call Us"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: $83ff51a28e66636d$export$a4d8e41c19a0ba80,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                    children: [
                        "\xa9 ",
                        new Date().getFullYear(),
                        " QR Butler. Made with ",
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$967ac3e653e15c7c), {
                            className: $83ff51a28e66636d$export$d658018a9147579e
                        }),
                        " for restaurants."
                    ]
                })
            })
        ]
    });
};
var $d17877a8c203f8b6$export$2e2bcd8739ae039 = $d17877a8c203f8b6$var$Footer;




var $7fPBF = parcelRequire("7fPBF");



var $dc2260a81b354db5$export$b6fb1741c7f64881;
var $dc2260a81b354db5$export$2be0a6a358329fc0;
var $dc2260a81b354db5$export$bb5ee47d9ea2348e;
var $dc2260a81b354db5$export$fbb7b67c7bb77588;
var $dc2260a81b354db5$export$34e0f9847d4c02dd;
var $dc2260a81b354db5$export$a7db06668cad9adb;
var $dc2260a81b354db5$export$b2780383ffc52a54;
var $dc2260a81b354db5$export$971ece4402ffcac5;
var $dc2260a81b354db5$export$8eba26731b835a8f;
var $dc2260a81b354db5$export$c247fd01dee748f7;
var $dc2260a81b354db5$export$493b5823483d2c4e;
var $dc2260a81b354db5$export$ced6ed16dfd6a264;
var $dc2260a81b354db5$export$6d861d61bde0b1ef;
var $dc2260a81b354db5$export$69f56c0cc76811d3;
var $dc2260a81b354db5$export$5f2b7b00d8e925bc;
var $dc2260a81b354db5$export$606190e461fe9031;
var $dc2260a81b354db5$export$fc648a4b66bc7d2d;
var $dc2260a81b354db5$export$124049a9e3d0d4c3;
var $dc2260a81b354db5$export$258045f16f202858;
var $dc2260a81b354db5$export$46c1c92549715335;
var $dc2260a81b354db5$export$7acf0aff43f729a5;
var $dc2260a81b354db5$export$db3c28d99448dcff;
var $dc2260a81b354db5$export$c6b27f75c627b4ab;
var $dc2260a81b354db5$export$c7a539ade3588a3f;
var $dc2260a81b354db5$export$321c0b1a406de31f;
var $dc2260a81b354db5$export$2dbb09b0ed590f0b;
var $dc2260a81b354db5$export$ee3212a4833dc722;
var $dc2260a81b354db5$export$5bf9d759e1699aa7;
var $dc2260a81b354db5$export$3591801e22de1e9e;
var $dc2260a81b354db5$export$43fe7bf2e5edc67d;
var $dc2260a81b354db5$export$515121fcb5723fc2;
var $dc2260a81b354db5$export$44cd80121b43cae7;
var $dc2260a81b354db5$export$41c1085b355ecc97;
var $dc2260a81b354db5$export$f3aaf94dc96a60de;
var $dc2260a81b354db5$export$403a2131e4ff8b8f;
var $dc2260a81b354db5$export$9d9d1253957b0616;
var $dc2260a81b354db5$export$cd401279ab74bbca;
var $dc2260a81b354db5$export$130dd2cd4186e923;
var $dc2260a81b354db5$export$fe855b81debe7b71;
var $dc2260a81b354db5$export$1a952fe22cdce89e;
var $dc2260a81b354db5$export$676717a9597b3c62;
var $dc2260a81b354db5$export$35d34bc0ed591a92;
var $dc2260a81b354db5$export$546e2a058a340364;
var $dc2260a81b354db5$export$708b5b39b38440a3;
var $dc2260a81b354db5$export$be3f796aed065412;
var $dc2260a81b354db5$export$944f54e3c2b14b58;
var $dc2260a81b354db5$export$fc939fb63b05d9da;
var $dc2260a81b354db5$export$396f17a016ff097f;
var $dc2260a81b354db5$export$1d345251a14461a8;
var $dc2260a81b354db5$export$6070e6f2251ac559;
var $dc2260a81b354db5$export$24ebf593b331c8aa;
var $dc2260a81b354db5$export$5b14dfaa098c2f87;
var $dc2260a81b354db5$export$43c6170710783f33;
$dc2260a81b354db5$export$b6fb1741c7f64881 = `_8Es5KW_actionButtons`;
$dc2260a81b354db5$export$2be0a6a358329fc0 = `_8Es5KW_authButtons`;
$dc2260a81b354db5$export$bb5ee47d9ea2348e = `_8Es5KW_banner`;
$dc2260a81b354db5$export$fbb7b67c7bb77588 = `_8Es5KW_calculatorContainer`;
$dc2260a81b354db5$export$34e0f9847d4c02dd = `_8Es5KW_container`;
$dc2260a81b354db5$export$a7db06668cad9adb = `_8Es5KW_content`;
$dc2260a81b354db5$export$b2780383ffc52a54 = `_8Es5KW_ctaButtons`;
$dc2260a81b354db5$export$971ece4402ffcac5 = `_8Es5KW_dashboardActions`;
$dc2260a81b354db5$export$8eba26731b835a8f = `_8Es5KW_dashboardContainer`;
$dc2260a81b354db5$export$c247fd01dee748f7 = `_8Es5KW_dashboardContent`;
$dc2260a81b354db5$export$493b5823483d2c4e = `_8Es5KW_errorMessage`;
$dc2260a81b354db5$export$ced6ed16dfd6a264 = `_8Es5KW_feature`;
$dc2260a81b354db5$export$6d861d61bde0b1ef = `_8Es5KW_featureCard`;
$dc2260a81b354db5$export$69f56c0cc76811d3 = `_8Es5KW_featureGrid`;
$dc2260a81b354db5$export$5f2b7b00d8e925bc = `_8Es5KW_featureIcon`;
$dc2260a81b354db5$export$606190e461fe9031 = `_8Es5KW_features`;
$dc2260a81b354db5$export$fc648a4b66bc7d2d = `_8Es5KW_finalCta`;
$dc2260a81b354db5$export$124049a9e3d0d4c3 = `_8Es5KW_hero`;
$dc2260a81b354db5$export$258045f16f202858 = `_8Es5KW_howItWorks`;
$dc2260a81b354db5$export$46c1c92549715335 = `_8Es5KW_loading`;
$dc2260a81b354db5$export$7acf0aff43f729a5 = `_8Es5KW_loadingContainer`;
$dc2260a81b354db5$export$db3c28d99448dcff = `_8Es5KW_logo`;
$dc2260a81b354db5$export$c6b27f75c627b4ab = `_8Es5KW_marketingContainer`;
$dc2260a81b354db5$export$c7a539ade3588a3f = `_8Es5KW_noRestaurantsMessage`;
$dc2260a81b354db5$export$321c0b1a406de31f = `_8Es5KW_price`;
$dc2260a81b354db5$export$2dbb09b0ed590f0b = `_8Es5KW_priceDetail`;
$dc2260a81b354db5$export$ee3212a4833dc722 = `_8Es5KW_pricing`;
$dc2260a81b354db5$export$5bf9d759e1699aa7 = `_8Es5KW_pricingCard`;
$dc2260a81b354db5$export$3591801e22de1e9e = `_8Es5KW_pricingContainer`;
$dc2260a81b354db5$export$43fe7bf2e5edc67d = `_8Es5KW_pricingFeatures`;
$dc2260a81b354db5$export$515121fcb5723fc2 = `_8Es5KW_pricingHeader`;
$dc2260a81b354db5$export$44cd80121b43cae7 = `_8Es5KW_pricingIntro`;
$dc2260a81b354db5$export$41c1085b355ecc97 = `_8Es5KW_primaryButton`;
$dc2260a81b354db5$export$f3aaf94dc96a60de = `_8Es5KW_pulse`;
$dc2260a81b354db5$export$f3aaf94dc96a60de;
$dc2260a81b354db5$export$403a2131e4ff8b8f = `_8Es5KW_roiCalculator`;
$dc2260a81b354db5$export$9d9d1253957b0616 = `_8Es5KW_roiHighlight`;
$dc2260a81b354db5$export$cd401279ab74bbca = `_8Es5KW_roiTable`;
$dc2260a81b354db5$export$130dd2cd4186e923 = `_8Es5KW_secondaryButton`;
$dc2260a81b354db5$export$fe855b81debe7b71 = `_8Es5KW_sectionSubtitle`;
$dc2260a81b354db5$export$1a952fe22cdce89e = `_8Es5KW_sectionTitle`;
$dc2260a81b354db5$export$676717a9597b3c62 = `_8Es5KW_setupContainer`;
$dc2260a81b354db5$export$35d34bc0ed591a92 = `_8Es5KW_step`;
$dc2260a81b354db5$export$546e2a058a340364 = `_8Es5KW_stepContent`;
$dc2260a81b354db5$export$708b5b39b38440a3 = `_8Es5KW_stepNumber`;
$dc2260a81b354db5$export$be3f796aed065412 = `_8Es5KW_steps`;
$dc2260a81b354db5$export$944f54e3c2b14b58 = `_8Es5KW_testimonialAuthor`;
$dc2260a81b354db5$export$fc939fb63b05d9da = `_8Es5KW_testimonialCard`;
$dc2260a81b354db5$export$396f17a016ff097f = `_8Es5KW_testimonialGrid`;
$dc2260a81b354db5$export$1d345251a14461a8 = `_8Es5KW_testimonialRole`;
$dc2260a81b354db5$export$6070e6f2251ac559 = `_8Es5KW_testimonialText`;
$dc2260a81b354db5$export$24ebf593b331c8aa = `_8Es5KW_testimonials`;
$dc2260a81b354db5$export$5b14dfaa098c2f87 = `_8Es5KW_welcomeHeader`;
$dc2260a81b354db5$export$43c6170710783f33 = `_8Es5KW_welcomeSection`;




function $11bf3e2e75c24a58$export$2e2bcd8739ae039() {
    const { user: user } = (0, $fa441f73aa1797a9$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [initialCheckDone, setInitialCheckDone] = (0, $7fPBF.useState)(false);
    const [stripeAccountId, setStripeAccountId] = (0, $7fPBF.useState)(null);
    const [accountStatus, setAccountStatus] = (0, $7fPBF.useState)(null);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Check if user already has a Stripe account
    (0, $7fPBF.useEffect)(()=>{
        async function checkStripeAccount() {
            if (user) try {
                const { data: data } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('stripe_connect_id, stripe_account_status').eq('user_id', user.id).single();
                if (data && data.stripe_connect_id) {
                    setStripeAccountId(data.stripe_connect_id);
                    setAccountStatus(data.stripe_account_status);
                    // Verify status with Stripe API if we have an account ID
                    if (data.stripe_connect_id) try {
                        const response = await fetch('/check-account-type', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                account_id: data.stripe_connect_id
                            })
                        });
                        if (response.ok) {
                            const accountData = await response.json();
                            setAccountStatus(accountData.charges_enabled && accountData.payouts_enabled ? 'active' : 'pending');
                        }
                    } catch (err) {
                        console.error("Error checking account with Stripe:", err);
                    }
                }
                setInitialCheckDone(true);
            } catch (error) {
                console.error("Error checking Stripe account:", error);
                setInitialCheckDone(true);
            }
            else setInitialCheckDone(true);
        }
        checkStripeAccount();
    }, [
        user
    ]);
    // Handle setting up Stripe Connect
    const handleStripeConnect = async ()=>{
        if (!user) {
            navigate('/login');
            return;
        }
        setLoading(true);
        setError(null);
        try {
            // First, check if user already has a Stripe account
            const { data: profile } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('stripe_connect_id').eq('user_id', user.id).single();
            if (profile?.stripe_connect_id) // Use the simplified account link creation for existing accounts
            try {
                const response = await fetch('/account-link', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        accountId: profile.stripe_connect_id
                    })
                });
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to create account link: ${response.status} - ${errorText}`);
                }
                const data = await response.json();
                if (data.url) {
                    // Redirect to Stripe's onboarding page
                    window.location.href = data.url;
                    return;
                } else throw new Error('No URL returned from server');
            } catch (error) {
                console.error('Account link error:', error);
                setError(`Error connecting to Stripe: ${error.message}`);
                setLoading(false);
                return;
            }
        // For new accounts, continue with account creation process
        // ...existing code...
        } catch (err) {
            console.error("Error:", err);
            setError(err.message);
        } finally{
            setLoading(false);
        }
    };
    // Handle Stripe dashboard access
    const handleStripeDashboard = async ()=>{
        if (!stripeAccountId) return;
        setLoading(true);
        try {
            const response = await fetch('/create-login-link', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    account_id: stripeAccountId
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Could not create login link');
            window.location.href = data.url;
        } catch (err) {
            console.error("Error creating dashboard link:", err);
            setError(err.message);
            setLoading(false);
        }
    };
    if (!initialCheckDone) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: $dc2260a81b354db5$export$7acf0aff43f729a5,
        children: "Loading..."
    });
    // If user is logged in, show their dashboard or Stripe setup
    if (user) {
        if (accountStatus === 'active') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: $dc2260a81b354db5$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: $dc2260a81b354db5$export$bb5ee47d9ea2348e,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                            children: "QR Butler"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Smart QR Solutions for Restaurants & Retail"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: $dc2260a81b354db5$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$971ece4402ffcac5,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "Welcome back!"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Your account is ready to take payments."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$b6fb1741c7f64881,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        onClick: ()=>navigate('/dashboard'),
                                        className: $dc2260a81b354db5$export$41c1085b355ecc97,
                                        children: [
                                            "View Dashboard ",
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a8d72316988d19f1), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        onClick: handleStripeDashboard,
                                        disabled: loading,
                                        className: $dc2260a81b354db5$export$130dd2cd4186e923,
                                        children: "Stripe Dashboard"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: $dc2260a81b354db5$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: $dc2260a81b354db5$export$bb5ee47d9ea2348e,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                            children: "QR Butler"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Smart QR Solutions for Restaurants & Retail"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: $dc2260a81b354db5$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$676717a9597b3c62,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "Complete Your Setup"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Connect with Stripe to start receiving payments for orders"
                            }),
                            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: $dc2260a81b354db5$export$493b5823483d2c4e,
                                children: error
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: handleStripeConnect,
                                disabled: loading,
                                className: $dc2260a81b354db5$export$41c1085b355ecc97,
                                style: {
                                    cursor: loading ? 'wait' : 'pointer',
                                    opacity: loading ? 0.7 : 1
                                },
                                children: loading ? "Setting up..." : "Set up Stripe Connect"
                            })
                        ]
                    })
                })
            ]
        });
    }
    const PricingSection = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
            className: $dc2260a81b354db5$export$ee3212a4833dc722,
            id: "pricing",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: $dc2260a81b354db5$export$1a952fe22cdce89e,
                        children: "Simple, Transparent Pricing"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $dc2260a81b354db5$export$44cd80121b43cae7,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "No monthly fees or hidden charges. Only pay when your customers order."
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$5bf9d759e1699aa7,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "Pay As You Go"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$321c0b1a406de31f,
                                children: [
                                    "6% ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        style: {
                                            fontSize: '16px',
                                            margin: '0 5px'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: $dc2260a81b354db5$export$2dbb09b0ed590f0b,
                                children: "per transaction"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                className: $dc2260a81b354db5$export$43fe7bf2e5edc67d,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "No monthly subscription fees"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Full menu management"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Unlimited QR codes"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Real-time order dashboard"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Basic analytics"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Customer-friendly ordering experience"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Stripe Processing Fees Not Included In Price"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                className: $dc2260a81b354db5$export$41c1085b355ecc97,
                                children: "Start For Free"
                            })
                        ]
                    })
                ]
            })
        });
    };
    // New marketing-focused landing page for non-authenticated users
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: $dc2260a81b354db5$export$c6b27f75c627b4ab,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$124049a9e3d0d4c3,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $dc2260a81b354db5$export$db3c28d99448dcff,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {
                            color: "white",
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                        children: [
                            "QR Ordering & Payments",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {}),
                            "With No Monthly Fees"
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Turn any restaurant or hotel into a digital ordering powerhouse without expensive hardware or training."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$b2780383ffc52a54,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                className: $dc2260a81b354db5$export$41c1085b355ecc97,
                                children: [
                                    "Get Started ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a8d72316988d19f1), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: "#howItWorks",
                                className: $dc2260a81b354db5$export$130dd2cd4186e923,
                                children: "How It Works"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$606190e461fe9031,
                id: "features",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: $dc2260a81b354db5$export$1a952fe22cdce89e,
                        children: "Why Choose QR Butler?"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$69f56c0cc76811d3,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-mobile-alt"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "No Special Hardware Needed"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Use your existing devices - no expensive POS terminals or proprietary hardware required. Just print QR codes and go!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-dollar-sign"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "No Monthly Fees"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Only pay when you make money - a simple 6% fee per transaction (not including payment processing). No subscriptions or hidden costs."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-chart-line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "Detailed Analytics"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Track sales trends, popular menu items, and customer behavior to optimize your business decisions in real-time."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-users"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "Reduce Labor Costs"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Let customers browse, order and pay themselves to reduce staffing needs and free up your team to focus on hospitality."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-laptop"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "No App Downloads"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Works directly in your customers' browsers - no friction, no app downloads, just scan and order."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$6d861d61bde0b1ef,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$5f2b7b00d8e925bc,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                            className: "fas fa-clock"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "Set Up in Minutes"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Create your menu, generate QR codes, and start taking orders the same day. No complex configuration or IT knowledge required."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$258045f16f202858,
                id: "howItWorks",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: $dc2260a81b354db5$export$1a952fe22cdce89e,
                        children: "How QR Butler Works"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$be3f796aed065412,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$35d34bc0ed591a92,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$708b5b39b38440a3,
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: $dc2260a81b354db5$export$546e2a058a340364,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                children: "Create Your Digital Menu"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "Sign up and build your digital menu in our simple dashboard. Add items with descriptions, prices, and photos in just minutes."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$35d34bc0ed591a92,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$708b5b39b38440a3,
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: $dc2260a81b354db5$export$546e2a058a340364,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                children: "Generate & Print QR Codes"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "Create custom QR codes for each table with our one-click generator. Print them out and place them at your tables."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$35d34bc0ed591a92,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$708b5b39b38440a3,
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: $dc2260a81b354db5$export$546e2a058a340364,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                children: "Customers Order & Pay"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "Guests scan the code with their phone, browse your menu, and place orders with secure payment - all without downloading an app."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$35d34bc0ed591a92,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: $dc2260a81b354db5$export$708b5b39b38440a3,
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: $dc2260a81b354db5$export$546e2a058a340364,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                children: "Fulfill Orders"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "Receive orders instantly on your dashboard and track them through preparation, ready, and completed states."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$24ebf593b331c8aa,
                id: "testimonials",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: $dc2260a81b354db5$export$1a952fe22cdce89e,
                        children: "What Our Customers Say"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$396f17a016ff097f,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$fc939fb63b05d9da,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$6070e6f2251ac559,
                                        children: '"We\'ve reduced front-of-house staff by 30% while increasing our average ticket size. QR Butler paid for itself in the first week and setup took less than an hour!"'
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$944f54e3c2b14b58,
                                        children: "Michael Rodriguez"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$1d345251a14461a8,
                                        children: "Owner, Coastal Kitchen"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$fc939fb63b05d9da,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$6070e6f2251ac559,
                                        children: '"I was skeptical about digital ordering, but QR Butler has been game-changing for our small restaurant. No monthly fees meant there was zero risk to try it, and now we\'re seeing 20% higher order values."'
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$944f54e3c2b14b58,
                                        children: "Sarah Johnson"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$1d345251a14461a8,
                                        children: "Manager, Urban Plate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $dc2260a81b354db5$export$fc939fb63b05d9da,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$6070e6f2251ac559,
                                        children: '"As a boutique hotel, implementing QR Butler for room service has dramatically improved our guest experience while saving us on staffing costs. The analytics help us understand what our guests really want."'
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$944f54e3c2b14b58,
                                        children: "David Chen"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: $dc2260a81b354db5$export$1d345251a14461a8,
                                        children: "General Manager, Harbor View Hotel"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PricingSection, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$403a2131e4ff8b8f,
                id: "roi",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: $dc2260a81b354db5$export$1a952fe22cdce89e,
                        children: "See Your Return On Investment"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$fbb7b67c7bb77588,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Here's how QR Butler can impact your restaurant's bottom line:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                                className: $dc2260a81b354db5$export$cd401279ab74bbca,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                    children: "Metric"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                    children: "Before QR Butler"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                    children: "With QR Butler"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "Average Order Value"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "$20.00"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("td", {
                                                        children: [
                                                            "$24.00 ",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("small", {
                                                                children: "(+20%)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "Orders Per Day"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "100"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("td", {
                                                        children: [
                                                            "120 ",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("small", {
                                                                children: "(+20%)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "Front-of-House Staff"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "5 servers"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("td", {
                                                        children: [
                                                            "3 servers ",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("small", {
                                                                children: "(-40%)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "Monthly Staff Cost"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "$12,500"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("td", {
                                                        children: [
                                                            "$7,500 ",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("small", {
                                                                children: "(-$5,000)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "QR Butler Fee (6%)"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "$0"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "$2,592"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                className: $dc2260a81b354db5$export$9d9d1253957b0616,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "Monthly Net Benefit"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        children: "+$7,408"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Results vary by establishment. This example represents a typical medium-sized restaurant implementing QR Butler for all orders."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: $dc2260a81b354db5$export$fc648a4b66bc7d2d,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Ready to transform your restaurant?"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $dc2260a81b354db5$export$2be0a6a358329fc0,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                className: $dc2260a81b354db5$export$41c1085b355ecc97,
                                children: "Sign Up Free"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                className: $dc2260a81b354db5$export$130dd2cd4186e923,
                                children: "Log In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");


parcelRequire("7fPBF");

function $b6666d0a76301080$export$2e2bcd8739ae039({ title: title, showLogo: showLogo = true }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "banner",
        children: [
            showLogo && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "headerLogo",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {
                    color: "white"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: title
            })
        ]
    });
}


function $42de0d503777469a$export$2e2bcd8739ae039() {
    const { connectedAccountId: connectedAccountId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [accountLinkCreatePending, setAccountLinkCreatePending] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (connectedAccountId) {
            setAccountLinkCreatePending(true);
            fetch("/account-link", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    accountId: connectedAccountId
                })
            }).then((response)=>response.json()).then((json)=>{
                setAccountLinkCreatePending(false);
                const { url: url, error: error } = json;
                if (url) window.location.href = url;
                if (error) setError(true);
            });
        }
    }, [
        connectedAccountId
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6666d0a76301080$export$2e2bcd8739ae039), {
                title: "Account Setup"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Complete Your Account Setup"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please provide the required information to start accepting payments for your restaurant."
                    }),
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: "Something went wrong!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "dev-callout",
                children: [
                    connectedAccountId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Account ID: ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("code", {
                                className: "bold",
                                children: connectedAccountId
                            })
                        ]
                    }),
                    accountLinkCreatePending && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Creating account link..."
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");




parcelRequire("7fPBF");
var $b2d9c00afe81deb3$exports = {};

$parcel$export($b2d9c00afe81deb3$exports, "bounce", function () { return $b2d9c00afe81deb3$export$e3ce947fb98643bf; }, function (v) { return $b2d9c00afe81deb3$export$e3ce947fb98643bf = v; });
$parcel$export($b2d9c00afe81deb3$exports, "bounce1", function () { return $b2d9c00afe81deb3$export$510d3389611ab7ac; }, function (v) { return $b2d9c00afe81deb3$export$510d3389611ab7ac = v; });
$parcel$export($b2d9c00afe81deb3$exports, "bounce2", function () { return $b2d9c00afe81deb3$export$7f7385929e91c3d5; }, function (v) { return $b2d9c00afe81deb3$export$7f7385929e91c3d5 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "centered", function () { return $b2d9c00afe81deb3$export$4081345ed090ce95; }, function (v) { return $b2d9c00afe81deb3$export$4081345ed090ce95 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "dark", function () { return $b2d9c00afe81deb3$export$55ce6f3a06c59543; }, function (v) { return $b2d9c00afe81deb3$export$55ce6f3a06c59543 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "large", function () { return $b2d9c00afe81deb3$export$f09585a853dddd32; }, function (v) { return $b2d9c00afe81deb3$export$f09585a853dddd32 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "light", function () { return $b2d9c00afe81deb3$export$a43af521ac8c3202; }, function (v) { return $b2d9c00afe81deb3$export$a43af521ac8c3202 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "medium", function () { return $b2d9c00afe81deb3$export$649ecc744817b5c7; }, function (v) { return $b2d9c00afe81deb3$export$649ecc744817b5c7 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "primary", function () { return $b2d9c00afe81deb3$export$9ad721cf3b3debe0; }, function (v) { return $b2d9c00afe81deb3$export$9ad721cf3b3debe0 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "small", function () { return $b2d9c00afe81deb3$export$3c17b0e969a90510; }, function (v) { return $b2d9c00afe81deb3$export$3c17b0e969a90510 = v; });
$parcel$export($b2d9c00afe81deb3$exports, "spinner", function () { return $b2d9c00afe81deb3$export$641374ffb95bc399; }, function (v) { return $b2d9c00afe81deb3$export$641374ffb95bc399 = v; });
var $b2d9c00afe81deb3$export$e3ce947fb98643bf;
var $b2d9c00afe81deb3$export$510d3389611ab7ac;
var $b2d9c00afe81deb3$export$7f7385929e91c3d5;
var $b2d9c00afe81deb3$export$4081345ed090ce95;
var $b2d9c00afe81deb3$export$55ce6f3a06c59543;
var $b2d9c00afe81deb3$export$f09585a853dddd32;
var $b2d9c00afe81deb3$export$a43af521ac8c3202;
var $b2d9c00afe81deb3$export$649ecc744817b5c7;
var $b2d9c00afe81deb3$export$9ad721cf3b3debe0;
var $b2d9c00afe81deb3$export$3c17b0e969a90510;
var $b2d9c00afe81deb3$export$641374ffb95bc399;
$b2d9c00afe81deb3$export$e3ce947fb98643bf = `-9zTYq_bounce`;
$b2d9c00afe81deb3$export$e3ce947fb98643bf;
$b2d9c00afe81deb3$export$510d3389611ab7ac = `-9zTYq_bounce1`;
$b2d9c00afe81deb3$export$7f7385929e91c3d5 = `-9zTYq_bounce2`;
$b2d9c00afe81deb3$export$4081345ed090ce95 = `-9zTYq_centered`;
$b2d9c00afe81deb3$export$55ce6f3a06c59543 = `-9zTYq_dark`;
$b2d9c00afe81deb3$export$f09585a853dddd32 = `-9zTYq_large`;
$b2d9c00afe81deb3$export$a43af521ac8c3202 = `-9zTYq_light`;
$b2d9c00afe81deb3$export$649ecc744817b5c7 = `-9zTYq_medium`;
$b2d9c00afe81deb3$export$9ad721cf3b3debe0 = `-9zTYq_primary`;
$b2d9c00afe81deb3$export$3c17b0e969a90510 = `-9zTYq_small`;
$b2d9c00afe81deb3$export$641374ffb95bc399 = `-9zTYq_spinner`;


const $dba5ea7582e69c6a$export$7c20be4c1d342248 = ({ size: size = 'medium', color: color = 'primary', centered: centered = false })=>{
    const sizeClass = {
        small: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).small,
        medium: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).medium,
        large: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).large
    }[size];
    const colorClass = {
        primary: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).primary,
        light: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).light,
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).dark
    }[color];
    const containerClass = centered ? (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).centered : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: containerClass,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).spinner} ${sizeClass} ${colorClass}`,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).bounce1
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).bounce2
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b2d9c00afe81deb3$exports))).bounce3
                })
            ]
        })
    });
};


function $7ccf711b7896eefe$export$2e2bcd8739ae039() {
    const { connectedAccountId: connectedAccountId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        const checkAccountStatus = async ()=>{
            if (!connectedAccountId) {
                setError("Missing account ID");
                setLoading(false);
                return;
            }
            try {
                console.log("Checking status for account:", connectedAccountId);
                // First, try to get account status from Stripe
                try {
                    const response = await fetch('/check-account-type', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            account_id: connectedAccountId
                        })
                    });
                    // Check if the response is JSON
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.includes("application/json")) {
                        const accountData = await response.json();
                        console.log("Account status from Stripe:", accountData);
                        // Get user ID associated with this Stripe account
                        const { data: userProfile } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('user_id').eq('stripe_connect_id', connectedAccountId).single();
                        if (!userProfile) throw new Error("Could not find user profile for this Stripe account");
                        // Update user profile with status - ALWAYS update regardless of status
                        // This ensures the database is in sync with Stripe
                        const newStatus = accountData.charges_enabled && accountData.payouts_enabled ? 'active' : 'pending';
                        console.log(`Updating account status to ${newStatus} for account ${connectedAccountId}`);
                        const { error: updateError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').update({
                            stripe_account_status: newStatus,
                            updated_at: new Date().toISOString()
                        }).eq('stripe_connect_id', connectedAccountId);
                        if (updateError) console.error("Error updating profile status:", updateError);
                        else console.log("Account status updated successfully");
                    } else console.warn("Non-JSON response from check-account-type:", await response.text());
                } catch (err) {
                    console.error("Error checking account status:", err);
                }
                // Always redirect to dashboard after a short delay
                setTimeout(()=>{
                    navigate("/dashboard");
                }, 2000);
            } catch (err) {
                console.error("Error in Return component:", err);
                setError(err.message);
            } finally{
                setLoading(false);
            }
        };
        checkAccountStatus();
    }, [
        connectedAccountId,
        navigate
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6666d0a76301080$export$2e2bcd8739ae039), {
                title: "Account Setup"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Thank You for Connecting Your Account"
                    }),
                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "loading-state",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dba5ea7582e69c6a$export$7c20be4c1d342248), {
                                size: "large",
                                centered: true
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Processing your account information..."
                            })
                        ]
                    }) : error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "error-message",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "There was a problem with your account setup: ",
                                    error
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>navigate("/dashboard"),
                                children: "Go to Dashboard"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "success-message",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Your account has been successfully connected!"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "You'll be redirected to the dashboard in a moment."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// src/components/Auth/Login.jsx


var $7fPBF = parcelRequire("7fPBF");



var $3e72fbf05f9c11e7$export$2dfc706f5cf3324e;
var $3e72fbf05f9c11e7$export$8e5abf1bd3c2f426;
var $3e72fbf05f9c11e7$export$d6f5363164931430;
var $3e72fbf05f9c11e7$export$714e9b412011a758;
var $3e72fbf05f9c11e7$export$935b30ea6eeec3be;
var $3e72fbf05f9c11e7$export$a3b7721557df7601;
var $3e72fbf05f9c11e7$export$7b13c61120c28603;
var $3e72fbf05f9c11e7$export$132a926ccc3d5388;
var $3e72fbf05f9c11e7$export$ddcee0ea2d92c46f;
var $3e72fbf05f9c11e7$export$d2297815c52203ee;
$3e72fbf05f9c11e7$export$2dfc706f5cf3324e = `Wsza8q_authButton`;
$3e72fbf05f9c11e7$export$8e5abf1bd3c2f426 = `Wsza8q_authContainer`;
$3e72fbf05f9c11e7$export$d6f5363164931430 = `Wsza8q_authError`;
$3e72fbf05f9c11e7$export$714e9b412011a758 = `Wsza8q_authForm`;
$3e72fbf05f9c11e7$export$935b30ea6eeec3be = `Wsza8q_authFormContainer`;
$3e72fbf05f9c11e7$export$a3b7721557df7601 = `Wsza8q_authHeader`;
$3e72fbf05f9c11e7$export$7b13c61120c28603 = `Wsza8q_authLinks`;
$3e72fbf05f9c11e7$export$132a926ccc3d5388 = `Wsza8q_authSuccess`;
$3e72fbf05f9c11e7$export$ddcee0ea2d92c46f = `Wsza8q_forgotPasswordLink`;
$3e72fbf05f9c11e7$export$d2297815c52203ee = `Wsza8q_formGroup`;


function $3d38facbb4779e40$export$2e2bcd8739ae039() {
    const [email, setEmail] = (0, $7fPBF.useState)("");
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const handleLogin = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signInWithPassword({
                email: email,
                password: password
            });
            if (error) throw error;
            navigate("/dashboard");
        } catch (error) {
            setError(error.message);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6666d0a76301080$export$2e2bcd8739ae039), {
                title: "Welcome Back"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Login to your account"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Sign in to manage your restaurant menus"
                    }),
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleLogin,
                        style: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "email",
                                        value: email,
                                        onChange: (e)=>setEmail(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "password",
                                        value: password,
                                        onChange: (e)=>setPassword(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "forgotPasswordLink",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: "/password-reset",
                                    children: "Forgot your password?"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                children: loading ? "Logging in..." : "Login"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        style: {
                            marginTop: '15px'
                        },
                        children: [
                            "Don't have an account? ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: "/signup",
                                children: "Sign up"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");


function $27921cfa64cacaa7$export$2e2bcd8739ae039() {
    const [email, setEmail] = (0, $7fPBF.useState)("");
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const [businessName, setBusinessName] = (0, $7fPBF.useState)("");
    const [businessType, setBusinessType] = (0, $7fPBF.useState)("");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const handleSignup = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            console.log("Starting signup process...");
            // 1. Create Supabase auth user
            const { data: authData, error: authError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signUp({
                email: email,
                password: password
            });
            if (authError) {
                console.error('Auth error:', authError);
                throw authError;
            }
            console.log("Auth user created:", authData.user.id);
            // 2. Create Stripe Connect account using the server endpoint
            const businessDetails = {
                email: email,
                name: businessName,
                businessType: businessType
            };
            console.log("Business details being sent:", {
                email: email,
                name: businessName,
                businessType: businessType
            });
            const response = await fetch("/account", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    userId: authData.user.id,
                    businessDetails: businessDetails
                })
            });
            const accountData = await response.json();
            console.log("Response from server:", accountData);
            console.log("Account type:", accountData.accountType);
            console.log("Account link URL:", accountData.accountLink);
            if (!response.ok) throw new Error(accountData.error || 'Failed to create Stripe account');
            console.log("Stripe account created:", accountData.account);
            if (accountData.accountLink) {
                console.log("Redirecting to:", accountData.accountLink);
                window.location.href = accountData.accountLink;
                return; // Important to stop execution
            }
            const { data: existingProfile } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('*').eq('user_id', authData.user.id).single();
            if (!existingProfile) {
                console.log("Creating user profile as fallback");
                const { error: dbError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').insert({
                    user_id: authData.user.id,
                    stripe_connect_id: accountData.account,
                    stripe_account_status: 'pending',
                    stripe_account_type: accountData.accountType || 'standard',
                    business_name: businessName,
                    created_at: new Date(),
                    updated_at: new Date()
                });
                if (dbError) console.error('Database error:', dbError);
            }
            const { error: signInError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signOut();
            if (signInError) console.error("Error signing out:", signInError);
            const { error: loginError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signInWithPassword({
                email: email,
                password: password
            });
            if (loginError) {
                console.error("Error signing in:", loginError);
                throw loginError;
            }
            console.log("Signup complete, navigating to dashboard");
            navigate("/dashboard");
        } catch (error) {
            console.error('Signup error:', error);
            setError(error.message);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "banner",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    children: "QR Butler"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Create an account"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Sign up to start accepting payments with Stripe Connect"
                    }),
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleSignup,
                        style: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "email",
                                        value: email,
                                        onChange: (e)=>setEmail(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "password",
                                        value: password,
                                        onChange: (e)=>setPassword(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Business Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "text",
                                        value: businessName,
                                        onChange: (e)=>setBusinessName(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    marginBottom: '15px',
                                    textAlign: 'left'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Business Type"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        value: businessType,
                                        onChange: (e)=>setBusinessType(e.target.value),
                                        style: {
                                            width: '100%',
                                            padding: '8px',
                                            marginTop: '5px',
                                            borderRadius: '4px',
                                            border: '1px solid #ddd'
                                        },
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "",
                                                children: "Select Type"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "individual",
                                                children: "Individual"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "company",
                                                children: "Company"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                style: {
                                    backgroundColor: '#635BFF',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 20px',
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    cursor: loading ? 'wait' : 'pointer',
                                    width: '100%',
                                    opacity: loading ? 0.7 : 1
                                },
                                children: loading ? "Creating account..." : "Sign Up"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        style: {
                            marginTop: '15px'
                        },
                        children: [
                            "Already have an account? ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: "/login",
                                children: "Login"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");




async function $928974befe8c4d00$export$daaa569a989b1b6(restaurantId) {
    try {
        const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('*').eq('id', restaurantId).single();
        if (error) {
            console.error('Error fetching restaurant:', error);
            throw error;
        }
        return data;
    } catch (error) {
        console.error('Error in getRestaurant:', error);
        throw error;
    }
}
async function $928974befe8c4d00$export$91949f6738d812a(userId) {
    try {
        const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('*').eq('user_id', userId).order('created_at', {
            ascending: false
        });
        if (error) {
            console.error('Error fetching user restaurants:', error);
            throw error;
        }
        return data || [];
    } catch (error) {
        console.error('Error in getUserRestaurants:', error);
        return [];
    }
}
async function $928974befe8c4d00$export$7a0f33e8df10bd94(restaurantId) {
    try {
        // Update table name to match your schema
        const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('categories') // This matches your schema
        .select('*').eq('restaurant_id', restaurantId).order('display_order', {
            ascending: true
        });
        if (error) {
            console.error('Error fetching categories:', error);
            throw error;
        }
        return data || [];
    } catch (error) {
        console.error('Error in getCategories:', error);
        return [];
    }
}
async function $928974befe8c4d00$export$91d66573ef213493(restaurantId, categoryId = null) {
    try {
        let query = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').select('*').eq('restaurant_id', restaurantId);
        if (categoryId) query = query.eq('category_id', categoryId);
        const { data: data, error: error } = await query.order('display_order', {
            ascending: true
        });
        if (error) {
            console.error('Error fetching menu items:', error);
            throw error;
        }
        return data || [];
    } catch (error) {
        console.error('Error in getMenuItems:', error);
        return [];
    }
}
async function $928974befe8c4d00$export$33128913ed9fcff9(restaurantId) {
    try {
        // First get all categories
        const { data: categories, error: categoriesError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('categories').select('*').eq('restaurant_id', restaurantId).order('display_order');
        if (categoriesError) throw categoriesError;
        // Then get all menu items for this restaurant
        const { data: menuItems, error: menuItemsError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').select('*').eq('restaurant_id', restaurantId);
        if (menuItemsError) throw menuItemsError;
        // Organize menu items by category
        const categoriesWithItems = categories.map((category)=>{
            // Add items that belong to this category
            const items = menuItems.filter((item)=>item.category_id === category.id);
            return {
                ...category,
                menu_items: items
            };
        });
        return categoriesWithItems;
    } catch (error) {
        console.error('Error in getRestaurantMenu:', error);
        throw error;
    }
}
async function $928974befe8c4d00$export$7019b1fc0a43af09(restaurantData) {
    try {
        const { data: restaurant, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').insert([
            restaurantData
        ]).select().single();
        if (error) {
            console.error('Error creating restaurant:', error);
            throw error;
        }
        return restaurant;
    } catch (error) {
        console.error('Error in createRestaurant:', error);
        throw error;
    }
}



var $4ed8f9f1446b5aff$exports = {};

$parcel$export($4ed8f9f1446b5aff$exports, "actionButtons", function () { return $4ed8f9f1446b5aff$export$b6fb1741c7f64881; }, function (v) { return $4ed8f9f1446b5aff$export$b6fb1741c7f64881 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "addButton", function () { return $4ed8f9f1446b5aff$export$76174c80c75f9baa; }, function (v) { return $4ed8f9f1446b5aff$export$76174c80c75f9baa = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "analyticsButton", function () { return $4ed8f9f1446b5aff$export$41d9594eecd9811c; }, function (v) { return $4ed8f9f1446b5aff$export$41d9594eecd9811c = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "buttonIcon", function () { return $4ed8f9f1446b5aff$export$ac9988d300f6ef8a; }, function (v) { return $4ed8f9f1446b5aff$export$ac9988d300f6ef8a = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "cancelButton", function () { return $4ed8f9f1446b5aff$export$4ededb8e5b56a6fb; }, function (v) { return $4ed8f9f1446b5aff$export$4ededb8e5b56a6fb = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "cardActions", function () { return $4ed8f9f1446b5aff$export$208b3f105db6b572; }, function (v) { return $4ed8f9f1446b5aff$export$208b3f105db6b572 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "container", function () { return $4ed8f9f1446b5aff$export$34e0f9847d4c02dd; }, function (v) { return $4ed8f9f1446b5aff$export$34e0f9847d4c02dd = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "content", function () { return $4ed8f9f1446b5aff$export$a7db06668cad9adb; }, function (v) { return $4ed8f9f1446b5aff$export$a7db06668cad9adb = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "dashboardSection", function () { return $4ed8f9f1446b5aff$export$a148f3b24331d355; }, function (v) { return $4ed8f9f1446b5aff$export$a148f3b24331d355 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "deleteButton", function () { return $4ed8f9f1446b5aff$export$62f325dbfbc8f81; }, function (v) { return $4ed8f9f1446b5aff$export$62f325dbfbc8f81 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "editButton", function () { return $4ed8f9f1446b5aff$export$93e1a85926f756bf; }, function (v) { return $4ed8f9f1446b5aff$export$93e1a85926f756bf = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "emptyState", function () { return $4ed8f9f1446b5aff$export$252465da46a2ae40; }, function (v) { return $4ed8f9f1446b5aff$export$252465da46a2ae40 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "fileInput", function () { return $4ed8f9f1446b5aff$export$5d5b61cfc3d870a9; }, function (v) { return $4ed8f9f1446b5aff$export$5d5b61cfc3d870a9 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "headerButtons", function () { return $4ed8f9f1446b5aff$export$f085c73b70a9549f; }, function (v) { return $4ed8f9f1446b5aff$export$f085c73b70a9549f = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "headerRow", function () { return $4ed8f9f1446b5aff$export$faed4863136ce212; }, function (v) { return $4ed8f9f1446b5aff$export$faed4863136ce212 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "infoCallout", function () { return $4ed8f9f1446b5aff$export$4b267e9dd8a8e9bd; }, function (v) { return $4ed8f9f1446b5aff$export$4b267e9dd8a8e9bd = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "infoCalloutText", function () { return $4ed8f9f1446b5aff$export$6ae8caf36127d726; }, function (v) { return $4ed8f9f1446b5aff$export$6ae8caf36127d726 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "loadingContainer", function () { return $4ed8f9f1446b5aff$export$7acf0aff43f729a5; }, function (v) { return $4ed8f9f1446b5aff$export$7acf0aff43f729a5 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "loadingSpinner", function () { return $4ed8f9f1446b5aff$export$deaa9e6d912ce6c6; }, function (v) { return $4ed8f9f1446b5aff$export$deaa9e6d912ce6c6 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoEditButton", function () { return $4ed8f9f1446b5aff$export$b9b532c91ed944d6; }, function (v) { return $4ed8f9f1446b5aff$export$b9b532c91ed944d6 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoImage", function () { return $4ed8f9f1446b5aff$export$3ba0bfd74bc3a6fe; }, function (v) { return $4ed8f9f1446b5aff$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoModal", function () { return $4ed8f9f1446b5aff$export$1d146759822006be; }, function (v) { return $4ed8f9f1446b5aff$export$1d146759822006be = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoModalActions", function () { return $4ed8f9f1446b5aff$export$886f537f995bba1b; }, function (v) { return $4ed8f9f1446b5aff$export$886f537f995bba1b = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoModalContent", function () { return $4ed8f9f1446b5aff$export$d2f5442e4c43b4e2; }, function (v) { return $4ed8f9f1446b5aff$export$d2f5442e4c43b4e2 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoPlaceholder", function () { return $4ed8f9f1446b5aff$export$8ebdbf7d1159adc4; }, function (v) { return $4ed8f9f1446b5aff$export$8ebdbf7d1159adc4 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "logoThumbnail", function () { return $4ed8f9f1446b5aff$export$7be8aef34cfec41f; }, function (v) { return $4ed8f9f1446b5aff$export$7be8aef34cfec41f = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "ordersButton", function () { return $4ed8f9f1446b5aff$export$b94b55f86ad73dcf; }, function (v) { return $4ed8f9f1446b5aff$export$b94b55f86ad73dcf = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "pageTitle", function () { return $4ed8f9f1446b5aff$export$cf9644ba8d6cd7c3; }, function (v) { return $4ed8f9f1446b5aff$export$cf9644ba8d6cd7c3 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "primaryButton", function () { return $4ed8f9f1446b5aff$export$41c1085b355ecc97; }, function (v) { return $4ed8f9f1446b5aff$export$41c1085b355ecc97 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "qrButton", function () { return $4ed8f9f1446b5aff$export$7a11eb0c363eb387; }, function (v) { return $4ed8f9f1446b5aff$export$7a11eb0c363eb387 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "restaurantCard", function () { return $4ed8f9f1446b5aff$export$11e8f951600a219; }, function (v) { return $4ed8f9f1446b5aff$export$11e8f951600a219 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "restaurantDesc", function () { return $4ed8f9f1446b5aff$export$eb93f2dde91973ca; }, function (v) { return $4ed8f9f1446b5aff$export$eb93f2dde91973ca = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "restaurantGrid", function () { return $4ed8f9f1446b5aff$export$76dc3e8a5e4787fd; }, function (v) { return $4ed8f9f1446b5aff$export$76dc3e8a5e4787fd = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "restaurantLogoSection", function () { return $4ed8f9f1446b5aff$export$e89f3e242efd158e; }, function (v) { return $4ed8f9f1446b5aff$export$e89f3e242efd158e = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "restaurantName", function () { return $4ed8f9f1446b5aff$export$1467a66621ac6d71; }, function (v) { return $4ed8f9f1446b5aff$export$1467a66621ac6d71 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "sectionDescription", function () { return $4ed8f9f1446b5aff$export$339751927ac4aea1; }, function (v) { return $4ed8f9f1446b5aff$export$339751927ac4aea1 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "sectionTitle", function () { return $4ed8f9f1446b5aff$export$1a952fe22cdce89e; }, function (v) { return $4ed8f9f1446b5aff$export$1a952fe22cdce89e = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "spin", function () { return $4ed8f9f1446b5aff$export$c82e186cf428d56d; }, function (v) { return $4ed8f9f1446b5aff$export$c82e186cf428d56d = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "viewAnalyticsButton", function () { return $4ed8f9f1446b5aff$export$9c7673f35810fcf1; }, function (v) { return $4ed8f9f1446b5aff$export$9c7673f35810fcf1 = v; });
$parcel$export($4ed8f9f1446b5aff$exports, "welcomeText", function () { return $4ed8f9f1446b5aff$export$106087bb6fd473c0; }, function (v) { return $4ed8f9f1446b5aff$export$106087bb6fd473c0 = v; });
var $4ed8f9f1446b5aff$export$b6fb1741c7f64881;
var $4ed8f9f1446b5aff$export$76174c80c75f9baa;
var $4ed8f9f1446b5aff$export$41d9594eecd9811c;
var $4ed8f9f1446b5aff$export$ac9988d300f6ef8a;
var $4ed8f9f1446b5aff$export$4ededb8e5b56a6fb;
var $4ed8f9f1446b5aff$export$208b3f105db6b572;
var $4ed8f9f1446b5aff$export$34e0f9847d4c02dd;
var $4ed8f9f1446b5aff$export$a7db06668cad9adb;
var $4ed8f9f1446b5aff$export$a148f3b24331d355;
var $4ed8f9f1446b5aff$export$62f325dbfbc8f81;
var $4ed8f9f1446b5aff$export$93e1a85926f756bf;
var $4ed8f9f1446b5aff$export$252465da46a2ae40;
var $4ed8f9f1446b5aff$export$5d5b61cfc3d870a9;
var $4ed8f9f1446b5aff$export$f085c73b70a9549f;
var $4ed8f9f1446b5aff$export$faed4863136ce212;
var $4ed8f9f1446b5aff$export$4b267e9dd8a8e9bd;
var $4ed8f9f1446b5aff$export$6ae8caf36127d726;
var $4ed8f9f1446b5aff$export$7acf0aff43f729a5;
var $4ed8f9f1446b5aff$export$deaa9e6d912ce6c6;
var $4ed8f9f1446b5aff$export$b9b532c91ed944d6;
var $4ed8f9f1446b5aff$export$3ba0bfd74bc3a6fe;
var $4ed8f9f1446b5aff$export$1d146759822006be;
var $4ed8f9f1446b5aff$export$886f537f995bba1b;
var $4ed8f9f1446b5aff$export$d2f5442e4c43b4e2;
var $4ed8f9f1446b5aff$export$8ebdbf7d1159adc4;
var $4ed8f9f1446b5aff$export$7be8aef34cfec41f;
var $4ed8f9f1446b5aff$export$b94b55f86ad73dcf;
var $4ed8f9f1446b5aff$export$cf9644ba8d6cd7c3;
var $4ed8f9f1446b5aff$export$41c1085b355ecc97;
var $4ed8f9f1446b5aff$export$7a11eb0c363eb387;
var $4ed8f9f1446b5aff$export$11e8f951600a219;
var $4ed8f9f1446b5aff$export$eb93f2dde91973ca;
var $4ed8f9f1446b5aff$export$76dc3e8a5e4787fd;
var $4ed8f9f1446b5aff$export$e89f3e242efd158e;
var $4ed8f9f1446b5aff$export$1467a66621ac6d71;
var $4ed8f9f1446b5aff$export$339751927ac4aea1;
var $4ed8f9f1446b5aff$export$1a952fe22cdce89e;
var $4ed8f9f1446b5aff$export$c82e186cf428d56d;
var $4ed8f9f1446b5aff$export$9c7673f35810fcf1;
var $4ed8f9f1446b5aff$export$106087bb6fd473c0;
$4ed8f9f1446b5aff$export$b6fb1741c7f64881 = `xwYmMq_actionButtons`;
$4ed8f9f1446b5aff$export$76174c80c75f9baa = `xwYmMq_addButton`;
$4ed8f9f1446b5aff$export$41d9594eecd9811c = `xwYmMq_analyticsButton`;
$4ed8f9f1446b5aff$export$ac9988d300f6ef8a = `xwYmMq_buttonIcon`;
$4ed8f9f1446b5aff$export$4ededb8e5b56a6fb = `xwYmMq_cancelButton`;
$4ed8f9f1446b5aff$export$208b3f105db6b572 = `xwYmMq_cardActions`;
$4ed8f9f1446b5aff$export$34e0f9847d4c02dd = `xwYmMq_container`;
$4ed8f9f1446b5aff$export$a7db06668cad9adb = `xwYmMq_content`;
$4ed8f9f1446b5aff$export$a148f3b24331d355 = `xwYmMq_dashboardSection`;
$4ed8f9f1446b5aff$export$62f325dbfbc8f81 = `xwYmMq_deleteButton`;
$4ed8f9f1446b5aff$export$93e1a85926f756bf = `xwYmMq_editButton`;
$4ed8f9f1446b5aff$export$252465da46a2ae40 = `xwYmMq_emptyState`;
$4ed8f9f1446b5aff$export$5d5b61cfc3d870a9 = `xwYmMq_fileInput`;
$4ed8f9f1446b5aff$export$f085c73b70a9549f = `xwYmMq_headerButtons`;
$4ed8f9f1446b5aff$export$faed4863136ce212 = `xwYmMq_headerRow`;
$4ed8f9f1446b5aff$export$4b267e9dd8a8e9bd = `xwYmMq_infoCallout`;
$4ed8f9f1446b5aff$export$6ae8caf36127d726 = `xwYmMq_infoCalloutText`;
$4ed8f9f1446b5aff$export$7acf0aff43f729a5 = `xwYmMq_loadingContainer`;
$4ed8f9f1446b5aff$export$deaa9e6d912ce6c6 = `xwYmMq_loadingSpinner`;
$4ed8f9f1446b5aff$export$b9b532c91ed944d6 = `xwYmMq_logoEditButton`;
$4ed8f9f1446b5aff$export$3ba0bfd74bc3a6fe = `xwYmMq_logoImage`;
$4ed8f9f1446b5aff$export$1d146759822006be = `xwYmMq_logoModal`;
$4ed8f9f1446b5aff$export$886f537f995bba1b = `xwYmMq_logoModalActions`;
$4ed8f9f1446b5aff$export$d2f5442e4c43b4e2 = `xwYmMq_logoModalContent`;
$4ed8f9f1446b5aff$export$8ebdbf7d1159adc4 = `xwYmMq_logoPlaceholder`;
$4ed8f9f1446b5aff$export$7be8aef34cfec41f = `xwYmMq_logoThumbnail`;
$4ed8f9f1446b5aff$export$b94b55f86ad73dcf = `xwYmMq_ordersButton`;
$4ed8f9f1446b5aff$export$cf9644ba8d6cd7c3 = `xwYmMq_pageTitle`;
$4ed8f9f1446b5aff$export$41c1085b355ecc97 = `xwYmMq_primaryButton`;
$4ed8f9f1446b5aff$export$7a11eb0c363eb387 = `xwYmMq_qrButton`;
$4ed8f9f1446b5aff$export$11e8f951600a219 = `xwYmMq_restaurantCard`;
$4ed8f9f1446b5aff$export$eb93f2dde91973ca = `xwYmMq_restaurantDesc`;
$4ed8f9f1446b5aff$export$76dc3e8a5e4787fd = `xwYmMq_restaurantGrid`;
$4ed8f9f1446b5aff$export$e89f3e242efd158e = `xwYmMq_restaurantLogoSection`;
$4ed8f9f1446b5aff$export$1467a66621ac6d71 = `xwYmMq_restaurantName`;
$4ed8f9f1446b5aff$export$339751927ac4aea1 = `xwYmMq_sectionDescription`;
$4ed8f9f1446b5aff$export$1a952fe22cdce89e = `xwYmMq_sectionTitle`;
$4ed8f9f1446b5aff$export$c82e186cf428d56d = `xwYmMq_spin`;
$4ed8f9f1446b5aff$export$c82e186cf428d56d;
$4ed8f9f1446b5aff$export$9c7673f35810fcf1 = `xwYmMq_viewAnalyticsButton`;
$4ed8f9f1446b5aff$export$106087bb6fd473c0 = `xwYmMq_welcomeText`;


function $8db6b399d1a9b013$export$2e2bcd8739ae039() {
    const { user: user } = (0, $fa441f73aa1797a9$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [restaurants, setRestaurants] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [connectedAccountId, setConnectedAccountId] = (0, $7fPBF.useState)(null);
    const [accountStatus, setAccountStatus] = (0, $7fPBF.useState)(null);
    // Add state for logo management
    const [logoModal, setLogoModal] = (0, $7fPBF.useState)(null);
    const [uploadingLogo, setUploadingLogo] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const loadData = async ()=>{
            if (user) try {
                console.log("Loading dashboard data for user:", user.id);
                // Get Stripe Connect ID and account status - still needed for setup notification
                const { data: profile } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('stripe_connect_id, stripe_account_status').eq('user_id', user.id).single();
                if (profile && profile.stripe_connect_id) {
                    setConnectedAccountId(profile.stripe_connect_id);
                    setAccountStatus(profile.stripe_account_status || 'pending');
                    // Still verify status with Stripe API to ensure proper setup notification
                    try {
                        const response = await fetch('/check-account-type', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                account_id: profile.stripe_connect_id
                            })
                        });
                        if (response.ok) {
                            const accountData = await response.json();
                            const newStatus = accountData.charges_enabled && accountData.payouts_enabled ? 'active' : 'pending';
                            setAccountStatus(newStatus);
                            // Update database if status changed
                            if (newStatus !== profile.stripe_account_status) await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').update({
                                stripe_account_status: newStatus
                            }).eq('user_id', user.id);
                        }
                    } catch (err) {
                        console.error("Error checking account with Stripe:", err);
                    }
                }
                // Get user's restaurants
                const restaurants = await (0, $928974befe8c4d00$export$91949f6738d812a)(user.id);
                setRestaurants(restaurants);
            } catch (error) {
                console.error("Error loading dashboard data:", error);
            } finally{
                setLoading(false);
            }
        };
        loadData();
    }, [
        user
    ]);
    // Add logo upload function
    const handleLogoUpload = async (restaurantId, file)=>{
        if (!file) return;
        setUploadingLogo(true);
        try {
            // Create unique filename
            const fileExt = file.name.split('.').pop();
            const fileName = `restaurant-logos/${restaurantId}-${Date.now()}.${fileExt}`;
            // Upload to Supabase storage
            const { data: uploadData, error: uploadError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('restaurant-assets').upload(fileName, file);
            if (uploadError) throw uploadError;
            // Get public URL
            const { data: { publicUrl: publicUrl } } = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('restaurant-assets').getPublicUrl(fileName);
            // Update restaurant record
            const { error: updateError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').update({
                logo_url: publicUrl
            }).eq('id', restaurantId);
            if (updateError) throw updateError;
            // Update local state
            setRestaurants(restaurants.map((restaurant)=>restaurant.id === restaurantId ? {
                    ...restaurant,
                    logo_url: publicUrl
                } : restaurant));
            setLogoModal(null);
        } catch (error) {
            console.error('Error uploading logo:', error);
            alert('Failed to upload logo');
        } finally{
            setUploadingLogo(false);
        }
    };
    const handleDeleteRestaurant = async (restaurantId)=>{
        if (window.confirm("Are you sure you want to delete this restaurant? This action cannot be undone.")) try {
            // Delete all menu items and categories first (cascading delete)
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').delete().eq('id', restaurantId);
            if (error) throw error;
            setRestaurants(restaurants.filter((r)=>r.id !== restaurantId));
        } catch (error) {
            console.error("Error deleting restaurant:", error);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).loadingContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).loadingSpinner
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Loading your dashboard..."
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).content,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).pageTitle,
                        children: "Dashboard"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).welcomeText,
                        children: [
                            "Welcome",
                            user?.email ? `, ${user.email.split('@')[0]}` : '',
                            "!"
                        ]
                    }),
                    (!connectedAccountId || accountStatus !== 'active') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).infoCallout,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).infoCalloutText,
                                children: connectedAccountId ? 'Please complete your Stripe account setup to accept payments' : 'Please connect your account with Stripe to accept payments'
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>navigate("/"),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).primaryButton,
                                children: connectedAccountId ? 'Complete Stripe Setup' : 'Set up Stripe Connect'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).dashboardSection,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).sectionTitle,
                                children: "Your Restaurants"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).sectionDescription,
                                children: "Manage your restaurant menus, QR codes, and orders."
                            })
                        ]
                    }),
                    restaurants.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).emptyState,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "You don't have any restaurants yet"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Create your first restaurant to get started."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                onClick: ()=>navigate('/restaurant/new'),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).primaryButton,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).buttonIcon
                                    }),
                                    "Add Restaurant"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).restaurantGrid,
                                children: restaurants.map((restaurant)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).restaurantCard,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).restaurantLogoSection,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoThumbnail,
                                                    children: [
                                                        restaurant.logo_url ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                            src: restaurant.logo_url,
                                                            alt: `${restaurant.name} logo`,
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoImage
                                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoPlaceholder,
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a5d4befc3914f30d), {
                                                                size: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoEditButton,
                                                            onClick: ()=>setLogoModal(restaurant.id),
                                                            title: "Change logo",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$3160a2892d0a1e20), {
                                                                size: 12
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).restaurantName,
                                                children: restaurant.name
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).restaurantDesc,
                                                children: restaurant.description || 'No description available'
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).cardActions,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                    onClick: ()=>navigate(`/restaurant/${restaurant.id}/analytics`),
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).viewAnalyticsButton,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$13af84db5d19481e), {
                                                            size: 16
                                                        }),
                                                        "View Analytics"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).actionButtons,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        onClick: ()=>navigate(`/restaurant/${restaurant.id}/menu`),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).editButton,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$3160a2892d0a1e20), {
                                                                size: 16
                                                            }),
                                                            "Edit Menu"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        onClick: ()=>navigate(`/restaurant/${restaurant.id}/qr`),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).qrButton,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$c436bd52326ef6), {
                                                                size: 16
                                                            }),
                                                            "QR Codes"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        onClick: ()=>navigate(`/restaurant/${restaurant.id}/orders`),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).ordersButton,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$4f5d42594a6c344f), {
                                                                size: 16
                                                            }),
                                                            "Orders"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        onClick: ()=>navigate(`/restaurant/${restaurant.id}/analytics`),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).analyticsButton,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$13af84db5d19481e), {
                                                                size: 16
                                                            }),
                                                            "Analytics"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        onClick: ()=>handleDeleteRestaurant(restaurant.id),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).deleteButton,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$b45f06eb58143962), {
                                                                size: 16
                                                            }),
                                                            "Delete"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, restaurant.id))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>navigate('/restaurant/new'),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).addButton,
                                "aria-label": "Add new restaurant",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {})
                            })
                        ]
                    })
                ]
            }),
            logoModal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoModalContent,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: "Update Restaurant Logo"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            type: "file",
                            accept: "image/*",
                            onChange: (e)=>{
                                const file = e.target.files[0];
                                if (file) handleLogoUpload(logoModal, file);
                            },
                            disabled: uploadingLogo,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).fileInput
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).logoModalActions,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setLogoModal(null),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ed8f9f1446b5aff$exports))).cancelButton,
                                disabled: uploadingLogo,
                                children: "Cancel"
                            })
                        }),
                        uploadingLogo && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Uploading..."
                        })
                    ]
                })
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");





var $38d694cb06a23502$exports = {};

$parcel$export($38d694cb06a23502$exports, "checkboxLabel", function () { return $38d694cb06a23502$export$68673652bda1864d; }, function (v) { return $38d694cb06a23502$export$68673652bda1864d = v; });
$parcel$export($38d694cb06a23502$exports, "error", function () { return $38d694cb06a23502$export$a3bc9b8ed74fc; }, function (v) { return $38d694cb06a23502$export$a3bc9b8ed74fc = v; });
$parcel$export($38d694cb06a23502$exports, "errorMessage", function () { return $38d694cb06a23502$export$493b5823483d2c4e; }, function (v) { return $38d694cb06a23502$export$493b5823483d2c4e = v; });
$parcel$export($38d694cb06a23502$exports, "fileInput", function () { return $38d694cb06a23502$export$5d5b61cfc3d870a9; }, function (v) { return $38d694cb06a23502$export$5d5b61cfc3d870a9 = v; });
$parcel$export($38d694cb06a23502$exports, "fileInputLabel", function () { return $38d694cb06a23502$export$d58ba447e55b1d5c; }, function (v) { return $38d694cb06a23502$export$d58ba447e55b1d5c = v; });
$parcel$export($38d694cb06a23502$exports, "formContainer", function () { return $38d694cb06a23502$export$231ba5fc42c01d86; }, function (v) { return $38d694cb06a23502$export$231ba5fc42c01d86 = v; });
$parcel$export($38d694cb06a23502$exports, "formGroup", function () { return $38d694cb06a23502$export$d2297815c52203ee; }, function (v) { return $38d694cb06a23502$export$d2297815c52203ee = v; });
$parcel$export($38d694cb06a23502$exports, "imagePreviewContainer", function () { return $38d694cb06a23502$export$f654b328e5c98692; }, function (v) { return $38d694cb06a23502$export$f654b328e5c98692 = v; });
$parcel$export($38d694cb06a23502$exports, "imageUploadContainer", function () { return $38d694cb06a23502$export$a7f71534d91c322d; }, function (v) { return $38d694cb06a23502$export$a7f71534d91c322d = v; });
$parcel$export($38d694cb06a23502$exports, "input", function () { return $38d694cb06a23502$export$b7e3ae3d7c15e42e; }, function (v) { return $38d694cb06a23502$export$b7e3ae3d7c15e42e = v; });
$parcel$export($38d694cb06a23502$exports, "inputError", function () { return $38d694cb06a23502$export$ad080a00b79f0160; }, function (v) { return $38d694cb06a23502$export$ad080a00b79f0160 = v; });
$parcel$export($38d694cb06a23502$exports, "label", function () { return $38d694cb06a23502$export$1237798dc640739a; }, function (v) { return $38d694cb06a23502$export$1237798dc640739a = v; });
$parcel$export($38d694cb06a23502$exports, "logoPreview", function () { return $38d694cb06a23502$export$e2a69dfea6377805; }, function (v) { return $38d694cb06a23502$export$e2a69dfea6377805 = v; });
$parcel$export($38d694cb06a23502$exports, "select", function () { return $38d694cb06a23502$export$2e6c959c16ff56b8; }, function (v) { return $38d694cb06a23502$export$2e6c959c16ff56b8 = v; });
$parcel$export($38d694cb06a23502$exports, "submitButton", function () { return $38d694cb06a23502$export$d675b3969e4857cb; }, function (v) { return $38d694cb06a23502$export$d675b3969e4857cb = v; });
$parcel$export($38d694cb06a23502$exports, "textarea", function () { return $38d694cb06a23502$export$a3574df893ffa88d; }, function (v) { return $38d694cb06a23502$export$a3574df893ffa88d = v; });
var $38d694cb06a23502$export$68673652bda1864d;
var $38d694cb06a23502$export$a3bc9b8ed74fc;
var $38d694cb06a23502$export$493b5823483d2c4e;
var $38d694cb06a23502$export$5d5b61cfc3d870a9;
var $38d694cb06a23502$export$d58ba447e55b1d5c;
var $38d694cb06a23502$export$231ba5fc42c01d86;
var $38d694cb06a23502$export$d2297815c52203ee;
var $38d694cb06a23502$export$f654b328e5c98692;
var $38d694cb06a23502$export$a7f71534d91c322d;
var $38d694cb06a23502$export$b7e3ae3d7c15e42e;
var $38d694cb06a23502$export$ad080a00b79f0160;
var $38d694cb06a23502$export$1237798dc640739a;
var $38d694cb06a23502$export$e2a69dfea6377805;
var $38d694cb06a23502$export$2e6c959c16ff56b8;
var $38d694cb06a23502$export$d675b3969e4857cb;
var $38d694cb06a23502$export$a3574df893ffa88d;
$38d694cb06a23502$export$68673652bda1864d = `bVl89G_checkboxLabel`;
$38d694cb06a23502$export$a3bc9b8ed74fc = `bVl89G_error`;
$38d694cb06a23502$export$493b5823483d2c4e = `bVl89G_errorMessage`;
$38d694cb06a23502$export$5d5b61cfc3d870a9 = `bVl89G_fileInput`;
$38d694cb06a23502$export$d58ba447e55b1d5c = `bVl89G_fileInputLabel`;
$38d694cb06a23502$export$231ba5fc42c01d86 = `bVl89G_formContainer`;
$38d694cb06a23502$export$d2297815c52203ee = `bVl89G_formGroup`;
$38d694cb06a23502$export$f654b328e5c98692 = `bVl89G_imagePreviewContainer`;
$38d694cb06a23502$export$a7f71534d91c322d = `bVl89G_imageUploadContainer`;
$38d694cb06a23502$export$b7e3ae3d7c15e42e = `bVl89G_input`;
$38d694cb06a23502$export$ad080a00b79f0160 = `bVl89G_inputError`;
$38d694cb06a23502$export$1237798dc640739a = `bVl89G_label`;
$38d694cb06a23502$export$e2a69dfea6377805 = `bVl89G_logoPreview`;
$38d694cb06a23502$export$2e6c959c16ff56b8 = `bVl89G_select`;
$38d694cb06a23502$export$d675b3969e4857cb = `bVl89G_submitButton`;
$38d694cb06a23502$export$a3574df893ffa88d = `bVl89G_textarea`;


function $afd6521b42f78544$export$2e2bcd8739ae039() {
    const { user: user } = (0, $fa441f73aa1797a9$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [formData, setFormData] = (0, $7fPBF.useState)({
        name: '',
        description: '',
        address: ''
    });
    const [logo, setLogo] = (0, $7fPBF.useState)({
        file: null,
        preview: null
    });
    const [uploading, setUploading] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const handleChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handleLogoChange = (e)=>{
        const file = e.target.files[0];
        if (file) {
            // Check file size (2MB limit)
            if (file.size > 2097152) {
                alert('Logo image is too large. Please select an image under 2MB.');
                e.target.value = null; // Clear the input
                return;
            }
            setLogo({
                file: file,
                preview: null
            });
            // Create a preview
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setLogo((prev)=>({
                        ...prev,
                        preview: reader.result
                    }));
            };
            reader.readAsDataURL(file);
        }
    };
    const uploadLogo = async (file, restaurantId)=>{
        try {
            setUploading(true);
            // Create a unique filename
            const fileExt = file.name.split('.').pop();
            const fileName = `logo-${Date.now()}.${fileExt}`;
            const filePath = `restaurant-logos/${restaurantId}/${fileName}`;
            // Upload the file to the restaurant-assets bucket
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('restaurant-assets').upload(filePath, file);
            if (error) throw error;
            // Get the public URL
            const { data: { publicUrl: publicUrl } } = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('restaurant-assets').getPublicUrl(filePath);
            return publicUrl;
        } catch (error) {
            console.error('Error uploading logo:', error);
            throw error;
        } finally{
            setUploading(false);
        }
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            // First create the restaurant to get an ID
            const newRestaurant = await (0, $928974befe8c4d00$export$7019b1fc0a43af09)({
                ...formData,
                user_id: user.id
            });
            // Then upload logo if selected and update restaurant with logo URL
            if (logo.file) {
                const logoUrl = await uploadLogo(logo.file, newRestaurant.id);
                // Update restaurant with logo URL
                const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').update({
                    logo_url: logoUrl
                }).eq('id', newRestaurant.id);
                if (error) throw error;
            }
            navigate(`/restaurant/${newRestaurant.id}/menu`);
        } catch (err) {
            setError(err.message);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "banner",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    children: "QR Menu App"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).formContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Set Up Your Restaurant"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Create your restaurant profile to start managing your menu"
                    }),
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).error,
                        children: error
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).label,
                                        children: "Restaurant Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        value: formData.name,
                                        onChange: handleChange,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).input,
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).label,
                                        children: "Logo (optional)"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).imageUploadContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "file",
                                                id: "restaurant-logo",
                                                accept: "image/*",
                                                onChange: handleLogoChange,
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).fileInput
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                htmlFor: "restaurant-logo",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).fileInputLabel,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a5e7deed97e8be52), {
                                                        size: 18
                                                    }),
                                                    logo.file ? 'Change Logo' : 'Upload Logo'
                                                ]
                                            })
                                        ]
                                    }),
                                    logo.preview && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).imagePreviewContainer,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: logo.preview,
                                            alt: "Logo Preview",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).logoPreview
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).label,
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                        name: "description",
                                        value: formData.description,
                                        onChange: handleChange,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).textarea
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).label,
                                        children: "Address"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "text",
                                        name: "address",
                                        value: formData.address,
                                        onChange: handleChange,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading || uploading,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($38d694cb06a23502$exports))).submitButton,
                                children: loading || uploading ? 'Creating...' : 'Create Restaurant'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");




var $a6155302d6240a0b$exports = {};

$parcel$export($a6155302d6240a0b$exports, "backButton", function () { return $a6155302d6240a0b$export$8d6d009d1f06226e; }, function (v) { return $a6155302d6240a0b$export$8d6d009d1f06226e = v; });
$parcel$export($a6155302d6240a0b$exports, "contentLayout", function () { return $a6155302d6240a0b$export$f923184c0f9fe848; }, function (v) { return $a6155302d6240a0b$export$f923184c0f9fe848 = v; });
$parcel$export($a6155302d6240a0b$exports, "header", function () { return $a6155302d6240a0b$export$38e42c68cf43b5d4; }, function (v) { return $a6155302d6240a0b$export$38e42c68cf43b5d4 = v; });
$parcel$export($a6155302d6240a0b$exports, "headerContent", function () { return $a6155302d6240a0b$export$838c0e7679321ff3; }, function (v) { return $a6155302d6240a0b$export$838c0e7679321ff3 = v; });
$parcel$export($a6155302d6240a0b$exports, "headerRow", function () { return $a6155302d6240a0b$export$faed4863136ce212; }, function (v) { return $a6155302d6240a0b$export$faed4863136ce212 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmAddButton", function () { return $a6155302d6240a0b$export$70d882898309afa2; }, function (v) { return $a6155302d6240a0b$export$70d882898309afa2 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmAddCategoryForm", function () { return $a6155302d6240a0b$export$c41b1389f76cd1e0; }, function (v) { return $a6155302d6240a0b$export$c41b1389f76cd1e0 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmAvailable", function () { return $a6155302d6240a0b$export$f74a36c0f9ed7101; }, function (v) { return $a6155302d6240a0b$export$f74a36c0f9ed7101 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmCategoryButton", function () { return $a6155302d6240a0b$export$eee8a542c0bf98af; }, function (v) { return $a6155302d6240a0b$export$eee8a542c0bf98af = v; });
$parcel$export($a6155302d6240a0b$exports, "mmCategoryList", function () { return $a6155302d6240a0b$export$e76087c048e7627f; }, function (v) { return $a6155302d6240a0b$export$e76087c048e7627f = v; });
$parcel$export($a6155302d6240a0b$exports, "mmCloseButton", function () { return $a6155302d6240a0b$export$10e9a70d68a22928; }, function (v) { return $a6155302d6240a0b$export$10e9a70d68a22928 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmContainer", function () { return $a6155302d6240a0b$export$881ad9a6d6150dee; }, function (v) { return $a6155302d6240a0b$export$881ad9a6d6150dee = v; });
$parcel$export($a6155302d6240a0b$exports, "mmDeleteButton", function () { return $a6155302d6240a0b$export$5ad545efbe675770; }, function (v) { return $a6155302d6240a0b$export$5ad545efbe675770 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmEditButton", function () { return $a6155302d6240a0b$export$9091e0868ece2651; }, function (v) { return $a6155302d6240a0b$export$9091e0868ece2651 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmEmptyState", function () { return $a6155302d6240a0b$export$3ae2aa596593db8f; }, function (v) { return $a6155302d6240a0b$export$3ae2aa596593db8f = v; });
$parcel$export($a6155302d6240a0b$exports, "mmFormGroup", function () { return $a6155302d6240a0b$export$287f5bd88521cf4e; }, function (v) { return $a6155302d6240a0b$export$287f5bd88521cf4e = v; });
$parcel$export($a6155302d6240a0b$exports, "mmInput", function () { return $a6155302d6240a0b$export$f0a9805612221944; }, function (v) { return $a6155302d6240a0b$export$f0a9805612221944 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmItemStatus", function () { return $a6155302d6240a0b$export$54bd4dcda1d36c9d; }, function (v) { return $a6155302d6240a0b$export$54bd4dcda1d36c9d = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMainContent", function () { return $a6155302d6240a0b$export$dc6fa9e79e1861f2; }, function (v) { return $a6155302d6240a0b$export$dc6fa9e79e1861f2 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuGrid", function () { return $a6155302d6240a0b$export$7f297ccbb91bd8ed; }, function (v) { return $a6155302d6240a0b$export$7f297ccbb91bd8ed = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItem", function () { return $a6155302d6240a0b$export$7dd990f0f79330c8; }, function (v) { return $a6155302d6240a0b$export$7dd990f0f79330c8 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemActions", function () { return $a6155302d6240a0b$export$47a418addc8f5e2f; }, function (v) { return $a6155302d6240a0b$export$47a418addc8f5e2f = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemDesc", function () { return $a6155302d6240a0b$export$780008981962f45e; }, function (v) { return $a6155302d6240a0b$export$780008981962f45e = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemFooter", function () { return $a6155302d6240a0b$export$3670132d5c8ebd81; }, function (v) { return $a6155302d6240a0b$export$3670132d5c8ebd81 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemHeader", function () { return $a6155302d6240a0b$export$394bb246cf1e7982; }, function (v) { return $a6155302d6240a0b$export$394bb246cf1e7982 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemImage", function () { return $a6155302d6240a0b$export$a97b5255db43a40f; }, function (v) { return $a6155302d6240a0b$export$a97b5255db43a40f = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemImageContainer", function () { return $a6155302d6240a0b$export$e0cd6dc1e7e4f3c5; }, function (v) { return $a6155302d6240a0b$export$e0cd6dc1e7e4f3c5 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemName", function () { return $a6155302d6240a0b$export$f5038fca6798c5fa; }, function (v) { return $a6155302d6240a0b$export$f5038fca6798c5fa = v; });
$parcel$export($a6155302d6240a0b$exports, "mmMenuItemPrice", function () { return $a6155302d6240a0b$export$6b2c989b239ea845; }, function (v) { return $a6155302d6240a0b$export$6b2c989b239ea845 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmModal", function () { return $a6155302d6240a0b$export$c518fa690ed3a9f2; }, function (v) { return $a6155302d6240a0b$export$c518fa690ed3a9f2 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmModalContent", function () { return $a6155302d6240a0b$export$fc974fcc4abbc690; }, function (v) { return $a6155302d6240a0b$export$fc974fcc4abbc690 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmModalHeader", function () { return $a6155302d6240a0b$export$b2d92e4bc36ab637; }, function (v) { return $a6155302d6240a0b$export$b2d92e4bc36ab637 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmPrimaryButton", function () { return $a6155302d6240a0b$export$a7b65af89d72343c; }, function (v) { return $a6155302d6240a0b$export$a7b65af89d72343c = v; });
$parcel$export($a6155302d6240a0b$exports, "mmSecondaryButton", function () { return $a6155302d6240a0b$export$48f8a3f81e6d17ca; }, function (v) { return $a6155302d6240a0b$export$48f8a3f81e6d17ca = v; });
$parcel$export($a6155302d6240a0b$exports, "mmSectionHeader", function () { return $a6155302d6240a0b$export$8b4643f895f81def; }, function (v) { return $a6155302d6240a0b$export$8b4643f895f81def = v; });
$parcel$export($a6155302d6240a0b$exports, "mmSectionTitle", function () { return $a6155302d6240a0b$export$85794f85abb4117e; }, function (v) { return $a6155302d6240a0b$export$85794f85abb4117e = v; });
$parcel$export($a6155302d6240a0b$exports, "mmSelected", function () { return $a6155302d6240a0b$export$bb9359aeda756628; }, function (v) { return $a6155302d6240a0b$export$bb9359aeda756628 = v; });
$parcel$export($a6155302d6240a0b$exports, "mmSidebar", function () { return $a6155302d6240a0b$export$3aaf045bb52feb7a; }, function (v) { return $a6155302d6240a0b$export$3aaf045bb52feb7a = v; });
$parcel$export($a6155302d6240a0b$exports, "mmUnavailable", function () { return $a6155302d6240a0b$export$d175e814a6b2dbe3; }, function (v) { return $a6155302d6240a0b$export$d175e814a6b2dbe3 = v; });
var $a6155302d6240a0b$export$8d6d009d1f06226e;
var $a6155302d6240a0b$export$f923184c0f9fe848;
var $a6155302d6240a0b$export$38e42c68cf43b5d4;
var $a6155302d6240a0b$export$838c0e7679321ff3;
var $a6155302d6240a0b$export$faed4863136ce212;
var $a6155302d6240a0b$export$70d882898309afa2;
var $a6155302d6240a0b$export$c41b1389f76cd1e0;
var $a6155302d6240a0b$export$f74a36c0f9ed7101;
var $a6155302d6240a0b$export$eee8a542c0bf98af;
var $a6155302d6240a0b$export$e76087c048e7627f;
var $a6155302d6240a0b$export$10e9a70d68a22928;
var $a6155302d6240a0b$export$881ad9a6d6150dee;
var $a6155302d6240a0b$export$5ad545efbe675770;
var $a6155302d6240a0b$export$9091e0868ece2651;
var $a6155302d6240a0b$export$3ae2aa596593db8f;
var $a6155302d6240a0b$export$287f5bd88521cf4e;
var $a6155302d6240a0b$export$f0a9805612221944;
var $a6155302d6240a0b$export$54bd4dcda1d36c9d;
var $a6155302d6240a0b$export$dc6fa9e79e1861f2;
var $a6155302d6240a0b$export$7f297ccbb91bd8ed;
var $a6155302d6240a0b$export$7dd990f0f79330c8;
var $a6155302d6240a0b$export$47a418addc8f5e2f;
var $a6155302d6240a0b$export$780008981962f45e;
var $a6155302d6240a0b$export$3670132d5c8ebd81;
var $a6155302d6240a0b$export$394bb246cf1e7982;
var $a6155302d6240a0b$export$a97b5255db43a40f;
var $a6155302d6240a0b$export$e0cd6dc1e7e4f3c5;
var $a6155302d6240a0b$export$f5038fca6798c5fa;
var $a6155302d6240a0b$export$6b2c989b239ea845;
var $a6155302d6240a0b$export$c518fa690ed3a9f2;
var $a6155302d6240a0b$export$fc974fcc4abbc690;
var $a6155302d6240a0b$export$b2d92e4bc36ab637;
var $a6155302d6240a0b$export$a7b65af89d72343c;
var $a6155302d6240a0b$export$48f8a3f81e6d17ca;
var $a6155302d6240a0b$export$8b4643f895f81def;
var $a6155302d6240a0b$export$85794f85abb4117e;
var $a6155302d6240a0b$export$bb9359aeda756628;
var $a6155302d6240a0b$export$3aaf045bb52feb7a;
var $a6155302d6240a0b$export$d175e814a6b2dbe3;
$a6155302d6240a0b$export$8d6d009d1f06226e = `ZA-ssG_backButton`;
$a6155302d6240a0b$export$f923184c0f9fe848 = `ZA-ssG_contentLayout`;
$a6155302d6240a0b$export$38e42c68cf43b5d4 = `ZA-ssG_header`;
$a6155302d6240a0b$export$838c0e7679321ff3 = `ZA-ssG_headerContent`;
$a6155302d6240a0b$export$faed4863136ce212 = `ZA-ssG_headerRow`;
$a6155302d6240a0b$export$70d882898309afa2 = `ZA-ssG_mmAddButton`;
$a6155302d6240a0b$export$c41b1389f76cd1e0 = `ZA-ssG_mmAddCategoryForm`;
$a6155302d6240a0b$export$f74a36c0f9ed7101 = `ZA-ssG_mmAvailable`;
$a6155302d6240a0b$export$eee8a542c0bf98af = `ZA-ssG_mmCategoryButton`;
$a6155302d6240a0b$export$e76087c048e7627f = `ZA-ssG_mmCategoryList`;
$a6155302d6240a0b$export$10e9a70d68a22928 = `ZA-ssG_mmCloseButton`;
$a6155302d6240a0b$export$881ad9a6d6150dee = `ZA-ssG_mmContainer`;
$a6155302d6240a0b$export$5ad545efbe675770 = `ZA-ssG_mmDeleteButton`;
$a6155302d6240a0b$export$9091e0868ece2651 = `ZA-ssG_mmEditButton`;
$a6155302d6240a0b$export$3ae2aa596593db8f = `ZA-ssG_mmEmptyState`;
$a6155302d6240a0b$export$287f5bd88521cf4e = `ZA-ssG_mmFormGroup`;
$a6155302d6240a0b$export$f0a9805612221944 = `ZA-ssG_mmInput`;
$a6155302d6240a0b$export$54bd4dcda1d36c9d = `ZA-ssG_mmItemStatus`;
$a6155302d6240a0b$export$dc6fa9e79e1861f2 = `ZA-ssG_mmMainContent`;
$a6155302d6240a0b$export$7f297ccbb91bd8ed = `ZA-ssG_mmMenuGrid`;
$a6155302d6240a0b$export$7dd990f0f79330c8 = `ZA-ssG_mmMenuItem`;
$a6155302d6240a0b$export$47a418addc8f5e2f = `ZA-ssG_mmMenuItemActions`;
$a6155302d6240a0b$export$780008981962f45e = `ZA-ssG_mmMenuItemDesc`;
$a6155302d6240a0b$export$3670132d5c8ebd81 = `ZA-ssG_mmMenuItemFooter`;
$a6155302d6240a0b$export$394bb246cf1e7982 = `ZA-ssG_mmMenuItemHeader`;
$a6155302d6240a0b$export$a97b5255db43a40f = `ZA-ssG_mmMenuItemImage`;
$a6155302d6240a0b$export$e0cd6dc1e7e4f3c5 = `ZA-ssG_mmMenuItemImageContainer`;
$a6155302d6240a0b$export$f5038fca6798c5fa = `ZA-ssG_mmMenuItemName`;
$a6155302d6240a0b$export$6b2c989b239ea845 = `ZA-ssG_mmMenuItemPrice`;
$a6155302d6240a0b$export$c518fa690ed3a9f2 = `ZA-ssG_mmModal`;
$a6155302d6240a0b$export$fc974fcc4abbc690 = `ZA-ssG_mmModalContent`;
$a6155302d6240a0b$export$b2d92e4bc36ab637 = `ZA-ssG_mmModalHeader`;
$a6155302d6240a0b$export$a7b65af89d72343c = `ZA-ssG_mmPrimaryButton`;
$a6155302d6240a0b$export$48f8a3f81e6d17ca = `ZA-ssG_mmSecondaryButton`;
$a6155302d6240a0b$export$8b4643f895f81def = `ZA-ssG_mmSectionHeader`;
$a6155302d6240a0b$export$85794f85abb4117e = `ZA-ssG_mmSectionTitle`;
$a6155302d6240a0b$export$bb9359aeda756628 = `ZA-ssG_mmSelected`;
$a6155302d6240a0b$export$3aaf045bb52feb7a = `ZA-ssG_mmSidebar`;
$a6155302d6240a0b$export$d175e814a6b2dbe3 = `ZA-ssG_mmUnavailable`;


function $4341799d4cdbebad$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [categories, setCategories] = (0, $7fPBF.useState)([]);
    const [selectedCategory, setSelectedCategory] = (0, $7fPBF.useState)(null);
    const [menuItems, setMenuItems] = (0, $7fPBF.useState)([]);
    const [showAddCategoryForm, setShowAddCategoryForm] = (0, $7fPBF.useState)(false);
    const [showAddItemModal, setShowAddItemModal] = (0, $7fPBF.useState)(false);
    const [showEditItemModal, setShowEditItemModal] = (0, $7fPBF.useState)(false);
    const [newCategoryName, setNewCategoryName] = (0, $7fPBF.useState)('');
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [currentItem, setCurrentItem] = (0, $7fPBF.useState)(null);
    const [newItem, setNewItem] = (0, $7fPBF.useState)({
        name: '',
        description: '',
        price: '',
        is_available: true,
        image_file: null,
        image_preview: null
    });
    const [uploading, setUploading] = (0, $7fPBF.useState)(false);
    // Load restaurant data and menu categories
    (0, $7fPBF.useEffect)(()=>{
        const loadRestaurantData = async ()=>{
            try {
                const { data: restaurant, error: restaurantError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('*').eq('id', restaurantId).single();
                if (restaurantError) throw restaurantError;
                setRestaurant(restaurant);
                const { data: categories, error: categoriesError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('categories').select('*').eq('restaurant_id', restaurantId).order('display_order', {
                    ascending: true
                });
                if (categoriesError) throw categoriesError;
                setCategories(categories);
                if (categories && categories.length > 0) setSelectedCategory(categories[0].id);
                setLoading(false);
            } catch (error) {
                console.error('Error loading restaurant data:', error);
                setLoading(false);
            }
        };
        loadRestaurantData();
    }, [
        restaurantId
    ]);
    // Load menu items when category changes
    (0, $7fPBF.useEffect)(()=>{
        if (!selectedCategory) return;
        const loadMenuItems = async ()=>{
            try {
                const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').select('*').eq('category_id', selectedCategory).order('display_order', {
                    ascending: true
                });
                if (error) throw error;
                setMenuItems(data || []);
            } catch (error) {
                console.error('Error loading menu items:', error);
            }
        };
        loadMenuItems();
    }, [
        selectedCategory
    ]);
    const handleCategoryClick = (categoryId)=>{
        setSelectedCategory(categoryId);
    };
    const handleAddCategorySubmit = async (e)=>{
        e.preventDefault();
        if (!newCategoryName.trim()) return;
        try {
            const newDisplayOrder = categories.length;
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('categories').insert([
                {
                    name: newCategoryName,
                    restaurant_id: restaurantId,
                    display_order: newDisplayOrder
                }
            ]).select();
            if (error) throw error;
            console.log("New category created:", data);
            setCategories([
                ...categories,
                data[0]
            ]);
            setShowAddCategoryForm(false);
            setNewCategoryName('');
            setSelectedCategory(data[0].id);
        } catch (error) {
            console.error('Error adding category:', error);
        }
    };
    const handleAddItemClick = ()=>{
        setNewItem({
            name: '',
            description: '',
            price: '',
            is_available: true,
            image_file: null,
            image_preview: null
        });
        setShowAddItemModal(true);
    };
    // Handle file selection for menu item images
    const handleFileChange = (e)=>{
        const file = e.target.files[0];
        if (file) {
            // Check file size (2MB limit)
            if (file.size > 2000000) {
                alert('Image is too large. Please select an image under 2MB.');
                e.target.value = null; // Clear the input
                return;
            }
            setNewItem({
                ...newItem,
                image_file: file
            });
            // Create a preview
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setNewItem((prev)=>({
                        ...prev,
                        image_preview: reader.result
                    }));
            };
            reader.readAsDataURL(file);
        }
    };
    // Function to upload image to Supabase storage
    const uploadImage = async (file)=>{
        try {
            setUploading(true);
            // Create a unique filename
            const fileExt = file.name.split('.').pop();
            const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
            const filePath = `${restaurantId}/${fileName}`;
            // Upload the file
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('menu-item-images').upload(filePath, file);
            if (error) throw error;
            // Get the public URL
            const { data: { publicUrl: publicUrl } } = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('menu-item-images').getPublicUrl(filePath);
            return publicUrl;
        } catch (error) {
            console.error('Error uploading image:', error);
            throw error;
        } finally{
            setUploading(false);
        }
    };
    // Function to delete an image from Supabase storage
    const deleteImage = async (url)=>{
        if (!url) return;
        try {
            // Extract the path from the URL
            // The URL format will be like: https://[project-ref].supabase.co/storage/v1/object/public/menu-item-images/[restaurant-id]/[filename]
            const urlParts = url.split('/');
            const fileName = urlParts[urlParts.length - 1];
            const restaurantFolder = urlParts[urlParts.length - 2];
            const filePath = `${restaurantFolder}/${fileName}`;
            // Delete the file
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).storage.from('menu-item-images').remove([
                filePath
            ]);
            if (error) console.error('Error deleting image:', error);
        } catch (error) {
            console.error('Error parsing image URL for deletion:', error);
        }
    };
    const handleAddItem = async (e)=>{
        e.preventDefault();
        try {
            let imageUrl = '';
            // Upload the image if one is selected
            if (newItem.image_file) imageUrl = await uploadImage(newItem.image_file);
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').insert([
                {
                    name: newItem.name,
                    description: newItem.description,
                    price: parseFloat(newItem.price),
                    category_id: selectedCategory,
                    restaurant_id: restaurantId,
                    active: newItem.is_available,
                    image_url: imageUrl,
                    display_order: menuItems.length
                }
            ]).select();
            if (error) throw error;
            console.log("New menu item created:", data);
            setMenuItems([
                ...menuItems,
                data[0]
            ]);
            setShowAddItemModal(false);
            setNewItem({
                name: '',
                description: '',
                price: '',
                is_available: true,
                image_file: null,
                image_preview: null
            });
        } catch (error) {
            console.error('Error adding menu item:', error);
        }
    };
    const handleEditItemClick = (item)=>{
        setCurrentItem(item);
        setNewItem({
            name: item.name,
            description: item.description || '',
            price: item.price.toString(),
            is_available: item.active,
            image_file: null,
            image_preview: item.image_url
        });
        setShowEditItemModal(true);
    };
    const handleUpdateItem = async (e)=>{
        e.preventDefault();
        try {
            let imageUrl = currentItem.image_url;
            // Upload the new image if one is selected
            if (newItem.image_file) {
                // If there's an existing image, delete it first
                if (currentItem.image_url) await deleteImage(currentItem.image_url);
                imageUrl = await uploadImage(newItem.image_file);
            }
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').update({
                name: newItem.name,
                description: newItem.description,
                price: parseFloat(newItem.price),
                active: newItem.is_available,
                image_url: imageUrl
            }).eq('id', currentItem.id);
            if (error) throw error;
            // Update local state
            setMenuItems(menuItems.map((item)=>item.id === currentItem.id ? {
                    ...item,
                    name: newItem.name,
                    description: newItem.description,
                    price: parseFloat(newItem.price),
                    active: newItem.is_available,
                    image_url: imageUrl
                } : item));
            setShowEditItemModal(false);
            setCurrentItem(null);
            setNewItem({
                name: '',
                description: '',
                price: '',
                is_available: true,
                image_file: null,
                image_preview: null
            });
        } catch (error) {
            console.error('Error updating menu item:', error);
        }
    };
    const handleDeleteItem = async (itemId)=>{
        if (!window.confirm('Are you sure you want to delete this item?')) return;
        try {
            // Get the item to find its image URL
            const itemToDelete = menuItems.find((item)=>item.id === itemId);
            // Delete the image if it exists
            if (itemToDelete?.image_url) await deleteImage(itemToDelete.image_url);
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').delete().eq('id', itemId);
            if (error) throw error;
            setMenuItems(menuItems.filter((item)=>item.id !== itemId));
        } catch (error) {
            console.error('Error deleting menu item:', error);
        }
    };
    const toggleItemAvailability = async (itemId, currentStatus)=>{
        try {
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('menu_items').update({
                active: !currentStatus
            }) // Note: schema uses "active" not "is_available"
            .eq('id', itemId);
            if (error) throw error;
            setMenuItems(menuItems.map((item)=>item.id === itemId ? {
                    ...item,
                    active: !currentStatus
                } // Note: schema uses "active" not "is_available"
                 : item));
        } catch (error) {
            console.error('Error updating item availability:', error);
        }
    };
    if (loading && !restaurant) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmContainer,
        children: "Loading restaurant data..."
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).contentContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).pageHeader,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                children: restaurant?.name || 'Menu Management'
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                onClick: ()=>navigate('/dashboard'),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).backButton,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$7d058c8fc42b3484), {
                                        size: 16
                                    }),
                                    " Back to Dashboard"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).contentLayout,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSidebar,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSectionTitle,
                                        children: "Categories"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCategoryList,
                                        children: categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                onClick: ()=>handleCategoryClick(category.id),
                                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCategoryButton} ${selectedCategory === category.id ? (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSelected : ''}`,
                                                children: category.name
                                            }, category.id))
                                    }),
                                    showAddCategoryForm ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmAddCategoryForm,
                                        onSubmit: handleAddCategorySubmit,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "text",
                                                value: newCategoryName,
                                                onChange: (e)=>setNewCategoryName(e.target.value),
                                                placeholder: "Category name",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmInput,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormButtons,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setShowAddCategoryForm(false),
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSecondaryButton,
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmPrimaryButton,
                                                        children: "Add"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        onClick: ()=>setShowAddCategoryForm(true),
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmAddButton,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {
                                                size: 16
                                            }),
                                            " Add Category"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMainContent,
                                children: selectedCategory && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSectionHeader,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSectionTitle,
                                                    children: categories.find((c)=>c.id === selectedCategory)?.name || 'Menu Items'
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                    onClick: handleAddItemClick,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmPrimaryButton,
                                                    disabled: !selectedCategory,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {
                                                            size: 16
                                                        }),
                                                        " Add Item"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuGrid,
                                            children: menuItems.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmEmptyState,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$6d8c744810a836d), {
                                                        size: 48
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: "No items in this category yet."
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: 'Click "Add Item" to create your first menu item.'
                                                    })
                                                ]
                                            }) : menuItems.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItem,
                                                    children: [
                                                        item.image_url && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemImageContainer,
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                                src: item.image_url,
                                                                alt: item.name,
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemImage
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemHeader,
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemName,
                                                                    children: item.name
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemPrice,
                                                                    children: [
                                                                        "$",
                                                                        item.price.toFixed(2)
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemDesc,
                                                            children: item.description || 'No description provided.'
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemFooter,
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmItemStatus} ${item.active ? (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmAvailable : (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmUnavailable}`,
                                                                    onClick: ()=>toggleItemAvailability(item.id, item.active),
                                                                    children: item.active ? 'Available' : 'Unavailable'
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmMenuItemActions,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                            onClick: ()=>handleEditItemClick(item),
                                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmEditButton,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$72c1672405f8cac2), {
                                                                                size: 14
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                            onClick: ()=>handleDeleteItem(item.id),
                                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmDeleteButton,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$b45f06eb58143962), {
                                                                                size: 14
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.id))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            showAddItemModal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalContent,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalHeader,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    children: "Add Menu Item"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    onClick: ()=>setShowAddItemModal(false),
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCloseButton,
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                            onSubmit: handleAddItem,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "item-name",
                                            children: "Item Name"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "item-name",
                                            type: "text",
                                            value: newItem.name,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    name: e.target.value
                                                }),
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "item-description",
                                            children: "Description (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                            id: "item-description",
                                            value: newItem.description,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    description: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "item-price",
                                            children: "Price ($)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "item-price",
                                            type: "number",
                                            step: "0.01",
                                            min: "0",
                                            value: newItem.price,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    price: e.target.value
                                                }),
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "item-image",
                                            children: "Item Image (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImageUploadContainer,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "file",
                                                    id: "item-image",
                                                    accept: "image/*",
                                                    onChange: handleFileChange,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFileInput
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                    htmlFor: "item-image",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFileInputLabel,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a5e7deed97e8be52), {
                                                            size: 18
                                                        }),
                                                        newItem.image_file ? 'Change Image' : 'Upload Image'
                                                    ]
                                                })
                                            ]
                                        }),
                                        newItem.image_preview && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImagePreviewContainer,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: newItem.image_preview,
                                                alt: "Preview",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImagePreview
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCheckboxLabel,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: newItem.is_available,
                                                onChange: (e)=>setNewItem({
                                                        ...newItem,
                                                        is_available: e.target.checked
                                                    })
                                            }),
                                            "Item is available"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalActions,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowAddItemModal(false),
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSecondaryButton,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "submit",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmPrimaryButton,
                                            disabled: uploading,
                                            children: uploading ? 'Uploading...' : 'Add Item'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showEditItemModal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalContent,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalHeader,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    children: "Edit Menu Item"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    onClick: ()=>setShowEditItemModal(false),
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCloseButton,
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                            onSubmit: handleUpdateItem,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "edit-item-name",
                                            children: "Item Name"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "edit-item-name",
                                            type: "text",
                                            value: newItem.name,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    name: e.target.value
                                                }),
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "edit-item-description",
                                            children: "Description (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                            id: "edit-item-description",
                                            value: newItem.description,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    description: e.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "edit-item-price",
                                            children: "Price ($)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "edit-item-price",
                                            type: "number",
                                            step: "0.01",
                                            min: "0",
                                            value: newItem.price,
                                            onChange: (e)=>setNewItem({
                                                    ...newItem,
                                                    price: e.target.value
                                                }),
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "edit-item-image",
                                            children: "Item Image (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImageUploadContainer,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "file",
                                                    id: "edit-item-image",
                                                    accept: "image/*",
                                                    onChange: handleFileChange,
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFileInput
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                    htmlFor: "edit-item-image",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFileInputLabel,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$a5e7deed97e8be52), {
                                                            size: 18
                                                        }),
                                                        newItem.image_file ? 'Change Image' : newItem.image_preview ? 'Replace Image' : 'Upload Image'
                                                    ]
                                                })
                                            ]
                                        }),
                                        newItem.image_preview && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImagePreviewContainer,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: newItem.image_preview,
                                                    alt: "Preview",
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmImagePreview
                                                }),
                                                newItem.image_preview && !newItem.image_file && currentItem?.image_url && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>{
                                                        if (window.confirm('Are you sure you want to remove this image?')) setNewItem({
                                                            ...newItem,
                                                            image_preview: null
                                                        });
                                                    },
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmRemoveImageButton,
                                                    children: "Remove Image"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmFormGroup,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmCheckboxLabel,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: newItem.is_available,
                                                onChange: (e)=>setNewItem({
                                                        ...newItem,
                                                        is_available: e.target.checked
                                                    })
                                            }),
                                            "Item is available"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmModalActions,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setShowEditItemModal(false),
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmSecondaryButton,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "submit",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a6155302d6240a0b$exports))).mmPrimaryButton,
                                            disabled: uploading,
                                            children: uploading ? 'Uploading...' : 'Update Item'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");



const $528c84b9a67485b9$export$9430419a8060863f = async (restaurantId, status = null)=>{
    try {
        console.log('Fetching orders for restaurant:', restaurantId, 'status:', status);
        let query = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('orders').select(`
        *,
        order_items (*)
      `).eq('restaurant_id', restaurantId).order('created_at', {
            ascending: false
        });
        if (status && status !== 'all') query = query.eq('status', status);
        const { data: data, error: error } = await query;
        if (error) {
            console.error('Database error fetching orders:', error);
            throw error;
        }
        console.log('Orders fetched successfully:', data?.length || 0, 'orders');
        return data || [];
    } catch (error) {
        console.error('Error in getRestaurantOrders:', error);
        // Return empty array instead of throwing to prevent complete failure
        return [];
    }
};
const $528c84b9a67485b9$export$3d5e2ef71327aff8 = async (orderId, status)=>{
    try {
        const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('orders').update({
            status: status,
            updated_at: new Date().toISOString()
        }).eq('id', orderId).select().single();
        if (error) {
            console.error('Error updating order status:', error);
            throw error;
        }
        return data;
    } catch (error) {
        console.error('Error in updateOrderStatus:', error);
        throw error;
    }
};
const $528c84b9a67485b9$export$4e05eed7f498666c = async (orderId)=>{
    try {
        console.log(`Fetching order with ID: ${orderId}`);
        const { data: order, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('orders').select(`
        *,
        restaurants (
          name,
          user_id
        ),
        order_items (*)
      `).eq('id', orderId).single();
        if (error) {
            console.error('Error fetching order:', error);
            throw error;
        }
        console.log('Order fetched successfully:', order);
        return order;
    } catch (error) {
        console.error('Error in getOrder:', error);
        throw error;
    }
};



var $82e9ac6adc80ef6f$exports = {};

$parcel$export($82e9ac6adc80ef6f$exports, "actionButtons", function () { return $82e9ac6adc80ef6f$export$b6fb1741c7f64881; }, function (v) { return $82e9ac6adc80ef6f$export$b6fb1741c7f64881 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "activeTab", function () { return $82e9ac6adc80ef6f$export$9f2575a093d7aa7b; }, function (v) { return $82e9ac6adc80ef6f$export$9f2575a093d7aa7b = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "container", function () { return $82e9ac6adc80ef6f$export$34e0f9847d4c02dd; }, function (v) { return $82e9ac6adc80ef6f$export$34e0f9847d4c02dd = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "content", function () { return $82e9ac6adc80ef6f$export$a7db06668cad9adb; }, function (v) { return $82e9ac6adc80ef6f$export$a7db06668cad9adb = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "customerInfo", function () { return $82e9ac6adc80ef6f$export$88b36cb4fcb71bf; }, function (v) { return $82e9ac6adc80ef6f$export$88b36cb4fcb71bf = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "dangerButton", function () { return $82e9ac6adc80ef6f$export$a6beae3ce20ad3b; }, function (v) { return $82e9ac6adc80ef6f$export$a6beae3ce20ad3b = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "emptyState", function () { return $82e9ac6adc80ef6f$export$252465da46a2ae40; }, function (v) { return $82e9ac6adc80ef6f$export$252465da46a2ae40 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "header", function () { return $82e9ac6adc80ef6f$export$38e42c68cf43b5d4; }, function (v) { return $82e9ac6adc80ef6f$export$38e42c68cf43b5d4 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "headerContent", function () { return $82e9ac6adc80ef6f$export$838c0e7679321ff3; }, function (v) { return $82e9ac6adc80ef6f$export$838c0e7679321ff3 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "headerRow", function () { return $82e9ac6adc80ef6f$export$faed4863136ce212; }, function (v) { return $82e9ac6adc80ef6f$export$faed4863136ce212 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "itemNotes", function () { return $82e9ac6adc80ef6f$export$8cfd869fe52712fe; }, function (v) { return $82e9ac6adc80ef6f$export$8cfd869fe52712fe = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "itemQuantity", function () { return $82e9ac6adc80ef6f$export$189cf77755084f31; }, function (v) { return $82e9ac6adc80ef6f$export$189cf77755084f31 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "loadingSpinner", function () { return $82e9ac6adc80ef6f$export$deaa9e6d912ce6c6; }, function (v) { return $82e9ac6adc80ef6f$export$deaa9e6d912ce6c6 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "loadingState", function () { return $82e9ac6adc80ef6f$export$d4777e60655a088c; }, function (v) { return $82e9ac6adc80ef6f$export$d4777e60655a088c = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "logo", function () { return $82e9ac6adc80ef6f$export$db3c28d99448dcff; }, function (v) { return $82e9ac6adc80ef6f$export$db3c28d99448dcff = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "logoContainer", function () { return $82e9ac6adc80ef6f$export$a1fe6a2d7788354f; }, function (v) { return $82e9ac6adc80ef6f$export$a1fe6a2d7788354f = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "noOrderSelected", function () { return $82e9ac6adc80ef6f$export$a6bd135593c65d97; }, function (v) { return $82e9ac6adc80ef6f$export$a6bd135593c65d97 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "notification", function () { return $82e9ac6adc80ef6f$export$2adf6238a2d0dafa; }, function (v) { return $82e9ac6adc80ef6f$export$2adf6238a2d0dafa = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderActions", function () { return $82e9ac6adc80ef6f$export$c85a6cdcc3c47b9a; }, function (v) { return $82e9ac6adc80ef6f$export$c85a6cdcc3c47b9a = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderAmount", function () { return $82e9ac6adc80ef6f$export$b95fdbe07592942c; }, function (v) { return $82e9ac6adc80ef6f$export$b95fdbe07592942c = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderCard", function () { return $82e9ac6adc80ef6f$export$5e37aef8f2a811e2; }, function (v) { return $82e9ac6adc80ef6f$export$5e37aef8f2a811e2 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderCardFooter", function () { return $82e9ac6adc80ef6f$export$ebb3cfd6ae717199; }, function (v) { return $82e9ac6adc80ef6f$export$ebb3cfd6ae717199 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderCardHeader", function () { return $82e9ac6adc80ef6f$export$69c29a6f2adea7e; }, function (v) { return $82e9ac6adc80ef6f$export$69c29a6f2adea7e = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderContainer", function () { return $82e9ac6adc80ef6f$export$70a62682f48cc2c0; }, function (v) { return $82e9ac6adc80ef6f$export$70a62682f48cc2c0 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderDetailHeader", function () { return $82e9ac6adc80ef6f$export$38a7e5b2a73b890e; }, function (v) { return $82e9ac6adc80ef6f$export$38a7e5b2a73b890e = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderDetails", function () { return $82e9ac6adc80ef6f$export$f4a3f69a19bda341; }, function (v) { return $82e9ac6adc80ef6f$export$f4a3f69a19bda341 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderItem", function () { return $82e9ac6adc80ef6f$export$20ac01fe5d166671; }, function (v) { return $82e9ac6adc80ef6f$export$20ac01fe5d166671 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderItemHeader", function () { return $82e9ac6adc80ef6f$export$1f3af4cbd325612a; }, function (v) { return $82e9ac6adc80ef6f$export$1f3af4cbd325612a = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderItemsList", function () { return $82e9ac6adc80ef6f$export$eebd5914249afe31; }, function (v) { return $82e9ac6adc80ef6f$export$eebd5914249afe31 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderItemsSection", function () { return $82e9ac6adc80ef6f$export$d891b802141f7484; }, function (v) { return $82e9ac6adc80ef6f$export$d891b802141f7484 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "orderTotal", function () { return $82e9ac6adc80ef6f$export$c3c2dc880887c924; }, function (v) { return $82e9ac6adc80ef6f$export$c3c2dc880887c924 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "ordersList", function () { return $82e9ac6adc80ef6f$export$7af9efb904a7687f; }, function (v) { return $82e9ac6adc80ef6f$export$7af9efb904a7687f = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "ordersListTitle", function () { return $82e9ac6adc80ef6f$export$9333ac1ef49b004c; }, function (v) { return $82e9ac6adc80ef6f$export$9333ac1ef49b004c = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "paymentStatus", function () { return $82e9ac6adc80ef6f$export$a18da5e670f0b062; }, function (v) { return $82e9ac6adc80ef6f$export$a18da5e670f0b062 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "primaryButton", function () { return $82e9ac6adc80ef6f$export$41c1085b355ecc97; }, function (v) { return $82e9ac6adc80ef6f$export$41c1085b355ecc97 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "restaurantDescription", function () { return $82e9ac6adc80ef6f$export$1c047df2f393edd8; }, function (v) { return $82e9ac6adc80ef6f$export$1c047df2f393edd8 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "secondaryButton", function () { return $82e9ac6adc80ef6f$export$130dd2cd4186e923; }, function (v) { return $82e9ac6adc80ef6f$export$130dd2cd4186e923 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "selectedOrderCard", function () { return $82e9ac6adc80ef6f$export$392e2ddbaf9a45c4; }, function (v) { return $82e9ac6adc80ef6f$export$392e2ddbaf9a45c4 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "slideIn", function () { return $82e9ac6adc80ef6f$export$d08c54023c399c9c; }, function (v) { return $82e9ac6adc80ef6f$export$d08c54023c399c9c = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "spin", function () { return $82e9ac6adc80ef6f$export$c82e186cf428d56d; }, function (v) { return $82e9ac6adc80ef6f$export$c82e186cf428d56d = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "statusBadge", function () { return $82e9ac6adc80ef6f$export$a7d7073b5bbba013; }, function (v) { return $82e9ac6adc80ef6f$export$a7d7073b5bbba013 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "successButton", function () { return $82e9ac6adc80ef6f$export$11a957fa5398d41e; }, function (v) { return $82e9ac6adc80ef6f$export$11a957fa5398d41e = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "tabButton", function () { return $82e9ac6adc80ef6f$export$ef65521c1db5cbae; }, function (v) { return $82e9ac6adc80ef6f$export$ef65521c1db5cbae = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "tableIndicator", function () { return $82e9ac6adc80ef6f$export$eb57a58ce1b7fc65; }, function (v) { return $82e9ac6adc80ef6f$export$eb57a58ce1b7fc65 = v; });
$parcel$export($82e9ac6adc80ef6f$exports, "tabs", function () { return $82e9ac6adc80ef6f$export$39f5674517ec0000; }, function (v) { return $82e9ac6adc80ef6f$export$39f5674517ec0000 = v; });
var $82e9ac6adc80ef6f$export$b6fb1741c7f64881;
var $82e9ac6adc80ef6f$export$9f2575a093d7aa7b;
var $82e9ac6adc80ef6f$export$34e0f9847d4c02dd;
var $82e9ac6adc80ef6f$export$a7db06668cad9adb;
var $82e9ac6adc80ef6f$export$88b36cb4fcb71bf;
var $82e9ac6adc80ef6f$export$a6beae3ce20ad3b;
var $82e9ac6adc80ef6f$export$252465da46a2ae40;
var $82e9ac6adc80ef6f$export$38e42c68cf43b5d4;
var $82e9ac6adc80ef6f$export$838c0e7679321ff3;
var $82e9ac6adc80ef6f$export$faed4863136ce212;
var $82e9ac6adc80ef6f$export$8cfd869fe52712fe;
var $82e9ac6adc80ef6f$export$189cf77755084f31;
var $82e9ac6adc80ef6f$export$deaa9e6d912ce6c6;
var $82e9ac6adc80ef6f$export$d4777e60655a088c;
var $82e9ac6adc80ef6f$export$db3c28d99448dcff;
var $82e9ac6adc80ef6f$export$a1fe6a2d7788354f;
var $82e9ac6adc80ef6f$export$a6bd135593c65d97;
var $82e9ac6adc80ef6f$export$2adf6238a2d0dafa;
var $82e9ac6adc80ef6f$export$c85a6cdcc3c47b9a;
var $82e9ac6adc80ef6f$export$b95fdbe07592942c;
var $82e9ac6adc80ef6f$export$5e37aef8f2a811e2;
var $82e9ac6adc80ef6f$export$ebb3cfd6ae717199;
var $82e9ac6adc80ef6f$export$69c29a6f2adea7e;
var $82e9ac6adc80ef6f$export$70a62682f48cc2c0;
var $82e9ac6adc80ef6f$export$38a7e5b2a73b890e;
var $82e9ac6adc80ef6f$export$f4a3f69a19bda341;
var $82e9ac6adc80ef6f$export$20ac01fe5d166671;
var $82e9ac6adc80ef6f$export$1f3af4cbd325612a;
var $82e9ac6adc80ef6f$export$eebd5914249afe31;
var $82e9ac6adc80ef6f$export$d891b802141f7484;
var $82e9ac6adc80ef6f$export$c3c2dc880887c924;
var $82e9ac6adc80ef6f$export$7af9efb904a7687f;
var $82e9ac6adc80ef6f$export$9333ac1ef49b004c;
var $82e9ac6adc80ef6f$export$a18da5e670f0b062;
var $82e9ac6adc80ef6f$export$41c1085b355ecc97;
var $82e9ac6adc80ef6f$export$1c047df2f393edd8;
var $82e9ac6adc80ef6f$export$130dd2cd4186e923;
var $82e9ac6adc80ef6f$export$392e2ddbaf9a45c4;
var $82e9ac6adc80ef6f$export$d08c54023c399c9c;
var $82e9ac6adc80ef6f$export$c82e186cf428d56d;
var $82e9ac6adc80ef6f$export$a7d7073b5bbba013;
var $82e9ac6adc80ef6f$export$11a957fa5398d41e;
var $82e9ac6adc80ef6f$export$ef65521c1db5cbae;
var $82e9ac6adc80ef6f$export$eb57a58ce1b7fc65;
var $82e9ac6adc80ef6f$export$39f5674517ec0000;
$82e9ac6adc80ef6f$export$b6fb1741c7f64881 = `WeoMqa_actionButtons`;
$82e9ac6adc80ef6f$export$9f2575a093d7aa7b = `WeoMqa_activeTab`;
$82e9ac6adc80ef6f$export$34e0f9847d4c02dd = `WeoMqa_container`;
$82e9ac6adc80ef6f$export$a7db06668cad9adb = `WeoMqa_content`;
$82e9ac6adc80ef6f$export$88b36cb4fcb71bf = `WeoMqa_customerInfo`;
$82e9ac6adc80ef6f$export$a6beae3ce20ad3b = `WeoMqa_dangerButton`;
$82e9ac6adc80ef6f$export$252465da46a2ae40 = `WeoMqa_emptyState`;
$82e9ac6adc80ef6f$export$38e42c68cf43b5d4 = `WeoMqa_header`;
$82e9ac6adc80ef6f$export$838c0e7679321ff3 = `WeoMqa_headerContent`;
$82e9ac6adc80ef6f$export$faed4863136ce212 = `WeoMqa_headerRow`;
$82e9ac6adc80ef6f$export$8cfd869fe52712fe = `WeoMqa_itemNotes`;
$82e9ac6adc80ef6f$export$189cf77755084f31 = `WeoMqa_itemQuantity`;
$82e9ac6adc80ef6f$export$deaa9e6d912ce6c6 = `WeoMqa_loadingSpinner`;
$82e9ac6adc80ef6f$export$d4777e60655a088c = `WeoMqa_loadingState`;
$82e9ac6adc80ef6f$export$db3c28d99448dcff = `WeoMqa_logo`;
$82e9ac6adc80ef6f$export$a1fe6a2d7788354f = `WeoMqa_logoContainer`;
$82e9ac6adc80ef6f$export$a6bd135593c65d97 = `WeoMqa_noOrderSelected`;
$82e9ac6adc80ef6f$export$2adf6238a2d0dafa = `WeoMqa_notification`;
$82e9ac6adc80ef6f$export$c85a6cdcc3c47b9a = `WeoMqa_orderActions`;
$82e9ac6adc80ef6f$export$b95fdbe07592942c = `WeoMqa_orderAmount`;
$82e9ac6adc80ef6f$export$5e37aef8f2a811e2 = `WeoMqa_orderCard`;
$82e9ac6adc80ef6f$export$ebb3cfd6ae717199 = `WeoMqa_orderCardFooter`;
$82e9ac6adc80ef6f$export$69c29a6f2adea7e = `WeoMqa_orderCardHeader`;
$82e9ac6adc80ef6f$export$70a62682f48cc2c0 = `WeoMqa_orderContainer`;
$82e9ac6adc80ef6f$export$38a7e5b2a73b890e = `WeoMqa_orderDetailHeader`;
$82e9ac6adc80ef6f$export$f4a3f69a19bda341 = `WeoMqa_orderDetails`;
$82e9ac6adc80ef6f$export$20ac01fe5d166671 = `WeoMqa_orderItem`;
$82e9ac6adc80ef6f$export$1f3af4cbd325612a = `WeoMqa_orderItemHeader`;
$82e9ac6adc80ef6f$export$eebd5914249afe31 = `WeoMqa_orderItemsList`;
$82e9ac6adc80ef6f$export$d891b802141f7484 = `WeoMqa_orderItemsSection`;
$82e9ac6adc80ef6f$export$c3c2dc880887c924 = `WeoMqa_orderTotal`;
$82e9ac6adc80ef6f$export$7af9efb904a7687f = `WeoMqa_ordersList`;
$82e9ac6adc80ef6f$export$9333ac1ef49b004c = `WeoMqa_ordersListTitle`;
$82e9ac6adc80ef6f$export$a18da5e670f0b062 = `WeoMqa_paymentStatus`;
$82e9ac6adc80ef6f$export$41c1085b355ecc97 = `WeoMqa_primaryButton`;
$82e9ac6adc80ef6f$export$1c047df2f393edd8 = `WeoMqa_restaurantDescription`;
$82e9ac6adc80ef6f$export$130dd2cd4186e923 = `WeoMqa_secondaryButton`;
$82e9ac6adc80ef6f$export$392e2ddbaf9a45c4 = `WeoMqa_selectedOrderCard`;
$82e9ac6adc80ef6f$export$d08c54023c399c9c = `WeoMqa_slideIn`;
$82e9ac6adc80ef6f$export$d08c54023c399c9c;
$82e9ac6adc80ef6f$export$c82e186cf428d56d = `WeoMqa_spin`;
$82e9ac6adc80ef6f$export$c82e186cf428d56d;
$82e9ac6adc80ef6f$export$a7d7073b5bbba013 = `WeoMqa_statusBadge`;
$82e9ac6adc80ef6f$export$11a957fa5398d41e = `WeoMqa_successButton`;
$82e9ac6adc80ef6f$export$ef65521c1db5cbae = `WeoMqa_tabButton`;
$82e9ac6adc80ef6f$export$eb57a58ce1b7fc65 = `WeoMqa_tableIndicator`;
$82e9ac6adc80ef6f$export$39f5674517ec0000 = `WeoMqa_tabs`;



function $1bef01aa08265719$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [orders, setOrders] = (0, $7fPBF.useState)([]);
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)('new');
    const [selectedOrder, setSelectedOrder] = (0, $7fPBF.useState)(null);
    const [newOrderNotification, setNewOrderNotification] = (0, $7fPBF.useState)(false);
    const audioRef = (0, $7fPBF.useRef)(null);
    const [stripeAccountId, setStripeAccountId] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        loadOrders();
        // Set up Supabase realtime subscription
        const subscription = (0, $ca7b91da655d9662$export$a0b632a28672d3c0).channel('orders-channel').on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'orders',
            filter: `restaurant_id=eq.${restaurantId}`
        }, (payload)=>{
            console.log('Real-time update received:', payload);
            // Play notification sound and show alert for new orders
            if (payload.eventType === 'INSERT') handleNewOrder();
            // Refresh orders when any change happens
            loadOrders();
        }).subscribe();
        // Clean up subscription when component unmounts
        return ()=>{
            (0, $ca7b91da655d9662$export$a0b632a28672d3c0).removeChannel(subscription);
        };
    }, [
        restaurantId,
        activeTab
    ]);
    const handleNewOrder = ()=>{
        // Play notification sound
        if (audioRef.current) audioRef.current.play().catch((e)=>console.log('Audio play failed:', e));
        // Show notification
        setNewOrderNotification(true);
        // Auto-hide notification after 5 seconds
        setTimeout(()=>{
            setNewOrderNotification(false);
        }, 5000);
    };
    const loadOrders = async ()=>{
        try {
            const data = await (0, $528c84b9a67485b9$export$9430419a8060863f)(restaurantId, activeTab !== 'all' ? activeTab : null);
            setOrders(data);
            // If we have at least one order, get the restaurant name
            if (data.length > 0 && data[0].restaurant) setRestaurant(data[0].restaurant);
            else {
                // If no orders with restaurant info, fetch restaurant separately
                const { data: restaurantData } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('name, stripe_account_id').eq('id', restaurantId).single();
                if (restaurantData) {
                    setRestaurant(restaurantData);
                    setStripeAccountId(restaurantData.stripe_account_id);
                }
            }
        } catch (error) {
            console.error('Error loading orders:', error);
        } finally{
            setLoading(false);
        }
    };
    const handleStatusChange = async (orderId, newStatus)=>{
        try {
            await (0, $528c84b9a67485b9$export$3d5e2ef71327aff8)(orderId, newStatus);
            // Update selected order if it's the one being changed
            if (selectedOrder && selectedOrder.id === orderId) setSelectedOrder((prev)=>({
                    ...prev,
                    status: newStatus
                }));
        // Orders will be refreshed automatically by the realtime subscription
        } catch (error) {
            console.error('Error updating order status:', error);
        }
    };
    const handleStripeDashboard = ()=>{
        if (stripeAccountId) window.open(`https://dashboard.stripe.com/${stripeAccountId}`, '_blank');
    };
    const formatDate = (dateString)=>{
        const options = {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };
    const getStatusColor = (status)=>{
        switch(status){
            case 'new':
                return '#3498db';
            case 'preparing':
                return '#f39c12';
            case 'ready':
                return '#2ecc71';
            case 'completed':
                return '#27ae60';
            case 'cancelled':
                return '#e74c3c';
            default:
                return '#95a5a6';
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("audio", {
                ref: audioRef,
                src: "/notification-sound.mp3"
            }),
            newOrderNotification && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).notification,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$daf9245cff6c3210), {
                        size: 20
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: "New order received!"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        onClick: ()=>setNewOrderNotification(false),
                        children: "Dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).content,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).pageHeader,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                children: restaurant?.name || 'Order Management'
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).pageHeaderButtons,
                                children: [
                                    stripeAccountId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        onClick: handleStripeDashboard,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).secondaryButton,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$dd412c17c542d388), {
                                                size: 16
                                            }),
                                            " Stripe Dashboard"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        onClick: ()=>navigate('/dashboard'),
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).backButton,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$7d058c8fc42b3484), {
                                                size: 16
                                            }),
                                            " Back to Dashboard"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabs,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveTab('new'),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabButton} ${activeTab === 'new' ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).activeTab : ''}`,
                                children: "New"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveTab('preparing'),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabButton} ${activeTab === 'preparing' ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).activeTab : ''}`,
                                children: "Preparing"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveTab('ready'),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabButton} ${activeTab === 'ready' ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).activeTab : ''}`,
                                children: "Ready"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveTab('completed'),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabButton} ${activeTab === 'completed' ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).activeTab : ''}`,
                                children: "Completed"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveTab('all'),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tabButton} ${activeTab === 'all' ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).activeTab : ''}`,
                                children: "All Orders"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderContainer,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).ordersList,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).ordersListTitle,
                                        children: activeTab === 'all' ? 'All Orders' : `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Orders`
                                    }),
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).loadingState,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).loadingSpinner
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "Loading orders..."
                                            })
                                        ]
                                    }) : orders.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).emptyState,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                            children: [
                                                "No ",
                                                activeTab,
                                                " orders found."
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: orders.map((order)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                onClick: ()=>setSelectedOrder(order),
                                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderCard} ${selectedOrder?.id === order.id ? (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).selectedOrderCard : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderCardHeader,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                                                        children: [
                                                                            "Order #",
                                                                            order.id.slice(-4)
                                                                        ]
                                                                    }),
                                                                    order.table_number && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).tableIndicator,
                                                                        children: [
                                                                            " \u2022 Table ",
                                                                            order.table_number
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderAmount,
                                                                children: [
                                                                    "$",
                                                                    order.total_amount.toFixed(2)
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderCardFooter,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                children: order.customer_name || 'Anonymous'
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                children: formatDate(order.created_at)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, order.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderDetails,
                                children: selectedOrder ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderDetailHeader,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                    children: "Order Details"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).statusBadge,
                                                    style: {
                                                        backgroundColor: getStatusColor(selectedOrder.status)
                                                    },
                                                    children: selectedOrder.status.toUpperCase()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).customerInfo,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Customer:"
                                                        }),
                                                        " ",
                                                        selectedOrder.customer_name || 'Anonymous'
                                                    ]
                                                }),
                                                selectedOrder.customer_email && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Email:"
                                                        }),
                                                        " ",
                                                        selectedOrder.customer_email
                                                    ]
                                                }),
                                                selectedOrder.table_number && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Table:"
                                                        }),
                                                        " ",
                                                        selectedOrder.table_number
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Order Time:"
                                                        }),
                                                        " ",
                                                        formatDate(selectedOrder.created_at)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).paymentStatus,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Payment Status:"
                                                        }),
                                                        " ",
                                                        selectedOrder.payment_status
                                                    ]
                                                }),
                                                selectedOrder.tip_amount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                            children: "Tip Amount:"
                                                        }),
                                                        " $",
                                                        selectedOrder.tip_amount.toFixed(2)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderItemsSection,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                                    children: "Items:"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderItemsList,
                                                    children: selectedOrder.order_items.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderItem,
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderItemHeader,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).itemQuantity,
                                                                                    children: [
                                                                                        item.quantity,
                                                                                        "x"
                                                                                    ]
                                                                                }),
                                                                                item.menu_item_name
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                            children: [
                                                                                "$",
                                                                                (item.price * item.quantity).toFixed(2)
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                item.special_instructions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).itemNotes,
                                                                    children: [
                                                                        "Note: ",
                                                                        item.special_instructions
                                                                    ]
                                                                })
                                                            ]
                                                        }, item.id))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderTotal,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    children: "Total:"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        "$",
                                                        selectedOrder.total_amount.toFixed(2)
                                                    ]
                                                })
                                            ]
                                        }),
                                        selectedOrder.status !== 'completed' && selectedOrder.status !== 'cancelled' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).orderActions,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                                    children: "Update Order Status:"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).actionButtons,
                                                    children: [
                                                        selectedOrder.status === 'new' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    onClick: ()=>handleStatusChange(selectedOrder.id, 'preparing'),
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).primaryButton,
                                                                    children: "Move to Preparing"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    onClick: ()=>handleStatusChange(selectedOrder.id, 'cancelled'),
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).dangerButton,
                                                                    children: "Cancel Order"
                                                                })
                                                            ]
                                                        }),
                                                        selectedOrder.status === 'preparing' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            onClick: ()=>handleStatusChange(selectedOrder.id, 'ready'),
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).successButton,
                                                            children: "Mark as Ready"
                                                        }),
                                                        selectedOrder.status === 'ready' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            onClick: ()=>handleStatusChange(selectedOrder.id, 'completed'),
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).successButton,
                                                            children: "Mark as Completed"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($82e9ac6adc80ef6f$exports))).noOrderSelected,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Select an order to view details"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;



var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();


var $e8db97472bada25e$exports = {};
(function(global, factory) {
    factory($e8db97472bada25e$exports);
})($e8db97472bada25e$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $489bbef2f916bf69$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $489bbef2f916bf69$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $489bbef2f916bf69$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $788a34246aa3a492$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $788a34246aa3a492$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $788a34246aa3a492$var$_typeof(o);
}
function $788a34246aa3a492$var$_toArray(arr) {
    return $788a34246aa3a492$var$_arrayWithHoles(arr) || $788a34246aa3a492$var$_iterableToArray(arr) || $788a34246aa3a492$var$_unsupportedIterableToArray(arr) || $788a34246aa3a492$var$_nonIterableRest();
}
function $788a34246aa3a492$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $788a34246aa3a492$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $788a34246aa3a492$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $788a34246aa3a492$var$_arrayLikeToArray(o, minLen);
}
function $788a34246aa3a492$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $788a34246aa3a492$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $788a34246aa3a492$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $788a34246aa3a492$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $788a34246aa3a492$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $489bbef2f916bf69$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $489bbef2f916bf69$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($788a34246aa3a492$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $f984d770f53b3c67$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f984d770f53b3c67$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f984d770f53b3c67$var$_typeof(o);
}
function $f984d770f53b3c67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f984d770f53b3c67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f984d770f53b3c67$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f984d770f53b3c67$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f984d770f53b3c67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f984d770f53b3c67$var$_defineProperty(obj, key, value) {
    key = $f984d770f53b3c67$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f984d770f53b3c67$var$_toPropertyKey(arg) {
    var key = $f984d770f53b3c67$var$_toPrimitive(arg, "string");
    return $f984d770f53b3c67$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f984d770f53b3c67$var$_toPrimitive(input, hint) {
    if ($f984d770f53b3c67$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f984d770f53b3c67$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f984d770f53b3c67$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $f984d770f53b3c67$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $f984d770f53b3c67$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $f984d770f53b3c67$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $f984d770f53b3c67$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $f984d770f53b3c67$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $f984d770f53b3c67$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $f984d770f53b3c67$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $f984d770f53b3c67$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $f984d770f53b3c67$var$_objectSpread($f984d770f53b3c67$var$_objectSpread({}, res), {}, $f984d770f53b3c67$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $f984d770f53b3c67$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($f984d770f53b3c67$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $f984d770f53b3c67$var$isDev = false;
var $f984d770f53b3c67$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($f984d770f53b3c67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $204c638eabc16c7c$var$_slicedToArray(arr, i) {
    return $204c638eabc16c7c$var$_arrayWithHoles(arr) || $204c638eabc16c7c$var$_iterableToArrayLimit(arr, i) || $204c638eabc16c7c$var$_unsupportedIterableToArray(arr, i) || $204c638eabc16c7c$var$_nonIterableRest();
}
function $204c638eabc16c7c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $204c638eabc16c7c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $204c638eabc16c7c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $204c638eabc16c7c$var$_toConsumableArray(arr) {
    return $204c638eabc16c7c$var$_arrayWithoutHoles(arr) || $204c638eabc16c7c$var$_iterableToArray(arr) || $204c638eabc16c7c$var$_unsupportedIterableToArray(arr) || $204c638eabc16c7c$var$_nonIterableSpread();
}
function $204c638eabc16c7c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $204c638eabc16c7c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $204c638eabc16c7c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $204c638eabc16c7c$var$_arrayLikeToArray(o, minLen);
}
function $204c638eabc16c7c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $204c638eabc16c7c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $204c638eabc16c7c$var$_arrayLikeToArray(arr);
}
function $204c638eabc16c7c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $204c638eabc16c7c$var$ACCURACY = 1e-4;
var $204c638eabc16c7c$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $204c638eabc16c7c$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $204c638eabc16c7c$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $204c638eabc16c7c$var$cubicBezierFactor(c1, c2);
        return $204c638eabc16c7c$var$multyTime(params, t);
    };
};
var $204c638eabc16c7c$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $204c638eabc16c7c$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($204c638eabc16c7c$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $204c638eabc16c7c$var$multyTime(newParams, t);
    };
};
var $204c638eabc16c7c$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $204c638eabc16c7c$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $204c638eabc16c7c$var$cubicBezier(x1, x2);
    var curveY = $204c638eabc16c7c$var$cubicBezier(y1, y2);
    var derCurveX = $204c638eabc16c7c$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $204c638eabc16c7c$var$ACCURACY || derVal < $204c638eabc16c7c$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $204c638eabc16c7c$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $204c638eabc16c7c$var$ACCURACY && Math.abs(newV) < $204c638eabc16c7c$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $204c638eabc16c7c$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $204c638eabc16c7c$export$56c51296f72f0592(easing);
        case 'spring':
            return $204c638eabc16c7c$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $204c638eabc16c7c$export$56c51296f72f0592(easing);
            (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $f984d770f53b3c67$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $c51ac03d54a173a9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c51ac03d54a173a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c51ac03d54a173a9$var$_typeof(o);
}
function $c51ac03d54a173a9$var$_toConsumableArray(arr) {
    return $c51ac03d54a173a9$var$_arrayWithoutHoles(arr) || $c51ac03d54a173a9$var$_iterableToArray(arr) || $c51ac03d54a173a9$var$_unsupportedIterableToArray(arr) || $c51ac03d54a173a9$var$_nonIterableSpread();
}
function $c51ac03d54a173a9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c51ac03d54a173a9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c51ac03d54a173a9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c51ac03d54a173a9$var$_arrayLikeToArray(arr);
}
function $c51ac03d54a173a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c51ac03d54a173a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c51ac03d54a173a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c51ac03d54a173a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c51ac03d54a173a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c51ac03d54a173a9$var$_defineProperty(obj, key, value) {
    key = $c51ac03d54a173a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c51ac03d54a173a9$var$_toPropertyKey(arg) {
    var key = $c51ac03d54a173a9$var$_toPrimitive(arg, "string");
    return $c51ac03d54a173a9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c51ac03d54a173a9$var$_toPrimitive(input, hint) {
    if ($c51ac03d54a173a9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c51ac03d54a173a9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c51ac03d54a173a9$var$_slicedToArray(arr, i) {
    return $c51ac03d54a173a9$var$_arrayWithHoles(arr) || $c51ac03d54a173a9$var$_iterableToArrayLimit(arr, i) || $c51ac03d54a173a9$var$_unsupportedIterableToArray(arr, i) || $c51ac03d54a173a9$var$_nonIterableRest();
}
function $c51ac03d54a173a9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c51ac03d54a173a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c51ac03d54a173a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c51ac03d54a173a9$var$_arrayLikeToArray(o, minLen);
}
function $c51ac03d54a173a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c51ac03d54a173a9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c51ac03d54a173a9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c51ac03d54a173a9$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $c51ac03d54a173a9$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $c51ac03d54a173a9$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
        if ($c51ac03d54a173a9$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $c51ac03d54a173a9$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
        if ($c51ac03d54a173a9$var$needContinue(val)) return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, val), {}, {
            velocity: $c51ac03d54a173a9$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $c51ac03d54a173a9$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$c51ac03d54a173a9$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $f984d770f53b3c67$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, res), {}, $c51ac03d54a173a9$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, res), {}, $c51ac03d54a173a9$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($c51ac03d54a173a9$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $c51ac03d54a173a9$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
            return $c51ac03d54a173a9$var$alpha.apply(void 0, $c51ac03d54a173a9$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $f984d770f53b3c67$export$d6051a0f7a227332)(function(key, val) {
                return $c51ac03d54a173a9$var$alpha.apply(void 0, $c51ac03d54a173a9$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread($c51ac03d54a173a9$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $c2acdb38c69c603a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c2acdb38c69c603a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c2acdb38c69c603a$var$_typeof(o);
}
var $c2acdb38c69c603a$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $c2acdb38c69c603a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c2acdb38c69c603a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c2acdb38c69c603a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c2acdb38c69c603a$var$_toConsumableArray(arr) {
    return $c2acdb38c69c603a$var$_arrayWithoutHoles(arr) || $c2acdb38c69c603a$var$_iterableToArray(arr) || $c2acdb38c69c603a$var$_unsupportedIterableToArray(arr) || $c2acdb38c69c603a$var$_nonIterableSpread();
}
function $c2acdb38c69c603a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c2acdb38c69c603a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c2acdb38c69c603a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c2acdb38c69c603a$var$_arrayLikeToArray(o, minLen);
}
function $c2acdb38c69c603a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c2acdb38c69c603a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c2acdb38c69c603a$var$_arrayLikeToArray(arr);
}
function $c2acdb38c69c603a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c2acdb38c69c603a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2acdb38c69c603a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2acdb38c69c603a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c2acdb38c69c603a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2acdb38c69c603a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2acdb38c69c603a$var$_defineProperty(obj, key, value) {
    key = $c2acdb38c69c603a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2acdb38c69c603a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c2acdb38c69c603a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c2acdb38c69c603a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c2acdb38c69c603a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c2acdb38c69c603a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2acdb38c69c603a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c2acdb38c69c603a$var$_toPropertyKey(arg) {
    var key = $c2acdb38c69c603a$var$_toPrimitive(arg, "string");
    return $c2acdb38c69c603a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c2acdb38c69c603a$var$_toPrimitive(input, hint) {
    if ($c2acdb38c69c603a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c2acdb38c69c603a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c2acdb38c69c603a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c2acdb38c69c603a$var$_setPrototypeOf(subClass, superClass);
}
function $c2acdb38c69c603a$var$_setPrototypeOf(o, p) {
    $c2acdb38c69c603a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c2acdb38c69c603a$var$_setPrototypeOf(o, p);
}
function $c2acdb38c69c603a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c2acdb38c69c603a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c2acdb38c69c603a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c2acdb38c69c603a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c2acdb38c69c603a$var$_possibleConstructorReturn(this, result);
    };
}
function $c2acdb38c69c603a$var$_possibleConstructorReturn(self, call) {
    if (call && ($c2acdb38c69c603a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c2acdb38c69c603a$var$_assertThisInitialized(self);
}
function $c2acdb38c69c603a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c2acdb38c69c603a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c2acdb38c69c603a$var$_getPrototypeOf(o) {
    $c2acdb38c69c603a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c2acdb38c69c603a$var$_getPrototypeOf(o);
}
var $c2acdb38c69c603a$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $c2acdb38c69c603a$var$_inherits(Animate, _PureComponent);
    var _super = $c2acdb38c69c603a$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $c2acdb38c69c603a$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($c2acdb38c69c603a$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($c2acdb38c69c603a$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $c2acdb38c69c603a$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $c2acdb38c69c603a$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $c2acdb38c69c603a$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $e8db97472bada25e$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $c51ac03d54a173a9$export$2e2bcd8739ae039)(from, to, (0, $204c638eabc16c7c$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($c2acdb38c69c603a$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $f984d770f53b3c67$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($c2acdb38c69c603a$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $f984d770f53b3c67$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($c2acdb38c69c603a$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $788a34246aa3a492$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $c2acdb38c69c603a$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $f984d770f53b3c67$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $c2acdb38c69c603a$var$_objectWithoutProperties(_this$props4, $c2acdb38c69c603a$var$_excluded);
                var count = (0, $7fPBF.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $7fPBF.cloneElement)(container, $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, others), {}, {
                        style: $c2acdb38c69c603a$var$_objectSpread($c2acdb38c69c603a$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $7fPBF.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, (0, $7fPBF.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $7fPBF.PureComponent));
$c2acdb38c69c603a$var$Animate.displayName = 'Animate';
$c2acdb38c69c603a$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$c2acdb38c69c603a$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $c2acdb38c69c603a$export$2e2bcd8739ae039 = $c2acdb38c69c603a$var$Animate;




var $36c7fa330327890a$export$2e2bcd8739ae039 = (0, $c2acdb38c69c603a$export$2e2bcd8739ae039);


var $034d80e6a88ef527$exports = {};
var $7c952302caee51c1$exports = {};
var $c633adf42a0b7174$exports = {};
var $75b9f8e835026959$exports = {};
var $d3ce36181053a891$exports = {};
var $b3532018e1ff9eab$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b3532018e1ff9eab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$b3532018e1ff9eab$exports = $b3532018e1ff9eab$var$listCacheClear;


var $0c46ef5003b13e31$exports = {};
var $38429cb5a86e691c$exports = {};
var $881bebc960934ade$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $881bebc960934ade$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$881bebc960934ade$exports = $881bebc960934ade$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $38429cb5a86e691c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($881bebc960934ade$exports(array[length][0], key)) return length;
    }
    return -1;
}
$38429cb5a86e691c$exports = $38429cb5a86e691c$var$assocIndexOf;


/** Used for built-in method references. */ var $0c46ef5003b13e31$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0c46ef5003b13e31$var$splice = $0c46ef5003b13e31$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0c46ef5003b13e31$var$listCacheDelete(key) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0c46ef5003b13e31$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$0c46ef5003b13e31$exports = $0c46ef5003b13e31$var$listCacheDelete;


var $e1040571ebb469f5$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1040571ebb469f5$var$listCacheGet(key) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e1040571ebb469f5$exports = $e1040571ebb469f5$var$listCacheGet;


var $7021072296e166d7$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7021072296e166d7$var$listCacheHas(key) {
    return $38429cb5a86e691c$exports(this.__data__, key) > -1;
}
$7021072296e166d7$exports = $7021072296e166d7$var$listCacheHas;


var $c0f6fe3ec712f3b3$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c0f6fe3ec712f3b3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$c0f6fe3ec712f3b3$exports = $c0f6fe3ec712f3b3$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3ce36181053a891$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3ce36181053a891$var$ListCache.prototype.clear = $b3532018e1ff9eab$exports;
$d3ce36181053a891$var$ListCache.prototype['delete'] = $0c46ef5003b13e31$exports;
$d3ce36181053a891$var$ListCache.prototype.get = $e1040571ebb469f5$exports;
$d3ce36181053a891$var$ListCache.prototype.has = $7021072296e166d7$exports;
$d3ce36181053a891$var$ListCache.prototype.set = $c0f6fe3ec712f3b3$exports;
$d3ce36181053a891$exports = $d3ce36181053a891$var$ListCache;


var $a7beb0ce4fa4126e$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a7beb0ce4fa4126e$var$stackClear() {
    this.__data__ = new $d3ce36181053a891$exports;
    this.size = 0;
}
$a7beb0ce4fa4126e$exports = $a7beb0ce4fa4126e$var$stackClear;


var $0766dee8ae28686e$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0766dee8ae28686e$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$0766dee8ae28686e$exports = $0766dee8ae28686e$var$stackDelete;


var $e9cab4f83b8cf2e9$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e9cab4f83b8cf2e9$var$stackGet(key) {
    return this.__data__.get(key);
}
$e9cab4f83b8cf2e9$exports = $e9cab4f83b8cf2e9$var$stackGet;


var $37e4c239050b91e3$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $37e4c239050b91e3$var$stackHas(key) {
    return this.__data__.has(key);
}
$37e4c239050b91e3$exports = $37e4c239050b91e3$var$stackHas;


var $f707f5e6173bece0$exports = {};

var $3b45073a9f2f1273$exports = {};
var $95eb055fdd27d869$exports = {};
var $b8bc552383eab615$exports = {};
var $07bc7c115e963817$exports = {};
var $ae3fe6c5950c122e$exports = {};
var $c9c36e86f7d6f497$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $1DySm.Symbol;
$c9c36e86f7d6f497$exports = $c9c36e86f7d6f497$var$Symbol;


var $76f84bdae49ee13c$exports = {};

/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
$76f84bdae49ee13c$exports = $76f84bdae49ee13c$var$getRawTag;


var $77d9fbfccc3fe2a6$exports = {};
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
$77d9fbfccc3fe2a6$exports = $77d9fbfccc3fe2a6$var$objectToString;


/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = '[object Null]', $ae3fe6c5950c122e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $76f84bdae49ee13c$exports(value) : $77d9fbfccc3fe2a6$exports(value);
}
$ae3fe6c5950c122e$exports = $ae3fe6c5950c122e$var$baseGetTag;


var $f328ff7ee4fde81a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f328ff7ee4fde81a$exports = $f328ff7ee4fde81a$var$isObject;


/** `Object#toString` result references. */ var $07bc7c115e963817$var$asyncTag = '[object AsyncFunction]', $07bc7c115e963817$var$funcTag = '[object Function]', $07bc7c115e963817$var$genTag = '[object GeneratorFunction]', $07bc7c115e963817$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $07bc7c115e963817$var$isFunction(value) {
    if (!$f328ff7ee4fde81a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ae3fe6c5950c122e$exports(value);
    return tag == $07bc7c115e963817$var$funcTag || tag == $07bc7c115e963817$var$genTag || tag == $07bc7c115e963817$var$asyncTag || tag == $07bc7c115e963817$var$proxyTag;
}
$07bc7c115e963817$exports = $07bc7c115e963817$var$isFunction;


var $e9fd1b1d57dc1cf8$exports = {};
var $1822c948e6f3062a$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Used to detect overreaching core-js shims. */ var $1822c948e6f3062a$var$coreJsData = $1DySm["__core-js_shared__"];
$1822c948e6f3062a$exports = $1822c948e6f3062a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $e9fd1b1d57dc1cf8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1822c948e6f3062a$exports && $1822c948e6f3062a$exports.keys && $1822c948e6f3062a$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e9fd1b1d57dc1cf8$var$isMasked(func) {
    return !!$e9fd1b1d57dc1cf8$var$maskSrcKey && $e9fd1b1d57dc1cf8$var$maskSrcKey in func;
}
$e9fd1b1d57dc1cf8$exports = $e9fd1b1d57dc1cf8$var$isMasked;



var $f4933d7f0a06eb7d$exports = {};
/** Used for built-in method references. */ var $f4933d7f0a06eb7d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4933d7f0a06eb7d$var$funcToString = $f4933d7f0a06eb7d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4933d7f0a06eb7d$var$toSource(func) {
    if (func != null) {
        try {
            return $f4933d7f0a06eb7d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$f4933d7f0a06eb7d$exports = $f4933d7f0a06eb7d$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b8bc552383eab615$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b8bc552383eab615$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b8bc552383eab615$var$funcProto = Function.prototype, $b8bc552383eab615$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b8bc552383eab615$var$funcToString = $b8bc552383eab615$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b8bc552383eab615$var$hasOwnProperty = $b8bc552383eab615$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b8bc552383eab615$var$reIsNative = RegExp('^' + $b8bc552383eab615$var$funcToString.call($b8bc552383eab615$var$hasOwnProperty).replace($b8bc552383eab615$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b8bc552383eab615$var$baseIsNative(value) {
    if (!$f328ff7ee4fde81a$exports(value) || $e9fd1b1d57dc1cf8$exports(value)) return false;
    var pattern = $07bc7c115e963817$exports(value) ? $b8bc552383eab615$var$reIsNative : $b8bc552383eab615$var$reIsHostCtor;
    return pattern.test($f4933d7f0a06eb7d$exports(value));
}
$b8bc552383eab615$exports = $b8bc552383eab615$var$baseIsNative;


var $0f77ce8dc1867245$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0f77ce8dc1867245$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$0f77ce8dc1867245$exports = $0f77ce8dc1867245$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $95eb055fdd27d869$var$getNative(object, key) {
    var value = $0f77ce8dc1867245$exports(object, key);
    return $b8bc552383eab615$exports(value) ? value : undefined;
}
$95eb055fdd27d869$exports = $95eb055fdd27d869$var$getNative;



var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $3b45073a9f2f1273$var$Map = $95eb055fdd27d869$exports($1DySm, 'Map');
$3b45073a9f2f1273$exports = $3b45073a9f2f1273$var$Map;


var $a6cc38418910b2e0$exports = {};
var $640327eb3d1069cf$exports = {};
var $3e17215e62373b7a$exports = {};
var $c25654624248087e$exports = {};
var $84cf21ec84c19391$exports = {};

/* Built-in method references that are verified to be native. */ var $84cf21ec84c19391$var$nativeCreate = $95eb055fdd27d869$exports(Object, 'create');
$84cf21ec84c19391$exports = $84cf21ec84c19391$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c25654624248087e$var$hashClear() {
    this.__data__ = $84cf21ec84c19391$exports ? $84cf21ec84c19391$exports(null) : {};
    this.size = 0;
}
$c25654624248087e$exports = $c25654624248087e$var$hashClear;


var $9b031a80da354f86$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9b031a80da354f86$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$9b031a80da354f86$exports = $9b031a80da354f86$var$hashDelete;


var $bb2415c9bb53848d$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $bb2415c9bb53848d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $bb2415c9bb53848d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb2415c9bb53848d$var$hasOwnProperty = $bb2415c9bb53848d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bb2415c9bb53848d$var$hashGet(key) {
    var data = this.__data__;
    if ($84cf21ec84c19391$exports) {
        var result = data[key];
        return result === $bb2415c9bb53848d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $bb2415c9bb53848d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$bb2415c9bb53848d$exports = $bb2415c9bb53848d$var$hashGet;


var $057fe85caf4b041d$exports = {};

/** Used for built-in method references. */ var $057fe85caf4b041d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $057fe85caf4b041d$var$hasOwnProperty = $057fe85caf4b041d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $057fe85caf4b041d$var$hashHas(key) {
    var data = this.__data__;
    return $84cf21ec84c19391$exports ? data[key] !== undefined : $057fe85caf4b041d$var$hasOwnProperty.call(data, key);
}
$057fe85caf4b041d$exports = $057fe85caf4b041d$var$hashHas;


var $83a7ac52366bc66e$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $83a7ac52366bc66e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $83a7ac52366bc66e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $84cf21ec84c19391$exports && value === undefined ? $83a7ac52366bc66e$var$HASH_UNDEFINED : value;
    return this;
}
$83a7ac52366bc66e$exports = $83a7ac52366bc66e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3e17215e62373b7a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3e17215e62373b7a$var$Hash.prototype.clear = $c25654624248087e$exports;
$3e17215e62373b7a$var$Hash.prototype['delete'] = $9b031a80da354f86$exports;
$3e17215e62373b7a$var$Hash.prototype.get = $bb2415c9bb53848d$exports;
$3e17215e62373b7a$var$Hash.prototype.has = $057fe85caf4b041d$exports;
$3e17215e62373b7a$var$Hash.prototype.set = $83a7ac52366bc66e$exports;
$3e17215e62373b7a$exports = $3e17215e62373b7a$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $640327eb3d1069cf$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $3e17215e62373b7a$exports,
        'map': new ($3b45073a9f2f1273$exports || $d3ce36181053a891$exports),
        'string': new $3e17215e62373b7a$exports
    };
}
$640327eb3d1069cf$exports = $640327eb3d1069cf$var$mapCacheClear;


var $575eb14ab2b31b03$exports = {};
var $e7e2cfab823d50ee$exports = {};
var $66c884747b0ddd4d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $66c884747b0ddd4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$66c884747b0ddd4d$exports = $66c884747b0ddd4d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e7e2cfab823d50ee$var$getMapData(map, key) {
    var data = map.__data__;
    return $66c884747b0ddd4d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$e7e2cfab823d50ee$exports = $e7e2cfab823d50ee$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $575eb14ab2b31b03$var$mapCacheDelete(key) {
    var result = $e7e2cfab823d50ee$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$575eb14ab2b31b03$exports = $575eb14ab2b31b03$var$mapCacheDelete;


var $2fe6cdb7e5c793dc$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fe6cdb7e5c793dc$var$mapCacheGet(key) {
    return $e7e2cfab823d50ee$exports(this, key).get(key);
}
$2fe6cdb7e5c793dc$exports = $2fe6cdb7e5c793dc$var$mapCacheGet;


var $22b760cf30a31377$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22b760cf30a31377$var$mapCacheHas(key) {
    return $e7e2cfab823d50ee$exports(this, key).has(key);
}
$22b760cf30a31377$exports = $22b760cf30a31377$var$mapCacheHas;


var $b39e430f93ec17f8$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b39e430f93ec17f8$var$mapCacheSet(key, value) {
    var data = $e7e2cfab823d50ee$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$b39e430f93ec17f8$exports = $b39e430f93ec17f8$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a6cc38418910b2e0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a6cc38418910b2e0$var$MapCache.prototype.clear = $640327eb3d1069cf$exports;
$a6cc38418910b2e0$var$MapCache.prototype['delete'] = $575eb14ab2b31b03$exports;
$a6cc38418910b2e0$var$MapCache.prototype.get = $2fe6cdb7e5c793dc$exports;
$a6cc38418910b2e0$var$MapCache.prototype.has = $22b760cf30a31377$exports;
$a6cc38418910b2e0$var$MapCache.prototype.set = $b39e430f93ec17f8$exports;
$a6cc38418910b2e0$exports = $a6cc38418910b2e0$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $f707f5e6173bece0$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f707f5e6173bece0$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $d3ce36181053a891$exports) {
        var pairs = data.__data__;
        if (!$3b45073a9f2f1273$exports || pairs.length < $f707f5e6173bece0$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $a6cc38418910b2e0$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$f707f5e6173bece0$exports = $f707f5e6173bece0$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75b9f8e835026959$var$Stack(entries) {
    var data = this.__data__ = new $d3ce36181053a891$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$75b9f8e835026959$var$Stack.prototype.clear = $a7beb0ce4fa4126e$exports;
$75b9f8e835026959$var$Stack.prototype['delete'] = $0766dee8ae28686e$exports;
$75b9f8e835026959$var$Stack.prototype.get = $e9cab4f83b8cf2e9$exports;
$75b9f8e835026959$var$Stack.prototype.has = $37e4c239050b91e3$exports;
$75b9f8e835026959$var$Stack.prototype.set = $f707f5e6173bece0$exports;
$75b9f8e835026959$exports = $75b9f8e835026959$var$Stack;


var $1443c170489acf32$exports = {};
var $7d2f3a0d9ce14f26$exports = {};

var $f6f0f11ce35948e9$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $f6f0f11ce35948e9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f6f0f11ce35948e9$var$setCacheAdd(value) {
    this.__data__.set(value, $f6f0f11ce35948e9$var$HASH_UNDEFINED);
    return this;
}
$f6f0f11ce35948e9$exports = $f6f0f11ce35948e9$var$setCacheAdd;


var $f0633ffdd75034a5$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0633ffdd75034a5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f0633ffdd75034a5$exports = $f0633ffdd75034a5$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7d2f3a0d9ce14f26$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $a6cc38418910b2e0$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7d2f3a0d9ce14f26$var$SetCache.prototype.add = $7d2f3a0d9ce14f26$var$SetCache.prototype.push = $f6f0f11ce35948e9$exports;
$7d2f3a0d9ce14f26$var$SetCache.prototype.has = $f0633ffdd75034a5$exports;
$7d2f3a0d9ce14f26$exports = $7d2f3a0d9ce14f26$var$SetCache;


var $c264d15e7c8deb78$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c264d15e7c8deb78$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c264d15e7c8deb78$exports = $c264d15e7c8deb78$var$arraySome;


var $601e4ed5362647b9$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $601e4ed5362647b9$var$cacheHas(cache, key) {
    return cache.has(key);
}
$601e4ed5362647b9$exports = $601e4ed5362647b9$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1443c170489acf32$var$COMPARE_PARTIAL_FLAG = 1, $1443c170489acf32$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1443c170489acf32$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1443c170489acf32$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1443c170489acf32$var$COMPARE_UNORDERED_FLAG ? new $7d2f3a0d9ce14f26$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c264d15e7c8deb78$exports(other, function(othValue, othIndex) {
                if (!$601e4ed5362647b9$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1443c170489acf32$exports = $1443c170489acf32$var$equalArrays;


var $31649b4ecd936387$exports = {};

var $82ae00c827cb4de5$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $82ae00c827cb4de5$var$Uint8Array = $1DySm.Uint8Array;
$82ae00c827cb4de5$exports = $82ae00c827cb4de5$var$Uint8Array;




var $29990a2aa372abaa$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $29990a2aa372abaa$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$29990a2aa372abaa$exports = $29990a2aa372abaa$var$mapToArray;


var $edfe5dc5ee94a646$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $edfe5dc5ee94a646$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$edfe5dc5ee94a646$exports = $edfe5dc5ee94a646$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG = 1, $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $31649b4ecd936387$var$boolTag = '[object Boolean]', $31649b4ecd936387$var$dateTag = '[object Date]', $31649b4ecd936387$var$errorTag = '[object Error]', $31649b4ecd936387$var$mapTag = '[object Map]', $31649b4ecd936387$var$numberTag = '[object Number]', $31649b4ecd936387$var$regexpTag = '[object RegExp]', $31649b4ecd936387$var$setTag = '[object Set]', $31649b4ecd936387$var$stringTag = '[object String]', $31649b4ecd936387$var$symbolTag = '[object Symbol]';
var $31649b4ecd936387$var$arrayBufferTag = '[object ArrayBuffer]', $31649b4ecd936387$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $31649b4ecd936387$var$symbolProto = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.prototype : undefined, $31649b4ecd936387$var$symbolValueOf = $31649b4ecd936387$var$symbolProto ? $31649b4ecd936387$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31649b4ecd936387$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $31649b4ecd936387$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $31649b4ecd936387$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $82ae00c827cb4de5$exports(object), new $82ae00c827cb4de5$exports(other))) return false;
            return true;
        case $31649b4ecd936387$var$boolTag:
        case $31649b4ecd936387$var$dateTag:
        case $31649b4ecd936387$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $881bebc960934ade$exports(+object, +other);
        case $31649b4ecd936387$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $31649b4ecd936387$var$regexpTag:
        case $31649b4ecd936387$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $31649b4ecd936387$var$mapTag:
            var convert = $29990a2aa372abaa$exports;
        case $31649b4ecd936387$var$setTag:
            var isPartial = bitmask & $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $edfe5dc5ee94a646$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1443c170489acf32$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $31649b4ecd936387$var$symbolTag:
            if ($31649b4ecd936387$var$symbolValueOf) return $31649b4ecd936387$var$symbolValueOf.call(object) == $31649b4ecd936387$var$symbolValueOf.call(other);
    }
    return false;
}
$31649b4ecd936387$exports = $31649b4ecd936387$var$equalByTag;


var $f7bae1035bea0715$exports = {};
var $b43254fda44c104a$exports = {};
var $5b332bf09b0c6ec2$exports = {};
var $efe685e6768936ef$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $efe685e6768936ef$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$efe685e6768936ef$exports = $efe685e6768936ef$var$arrayPush;


var $579b9ba2588bb9de$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $579b9ba2588bb9de$var$isArray = Array.isArray;
$579b9ba2588bb9de$exports = $579b9ba2588bb9de$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5b332bf09b0c6ec2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $579b9ba2588bb9de$exports(object) ? result : $efe685e6768936ef$exports(result, symbolsFunc(object));
}
$5b332bf09b0c6ec2$exports = $5b332bf09b0c6ec2$var$baseGetAllKeys;


var $f7bf8d1519698205$exports = {};
var $d53366b2ff590363$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $d53366b2ff590363$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$d53366b2ff590363$exports = $d53366b2ff590363$var$arrayFilter;


var $fd38b0983d4c349d$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fd38b0983d4c349d$var$stubArray() {
    return [];
}
$fd38b0983d4c349d$exports = $fd38b0983d4c349d$var$stubArray;


/** Used for built-in method references. */ var $f7bf8d1519698205$var$objectProto = Object.prototype;
/** Built-in value references. */ var $f7bf8d1519698205$var$propertyIsEnumerable = $f7bf8d1519698205$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f7bf8d1519698205$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f7bf8d1519698205$var$getSymbols = !$f7bf8d1519698205$var$nativeGetSymbols ? $fd38b0983d4c349d$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $d53366b2ff590363$exports($f7bf8d1519698205$var$nativeGetSymbols(object), function(symbol) {
        return $f7bf8d1519698205$var$propertyIsEnumerable.call(object, symbol);
    });
};
$f7bf8d1519698205$exports = $f7bf8d1519698205$var$getSymbols;


var $0fce4239ee480ef0$exports = {};
var $14f0cee26f6289b7$exports = {};
var $2af85a3e5a570ba7$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2af85a3e5a570ba7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$2af85a3e5a570ba7$exports = $2af85a3e5a570ba7$var$baseTimes;


var $4f4b95b8aefe4d77$exports = {};
var $16682bb217664efe$exports = {};

var $97dbbc1a069ce16a$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$97dbbc1a069ce16a$exports = $97dbbc1a069ce16a$var$isObjectLike;


/** `Object#toString` result references. */ var $16682bb217664efe$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $16682bb217664efe$var$baseIsArguments(value) {
    return $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $16682bb217664efe$var$argsTag;
}
$16682bb217664efe$exports = $16682bb217664efe$var$baseIsArguments;



/** Used for built-in method references. */ var $4f4b95b8aefe4d77$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f4b95b8aefe4d77$var$hasOwnProperty = $4f4b95b8aefe4d77$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4f4b95b8aefe4d77$var$propertyIsEnumerable = $4f4b95b8aefe4d77$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4f4b95b8aefe4d77$var$isArguments = $16682bb217664efe$exports(function() {
    return arguments;
}()) ? $16682bb217664efe$exports : function(value) {
    return $97dbbc1a069ce16a$exports(value) && $4f4b95b8aefe4d77$var$hasOwnProperty.call(value, 'callee') && !$4f4b95b8aefe4d77$var$propertyIsEnumerable.call(value, 'callee');
};
$4f4b95b8aefe4d77$exports = $4f4b95b8aefe4d77$var$isArguments;




var $9gBlp = parcelRequire("9gBlp");
var $a4ac18a3b008eabc$exports = {};
/** Used as references for various `Number` constants. */ var $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a4ac18a3b008eabc$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a4ac18a3b008eabc$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a4ac18a3b008eabc$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$a4ac18a3b008eabc$exports = $a4ac18a3b008eabc$var$isIndex;


var $91935e2ee1691ad1$exports = {};
var $409cf0e4c937c990$exports = {};

var $13758fcec31fd7af$exports = {};
/** Used as references for various `Number` constants. */ var $13758fcec31fd7af$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $13758fcec31fd7af$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $13758fcec31fd7af$var$MAX_SAFE_INTEGER;
}
$13758fcec31fd7af$exports = $13758fcec31fd7af$var$isLength;



/** `Object#toString` result references. */ var $409cf0e4c937c990$var$argsTag = '[object Arguments]', $409cf0e4c937c990$var$arrayTag = '[object Array]', $409cf0e4c937c990$var$boolTag = '[object Boolean]', $409cf0e4c937c990$var$dateTag = '[object Date]', $409cf0e4c937c990$var$errorTag = '[object Error]', $409cf0e4c937c990$var$funcTag = '[object Function]', $409cf0e4c937c990$var$mapTag = '[object Map]', $409cf0e4c937c990$var$numberTag = '[object Number]', $409cf0e4c937c990$var$objectTag = '[object Object]', $409cf0e4c937c990$var$regexpTag = '[object RegExp]', $409cf0e4c937c990$var$setTag = '[object Set]', $409cf0e4c937c990$var$stringTag = '[object String]', $409cf0e4c937c990$var$weakMapTag = '[object WeakMap]';
var $409cf0e4c937c990$var$arrayBufferTag = '[object ArrayBuffer]', $409cf0e4c937c990$var$dataViewTag = '[object DataView]', $409cf0e4c937c990$var$float32Tag = '[object Float32Array]', $409cf0e4c937c990$var$float64Tag = '[object Float64Array]', $409cf0e4c937c990$var$int8Tag = '[object Int8Array]', $409cf0e4c937c990$var$int16Tag = '[object Int16Array]', $409cf0e4c937c990$var$int32Tag = '[object Int32Array]', $409cf0e4c937c990$var$uint8Tag = '[object Uint8Array]', $409cf0e4c937c990$var$uint8ClampedTag = '[object Uint8ClampedArray]', $409cf0e4c937c990$var$uint16Tag = '[object Uint16Array]', $409cf0e4c937c990$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $409cf0e4c937c990$var$typedArrayTags = {};
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float64Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8ClampedTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint32Tag] = true;
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$argsTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayBufferTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$boolTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dataViewTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dateTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$errorTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$funcTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$mapTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$numberTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$objectTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$regexpTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$setTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$stringTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $409cf0e4c937c990$var$baseIsTypedArray(value) {
    return $97dbbc1a069ce16a$exports(value) && $13758fcec31fd7af$exports(value.length) && !!$409cf0e4c937c990$var$typedArrayTags[$ae3fe6c5950c122e$exports(value)];
}
$409cf0e4c937c990$exports = $409cf0e4c937c990$var$baseIsTypedArray;


var $c4aeaafb4421a79e$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c4aeaafb4421a79e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$c4aeaafb4421a79e$exports = $c4aeaafb4421a79e$var$baseUnary;



var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $91935e2ee1691ad1$var$nodeIsTypedArray = $iU8uW && $iU8uW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $91935e2ee1691ad1$var$isTypedArray = $91935e2ee1691ad1$var$nodeIsTypedArray ? $c4aeaafb4421a79e$exports($91935e2ee1691ad1$var$nodeIsTypedArray) : $409cf0e4c937c990$exports;
$91935e2ee1691ad1$exports = $91935e2ee1691ad1$var$isTypedArray;


/** Used for built-in method references. */ var $14f0cee26f6289b7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14f0cee26f6289b7$var$hasOwnProperty = $14f0cee26f6289b7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $14f0cee26f6289b7$var$arrayLikeKeys(value, inherited) {
    var isArr = $579b9ba2588bb9de$exports(value), isArg = !isArr && $4f4b95b8aefe4d77$exports(value), isBuff = !isArr && !isArg && $9gBlp(value), isType = !isArr && !isArg && !isBuff && $91935e2ee1691ad1$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $2af85a3e5a570ba7$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $14f0cee26f6289b7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $a4ac18a3b008eabc$exports(key, length)))) result.push(key);
    return result;
}
$14f0cee26f6289b7$exports = $14f0cee26f6289b7$var$arrayLikeKeys;


var $bdfe3da66489f7d9$exports = {};
var $b56b06902d83e6f4$exports = {};
/** Used for built-in method references. */ var $b56b06902d83e6f4$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $b56b06902d83e6f4$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $b56b06902d83e6f4$var$objectProto;
    return value === proto;
}
$b56b06902d83e6f4$exports = $b56b06902d83e6f4$var$isPrototype;


var $220737c9fb125768$exports = {};
var $fdcd49ef52ce3234$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fdcd49ef52ce3234$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fdcd49ef52ce3234$exports = $fdcd49ef52ce3234$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $220737c9fb125768$var$nativeKeys = $fdcd49ef52ce3234$exports(Object.keys, Object);
$220737c9fb125768$exports = $220737c9fb125768$var$nativeKeys;


/** Used for built-in method references. */ var $bdfe3da66489f7d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdfe3da66489f7d9$var$hasOwnProperty = $bdfe3da66489f7d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bdfe3da66489f7d9$var$baseKeys(object) {
    if (!$b56b06902d83e6f4$exports(object)) return $220737c9fb125768$exports(object);
    var result = [];
    for(var key in Object(object))if ($bdfe3da66489f7d9$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$bdfe3da66489f7d9$exports = $bdfe3da66489f7d9$var$baseKeys;


var $4506257970d5c979$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4506257970d5c979$var$isArrayLike(value) {
    return value != null && $13758fcec31fd7af$exports(value.length) && !$07bc7c115e963817$exports(value);
}
$4506257970d5c979$exports = $4506257970d5c979$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0fce4239ee480ef0$var$keys(object) {
    return $4506257970d5c979$exports(object) ? $14f0cee26f6289b7$exports(object) : $bdfe3da66489f7d9$exports(object);
}
$0fce4239ee480ef0$exports = $0fce4239ee480ef0$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b43254fda44c104a$var$getAllKeys(object) {
    return $5b332bf09b0c6ec2$exports(object, $0fce4239ee480ef0$exports, $f7bf8d1519698205$exports);
}
$b43254fda44c104a$exports = $b43254fda44c104a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f7bae1035bea0715$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7bae1035bea0715$var$hasOwnProperty = $f7bae1035bea0715$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f7bae1035bea0715$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG, objProps = $b43254fda44c104a$exports(object), objLength = objProps.length, othProps = $b43254fda44c104a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f7bae1035bea0715$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$f7bae1035bea0715$exports = $f7bae1035bea0715$var$equalObjects;


var $288c148fae7027f4$exports = {};
var $4e72a091824b54c2$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $4e72a091824b54c2$var$DataView = $95eb055fdd27d869$exports($1DySm, 'DataView');
$4e72a091824b54c2$exports = $4e72a091824b54c2$var$DataView;



var $c7bc43de39f545d4$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $c7bc43de39f545d4$var$Promise = $95eb055fdd27d869$exports($1DySm, 'Promise');
$c7bc43de39f545d4$exports = $c7bc43de39f545d4$var$Promise;


var $2a4786f2dfc898c9$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $2a4786f2dfc898c9$var$Set = $95eb055fdd27d869$exports($1DySm, 'Set');
$2a4786f2dfc898c9$exports = $2a4786f2dfc898c9$var$Set;


var $e262a6fad30144cf$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $e262a6fad30144cf$var$WeakMap = $95eb055fdd27d869$exports($1DySm, 'WeakMap');
$e262a6fad30144cf$exports = $e262a6fad30144cf$var$WeakMap;




/** `Object#toString` result references. */ var $288c148fae7027f4$var$mapTag = '[object Map]', $288c148fae7027f4$var$objectTag = '[object Object]', $288c148fae7027f4$var$promiseTag = '[object Promise]', $288c148fae7027f4$var$setTag = '[object Set]', $288c148fae7027f4$var$weakMapTag = '[object WeakMap]';
var $288c148fae7027f4$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $288c148fae7027f4$var$dataViewCtorString = $f4933d7f0a06eb7d$exports($4e72a091824b54c2$exports), $288c148fae7027f4$var$mapCtorString = $f4933d7f0a06eb7d$exports($3b45073a9f2f1273$exports), $288c148fae7027f4$var$promiseCtorString = $f4933d7f0a06eb7d$exports($c7bc43de39f545d4$exports), $288c148fae7027f4$var$setCtorString = $f4933d7f0a06eb7d$exports($2a4786f2dfc898c9$exports), $288c148fae7027f4$var$weakMapCtorString = $f4933d7f0a06eb7d$exports($e262a6fad30144cf$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $288c148fae7027f4$var$getTag = $ae3fe6c5950c122e$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4e72a091824b54c2$exports && $288c148fae7027f4$var$getTag(new $4e72a091824b54c2$exports(new ArrayBuffer(1))) != $288c148fae7027f4$var$dataViewTag || $3b45073a9f2f1273$exports && $288c148fae7027f4$var$getTag(new $3b45073a9f2f1273$exports) != $288c148fae7027f4$var$mapTag || $c7bc43de39f545d4$exports && $288c148fae7027f4$var$getTag($c7bc43de39f545d4$exports.resolve()) != $288c148fae7027f4$var$promiseTag || $2a4786f2dfc898c9$exports && $288c148fae7027f4$var$getTag(new $2a4786f2dfc898c9$exports) != $288c148fae7027f4$var$setTag || $e262a6fad30144cf$exports && $288c148fae7027f4$var$getTag(new $e262a6fad30144cf$exports) != $288c148fae7027f4$var$weakMapTag) $288c148fae7027f4$var$getTag = function(value) {
    var result = $ae3fe6c5950c122e$exports(value), Ctor = result == $288c148fae7027f4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $f4933d7f0a06eb7d$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $288c148fae7027f4$var$dataViewCtorString:
            return $288c148fae7027f4$var$dataViewTag;
        case $288c148fae7027f4$var$mapCtorString:
            return $288c148fae7027f4$var$mapTag;
        case $288c148fae7027f4$var$promiseCtorString:
            return $288c148fae7027f4$var$promiseTag;
        case $288c148fae7027f4$var$setCtorString:
            return $288c148fae7027f4$var$setTag;
        case $288c148fae7027f4$var$weakMapCtorString:
            return $288c148fae7027f4$var$weakMapTag;
    }
    return result;
};
$288c148fae7027f4$exports = $288c148fae7027f4$var$getTag;




var $9gBlp = parcelRequire("9gBlp");

/** Used to compose bitmasks for value comparisons. */ var $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c633adf42a0b7174$var$argsTag = '[object Arguments]', $c633adf42a0b7174$var$arrayTag = '[object Array]', $c633adf42a0b7174$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c633adf42a0b7174$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c633adf42a0b7174$var$hasOwnProperty = $c633adf42a0b7174$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c633adf42a0b7174$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $579b9ba2588bb9de$exports(object), othIsArr = $579b9ba2588bb9de$exports(other), objTag = objIsArr ? $c633adf42a0b7174$var$arrayTag : $288c148fae7027f4$exports(object), othTag = othIsArr ? $c633adf42a0b7174$var$arrayTag : $288c148fae7027f4$exports(other);
    objTag = objTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : objTag;
    othTag = othTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : othTag;
    var objIsObj = objTag == $c633adf42a0b7174$var$objectTag, othIsObj = othTag == $c633adf42a0b7174$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9gBlp(object)) {
        if (!$9gBlp(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $75b9f8e835026959$exports);
        return objIsArr || $91935e2ee1691ad1$exports(object) ? $1443c170489acf32$exports(object, other, bitmask, customizer, equalFunc, stack) : $31649b4ecd936387$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $75b9f8e835026959$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $75b9f8e835026959$exports);
    return $f7bae1035bea0715$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c633adf42a0b7174$exports = $c633adf42a0b7174$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7c952302caee51c1$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$97dbbc1a069ce16a$exports(value) && !$97dbbc1a069ce16a$exports(other)) return value !== value && other !== other;
    return $c633adf42a0b7174$exports(value, other, bitmask, customizer, $7c952302caee51c1$var$baseIsEqual, stack);
}
$7c952302caee51c1$exports = $7c952302caee51c1$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $034d80e6a88ef527$var$isEqual(value, other) {
    return $7c952302caee51c1$exports(value, other);
}
$034d80e6a88ef527$exports = $034d80e6a88ef527$var$isEqual;


var $a32d359663840a54$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $a32d359663840a54$var$isNil(value) {
    return value == null;
}
$a32d359663840a54$exports = $a32d359663840a54$var$isNil;



var $7fPBF = parcelRequire("7fPBF");

var $f7bfd9e73571977c$exports = {};
var $e913f1fcbff7147e$exports = {};
var $23e5d07d36d464f0$exports = {};

var $69479e268680fe10$exports = {};

var $2fffc1449db40502$exports = {};


/** `Object#toString` result references. */ var $2fffc1449db40502$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2fffc1449db40502$var$isSymbol(value) {
    return typeof value == 'symbol' || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $2fffc1449db40502$var$symbolTag;
}
$2fffc1449db40502$exports = $2fffc1449db40502$var$isSymbol;


/** Used to match property names within property paths. */ var $69479e268680fe10$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $69479e268680fe10$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $69479e268680fe10$var$isKey(value, object) {
    if ($579b9ba2588bb9de$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $2fffc1449db40502$exports(value)) return true;
    return $69479e268680fe10$var$reIsPlainProp.test(value) || !$69479e268680fe10$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$69479e268680fe10$exports = $69479e268680fe10$var$isKey;


var $a3922e70313d25cb$exports = {};
var $032fe0d410f8199d$exports = {};
var $5021746db8365e7e$exports = {};

/** Error message constants. */ var $5021746db8365e7e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5021746db8365e7e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5021746db8365e7e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5021746db8365e7e$var$memoize.Cache || $a6cc38418910b2e0$exports);
    return memoized;
}
// Expose `MapCache`.
$5021746db8365e7e$var$memoize.Cache = $a6cc38418910b2e0$exports;
$5021746db8365e7e$exports = $5021746db8365e7e$var$memoize;


/** Used as the maximum memoize cache size. */ var $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $032fe0d410f8199d$var$memoizeCapped(func) {
    var result = $5021746db8365e7e$exports(func, function(key) {
        if (cache.size === $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$032fe0d410f8199d$exports = $032fe0d410f8199d$var$memoizeCapped;


/** Used to match property names within property paths. */ var $a3922e70313d25cb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a3922e70313d25cb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a3922e70313d25cb$var$stringToPath = $032fe0d410f8199d$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a3922e70313d25cb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a3922e70313d25cb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$a3922e70313d25cb$exports = $a3922e70313d25cb$var$stringToPath;


var $78eb02cd4ef313ef$exports = {};
var $0e09541fbe2727c0$exports = {};

var $4c0f1a1d993f5976$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4c0f1a1d993f5976$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$4c0f1a1d993f5976$exports = $4c0f1a1d993f5976$var$arrayMap;




/** Used as references for various `Number` constants. */ var $0e09541fbe2727c0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0e09541fbe2727c0$var$symbolProto = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.prototype : undefined, $0e09541fbe2727c0$var$symbolToString = $0e09541fbe2727c0$var$symbolProto ? $0e09541fbe2727c0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0e09541fbe2727c0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($579b9ba2588bb9de$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $4c0f1a1d993f5976$exports(value, $0e09541fbe2727c0$var$baseToString) + '';
    if ($2fffc1449db40502$exports(value)) return $0e09541fbe2727c0$var$symbolToString ? $0e09541fbe2727c0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0e09541fbe2727c0$var$INFINITY ? '-0' : result;
}
$0e09541fbe2727c0$exports = $0e09541fbe2727c0$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $78eb02cd4ef313ef$var$toString(value) {
    return value == null ? '' : $0e09541fbe2727c0$exports(value);
}
$78eb02cd4ef313ef$exports = $78eb02cd4ef313ef$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $23e5d07d36d464f0$var$castPath(value, object) {
    if ($579b9ba2588bb9de$exports(value)) return value;
    return $69479e268680fe10$exports(value, object) ? [
        value
    ] : $a3922e70313d25cb$exports($78eb02cd4ef313ef$exports(value));
}
$23e5d07d36d464f0$exports = $23e5d07d36d464f0$var$castPath;


var $09a75ffd36bdbd18$exports = {};

/** Used as references for various `Number` constants. */ var $09a75ffd36bdbd18$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $09a75ffd36bdbd18$var$toKey(value) {
    if (typeof value == 'string' || $2fffc1449db40502$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$09a75ffd36bdbd18$var$INFINITY ? '-0' : result;
}
$09a75ffd36bdbd18$exports = $09a75ffd36bdbd18$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e913f1fcbff7147e$var$baseGet(object, path) {
    path = $23e5d07d36d464f0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$09a75ffd36bdbd18$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$e913f1fcbff7147e$exports = $e913f1fcbff7147e$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $f7bfd9e73571977c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $e913f1fcbff7147e$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$f7bfd9e73571977c$exports = $f7bfd9e73571977c$var$get;



var $3424b9151e51ad58$exports = {};



/** `Object#toString` result references. */ var $3424b9151e51ad58$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3424b9151e51ad58$var$isString(value) {
    return typeof value == 'string' || !$579b9ba2588bb9de$exports(value) && $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $3424b9151e51ad58$var$stringTag;
}
$3424b9151e51ad58$exports = $3424b9151e51ad58$var$isString;





var $7fPBF = parcelRequire("7fPBF");
var $fd96502950a00599$exports = {};
'use strict';

$fd96502950a00599$exports = (parcelRequire("i6bbH"));



var $420172254fa1575b$exports = {};
var $e41840ebc3ba4945$exports = {};


/** `Object#toString` result references. */ var $e41840ebc3ba4945$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $e41840ebc3ba4945$var$isNumber(value) {
    return typeof value == 'number' || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $e41840ebc3ba4945$var$numberTag;
}
$e41840ebc3ba4945$exports = $e41840ebc3ba4945$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $420172254fa1575b$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $e41840ebc3ba4945$exports(value) && value != +value;
}
$420172254fa1575b$exports = $420172254fa1575b$var$isNaN;




var $ddf2636240ab70e2$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $ddf2636240ab70e2$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $ddf2636240ab70e2$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($e41840ebc3ba4945$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($420172254fa1575b$exports)))(value);
};
var $ddf2636240ab70e2$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $ddf2636240ab70e2$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(value);
};
var $ddf2636240ab70e2$var$idCounter = 0;
var $ddf2636240ab70e2$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$ddf2636240ab70e2$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $ddf2636240ab70e2$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$ddf2636240ab70e2$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(percent)) return defaultValue;
    var value;
    if ($ddf2636240ab70e2$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($420172254fa1575b$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $ddf2636240ab70e2$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $ddf2636240ab70e2$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $ddf2636240ab70e2$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($ddf2636240ab70e2$export$7e4aa119212bc614(numberA) && $ddf2636240ab70e2$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $ddf2636240ab70e2$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $ddf2636240ab70e2$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $12af98dbc8c7996a$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $7fPBF = parcelRequire("7fPBF");

function $eb7294e7865e616e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb7294e7865e616e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb7294e7865e616e$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $eb7294e7865e616e$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $eb7294e7865e616e$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $eb7294e7865e616e$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $eb7294e7865e616e$export$2b22758266a6fa48 = {
    svg: $eb7294e7865e616e$var$SVGContainerPropKeys,
    polygon: $eb7294e7865e616e$var$PolyElementKeys,
    polyline: $eb7294e7865e616e$var$PolyElementKeys
};
var $eb7294e7865e616e$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $eb7294e7865e616e$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($eb7294e7865e616e$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $eb7294e7865e616e$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $eb7294e7865e616e$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(props) || $eb7294e7865e616e$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($eb7294e7865e616e$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $eb7294e7865e616e$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $86b14aaa4b2f228f$var$_excluded = [
    "children"
], $86b14aaa4b2f228f$var$_excluded2 = [
    "children"
];
function $86b14aaa4b2f228f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $86b14aaa4b2f228f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $86b14aaa4b2f228f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $86b14aaa4b2f228f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $86b14aaa4b2f228f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $86b14aaa4b2f228f$var$_typeof(o);
}
var $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $86b14aaa4b2f228f$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $86b14aaa4b2f228f$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $86b14aaa4b2f228f$export$59a4d7d024cf1025 = [
    'none'
];
var $86b14aaa4b2f228f$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $86b14aaa4b2f228f$var$lastChildren = null;
var $86b14aaa4b2f228f$var$lastResult = null;
var $86b14aaa4b2f228f$export$45b10814cc054894 = function toArray(children) {
    if (children === $86b14aaa4b2f228f$var$lastChildren && Array.isArray($86b14aaa4b2f228f$var$lastResult)) return $86b14aaa4b2f228f$var$lastResult;
    var result = [];
    (0, $7fPBF.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(child)) return;
        if ((0, $fd96502950a00599$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $86b14aaa4b2f228f$var$lastResult = result;
    $86b14aaa4b2f228f$var$lastChildren = children;
    return result;
};
function $86b14aaa4b2f228f$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $86b14aaa4b2f228f$export$be63e0664592e141(t);
    });
    else types = [
        $86b14aaa4b2f228f$export$be63e0664592e141(type)
    ];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $86b14aaa4b2f228f$export$64c61536a2b72e0f(children, type) {
    var result = $86b14aaa4b2f228f$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $86b14aaa4b2f228f$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $86b14aaa4b2f228f$export$be63e0664592e141(t);
    });
    else types = [
        $86b14aaa4b2f228f$export$be63e0664592e141(type)
    ];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $86b14aaa4b2f228f$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $86b14aaa4b2f228f$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $86b14aaa4b2f228f$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(child.type) && $86b14aaa4b2f228f$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $86b14aaa4b2f228f$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $86b14aaa4b2f228f$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $86b14aaa4b2f228f$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $eb7294e7865e616e$export$2b22758266a6fa48) === null || (0, $eb7294e7865e616e$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $eb7294e7865e616e$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $eb7294e7865e616e$export$190f430946f96110).includes(key)) || includeEvents && (0, $eb7294e7865e616e$export$f30789245f2c4d11).includes(key);
};
var $86b14aaa4b2f228f$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(entry) {
        if ($86b14aaa4b2f228f$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $86b14aaa4b2f228f$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($86b14aaa4b2f228f$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $86b14aaa4b2f228f$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $7fPBF.Children).count(nextChildren);
    if (count !== (0, $7fPBF.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $86b14aaa4b2f228f$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$86b14aaa4b2f228f$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $86b14aaa4b2f228f$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $86b14aaa4b2f228f$var$_objectWithoutProperties(_ref, $86b14aaa4b2f228f$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $86b14aaa4b2f228f$var$_objectWithoutProperties(_ref2, $86b14aaa4b2f228f$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextProps, prevProps) && $86b14aaa4b2f228f$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $86b14aaa4b2f228f$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $86b14aaa4b2f228f$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($86b14aaa4b2f228f$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $86b14aaa4b2f228f$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $86b14aaa4b2f228f$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP[type]) return $86b14aaa4b2f228f$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $86b14aaa4b2f228f$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $86b14aaa4b2f228f$export$45b10814cc054894(children).indexOf(child);
};


var $96829a30e4c93428$var$_excluded = [
    "children",
    "className"
];
function $96829a30e4c93428$var$_extends() {
    $96829a30e4c93428$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96829a30e4c93428$var$_extends.apply(this, arguments);
}
function $96829a30e4c93428$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $96829a30e4c93428$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $96829a30e4c93428$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $96829a30e4c93428$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $96829a30e4c93428$var$_objectWithoutProperties(props, $96829a30e4c93428$var$_excluded);
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", $96829a30e4c93428$var$_extends({
        className: layerClass
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $7fPBF = parcelRequire("7fPBF");
var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($80ee8fc99f5202eb$var$prefix, ": ").concat(provided) : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}




var $d05ab0383decc723$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $d05ab0383decc723$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d05ab0383decc723$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d05ab0383decc723$var$_typeof(o);
}
function $d05ab0383decc723$var$_extends() {
    $d05ab0383decc723$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d05ab0383decc723$var$_extends.apply(this, arguments);
}
function $d05ab0383decc723$var$_slicedToArray(arr, i) {
    return $d05ab0383decc723$var$_arrayWithHoles(arr) || $d05ab0383decc723$var$_iterableToArrayLimit(arr, i) || $d05ab0383decc723$var$_unsupportedIterableToArray(arr, i) || $d05ab0383decc723$var$_nonIterableRest();
}
function $d05ab0383decc723$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d05ab0383decc723$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d05ab0383decc723$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d05ab0383decc723$var$_arrayLikeToArray(o, minLen);
}
function $d05ab0383decc723$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d05ab0383decc723$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d05ab0383decc723$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d05ab0383decc723$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d05ab0383decc723$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d05ab0383decc723$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d05ab0383decc723$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d05ab0383decc723$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d05ab0383decc723$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d05ab0383decc723$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d05ab0383decc723$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d05ab0383decc723$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d05ab0383decc723$var$_callSuper(t, o, e) {
    return o = $d05ab0383decc723$var$_getPrototypeOf(o), $d05ab0383decc723$var$_possibleConstructorReturn(t, $d05ab0383decc723$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $d05ab0383decc723$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $d05ab0383decc723$var$_possibleConstructorReturn(self, call) {
    if (call && ($d05ab0383decc723$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d05ab0383decc723$var$_assertThisInitialized(self);
}
function $d05ab0383decc723$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d05ab0383decc723$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d05ab0383decc723$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d05ab0383decc723$var$_getPrototypeOf(o) {
    $d05ab0383decc723$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d05ab0383decc723$var$_getPrototypeOf(o);
}
function $d05ab0383decc723$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d05ab0383decc723$var$_setPrototypeOf(subClass, superClass);
}
function $d05ab0383decc723$var$_setPrototypeOf(o, p) {
    $d05ab0383decc723$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d05ab0383decc723$var$_setPrototypeOf(o, p);
}
function $d05ab0383decc723$var$_defineProperty(obj, key, value) {
    key = $d05ab0383decc723$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d05ab0383decc723$var$_toPropertyKey(t) {
    var i = $d05ab0383decc723$var$_toPrimitive(t, "string");
    return "symbol" == $d05ab0383decc723$var$_typeof(i) ? i : i + "";
}
function $d05ab0383decc723$var$_toPrimitive(t, r) {
    if ("object" != $d05ab0383decc723$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d05ab0383decc723$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d05ab0383decc723$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $d05ab0383decc723$var$_classCallCheck(this, ErrorBar);
        return $d05ab0383decc723$var$_callSuper(this, ErrorBar, arguments);
    }
    $d05ab0383decc723$var$_inherits(ErrorBar, _React$Component);
    return $d05ab0383decc723$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $d05ab0383decc723$var$_objectWithoutProperties(_this$props, $d05ab0383decc723$var$_excluded);
                var svgProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $d05ab0383decc723$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $d05ab0383decc723$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $d05ab0383decc723$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$d05ab0383decc723$var$_defineProperty($d05ab0383decc723$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$d05ab0383decc723$var$_defineProperty($d05ab0383decc723$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');


/**
 * @fileOverview Cross
 */ var $979e4bae4ee44f07$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$979e4bae4ee44f07$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $7fPBF = parcelRequire("7fPBF");



var $0af9c5bb33cc0648$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $0af9c5bb33cc0648$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$0af9c5bb33cc0648$exports = $0af9c5bb33cc0648$var$last;



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");



var $bdfd77d06577c8ff$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $bdfd77d06577c8ff$export$98f03c5d19621d70 = {
    isSsr: $bdfd77d06577c8ff$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $bdfd77d06577c8ff$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $bdfd77d06577c8ff$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $bdfd77d06577c8ff$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $5da910530c0379f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5da910530c0379f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5da910530c0379f8$var$_typeof(o);
}
function $5da910530c0379f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5da910530c0379f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5da910530c0379f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5da910530c0379f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5da910530c0379f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5da910530c0379f8$var$_defineProperty(obj, key, value) {
    key = $5da910530c0379f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5da910530c0379f8$var$_toPropertyKey(t) {
    var i = $5da910530c0379f8$var$_toPrimitive(t, "string");
    return "symbol" == $5da910530c0379f8$var$_typeof(i) ? i : i + "";
}
function $5da910530c0379f8$var$_toPrimitive(t, r) {
    if ("object" != $5da910530c0379f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5da910530c0379f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5da910530c0379f8$var$_toConsumableArray(arr) {
    return $5da910530c0379f8$var$_arrayWithoutHoles(arr) || $5da910530c0379f8$var$_iterableToArray(arr) || $5da910530c0379f8$var$_unsupportedIterableToArray(arr) || $5da910530c0379f8$var$_nonIterableSpread();
}
function $5da910530c0379f8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5da910530c0379f8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5da910530c0379f8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5da910530c0379f8$var$_arrayLikeToArray(o, minLen);
}
function $5da910530c0379f8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5da910530c0379f8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5da910530c0379f8$var$_arrayLikeToArray(arr);
}
function $5da910530c0379f8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5da910530c0379f8$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $5da910530c0379f8$var$MAX_CACHE_NUM = 2000;
var $5da910530c0379f8$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $5da910530c0379f8$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $5da910530c0379f8$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $5da910530c0379f8$var$autoCompleteStyle(name, value) {
    if ($5da910530c0379f8$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $5da910530c0379f8$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($5da910530c0379f8$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($5da910530c0379f8$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $5da910530c0379f8$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($5da910530c0379f8$var$camelToMiddleLine(s), ":").concat($5da910530c0379f8$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $5da910530c0379f8$var$removeInvalidKeys(obj) {
    var copyObj = $5da910530c0379f8$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $5da910530c0379f8$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $5da910530c0379f8$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($5da910530c0379f8$var$stringCache.widthCache[cacheKey]) return $5da910530c0379f8$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($5da910530c0379f8$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $5da910530c0379f8$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $5da910530c0379f8$var$_objectSpread($5da910530c0379f8$var$_objectSpread({}, $5da910530c0379f8$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $5da910530c0379f8$var$stringCache.widthCache[cacheKey] = result;
        if (++$5da910530c0379f8$var$stringCache.cacheCount > $5da910530c0379f8$var$MAX_CACHE_NUM) {
            $5da910530c0379f8$var$stringCache.cacheCount = 0;
            $5da910530c0379f8$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $5da910530c0379f8$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $049c28fee99b53fe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $049c28fee99b53fe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $049c28fee99b53fe$var$_typeof(o);
}
function $049c28fee99b53fe$var$_slicedToArray(arr, i) {
    return $049c28fee99b53fe$var$_arrayWithHoles(arr) || $049c28fee99b53fe$var$_iterableToArrayLimit(arr, i) || $049c28fee99b53fe$var$_unsupportedIterableToArray(arr, i) || $049c28fee99b53fe$var$_nonIterableRest();
}
function $049c28fee99b53fe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $049c28fee99b53fe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $049c28fee99b53fe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $049c28fee99b53fe$var$_arrayLikeToArray(o, minLen);
}
function $049c28fee99b53fe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $049c28fee99b53fe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $049c28fee99b53fe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $049c28fee99b53fe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $049c28fee99b53fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $049c28fee99b53fe$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $049c28fee99b53fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $049c28fee99b53fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $049c28fee99b53fe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $049c28fee99b53fe$var$_toPropertyKey(t) {
    var i = $049c28fee99b53fe$var$_toPrimitive(t, "string");
    return "symbol" == $049c28fee99b53fe$var$_typeof(i) ? i : i + "";
}
function $049c28fee99b53fe$var$_toPrimitive(t, r) {
    if ("object" != $049c28fee99b53fe$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $049c28fee99b53fe$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $049c28fee99b53fe$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $049c28fee99b53fe$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $049c28fee99b53fe$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $049c28fee99b53fe$var$FIXED_CSS_LENGTH_UNITS = Object.keys($049c28fee99b53fe$var$CONVERSION_RATES);
var $049c28fee99b53fe$var$STR_NAN = 'NaN';
function $049c28fee99b53fe$var$convertToPx(value, unit) {
    return value * $049c28fee99b53fe$var$CONVERSION_RATES[unit];
}
var $049c28fee99b53fe$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $049c28fee99b53fe$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$049c28fee99b53fe$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($049c28fee99b53fe$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $049c28fee99b53fe$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $049c28fee99b53fe$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $049c28fee99b53fe$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $049c28fee99b53fe$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $049c28fee99b53fe$var$calculateArithmetic(expr) {
    if (expr.includes($049c28fee99b53fe$var$STR_NAN)) return $049c28fee99b53fe$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $049c28fee99b53fe$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $049c28fee99b53fe$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $049c28fee99b53fe$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $049c28fee99b53fe$var$STR_NAN;
        newExpr = newExpr.replace($049c28fee99b53fe$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $049c28fee99b53fe$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $049c28fee99b53fe$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $049c28fee99b53fe$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $049c28fee99b53fe$var$STR_NAN;
        newExpr = newExpr.replace($049c28fee99b53fe$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $049c28fee99b53fe$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $049c28fee99b53fe$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $049c28fee99b53fe$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $049c28fee99b53fe$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($049c28fee99b53fe$var$PARENTHESES_REGEX, $049c28fee99b53fe$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $049c28fee99b53fe$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $049c28fee99b53fe$var$calculateParentheses(newExpr);
    newExpr = $049c28fee99b53fe$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $049c28fee99b53fe$export$c891f73c9c6d00c9(expression) {
    try {
        return $049c28fee99b53fe$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $049c28fee99b53fe$var$STR_NAN;
    }
}
function $049c28fee99b53fe$export$254eac204f89fd7d(expression) {
    var result = $049c28fee99b53fe$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $049c28fee99b53fe$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $94f8473029f59671$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $94f8473029f59671$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $94f8473029f59671$var$_extends() {
    $94f8473029f59671$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $94f8473029f59671$var$_extends.apply(this, arguments);
}
function $94f8473029f59671$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $94f8473029f59671$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $94f8473029f59671$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $94f8473029f59671$var$_slicedToArray(arr, i) {
    return $94f8473029f59671$var$_arrayWithHoles(arr) || $94f8473029f59671$var$_iterableToArrayLimit(arr, i) || $94f8473029f59671$var$_unsupportedIterableToArray(arr, i) || $94f8473029f59671$var$_nonIterableRest();
}
function $94f8473029f59671$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94f8473029f59671$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94f8473029f59671$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94f8473029f59671$var$_arrayLikeToArray(o, minLen);
}
function $94f8473029f59671$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $94f8473029f59671$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $94f8473029f59671$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $94f8473029f59671$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $94f8473029f59671$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($94f8473029f59671$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $5da910530c0379f8$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $5da910530c0379f8$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $94f8473029f59671$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $94f8473029f59671$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $94f8473029f59671$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $94f8473029f59671$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $94f8473029f59671$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(children) ? children.toString().split($94f8473029f59671$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $94f8473029f59671$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $94f8473029f59671$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $94f8473029f59671$var$getWordsWithoutCalculate(children);
        return $94f8473029f59671$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $94f8473029f59671$var$getWordsWithoutCalculate(children);
};
var $94f8473029f59671$var$DEFAULT_FILL = '#808080';
var $94f8473029f59671$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $94f8473029f59671$var$DEFAULT_FILL : _ref5$fill, props = $94f8473029f59671$var$_objectWithoutProperties(_ref5, $94f8473029f59671$var$_excluded);
    var wordsByLines = (0, $7fPBF.useMemo)(function() {
        return $94f8473029f59671$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $94f8473029f59671$var$_objectWithoutProperties(props, $94f8473029f59671$var$_excluded2);
    if (!(0, $ddf2636240ab70e2$export$402a499e1ea44294)(propsX) || !(0, $ddf2636240ab70e2$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $049c28fee99b53fe$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("text", $94f8473029f59671$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $94f8473029f59671$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $7fPBF = parcelRequire("7fPBF");


var $88853d08cf75746a$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$88853d08cf75746a$exports = (parcelRequire("3kQXm"));


var $922af94be54ea802$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$922af94be54ea802$exports = (parcelRequire("7L7R7"));


var $be797d78b695737e$exports = {};
var $89ecae80ebf99b3b$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $89ecae80ebf99b3b$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$2fffc1449db40502$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$89ecae80ebf99b3b$exports = $89ecae80ebf99b3b$var$baseExtremum;


var $7625ba1fc4678500$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $7625ba1fc4678500$var$baseGt(value, other) {
    return value > other;
}
$7625ba1fc4678500$exports = $7625ba1fc4678500$var$baseGt;


var $e4dbcba8665d9b6c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e4dbcba8665d9b6c$var$identity(value) {
    return value;
}
$e4dbcba8665d9b6c$exports = $e4dbcba8665d9b6c$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $be797d78b695737e$var$max(array) {
    return array && array.length ? $89ecae80ebf99b3b$exports(array, $e4dbcba8665d9b6c$exports, $7625ba1fc4678500$exports) : undefined;
}
$be797d78b695737e$exports = $be797d78b695737e$var$max;


var $205507389c66871e$exports = {};

var $d278bc77a5870dce$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $d278bc77a5870dce$var$baseLt(value, other) {
    return value < other;
}
$d278bc77a5870dce$exports = $d278bc77a5870dce$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $205507389c66871e$var$min(array) {
    return array && array.length ? $89ecae80ebf99b3b$exports(array, $e4dbcba8665d9b6c$exports, $d278bc77a5870dce$exports) : undefined;
}
$205507389c66871e$exports = $205507389c66871e$var$min;






var $c27f8af095e0eaa7$exports = {};
var $df6466a12cae3866$exports = {};

var $2e55701aa5e08350$exports = {};



/** Built-in value references. */ var $2e55701aa5e08350$var$spreadableSymbol = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $2e55701aa5e08350$var$isFlattenable(value) {
    return $579b9ba2588bb9de$exports(value) || $4f4b95b8aefe4d77$exports(value) || !!($2e55701aa5e08350$var$spreadableSymbol && value && value[$2e55701aa5e08350$var$spreadableSymbol]);
}
$2e55701aa5e08350$exports = $2e55701aa5e08350$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $df6466a12cae3866$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $2e55701aa5e08350$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $df6466a12cae3866$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $efe685e6768936ef$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$df6466a12cae3866$exports = $df6466a12cae3866$var$baseFlatten;


var $a649fd6b6748664a$exports = {};

var $bf70b66c162aef31$exports = {};
var $26276a5f2fd81978$exports = {};
var $d1efba33353344a0$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG = 1, $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d1efba33353344a0$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $75b9f8e835026959$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $7c952302caee51c1$exports(srcValue, objValue, $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG | $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$d1efba33353344a0$exports = $d1efba33353344a0$var$baseIsMatch;


var $0c264c2d18b81eb5$exports = {};
var $1fffae593e239b7a$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1fffae593e239b7a$var$isStrictComparable(value) {
    return value === value && !$f328ff7ee4fde81a$exports(value);
}
$1fffae593e239b7a$exports = $1fffae593e239b7a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $0c264c2d18b81eb5$var$getMatchData(object) {
    var result = $0fce4239ee480ef0$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1fffae593e239b7a$exports(value)
        ];
    }
    return result;
}
$0c264c2d18b81eb5$exports = $0c264c2d18b81eb5$var$getMatchData;


var $8bf164e6cb59822f$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8bf164e6cb59822f$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$8bf164e6cb59822f$exports = $8bf164e6cb59822f$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $26276a5f2fd81978$var$baseMatches(source) {
    var matchData = $0c264c2d18b81eb5$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $8bf164e6cb59822f$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $d1efba33353344a0$exports(object, source, matchData);
    };
}
$26276a5f2fd81978$exports = $26276a5f2fd81978$var$baseMatches;


var $952f5322c982d82b$exports = {};


var $065767a6557522ec$exports = {};
var $f39b1c537d656d19$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f39b1c537d656d19$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$f39b1c537d656d19$exports = $f39b1c537d656d19$var$baseHasIn;


var $e115c865f83e382c$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e115c865f83e382c$var$hasPath(object, path, hasFunc) {
    path = $23e5d07d36d464f0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $09a75ffd36bdbd18$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $13758fcec31fd7af$exports(length) && $a4ac18a3b008eabc$exports(key, length) && ($579b9ba2588bb9de$exports(object) || $4f4b95b8aefe4d77$exports(object));
}
$e115c865f83e382c$exports = $e115c865f83e382c$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $065767a6557522ec$var$hasIn(object, path) {
    return object != null && $e115c865f83e382c$exports(object, path, $f39b1c537d656d19$exports);
}
$065767a6557522ec$exports = $065767a6557522ec$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG = 1, $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $952f5322c982d82b$var$baseMatchesProperty(path, srcValue) {
    if ($69479e268680fe10$exports(path) && $1fffae593e239b7a$exports(srcValue)) return $8bf164e6cb59822f$exports($09a75ffd36bdbd18$exports(path), srcValue);
    return function(object) {
        var objValue = $f7bfd9e73571977c$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $065767a6557522ec$exports(object, path) : $7c952302caee51c1$exports(srcValue, objValue, $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG | $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG);
    };
}
$952f5322c982d82b$exports = $952f5322c982d82b$var$baseMatchesProperty;




var $2e890ca2b88f7d2c$exports = {};
var $e8a9c7d31faa2cc3$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e8a9c7d31faa2cc3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$e8a9c7d31faa2cc3$exports = $e8a9c7d31faa2cc3$var$baseProperty;


var $e6abd5b3ef04327c$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e6abd5b3ef04327c$var$basePropertyDeep(path) {
    return function(object) {
        return $e913f1fcbff7147e$exports(object, path);
    };
}
$e6abd5b3ef04327c$exports = $e6abd5b3ef04327c$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $2e890ca2b88f7d2c$var$property(path) {
    return $69479e268680fe10$exports(path) ? $e8a9c7d31faa2cc3$exports($09a75ffd36bdbd18$exports(path)) : $e6abd5b3ef04327c$exports(path);
}
$2e890ca2b88f7d2c$exports = $2e890ca2b88f7d2c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bf70b66c162aef31$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $e4dbcba8665d9b6c$exports;
    if (typeof value == 'object') return $579b9ba2588bb9de$exports(value) ? $952f5322c982d82b$exports(value[0], value[1]) : $26276a5f2fd81978$exports(value);
    return $2e890ca2b88f7d2c$exports(value);
}
$bf70b66c162aef31$exports = $bf70b66c162aef31$var$baseIteratee;


var $096af2082e63acfa$exports = {};
var $7ebb68e7a3797e10$exports = {};
var $feac72adfe18f958$exports = {};
var $1a862ca629cc3032$exports = {};
var $3bb6739cad2da2c9$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3bb6739cad2da2c9$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$3bb6739cad2da2c9$exports = $3bb6739cad2da2c9$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1a862ca629cc3032$var$baseFor = $3bb6739cad2da2c9$exports();
$1a862ca629cc3032$exports = $1a862ca629cc3032$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $feac72adfe18f958$var$baseForOwn(object, iteratee) {
    return object && $1a862ca629cc3032$exports(object, iteratee, $0fce4239ee480ef0$exports);
}
$feac72adfe18f958$exports = $feac72adfe18f958$var$baseForOwn;


var $a19fb4a1ae1d38c6$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a19fb4a1ae1d38c6$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$4506257970d5c979$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$a19fb4a1ae1d38c6$exports = $a19fb4a1ae1d38c6$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7ebb68e7a3797e10$var$baseEach = $a19fb4a1ae1d38c6$exports($feac72adfe18f958$exports);
$7ebb68e7a3797e10$exports = $7ebb68e7a3797e10$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $096af2082e63acfa$var$baseMap(collection, iteratee) {
    var index = -1, result = $4506257970d5c979$exports(collection) ? Array(collection.length) : [];
    $7ebb68e7a3797e10$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$096af2082e63acfa$exports = $096af2082e63acfa$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a649fd6b6748664a$var$map(collection, iteratee) {
    var func = $579b9ba2588bb9de$exports(collection) ? $4c0f1a1d993f5976$exports : $096af2082e63acfa$exports;
    return func(collection, $bf70b66c162aef31$exports(iteratee, 3));
}
$a649fd6b6748664a$exports = $a649fd6b6748664a$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $c27f8af095e0eaa7$var$flatMap(collection, iteratee) {
    return $df6466a12cae3866$exports($a649fd6b6748664a$exports(collection, iteratee), 1);
}
$c27f8af095e0eaa7$exports = $c27f8af095e0eaa7$var$flatMap;



var $1557215ae053272d$exports = {};
var $51dea4a2e2631317$exports = {};
var $b67ec3577fd2cfcf$exports = {};
var $0372dacbc03388e3$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $0372dacbc03388e3$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$0372dacbc03388e3$exports = $0372dacbc03388e3$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $b67ec3577fd2cfcf$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $0372dacbc03388e3$exports(array, start, end);
}
$b67ec3577fd2cfcf$exports = $b67ec3577fd2cfcf$var$castSlice;


var $1545ad01d99df16b$exports = {};
/** Used to compose unicode character classes. */ var $1545ad01d99df16b$var$rsAstralRange = '\\ud800-\\udfff', $1545ad01d99df16b$var$rsComboMarksRange = '\\u0300-\\u036f', $1545ad01d99df16b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1545ad01d99df16b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1545ad01d99df16b$var$rsComboRange = $1545ad01d99df16b$var$rsComboMarksRange + $1545ad01d99df16b$var$reComboHalfMarksRange + $1545ad01d99df16b$var$rsComboSymbolsRange, $1545ad01d99df16b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1545ad01d99df16b$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1545ad01d99df16b$var$reHasUnicode = RegExp('[' + $1545ad01d99df16b$var$rsZWJ + $1545ad01d99df16b$var$rsAstralRange + $1545ad01d99df16b$var$rsComboRange + $1545ad01d99df16b$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1545ad01d99df16b$var$hasUnicode(string) {
    return $1545ad01d99df16b$var$reHasUnicode.test(string);
}
$1545ad01d99df16b$exports = $1545ad01d99df16b$var$hasUnicode;


var $3feda1c248532a44$exports = {};
var $0a377f169d30a6ad$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0a377f169d30a6ad$var$asciiToArray(string) {
    return string.split('');
}
$0a377f169d30a6ad$exports = $0a377f169d30a6ad$var$asciiToArray;



var $5d7e2db9b917571b$exports = {};
/** Used to compose unicode character classes. */ var $5d7e2db9b917571b$var$rsAstralRange = '\\ud800-\\udfff', $5d7e2db9b917571b$var$rsComboMarksRange = '\\u0300-\\u036f', $5d7e2db9b917571b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $5d7e2db9b917571b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $5d7e2db9b917571b$var$rsComboRange = $5d7e2db9b917571b$var$rsComboMarksRange + $5d7e2db9b917571b$var$reComboHalfMarksRange + $5d7e2db9b917571b$var$rsComboSymbolsRange, $5d7e2db9b917571b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $5d7e2db9b917571b$var$rsAstral = '[' + $5d7e2db9b917571b$var$rsAstralRange + ']', $5d7e2db9b917571b$var$rsCombo = '[' + $5d7e2db9b917571b$var$rsComboRange + ']', $5d7e2db9b917571b$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $5d7e2db9b917571b$var$rsModifier = '(?:' + $5d7e2db9b917571b$var$rsCombo + '|' + $5d7e2db9b917571b$var$rsFitz + ')', $5d7e2db9b917571b$var$rsNonAstral = '[^' + $5d7e2db9b917571b$var$rsAstralRange + ']', $5d7e2db9b917571b$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $5d7e2db9b917571b$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $5d7e2db9b917571b$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $5d7e2db9b917571b$var$reOptMod = $5d7e2db9b917571b$var$rsModifier + '?', $5d7e2db9b917571b$var$rsOptVar = '[' + $5d7e2db9b917571b$var$rsVarRange + ']?', $5d7e2db9b917571b$var$rsOptJoin = '(?:' + $5d7e2db9b917571b$var$rsZWJ + '(?:' + [
    $5d7e2db9b917571b$var$rsNonAstral,
    $5d7e2db9b917571b$var$rsRegional,
    $5d7e2db9b917571b$var$rsSurrPair
].join('|') + ')' + $5d7e2db9b917571b$var$rsOptVar + $5d7e2db9b917571b$var$reOptMod + ')*', $5d7e2db9b917571b$var$rsSeq = $5d7e2db9b917571b$var$rsOptVar + $5d7e2db9b917571b$var$reOptMod + $5d7e2db9b917571b$var$rsOptJoin, $5d7e2db9b917571b$var$rsSymbol = '(?:' + [
    $5d7e2db9b917571b$var$rsNonAstral + $5d7e2db9b917571b$var$rsCombo + '?',
    $5d7e2db9b917571b$var$rsCombo,
    $5d7e2db9b917571b$var$rsRegional,
    $5d7e2db9b917571b$var$rsSurrPair,
    $5d7e2db9b917571b$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $5d7e2db9b917571b$var$reUnicode = RegExp($5d7e2db9b917571b$var$rsFitz + '(?=' + $5d7e2db9b917571b$var$rsFitz + ')|' + $5d7e2db9b917571b$var$rsSymbol + $5d7e2db9b917571b$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $5d7e2db9b917571b$var$unicodeToArray(string) {
    return string.match($5d7e2db9b917571b$var$reUnicode) || [];
}
$5d7e2db9b917571b$exports = $5d7e2db9b917571b$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3feda1c248532a44$var$stringToArray(string) {
    return $1545ad01d99df16b$exports(string) ? $5d7e2db9b917571b$exports(string) : $0a377f169d30a6ad$exports(string);
}
$3feda1c248532a44$exports = $3feda1c248532a44$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $51dea4a2e2631317$var$createCaseFirst(methodName) {
    return function(string) {
        string = $78eb02cd4ef313ef$exports(string);
        var strSymbols = $1545ad01d99df16b$exports(string) ? $3feda1c248532a44$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $b67ec3577fd2cfcf$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$51dea4a2e2631317$exports = $51dea4a2e2631317$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $1557215ae053272d$var$upperFirst = $51dea4a2e2631317$exports('toUpperCase');
$1557215ae053272d$exports = $1557215ae053272d$var$upperFirst;



var $5cbcadbe316600de$exports = {};

var $06e3445471e22668$exports = {};




var $9cc81b309921e28a$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9cc81b309921e28a$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9cc81b309921e28a$exports = $9cc81b309921e28a$var$baseSortBy;



var $4de0c06f5a982b80$exports = {};
var $730e73ab53b8c757$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $730e73ab53b8c757$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $2fffc1449db40502$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $2fffc1449db40502$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$730e73ab53b8c757$exports = $730e73ab53b8c757$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4de0c06f5a982b80$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $730e73ab53b8c757$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$4de0c06f5a982b80$exports = $4de0c06f5a982b80$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $06e3445471e22668$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $4c0f1a1d993f5976$exports(iteratees, function(iteratee) {
        if ($579b9ba2588bb9de$exports(iteratee)) return function(value) {
            return $e913f1fcbff7147e$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $e4dbcba8665d9b6c$exports
    ];
    var index = -1;
    iteratees = $4c0f1a1d993f5976$exports(iteratees, $c4aeaafb4421a79e$exports($bf70b66c162aef31$exports));
    var result = $096af2082e63acfa$exports(collection, function(value, key, collection) {
        var criteria = $4c0f1a1d993f5976$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9cc81b309921e28a$exports(result, function(object, other) {
        return $4de0c06f5a982b80$exports(object, other, orders);
    });
}
$06e3445471e22668$exports = $06e3445471e22668$var$baseOrderBy;


var $6b119307bcdda881$exports = {};

var $edebe4cd16ce0339$exports = {};
var $2c8082d1abd12c9f$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $2c8082d1abd12c9f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$2c8082d1abd12c9f$exports = $2c8082d1abd12c9f$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $edebe4cd16ce0339$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $edebe4cd16ce0339$var$overRest(func, start, transform) {
    start = $edebe4cd16ce0339$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $edebe4cd16ce0339$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $2c8082d1abd12c9f$exports(func, this, otherArgs);
    };
}
$edebe4cd16ce0339$exports = $edebe4cd16ce0339$var$overRest;


var $e94006b0ead3bc9b$exports = {};
var $10869bce639d4319$exports = {};
var $f24125b8d605265c$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f24125b8d605265c$var$constant(value) {
    return function() {
        return value;
    };
}
$f24125b8d605265c$exports = $f24125b8d605265c$var$constant;


var $25e57808ab068dc5$exports = {};

var $25e57808ab068dc5$var$defineProperty = function() {
    try {
        var func = $95eb055fdd27d869$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$25e57808ab068dc5$exports = $25e57808ab068dc5$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $10869bce639d4319$var$baseSetToString = !$25e57808ab068dc5$exports ? $e4dbcba8665d9b6c$exports : function(func, string) {
    return $25e57808ab068dc5$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $f24125b8d605265c$exports(string),
        'writable': true
    });
};
$10869bce639d4319$exports = $10869bce639d4319$var$baseSetToString;


var $1159b1adb5e363bf$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1159b1adb5e363bf$var$HOT_COUNT = 800, $1159b1adb5e363bf$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1159b1adb5e363bf$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1159b1adb5e363bf$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1159b1adb5e363bf$var$nativeNow(), remaining = $1159b1adb5e363bf$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1159b1adb5e363bf$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$1159b1adb5e363bf$exports = $1159b1adb5e363bf$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e94006b0ead3bc9b$var$setToString = $1159b1adb5e363bf$exports($10869bce639d4319$exports);
$e94006b0ead3bc9b$exports = $e94006b0ead3bc9b$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $6b119307bcdda881$var$baseRest(func, start) {
    return $e94006b0ead3bc9b$exports($edebe4cd16ce0339$exports(func, start, $e4dbcba8665d9b6c$exports), func + '');
}
$6b119307bcdda881$exports = $6b119307bcdda881$var$baseRest;


var $18da533e307f2df0$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $18da533e307f2df0$var$isIterateeCall(value, index, object) {
    if (!$f328ff7ee4fde81a$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $4506257970d5c979$exports(object) && $a4ac18a3b008eabc$exports(index, object.length) : type == 'string' && index in object) return $881bebc960934ade$exports(object[index], value);
    return false;
}
$18da533e307f2df0$exports = $18da533e307f2df0$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5cbcadbe316600de$var$sortBy = $6b119307bcdda881$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $18da533e307f2df0$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $18da533e307f2df0$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $06e3445471e22668$exports(collection, $df6466a12cae3866$exports(iteratees, 1), []);
});
$5cbcadbe316600de$exports = $5cbcadbe316600de$var$sortBy;


var $57e46f3c4239bc7f$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $57e46f3c4239bc7f$exports) $57e46f3c4239bc7f$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($57e46f3c4239bc7f$exports);


function $45a183d0c6718727$var$_toConsumableArray(arr) {
    return $45a183d0c6718727$var$_arrayWithoutHoles(arr) || $45a183d0c6718727$var$_iterableToArray(arr) || $45a183d0c6718727$var$_unsupportedIterableToArray(arr) || $45a183d0c6718727$var$_nonIterableSpread();
}
function $45a183d0c6718727$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $45a183d0c6718727$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $45a183d0c6718727$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $45a183d0c6718727$var$_arrayLikeToArray(o, minLen);
}
function $45a183d0c6718727$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $45a183d0c6718727$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $45a183d0c6718727$var$_arrayLikeToArray(arr);
}
function $45a183d0c6718727$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $45a183d0c6718727$var$identity = function identity(i) {
    return i;
};
var $45a183d0c6718727$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $45a183d0c6718727$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $45a183d0c6718727$export$ca73b6d700d0505;
};
var $45a183d0c6718727$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $45a183d0c6718727$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $45a183d0c6718727$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $45a183d0c6718727$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $45a183d0c6718727$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $45a183d0c6718727$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $45a183d0c6718727$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $45a183d0c6718727$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $45a183d0c6718727$export$c3095a23b368d1f2 = function curry(fn) {
    return $45a183d0c6718727$var$curryN(fn.length, fn);
};
var $45a183d0c6718727$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $45a183d0c6718727$export$871de8747c9eaa88 = $45a183d0c6718727$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $45a183d0c6718727$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $45a183d0c6718727$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $45a183d0c6718727$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $45a183d0c6718727$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $3bbc3a54db54bf0d$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $3bbc3a54db54bf0d$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $3bbc3a54db54bf0d$var$interpolateNumber = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $3bbc3a54db54bf0d$var$uninterpolateNumber = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $3bbc3a54db54bf0d$var$uninterpolateTruncation = (0, $45a183d0c6718727$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $3bbc3a54db54bf0d$export$2e2bcd8739ae039 = {
    rangeStep: $3bbc3a54db54bf0d$var$rangeStep,
    getDigitCount: $3bbc3a54db54bf0d$var$getDigitCount,
    interpolateNumber: $3bbc3a54db54bf0d$var$interpolateNumber,
    uninterpolateNumber: $3bbc3a54db54bf0d$var$uninterpolateNumber,
    uninterpolateTruncation: $3bbc3a54db54bf0d$var$uninterpolateTruncation
};


function $de63bedd203e5dd9$var$_toConsumableArray(arr) {
    return $de63bedd203e5dd9$var$_arrayWithoutHoles(arr) || $de63bedd203e5dd9$var$_iterableToArray(arr) || $de63bedd203e5dd9$var$_unsupportedIterableToArray(arr) || $de63bedd203e5dd9$var$_nonIterableSpread();
}
function $de63bedd203e5dd9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de63bedd203e5dd9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $de63bedd203e5dd9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $de63bedd203e5dd9$var$_arrayLikeToArray(arr);
}
function $de63bedd203e5dd9$var$_slicedToArray(arr, i) {
    return $de63bedd203e5dd9$var$_arrayWithHoles(arr) || $de63bedd203e5dd9$var$_iterableToArrayLimit(arr, i) || $de63bedd203e5dd9$var$_unsupportedIterableToArray(arr, i) || $de63bedd203e5dd9$var$_nonIterableRest();
}
function $de63bedd203e5dd9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de63bedd203e5dd9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de63bedd203e5dd9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de63bedd203e5dd9$var$_arrayLikeToArray(o, minLen);
}
function $de63bedd203e5dd9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de63bedd203e5dd9$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $de63bedd203e5dd9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $de63bedd203e5dd9$var$getValidInterval(_ref) {
    var _ref2 = $de63bedd203e5dd9$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $de63bedd203e5dd9$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0);
    var digitCount = (0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $de63bedd203e5dd9$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(10).pow((0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $45a183d0c6718727$export$f672e0b6f7222cd7)((0, $45a183d0c6718727$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $45a183d0c6718727$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $de63bedd203e5dd9$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $de63bedd203e5dd9$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $de63bedd203e5dd9$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $45a183d0c6718727$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $45a183d0c6718727$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $de63bedd203e5dd9$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $de63bedd203e5dd9$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getTickValuesFn(_ref5) {
    var _ref6 = $de63bedd203e5dd9$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $de63bedd203e5dd9$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $45a183d0c6718727$export$f672e0b6f7222cd7)((0, $45a183d0c6718727$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(n).mul(step)).toNumber();
    }), (0, $45a183d0c6718727$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $de63bedd203e5dd9$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $de63bedd203e5dd9$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $de63bedd203e5dd9$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $de63bedd203e5dd9$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $de63bedd203e5dd9$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($de63bedd203e5dd9$var$_toConsumableArray((0, $3bbc3a54db54bf0d$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($57e46f3c4239bc7f$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $45a183d0c6718727$export$66c1ae025e96b4bc)(values) : values;
}
var $de63bedd203e5dd9$export$b84e75ccbfe6a612 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getNiceTickValuesFn);
var $de63bedd203e5dd9$export$4cc7a216492b1f53 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getTickValuesFn);
var $de63bedd203e5dd9$export$e9d28da780436e98 = (0, $45a183d0c6718727$export$fc10aeed3a532e2a)($de63bedd203e5dd9$var$getTickValuesFixedDomainFn);








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


/* eslint no-console: 0 */ var $7e4f89fa33734bf7$var$isDev = false;
var $7e4f89fa33734bf7$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7e4f89fa33734bf7$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $7fPBF = parcelRequire("7fPBF");


var $6a2566a000284bc9$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $6a2566a000284bc9$var$_extends() {
    $6a2566a000284bc9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a2566a000284bc9$var$_extends.apply(this, arguments);
}
function $6a2566a000284bc9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6a2566a000284bc9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6a2566a000284bc9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6a2566a000284bc9$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $6a2566a000284bc9$var$_objectWithoutProperties(props, $6a2566a000284bc9$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $6a2566a000284bc9$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("desc", null, desc), children);
}



var $7fPBF = parcelRequire("7fPBF");




function $73ec554c060060c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73ec554c060060c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73ec554c060060c3$var$_typeof(o);
}
var $73ec554c060060c3$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $73ec554c060060c3$var$_extends() {
    $73ec554c060060c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73ec554c060060c3$var$_extends.apply(this, arguments);
}
function $73ec554c060060c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73ec554c060060c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73ec554c060060c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $73ec554c060060c3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73ec554c060060c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73ec554c060060c3$var$_defineProperty(obj, key, value) {
    key = $73ec554c060060c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73ec554c060060c3$var$_toPropertyKey(t) {
    var i = $73ec554c060060c3$var$_toPrimitive(t, "string");
    return "symbol" == $73ec554c060060c3$var$_typeof(i) ? i : i + "";
}
function $73ec554c060060c3$var$_toPrimitive(t, r) {
    if ("object" != $73ec554c060060c3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $73ec554c060060c3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $73ec554c060060c3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73ec554c060060c3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73ec554c060060c3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73ec554c060060c3$var$symbolFactories = {
    symbolCircle: (0, $922af94be54ea802$exports.symbolCircle),
    symbolCross: (0, $922af94be54ea802$exports.symbolCross),
    symbolDiamond: (0, $922af94be54ea802$exports.symbolDiamond),
    symbolSquare: (0, $922af94be54ea802$exports.symbolSquare),
    symbolStar: (0, $922af94be54ea802$exports.symbolStar),
    symbolTriangle: (0, $922af94be54ea802$exports.symbolTriangle),
    symbolWye: (0, $922af94be54ea802$exports.symbolWye)
};
var $73ec554c060060c3$var$RADIAN = Math.PI / 180;
var $73ec554c060060c3$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($1557215ae053272d$exports)))(type));
    return $73ec554c060060c3$var$symbolFactories[name] || (0, $922af94be54ea802$exports.symbolCircle);
};
var $73ec554c060060c3$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $73ec554c060060c3$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $73ec554c060060c3$var$registerSymbol = function registerSymbol(key, factory) {
    $73ec554c060060c3$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($1557215ae053272d$exports)))(key))] = factory;
};
var $73ec554c060060c3$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $73ec554c060060c3$var$_objectWithoutProperties(_ref, $73ec554c060060c3$var$_excluded);
    var props = $73ec554c060060c3$var$_objectSpread($73ec554c060060c3$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $73ec554c060060c3$var$getSymbolFactory(type);
        var symbol = (0, $922af94be54ea802$exports.symbol)().type(symbolFactory).size($73ec554c060060c3$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $73ec554c060060c3$var$_extends({}, filteredProps, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$73ec554c060060c3$export$fa456266707bf4e4.registerSymbol = $73ec554c060060c3$var$registerSymbol;



function $8b96df7c48af2c0d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b96df7c48af2c0d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b96df7c48af2c0d$var$_typeof(o);
}
function $8b96df7c48af2c0d$var$_extends() {
    $8b96df7c48af2c0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b96df7c48af2c0d$var$_extends.apply(this, arguments);
}
function $8b96df7c48af2c0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b96df7c48af2c0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b96df7c48af2c0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8b96df7c48af2c0d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b96df7c48af2c0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8b96df7c48af2c0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b96df7c48af2c0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8b96df7c48af2c0d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8b96df7c48af2c0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8b96df7c48af2c0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b96df7c48af2c0d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8b96df7c48af2c0d$var$_callSuper(t, o, e) {
    return o = $8b96df7c48af2c0d$var$_getPrototypeOf(o), $8b96df7c48af2c0d$var$_possibleConstructorReturn(t, $8b96df7c48af2c0d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $8b96df7c48af2c0d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $8b96df7c48af2c0d$var$_possibleConstructorReturn(self, call) {
    if (call && ($8b96df7c48af2c0d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8b96df7c48af2c0d$var$_assertThisInitialized(self);
}
function $8b96df7c48af2c0d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8b96df7c48af2c0d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8b96df7c48af2c0d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8b96df7c48af2c0d$var$_getPrototypeOf(o) {
    $8b96df7c48af2c0d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8b96df7c48af2c0d$var$_getPrototypeOf(o);
}
function $8b96df7c48af2c0d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8b96df7c48af2c0d$var$_setPrototypeOf(subClass, superClass);
}
function $8b96df7c48af2c0d$var$_setPrototypeOf(o, p) {
    $8b96df7c48af2c0d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8b96df7c48af2c0d$var$_setPrototypeOf(o, p);
}
function $8b96df7c48af2c0d$var$_defineProperty(obj, key, value) {
    key = $8b96df7c48af2c0d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b96df7c48af2c0d$var$_toPropertyKey(t) {
    var i = $8b96df7c48af2c0d$var$_toPrimitive(t, "string");
    return "symbol" == $8b96df7c48af2c0d$var$_typeof(i) ? i : i + "";
}
function $8b96df7c48af2c0d$var$_toPrimitive(t, r) {
    if ("object" != $8b96df7c48af2c0d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8b96df7c48af2c0d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8b96df7c48af2c0d$var$SIZE = 32;
var $8b96df7c48af2c0d$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $8b96df7c48af2c0d$var$_classCallCheck(this, DefaultLegendContent);
        return $8b96df7c48af2c0d$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $8b96df7c48af2c0d$var$_inherits(DefaultLegendContent, _PureComponent);
    return $8b96df7c48af2c0d$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $8b96df7c48af2c0d$var$SIZE / 2;
                var sixthSize = $8b96df7c48af2c0d$var$SIZE / 6;
                var thirdSize = $8b96df7c48af2c0d$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $8b96df7c48af2c0d$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($8b96df7c48af2c0d$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($8b96df7c48af2c0d$var$SIZE / 8, "h").concat($8b96df7c48af2c0d$var$SIZE, "v").concat($8b96df7c48af2c0d$var$SIZE * 3 / 4, "h").concat(-$8b96df7c48af2c0d$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(data.legendIcon)) {
                    var iconProps = $8b96df7c48af2c0d$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $73ec554c060060c3$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $8b96df7c48af2c0d$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $8b96df7c48af2c0d$var$SIZE,
                    height: $8b96df7c48af2c0d$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)($8b96df7c48af2c0d$var$_defineProperty($8b96df7c48af2c0d$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(entry.value) ? entry.value : null;
                    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", $8b96df7c48af2c0d$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$8b96df7c48af2c0d$var$_defineProperty($8b96df7c48af2c0d$export$99f8d96ed0cededa, "displayName", 'Legend');
$8b96df7c48af2c0d$var$_defineProperty($8b96df7c48af2c0d$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $99c2840ed14736a0$exports = {};

var $ab3e81e3191a16f7$exports = {};

var $6d186121efb321b5$exports = {};
var $87eaa0c999d1fce0$exports = {};
var $45fe5e20b6ff07af$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $45fe5e20b6ff07af$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$45fe5e20b6ff07af$exports = $45fe5e20b6ff07af$var$baseFindIndex;


var $b4cbf4afe6020a3c$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $b4cbf4afe6020a3c$var$baseIsNaN(value) {
    return value !== value;
}
$b4cbf4afe6020a3c$exports = $b4cbf4afe6020a3c$var$baseIsNaN;


var $c7636be3605d889e$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c7636be3605d889e$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$c7636be3605d889e$exports = $c7636be3605d889e$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87eaa0c999d1fce0$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $c7636be3605d889e$exports(array, value, fromIndex) : $45fe5e20b6ff07af$exports(array, $b4cbf4afe6020a3c$exports, fromIndex);
}
$87eaa0c999d1fce0$exports = $87eaa0c999d1fce0$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $6d186121efb321b5$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $87eaa0c999d1fce0$exports(array, value, 0) > -1;
}
$6d186121efb321b5$exports = $6d186121efb321b5$var$arrayIncludes;


var $c0d14eba3105b20d$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c0d14eba3105b20d$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$c0d14eba3105b20d$exports = $c0d14eba3105b20d$var$arrayIncludesWith;



var $fa874c262754487d$exports = {};

var $7cd962ea8094c633$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $7cd962ea8094c633$var$noop() {
// No operation performed.
}
$7cd962ea8094c633$exports = $7cd962ea8094c633$var$noop;



/** Used as references for various `Number` constants. */ var $fa874c262754487d$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $fa874c262754487d$var$createSet = !($2a4786f2dfc898c9$exports && 1 / $edfe5dc5ee94a646$exports(new $2a4786f2dfc898c9$exports([
    ,
    -0
]))[1] == $fa874c262754487d$var$INFINITY) ? $7cd962ea8094c633$exports : function(values) {
    return new $2a4786f2dfc898c9$exports(values);
};
$fa874c262754487d$exports = $fa874c262754487d$var$createSet;



/** Used as the size to enable large array optimizations. */ var $ab3e81e3191a16f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $ab3e81e3191a16f7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $6d186121efb321b5$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $c0d14eba3105b20d$exports;
    } else if (length >= $ab3e81e3191a16f7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $fa874c262754487d$exports(array);
        if (set) return $edfe5dc5ee94a646$exports(set);
        isCommon = false;
        includes = $601e4ed5362647b9$exports;
        seen = new $7d2f3a0d9ce14f26$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ab3e81e3191a16f7$exports = $ab3e81e3191a16f7$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $99c2840ed14736a0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ab3e81e3191a16f7$exports(array, $bf70b66c162aef31$exports(iteratee, 2)) : [];
}
$99c2840ed14736a0$exports = $99c2840ed14736a0$var$uniqBy;



function $9df57fcd3e3e7338$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(payload, option);
    return payload;
}


function $559b693b6a1d5199$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $559b693b6a1d5199$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $559b693b6a1d5199$var$_typeof(o);
}
var $559b693b6a1d5199$var$_excluded = [
    "ref"
];
function $559b693b6a1d5199$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $559b693b6a1d5199$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $559b693b6a1d5199$var$ownKeys(Object(t), !0).forEach(function(r) {
            $559b693b6a1d5199$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $559b693b6a1d5199$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $559b693b6a1d5199$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $559b693b6a1d5199$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $559b693b6a1d5199$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $559b693b6a1d5199$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $559b693b6a1d5199$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $559b693b6a1d5199$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $559b693b6a1d5199$var$_callSuper(t, o, e) {
    return o = $559b693b6a1d5199$var$_getPrototypeOf(o), $559b693b6a1d5199$var$_possibleConstructorReturn(t, $559b693b6a1d5199$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $559b693b6a1d5199$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $559b693b6a1d5199$var$_possibleConstructorReturn(self, call) {
    if (call && ($559b693b6a1d5199$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $559b693b6a1d5199$var$_assertThisInitialized(self);
}
function $559b693b6a1d5199$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $559b693b6a1d5199$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($559b693b6a1d5199$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $559b693b6a1d5199$var$_getPrototypeOf(o) {
    $559b693b6a1d5199$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $559b693b6a1d5199$var$_getPrototypeOf(o);
}
function $559b693b6a1d5199$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $559b693b6a1d5199$var$_setPrototypeOf(subClass, superClass);
}
function $559b693b6a1d5199$var$_setPrototypeOf(o, p) {
    $559b693b6a1d5199$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $559b693b6a1d5199$var$_setPrototypeOf(o, p);
}
function $559b693b6a1d5199$var$_defineProperty(obj, key, value) {
    key = $559b693b6a1d5199$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $559b693b6a1d5199$var$_toPropertyKey(t) {
    var i = $559b693b6a1d5199$var$_toPrimitive(t, "string");
    return "symbol" == $559b693b6a1d5199$var$_typeof(i) ? i : i + "";
}
function $559b693b6a1d5199$var$_toPrimitive(t, r) {
    if ("object" != $559b693b6a1d5199$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $559b693b6a1d5199$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $559b693b6a1d5199$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $559b693b6a1d5199$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $559b693b6a1d5199$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $559b693b6a1d5199$var$defaultUniqBy(entry) {
    return entry.value;
}
function $559b693b6a1d5199$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(content, props);
    var ref = props.ref, otherProps = $559b693b6a1d5199$var$_objectWithoutProperties(props, $559b693b6a1d5199$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8b96df7c48af2c0d$export$99f8d96ed0cededa), otherProps);
}
var $559b693b6a1d5199$var$EPS = 1;
var $559b693b6a1d5199$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $559b693b6a1d5199$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $559b693b6a1d5199$var$_callSuper(this, Legend, [].concat(args));
        $559b693b6a1d5199$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $559b693b6a1d5199$var$_inherits(Legend, _PureComponent);
    return $559b693b6a1d5199$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $559b693b6a1d5199$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $559b693b6a1d5199$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $559b693b6a1d5199$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $559b693b6a1d5199$var$renderContent(content, $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $9df57fcd3e3e7338$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $559b693b6a1d5199$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $559b693b6a1d5199$var$_objectSpread($559b693b6a1d5199$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$559b693b6a1d5199$var$_defineProperty($559b693b6a1d5199$export$ed247974535929c7, "displayName", 'Legend');
$559b693b6a1d5199$var$_defineProperty($559b693b6a1d5199$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $7bbd89b69def67ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7bbd89b69def67ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7bbd89b69def67ea$var$_typeof(o);
}
function $7bbd89b69def67ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bbd89b69def67ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bbd89b69def67ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7bbd89b69def67ea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bbd89b69def67ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7bbd89b69def67ea$var$_defineProperty(obj, key, value) {
    key = $7bbd89b69def67ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7bbd89b69def67ea$var$_toPropertyKey(t) {
    var i = $7bbd89b69def67ea$var$_toPrimitive(t, "string");
    return "symbol" == $7bbd89b69def67ea$var$_typeof(i) ? i : i + "";
}
function $7bbd89b69def67ea$var$_toPrimitive(t, r) {
    if ("object" != $7bbd89b69def67ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7bbd89b69def67ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7bbd89b69def67ea$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $559b693b6a1d5199$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $559b693b6a1d5199$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $3cf1854128f2220f$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread($7bbd89b69def67ea$var$_objectSpread({}, legendProps), (0, $559b693b6a1d5199$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $3cf1854128f2220f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cf1854128f2220f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cf1854128f2220f$var$_typeof(o);
}
function $3cf1854128f2220f$var$_toConsumableArray(arr) {
    return $3cf1854128f2220f$var$_arrayWithoutHoles(arr) || $3cf1854128f2220f$var$_iterableToArray(arr) || $3cf1854128f2220f$var$_unsupportedIterableToArray(arr) || $3cf1854128f2220f$var$_nonIterableSpread();
}
function $3cf1854128f2220f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cf1854128f2220f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cf1854128f2220f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cf1854128f2220f$var$_arrayLikeToArray(o, minLen);
}
function $3cf1854128f2220f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3cf1854128f2220f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3cf1854128f2220f$var$_arrayLikeToArray(arr);
}
function $3cf1854128f2220f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cf1854128f2220f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cf1854128f2220f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cf1854128f2220f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cf1854128f2220f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cf1854128f2220f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cf1854128f2220f$var$_defineProperty(obj, key, value) {
    key = $3cf1854128f2220f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cf1854128f2220f$var$_toPropertyKey(t) {
    var i = $3cf1854128f2220f$var$_toPrimitive(t, "string");
    return "symbol" == $3cf1854128f2220f$var$_typeof(i) ? i : i + "";
}
function $3cf1854128f2220f$var$_toPrimitive(t, r) {
    if ("object" != $3cf1854128f2220f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3cf1854128f2220f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3cf1854128f2220f$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey)) return defaultValue;
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $3cf1854128f2220f$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($c27f8af095e0eaa7$exports)))(data, function(entry) {
        return $3cf1854128f2220f$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($205507389c66871e$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($be797d78b695737e$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $ddf2636240ab70e2$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $3cf1854128f2220f$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $ddf2636240ab70e2$export$9d334328eb75e624)(cur - before) !== (0, $ddf2636240ab70e2$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $ddf2636240ab70e2$export$9d334328eb75e624)(after - cur) === (0, $ddf2636240ab70e2$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $3cf1854128f2220f$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $3cf1854128f2220f$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(barSize) ? undefined : (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $3cf1854128f2220f$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($3cf1854128f2220f$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($3cf1854128f2220f$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $3cf1854128f2220f$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $7bbd89b69def67ea$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(offset[align])) return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, offset), {}, $3cf1854128f2220f$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(offset[verticalAlign])) return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, offset), {}, $3cf1854128f2220f$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $3cf1854128f2220f$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $3cf1854128f2220f$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $d05ab0383decc723$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $3cf1854128f2220f$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $3cf1854128f2220f$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($205507389c66871e$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($be797d78b695737e$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $3cf1854128f2220f$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $3cf1854128f2220f$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $3cf1854128f2220f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $3cf1854128f2220f$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $3cf1854128f2220f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $3cf1854128f2220f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $3cf1854128f2220f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $3cf1854128f2220f$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $3cf1854128f2220f$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $3cf1854128f2220f$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $ddf2636240ab70e2$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($420172254fa1575b$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $3cf1854128f2220f$var$handlerWeakMap = new WeakMap();
var $3cf1854128f2220f$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$3cf1854128f2220f$var$handlerWeakMap.has(defaultHandler)) $3cf1854128f2220f$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $3cf1854128f2220f$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $3cf1854128f2220f$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $88853d08cf75746a$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $88853d08cf75746a$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $88853d08cf75746a$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $88853d08cf75746a$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $88853d08cf75746a$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($1557215ae053272d$exports)))(scale));
        return {
            scale: ($88853d08cf75746a$exports[name] || $88853d08cf75746a$exports.scalePoint)(),
            realScaleType: $88853d08cf75746a$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $88853d08cf75746a$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $3cf1854128f2220f$var$EPS = 1e-4;
var $3cf1854128f2220f$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $3cf1854128f2220f$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $3cf1854128f2220f$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $3cf1854128f2220f$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $3cf1854128f2220f$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domain[0]) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $3cf1854128f2220f$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($420172254fa1575b$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $3cf1854128f2220f$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($420172254fa1575b$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $3cf1854128f2220f$var$STACK_OFFSET_MAP = {
    sign: $3cf1854128f2220f$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $922af94be54ea802$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $922af94be54ea802$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $922af94be54ea802$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $922af94be54ea802$exports.stackOffsetWiggle),
    positive: $3cf1854128f2220f$export$9f2c6ead70935022
};
var $3cf1854128f2220f$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $3cf1854128f2220f$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $922af94be54ea802$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$3cf1854128f2220f$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $922af94be54ea802$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $3cf1854128f2220f$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, result), {}, $3cf1854128f2220f$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, res), {}, $3cf1854128f2220f$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $3cf1854128f2220f$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, result), {}, $3cf1854128f2220f$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $3cf1854128f2220f$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $de63bedd203e5dd9$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($205507389c66871e$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($be797d78b695737e$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $de63bedd203e5dd9$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $3cf1854128f2220f$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $3cf1854128f2220f$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(value) ? axis.scale(value) : null;
}
var $3cf1854128f2220f$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $3cf1854128f2220f$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $3cf1854128f2220f$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $3cf1854128f2220f$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $3cf1854128f2220f$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($205507389c66871e$exports)))(entry.concat([
                result[0]
            ]).filter((0, $ddf2636240ab70e2$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($be797d78b695737e$exports)))(entry.concat([
                result[1]
            ]).filter((0, $ddf2636240ab70e2$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $3cf1854128f2220f$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $3cf1854128f2220f$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $3cf1854128f2220f$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3cf1854128f2220f$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3cf1854128f2220f$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($3cf1854128f2220f$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$3cf1854128f2220f$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($3cf1854128f2220f$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$3cf1854128f2220f$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $3cf1854128f2220f$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $3cf1854128f2220f$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $3cf1854128f2220f$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $3cf1854128f2220f$var$_objectSpread($3cf1854128f2220f$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $3cf1854128f2220f$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $3cf1854128f2220f$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $2f494a175d2955a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2f494a175d2955a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f494a175d2955a8$var$_typeof(o);
}
function $2f494a175d2955a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f494a175d2955a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f494a175d2955a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f494a175d2955a8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f494a175d2955a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f494a175d2955a8$var$_defineProperty(obj, key, value) {
    key = $2f494a175d2955a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2f494a175d2955a8$var$_toPropertyKey(t) {
    var i = $2f494a175d2955a8$var$_toPrimitive(t, "string");
    return "symbol" == $2f494a175d2955a8$var$_typeof(i) ? i : i + "";
}
function $2f494a175d2955a8$var$_toPrimitive(t, r) {
    if ("object" != $2f494a175d2955a8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2f494a175d2955a8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2f494a175d2955a8$var$_slicedToArray(arr, i) {
    return $2f494a175d2955a8$var$_arrayWithHoles(arr) || $2f494a175d2955a8$var$_iterableToArrayLimit(arr, i) || $2f494a175d2955a8$var$_unsupportedIterableToArray(arr, i) || $2f494a175d2955a8$var$_nonIterableRest();
}
function $2f494a175d2955a8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2f494a175d2955a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2f494a175d2955a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2f494a175d2955a8$var$_arrayLikeToArray(o, minLen);
}
function $2f494a175d2955a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2f494a175d2955a8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2f494a175d2955a8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2f494a175d2955a8$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $2f494a175d2955a8$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $2f494a175d2955a8$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $2f494a175d2955a8$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$2f494a175d2955a8$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$2f494a175d2955a8$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $2f494a175d2955a8$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $2f494a175d2955a8$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $2f494a175d2955a8$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $2f494a175d2955a8$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $3cf1854128f2220f$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $3cf1854128f2220f$export$9d80152e23bae434)(scale);
        var ticks = (0, $3cf1854128f2220f$export$ac086aaa4358d590)(scale, $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, result), {}, $2f494a175d2955a8$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $2f494a175d2955a8$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $2f494a175d2955a8$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $2f494a175d2955a8$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $2f494a175d2955a8$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $2f494a175d2955a8$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $2f494a175d2955a8$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $2f494a175d2955a8$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $2f494a175d2955a8$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $2f494a175d2955a8$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $2f494a175d2955a8$var$_objectSpread($2f494a175d2955a8$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $2f494a175d2955a8$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $2f494a175d2955a8$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $7fPBF.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $41cf002e3fba69c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41cf002e3fba69c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41cf002e3fba69c7$var$_typeof(o);
}
var $41cf002e3fba69c7$var$_excluded = [
    "offset"
];
function $41cf002e3fba69c7$var$_toConsumableArray(arr) {
    return $41cf002e3fba69c7$var$_arrayWithoutHoles(arr) || $41cf002e3fba69c7$var$_iterableToArray(arr) || $41cf002e3fba69c7$var$_unsupportedIterableToArray(arr) || $41cf002e3fba69c7$var$_nonIterableSpread();
}
function $41cf002e3fba69c7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41cf002e3fba69c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41cf002e3fba69c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41cf002e3fba69c7$var$_arrayLikeToArray(o, minLen);
}
function $41cf002e3fba69c7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $41cf002e3fba69c7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $41cf002e3fba69c7$var$_arrayLikeToArray(arr);
}
function $41cf002e3fba69c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $41cf002e3fba69c7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $41cf002e3fba69c7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $41cf002e3fba69c7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $41cf002e3fba69c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41cf002e3fba69c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41cf002e3fba69c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41cf002e3fba69c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41cf002e3fba69c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41cf002e3fba69c7$var$_defineProperty(obj, key, value) {
    key = $41cf002e3fba69c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41cf002e3fba69c7$var$_toPropertyKey(t) {
    var i = $41cf002e3fba69c7$var$_toPrimitive(t, "string");
    return "symbol" == $41cf002e3fba69c7$var$_typeof(i) ? i : i + "";
}
function $41cf002e3fba69c7$var$_toPrimitive(t, r) {
    if ("object" != $41cf002e3fba69c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41cf002e3fba69c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41cf002e3fba69c7$var$_extends() {
    $41cf002e3fba69c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41cf002e3fba69c7$var$_extends.apply(this, arguments);
}
var $41cf002e3fba69c7$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(formatter)) return formatter(label);
    return label;
};
var $41cf002e3fba69c7$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $41cf002e3fba69c7$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $41cf002e3fba69c7$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(labelProps.id) ? (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("text", $41cf002e3fba69c7$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $41cf002e3fba69c7$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $41cf002e3fba69c7$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $41cf002e3fba69c7$var$_objectSpread($41cf002e3fba69c7$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(position) && ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position.x) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(position.x)) && ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position.y) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(position.y))) return $41cf002e3fba69c7$var$_objectSpread({
        x: x + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $41cf002e3fba69c7$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $41cf002e3fba69c7$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(viewBox.cx);
};
function $41cf002e3fba69c7$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $41cf002e3fba69c7$var$_objectWithoutProperties(_ref4, $41cf002e3fba69c7$var$_excluded);
    var props = $41cf002e3fba69c7$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(children) && !/*#__PURE__*/ (0, $7fPBF.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(content)) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(content)) {
        label = /*#__PURE__*/ (0, $7fPBF.createElement)(content, props);
        if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(label)) return label;
    } else label = $41cf002e3fba69c7$var$getLabel(props);
    var isPolarLabel = $41cf002e3fba69c7$var$isPolar(viewBox);
    var attrs = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $41cf002e3fba69c7$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $41cf002e3fba69c7$var$getAttrsOfPolarLabel(props) : $41cf002e3fba69c7$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $41cf002e3fba69c7$var$_extends({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$41cf002e3fba69c7$export$b04be29aa201d4f5.displayName = 'Label';
var $41cf002e3fba69c7$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height)) {
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(top) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cx) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $41cf002e3fba69c7$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $ddf2636240ab70e2$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(label)) {
        if (label.type === $41cf002e3fba69c7$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($41cf002e3fba69c7$export$b04be29aa201d4f5, $41cf002e3fba69c7$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $41cf002e3fba69c7$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $41cf002e3fba69c7$var$parseViewBox(parentProps);
    var explicitChildren = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, $41cf002e3fba69c7$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $41cf002e3fba69c7$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($41cf002e3fba69c7$var$_toConsumableArray(explicitChildren));
};
$41cf002e3fba69c7$export$b04be29aa201d4f5.parseViewBox = $41cf002e3fba69c7$var$parseViewBox;
$41cf002e3fba69c7$export$b04be29aa201d4f5.renderCallByParent = $41cf002e3fba69c7$var$renderCallByParent;





function $acfa11ccf9405f16$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $acfa11ccf9405f16$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $acfa11ccf9405f16$var$_typeof(o);
}
var $acfa11ccf9405f16$var$_excluded = [
    "valueAccessor"
], $acfa11ccf9405f16$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $acfa11ccf9405f16$var$_toConsumableArray(arr) {
    return $acfa11ccf9405f16$var$_arrayWithoutHoles(arr) || $acfa11ccf9405f16$var$_iterableToArray(arr) || $acfa11ccf9405f16$var$_unsupportedIterableToArray(arr) || $acfa11ccf9405f16$var$_nonIterableSpread();
}
function $acfa11ccf9405f16$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $acfa11ccf9405f16$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $acfa11ccf9405f16$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $acfa11ccf9405f16$var$_arrayLikeToArray(o, minLen);
}
function $acfa11ccf9405f16$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $acfa11ccf9405f16$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $acfa11ccf9405f16$var$_arrayLikeToArray(arr);
}
function $acfa11ccf9405f16$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $acfa11ccf9405f16$var$_extends() {
    $acfa11ccf9405f16$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $acfa11ccf9405f16$var$_extends.apply(this, arguments);
}
function $acfa11ccf9405f16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acfa11ccf9405f16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acfa11ccf9405f16$var$ownKeys(Object(t), !0).forEach(function(r) {
            $acfa11ccf9405f16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acfa11ccf9405f16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $acfa11ccf9405f16$var$_defineProperty(obj, key, value) {
    key = $acfa11ccf9405f16$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acfa11ccf9405f16$var$_toPropertyKey(t) {
    var i = $acfa11ccf9405f16$var$_toPrimitive(t, "string");
    return "symbol" == $acfa11ccf9405f16$var$_typeof(i) ? i : i + "";
}
function $acfa11ccf9405f16$var$_toPrimitive(t, r) {
    if ("object" != $acfa11ccf9405f16$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $acfa11ccf9405f16$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $acfa11ccf9405f16$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $acfa11ccf9405f16$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $acfa11ccf9405f16$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $acfa11ccf9405f16$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(entry.value) : entry.value;
};
function $acfa11ccf9405f16$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $acfa11ccf9405f16$var$defaultAccessor : _ref$valueAccessor, restProps = $acfa11ccf9405f16$var$_objectWithoutProperties(_ref, $acfa11ccf9405f16$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $acfa11ccf9405f16$var$_objectWithoutProperties(restProps, $acfa11ccf9405f16$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $41cf002e3fba69c7$export$b04be29aa201d4f5), $acfa11ccf9405f16$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(clockWise) ? entry : $acfa11ccf9405f16$var$_objectSpread($acfa11ccf9405f16$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$acfa11ccf9405f16$export$835fcf23ab7bf88.displayName = 'LabelList';
function $acfa11ccf9405f16$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f328ff7ee4fde81a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($acfa11ccf9405f16$export$835fcf23ab7bf88, $acfa11ccf9405f16$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $acfa11ccf9405f16$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, $acfa11ccf9405f16$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $acfa11ccf9405f16$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($acfa11ccf9405f16$var$_toConsumableArray(explicitChildren));
}
$acfa11ccf9405f16$export$835fcf23ab7bf88.renderCallByParent = $acfa11ccf9405f16$var$renderCallByParent;








var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $46e9524417ce8039$exports = {};

var $2272f6d455ebd3b2$exports = {};

/** Built-in value references. */ var $2272f6d455ebd3b2$var$getPrototype = $fdcd49ef52ce3234$exports(Object.getPrototypeOf, Object);
$2272f6d455ebd3b2$exports = $2272f6d455ebd3b2$var$getPrototype;



/** `Object#toString` result references. */ var $46e9524417ce8039$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $46e9524417ce8039$var$funcProto = Function.prototype, $46e9524417ce8039$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $46e9524417ce8039$var$funcToString = $46e9524417ce8039$var$funcProto.toString;
/** Used to check objects for own properties. */ var $46e9524417ce8039$var$hasOwnProperty = $46e9524417ce8039$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $46e9524417ce8039$var$objectCtorString = $46e9524417ce8039$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $46e9524417ce8039$var$isPlainObject(value) {
    if (!$97dbbc1a069ce16a$exports(value) || $ae3fe6c5950c122e$exports(value) != $46e9524417ce8039$var$objectTag) return false;
    var proto = $2272f6d455ebd3b2$exports(value);
    if (proto === null) return true;
    var Ctor = $46e9524417ce8039$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $46e9524417ce8039$var$funcToString.call(Ctor) == $46e9524417ce8039$var$objectCtorString;
}
$46e9524417ce8039$exports = $46e9524417ce8039$var$isPlainObject;


var $b38a1c4d29f6ba58$exports = {};


/** `Object#toString` result references. */ var $b38a1c4d29f6ba58$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $b38a1c4d29f6ba58$var$isBoolean(value) {
    return value === true || value === false || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $b38a1c4d29f6ba58$var$boolTag;
}
$b38a1c4d29f6ba58$exports = $b38a1c4d29f6ba58$var$isBoolean;




var $7fPBF = parcelRequire("7fPBF");



function $dd9e03c5c06a0d41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd9e03c5c06a0d41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd9e03c5c06a0d41$var$_typeof(o);
}
function $dd9e03c5c06a0d41$var$_extends() {
    $dd9e03c5c06a0d41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd9e03c5c06a0d41$var$_extends.apply(this, arguments);
}
function $dd9e03c5c06a0d41$var$_slicedToArray(arr, i) {
    return $dd9e03c5c06a0d41$var$_arrayWithHoles(arr) || $dd9e03c5c06a0d41$var$_iterableToArrayLimit(arr, i) || $dd9e03c5c06a0d41$var$_unsupportedIterableToArray(arr, i) || $dd9e03c5c06a0d41$var$_nonIterableRest();
}
function $dd9e03c5c06a0d41$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd9e03c5c06a0d41$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dd9e03c5c06a0d41$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dd9e03c5c06a0d41$var$_arrayLikeToArray(o, minLen);
}
function $dd9e03c5c06a0d41$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dd9e03c5c06a0d41$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dd9e03c5c06a0d41$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dd9e03c5c06a0d41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd9e03c5c06a0d41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd9e03c5c06a0d41$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd9e03c5c06a0d41$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd9e03c5c06a0d41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dd9e03c5c06a0d41$var$_defineProperty(obj, key, value) {
    key = $dd9e03c5c06a0d41$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd9e03c5c06a0d41$var$_toPropertyKey(t) {
    var i = $dd9e03c5c06a0d41$var$_toPrimitive(t, "string");
    return "symbol" == $dd9e03c5c06a0d41$var$_typeof(i) ? i : i + "";
}
function $dd9e03c5c06a0d41$var$_toPrimitive(t, r) {
    if ("object" != $dd9e03c5c06a0d41$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dd9e03c5c06a0d41$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dd9e03c5c06a0d41$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $dd9e03c5c06a0d41$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $dd9e03c5c06a0d41$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $dd9e03c5c06a0d41$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $dd9e03c5c06a0d41$var$_objectSpread($dd9e03c5c06a0d41$var$_objectSpread({}, $dd9e03c5c06a0d41$var$defaultProps), rectangleProps);
    var pathRef = (0, $7fPBF.useRef)();
    var _useState = (0, $7fPBF.useState)(-1), _useState2 = $dd9e03c5c06a0d41$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd9e03c5c06a0d41$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $dd9e03c5c06a0d41$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd9e03c5c06a0d41$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $dd9e03c5c06a0d41$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $7fPBF = parcelRequire("7fPBF");



function $8ef28ada15db1e5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ef28ada15db1e5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ef28ada15db1e5a$var$_typeof(o);
}
function $8ef28ada15db1e5a$var$_extends() {
    $8ef28ada15db1e5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ef28ada15db1e5a$var$_extends.apply(this, arguments);
}
function $8ef28ada15db1e5a$var$_slicedToArray(arr, i) {
    return $8ef28ada15db1e5a$var$_arrayWithHoles(arr) || $8ef28ada15db1e5a$var$_iterableToArrayLimit(arr, i) || $8ef28ada15db1e5a$var$_unsupportedIterableToArray(arr, i) || $8ef28ada15db1e5a$var$_nonIterableRest();
}
function $8ef28ada15db1e5a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8ef28ada15db1e5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8ef28ada15db1e5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8ef28ada15db1e5a$var$_arrayLikeToArray(o, minLen);
}
function $8ef28ada15db1e5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8ef28ada15db1e5a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8ef28ada15db1e5a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8ef28ada15db1e5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ef28ada15db1e5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ef28ada15db1e5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ef28ada15db1e5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ef28ada15db1e5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ef28ada15db1e5a$var$_defineProperty(obj, key, value) {
    key = $8ef28ada15db1e5a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ef28ada15db1e5a$var$_toPropertyKey(t) {
    var i = $8ef28ada15db1e5a$var$_toPrimitive(t, "string");
    return "symbol" == $8ef28ada15db1e5a$var$_typeof(i) ? i : i + "";
}
function $8ef28ada15db1e5a$var$_toPrimitive(t, r) {
    if ("object" != $8ef28ada15db1e5a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8ef28ada15db1e5a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8ef28ada15db1e5a$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $8ef28ada15db1e5a$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $8ef28ada15db1e5a$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $8ef28ada15db1e5a$var$_objectSpread($8ef28ada15db1e5a$var$_objectSpread({}, $8ef28ada15db1e5a$var$defaultProps), props);
    var pathRef = (0, $7fPBF.useRef)();
    var _useState = (0, $7fPBF.useState)(-1), _useState2 = $8ef28ada15db1e5a$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $8ef28ada15db1e5a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $8ef28ada15db1e5a$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $8ef28ada15db1e5a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $8ef28ada15db1e5a$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $7fPBF = parcelRequire("7fPBF");




function $dd92401041fdb928$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd92401041fdb928$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd92401041fdb928$var$_typeof(o);
}
function $dd92401041fdb928$var$_extends() {
    $dd92401041fdb928$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd92401041fdb928$var$_extends.apply(this, arguments);
}
function $dd92401041fdb928$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd92401041fdb928$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd92401041fdb928$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd92401041fdb928$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd92401041fdb928$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dd92401041fdb928$var$_defineProperty(obj, key, value) {
    key = $dd92401041fdb928$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd92401041fdb928$var$_toPropertyKey(t) {
    var i = $dd92401041fdb928$var$_toPrimitive(t, "string");
    return "symbol" == $dd92401041fdb928$var$_typeof(i) ? i : i + "";
}
function $dd92401041fdb928$var$_toPrimitive(t, r) {
    if ("object" != $dd92401041fdb928$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dd92401041fdb928$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dd92401041fdb928$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $dd92401041fdb928$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $2f494a175d2955a8$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $2f494a175d2955a8$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $dd92401041fdb928$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $dd92401041fdb928$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $dd92401041fdb928$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $dd92401041fdb928$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $dd92401041fdb928$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $dd92401041fdb928$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $dd92401041fdb928$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $dd92401041fdb928$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $dd92401041fdb928$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $dd92401041fdb928$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $dd92401041fdb928$var$_objectSpread($dd92401041fdb928$var$_objectSpread({}, $dd92401041fdb928$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $dd92401041fdb928$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $dd92401041fdb928$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $dd92401041fdb928$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $afd6034f160dea85$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $afd6034f160dea85$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afd6034f160dea85$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afd6034f160dea85$var$_typeof(o);
}
function $afd6034f160dea85$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $afd6034f160dea85$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $afd6034f160dea85$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $afd6034f160dea85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afd6034f160dea85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afd6034f160dea85$var$ownKeys(Object(t), !0).forEach(function(r) {
            $afd6034f160dea85$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afd6034f160dea85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afd6034f160dea85$var$_defineProperty(obj, key, value) {
    key = $afd6034f160dea85$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afd6034f160dea85$var$_toPropertyKey(t) {
    var i = $afd6034f160dea85$var$_toPrimitive(t, "string");
    return "symbol" == $afd6034f160dea85$var$_typeof(i) ? i : i + "";
}
function $afd6034f160dea85$var$_toPrimitive(t, r) {
    if ("object" != $afd6034f160dea85$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $afd6034f160dea85$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $afd6034f160dea85$var$defaultPropTransformer(option, props) {
    return $afd6034f160dea85$var$_objectSpread($afd6034f160dea85$var$_objectSpread({}, props), option);
}
function $afd6034f160dea85$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $afd6034f160dea85$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd9e03c5c06a0d41$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ef28ada15db1e5a$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd92401041fdb928$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($afd6034f160dea85$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $73ec554c060060c3$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $afd6034f160dea85$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) return option.props;
    return option;
}
function $afd6034f160dea85$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $afd6034f160dea85$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $afd6034f160dea85$var$_objectWithoutProperties(_ref2, $afd6034f160dea85$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) shape = /*#__PURE__*/ (0, $7fPBF.cloneElement)(option, $afd6034f160dea85$var$_objectSpread($afd6034f160dea85$var$_objectSpread({}, props), $afd6034f160dea85$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($b38a1c4d29f6ba58$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($afd6034f160dea85$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($afd6034f160dea85$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $afd6034f160dea85$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $afd6034f160dea85$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $afd6034f160dea85$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $afd6034f160dea85$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$7c9a98b3f068686f;
    else if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$b356b51e8337a02f;
    else if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $afd6034f160dea85$export$559c3a78b4889350;
    return comparison;
}
function $afd6034f160dea85$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $afd6034f160dea85$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($afd6034f160dea85$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($afd6034f160dea85$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($afd6034f160dea85$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $afd6034f160dea85$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $afd6034f160dea85$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $afd6034f160dea85$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $afd6034f160dea85$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $45bc2fb468e2e427$var$_excluded = [
    "x",
    "y"
];
function $45bc2fb468e2e427$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $45bc2fb468e2e427$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $45bc2fb468e2e427$var$_typeof(o);
}
function $45bc2fb468e2e427$var$_extends() {
    $45bc2fb468e2e427$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45bc2fb468e2e427$var$_extends.apply(this, arguments);
}
function $45bc2fb468e2e427$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45bc2fb468e2e427$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45bc2fb468e2e427$var$ownKeys(Object(t), !0).forEach(function(r) {
            $45bc2fb468e2e427$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45bc2fb468e2e427$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45bc2fb468e2e427$var$_defineProperty(obj, key, value) {
    key = $45bc2fb468e2e427$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $45bc2fb468e2e427$var$_toPropertyKey(t) {
    var i = $45bc2fb468e2e427$var$_toPrimitive(t, "string");
    return "symbol" == $45bc2fb468e2e427$var$_typeof(i) ? i : i + "";
}
function $45bc2fb468e2e427$var$_toPrimitive(t, r) {
    if ("object" != $45bc2fb468e2e427$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $45bc2fb468e2e427$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $45bc2fb468e2e427$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $45bc2fb468e2e427$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $45bc2fb468e2e427$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $45bc2fb468e2e427$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $45bc2fb468e2e427$var$_objectWithoutProperties(_ref, $45bc2fb468e2e427$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread($45bc2fb468e2e427$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $45bc2fb468e2e427$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afd6034f160dea85$export$6428a7f2611ef1fa), $45bc2fb468e2e427$var$_extends({
        shapeType: "rectangle",
        propTransformer: $45bc2fb468e2e427$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $45bc2fb468e2e427$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $22b628c8ce89e32e$var$_excluded = [
    "value",
    "background"
];
var $22b628c8ce89e32e$var$_Bar;
function $22b628c8ce89e32e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $22b628c8ce89e32e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $22b628c8ce89e32e$var$_typeof(o);
}
function $22b628c8ce89e32e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $22b628c8ce89e32e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $22b628c8ce89e32e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $22b628c8ce89e32e$var$_extends() {
    $22b628c8ce89e32e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22b628c8ce89e32e$var$_extends.apply(this, arguments);
}
function $22b628c8ce89e32e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $22b628c8ce89e32e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $22b628c8ce89e32e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $22b628c8ce89e32e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $22b628c8ce89e32e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $22b628c8ce89e32e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $22b628c8ce89e32e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $22b628c8ce89e32e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $22b628c8ce89e32e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $22b628c8ce89e32e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $22b628c8ce89e32e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $22b628c8ce89e32e$var$_callSuper(t, o, e) {
    return o = $22b628c8ce89e32e$var$_getPrototypeOf(o), $22b628c8ce89e32e$var$_possibleConstructorReturn(t, $22b628c8ce89e32e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $22b628c8ce89e32e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $22b628c8ce89e32e$var$_possibleConstructorReturn(self, call) {
    if (call && ($22b628c8ce89e32e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $22b628c8ce89e32e$var$_assertThisInitialized(self);
}
function $22b628c8ce89e32e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $22b628c8ce89e32e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($22b628c8ce89e32e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $22b628c8ce89e32e$var$_getPrototypeOf(o) {
    $22b628c8ce89e32e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $22b628c8ce89e32e$var$_getPrototypeOf(o);
}
function $22b628c8ce89e32e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $22b628c8ce89e32e$var$_setPrototypeOf(subClass, superClass);
}
function $22b628c8ce89e32e$var$_setPrototypeOf(o, p) {
    $22b628c8ce89e32e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $22b628c8ce89e32e$var$_setPrototypeOf(o, p);
}
function $22b628c8ce89e32e$var$_defineProperty(obj, key, value) {
    key = $22b628c8ce89e32e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22b628c8ce89e32e$var$_toPropertyKey(t) {
    var i = $22b628c8ce89e32e$var$_toPrimitive(t, "string");
    return "symbol" == $22b628c8ce89e32e$var$_typeof(i) ? i : i + "";
}
function $22b628c8ce89e32e$var$_toPrimitive(t, r) {
    if ("object" != $22b628c8ce89e32e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $22b628c8ce89e32e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $22b628c8ce89e32e$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $22b628c8ce89e32e$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $22b628c8ce89e32e$var$_callSuper(this, Bar, [].concat(args));
        $22b628c8ce89e32e$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $22b628c8ce89e32e$var$_defineProperty(_this, "id", (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-bar-'));
        $22b628c8ce89e32e$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $22b628c8ce89e32e$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $22b628c8ce89e32e$var$_inherits(Bar, _PureComponent);
    return $22b628c8ce89e32e$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $22b628c8ce89e32e$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45bc2fb468e2e427$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $22b628c8ce89e32e$var$_objectWithoutProperties(entry, $22b628c8ce89e32e$var$_excluded);
                    if (!background) return null;
                    var props = $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45bc2fb468e2e427$export$f19074a6842f9217), $22b628c8ce89e32e$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $d05ab0383decc723$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $3cf1854128f2220f$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $acfa11ccf9405f16$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$22b628c8ce89e32e$var$_Bar = $22b628c8ce89e32e$export$bbc6c6369b38e3d1;
$22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $22b628c8ce89e32e$var$_defineProperty($22b628c8ce89e32e$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $3cf1854128f2220f$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $3cf1854128f2220f$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $3cf1854128f2220f$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $45bc2fb468e2e427$export$c20d73790de171f0)(minPointSizeProp, $22b628c8ce89e32e$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $3cf1854128f2220f$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $3cf1854128f2220f$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread($22b628c8ce89e32e$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $3cf1854128f2220f$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $22b628c8ce89e32e$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $7fPBF = parcelRequire("7fPBF");


var $746faafd58231d4f$exports = {};
var $123fee7279f334e2$exports = {};
var $5d261c45de2bf876$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5d261c45de2bf876$var$nativeCeil = Math.ceil, $5d261c45de2bf876$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5d261c45de2bf876$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5d261c45de2bf876$var$nativeMax($5d261c45de2bf876$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$5d261c45de2bf876$exports = $5d261c45de2bf876$var$baseRange;



var $118033994fa4fe34$exports = {};
var $027fc05d9ba60754$exports = {};
var $f49ef2e63e1337d0$exports = {};
var $6abb93fe126bbf26$exports = {};
/** Used to match a single whitespace character. */ var $6abb93fe126bbf26$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6abb93fe126bbf26$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6abb93fe126bbf26$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6abb93fe126bbf26$exports = $6abb93fe126bbf26$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $f49ef2e63e1337d0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $f49ef2e63e1337d0$var$baseTrim(string) {
    return string ? string.slice(0, $6abb93fe126bbf26$exports(string) + 1).replace($f49ef2e63e1337d0$var$reTrimStart, '') : string;
}
$f49ef2e63e1337d0$exports = $f49ef2e63e1337d0$var$baseTrim;




/** Used as references for various `Number` constants. */ var $027fc05d9ba60754$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $027fc05d9ba60754$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $027fc05d9ba60754$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $027fc05d9ba60754$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $027fc05d9ba60754$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $027fc05d9ba60754$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2fffc1449db40502$exports(value)) return $027fc05d9ba60754$var$NAN;
    if ($f328ff7ee4fde81a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f328ff7ee4fde81a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $f49ef2e63e1337d0$exports(value);
    var isBinary = $027fc05d9ba60754$var$reIsBinary.test(value);
    return isBinary || $027fc05d9ba60754$var$reIsOctal.test(value) ? $027fc05d9ba60754$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $027fc05d9ba60754$var$reIsBadHex.test(value) ? $027fc05d9ba60754$var$NAN : +value;
}
$027fc05d9ba60754$exports = $027fc05d9ba60754$var$toNumber;


/** Used as references for various `Number` constants. */ var $118033994fa4fe34$var$INFINITY = 1 / 0, $118033994fa4fe34$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $118033994fa4fe34$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $027fc05d9ba60754$exports(value);
    if (value === $118033994fa4fe34$var$INFINITY || value === -$118033994fa4fe34$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $118033994fa4fe34$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$118033994fa4fe34$exports = $118033994fa4fe34$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $123fee7279f334e2$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $18da533e307f2df0$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $118033994fa4fe34$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $118033994fa4fe34$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $118033994fa4fe34$exports(step);
        return $5d261c45de2bf876$exports(start, end, step, fromRight);
    };
}
$123fee7279f334e2$exports = $123fee7279f334e2$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $746faafd58231d4f$var$range = $123fee7279f334e2$exports();
$746faafd58231d4f$exports = $746faafd58231d4f$var$range;




var $932a0672a1772507$exports = {};
var $26dbabe73f482390$exports = {};

var $f76380021e37252e$exports = {};

var $1DySm = parcelRequire("1DySm");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f76380021e37252e$var$now = function() {
    return $1DySm.Date.now();
};
$f76380021e37252e$exports = $f76380021e37252e$var$now;



/** Error message constants. */ var $26dbabe73f482390$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $26dbabe73f482390$var$nativeMax = Math.max, $26dbabe73f482390$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $26dbabe73f482390$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($26dbabe73f482390$var$FUNC_ERROR_TEXT);
    wait = $027fc05d9ba60754$exports(wait) || 0;
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $26dbabe73f482390$var$nativeMax($027fc05d9ba60754$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $26dbabe73f482390$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f76380021e37252e$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f76380021e37252e$exports());
    }
    function debounced() {
        var time = $f76380021e37252e$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$26dbabe73f482390$exports = $26dbabe73f482390$var$debounce;



/** Error message constants. */ var $932a0672a1772507$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $932a0672a1772507$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($932a0672a1772507$var$FUNC_ERROR_TEXT);
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $26dbabe73f482390$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$932a0672a1772507$exports = $932a0672a1772507$var$throttle;







var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");




function $c818619936319da7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c818619936319da7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c818619936319da7$var$_typeof(o);
}
function $c818619936319da7$var$_extends() {
    $c818619936319da7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c818619936319da7$var$_extends.apply(this, arguments);
}
function $c818619936319da7$var$_slicedToArray(arr, i) {
    return $c818619936319da7$var$_arrayWithHoles(arr) || $c818619936319da7$var$_iterableToArrayLimit(arr, i) || $c818619936319da7$var$_unsupportedIterableToArray(arr, i) || $c818619936319da7$var$_nonIterableRest();
}
function $c818619936319da7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c818619936319da7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c818619936319da7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c818619936319da7$var$_arrayLikeToArray(o, minLen);
}
function $c818619936319da7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c818619936319da7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c818619936319da7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c818619936319da7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c818619936319da7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c818619936319da7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c818619936319da7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c818619936319da7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c818619936319da7$var$_defineProperty(obj, key, value) {
    key = $c818619936319da7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c818619936319da7$var$_toPropertyKey(t) {
    var i = $c818619936319da7$var$_toPrimitive(t, "string");
    return "symbol" == $c818619936319da7$var$_typeof(i) ? i : i + "";
}
function $c818619936319da7$var$_toPrimitive(t, r) {
    if ("object" != $c818619936319da7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c818619936319da7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c818619936319da7$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $ddf2636240ab70e2$export$402a499e1ea44294)(value[0]) && (0, $ddf2636240ab70e2$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $c818619936319da7$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $c818619936319da7$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $c818619936319da7$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c818619936319da7$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $ddf2636240ab70e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $ddf2636240ab70e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c818619936319da7$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $c818619936319da7$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", $c818619936319da7$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $7fPBF = parcelRequire("7fPBF");


function $96e9624e62a8a593$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $96e9624e62a8a593$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $96e9624e62a8a593$var$_typeof(o);
}
function $96e9624e62a8a593$var$_defineProperty(obj, key, value) {
    key = $96e9624e62a8a593$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96e9624e62a8a593$var$_toPropertyKey(t) {
    var i = $96e9624e62a8a593$var$_toPrimitive(t, "string");
    return "symbol" == $96e9624e62a8a593$var$_typeof(i) ? i : i + "";
}
function $96e9624e62a8a593$var$_toPrimitive(t, r) {
    if ("object" != $96e9624e62a8a593$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $96e9624e62a8a593$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $96e9624e62a8a593$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $96e9624e62a8a593$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $96e9624e62a8a593$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $07a883fe7c352c85$export$2e2bcd8739ae039)($96e9624e62a8a593$var$CSS_CLASS_PREFIX, $96e9624e62a8a593$var$_defineProperty($96e9624e62a8a593$var$_defineProperty($96e9624e62a8a593$var$_defineProperty($96e9624e62a8a593$var$_defineProperty({}, "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-right"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-left"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-bottom"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($96e9624e62a8a593$var$CSS_CLASS_PREFIX, "-top"), (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $96e9624e62a8a593$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $96e9624e62a8a593$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $96e9624e62a8a593$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $96e9624e62a8a593$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $96e9624e62a8a593$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $96e9624e62a8a593$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $96e9624e62a8a593$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $96e9624e62a8a593$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $769d2a0825780eed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $769d2a0825780eed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $769d2a0825780eed$var$_typeof(o);
}
function $769d2a0825780eed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $769d2a0825780eed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $769d2a0825780eed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $769d2a0825780eed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $769d2a0825780eed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $769d2a0825780eed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $769d2a0825780eed$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $769d2a0825780eed$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $769d2a0825780eed$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $769d2a0825780eed$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $769d2a0825780eed$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $769d2a0825780eed$var$_callSuper(t, o, e) {
    return o = $769d2a0825780eed$var$_getPrototypeOf(o), $769d2a0825780eed$var$_possibleConstructorReturn(t, $769d2a0825780eed$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $769d2a0825780eed$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $769d2a0825780eed$var$_possibleConstructorReturn(self, call) {
    if (call && ($769d2a0825780eed$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $769d2a0825780eed$var$_assertThisInitialized(self);
}
function $769d2a0825780eed$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $769d2a0825780eed$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($769d2a0825780eed$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $769d2a0825780eed$var$_getPrototypeOf(o) {
    $769d2a0825780eed$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $769d2a0825780eed$var$_getPrototypeOf(o);
}
function $769d2a0825780eed$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $769d2a0825780eed$var$_setPrototypeOf(subClass, superClass);
}
function $769d2a0825780eed$var$_setPrototypeOf(o, p) {
    $769d2a0825780eed$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $769d2a0825780eed$var$_setPrototypeOf(o, p);
}
function $769d2a0825780eed$var$_defineProperty(obj, key, value) {
    key = $769d2a0825780eed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $769d2a0825780eed$var$_toPropertyKey(t) {
    var i = $769d2a0825780eed$var$_toPrimitive(t, "string");
    return "symbol" == $769d2a0825780eed$var$_typeof(i) ? i : i + "";
}
function $769d2a0825780eed$var$_toPrimitive(t, r) {
    if ("object" != $769d2a0825780eed$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $769d2a0825780eed$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $769d2a0825780eed$var$EPSILON = 1;
var $769d2a0825780eed$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $769d2a0825780eed$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $769d2a0825780eed$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $769d2a0825780eed$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $769d2a0825780eed$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $769d2a0825780eed$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $769d2a0825780eed$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $769d2a0825780eed$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $769d2a0825780eed$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $96e9624e62a8a593$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $769d2a0825780eed$var$_objectSpread($769d2a0825780eed$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $7fPBF.PureComponent));




function $9fa097d1de474101$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9fa097d1de474101$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9fa097d1de474101$var$_typeof(o);
}
function $9fa097d1de474101$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fa097d1de474101$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fa097d1de474101$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9fa097d1de474101$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fa097d1de474101$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fa097d1de474101$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9fa097d1de474101$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9fa097d1de474101$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9fa097d1de474101$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9fa097d1de474101$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9fa097d1de474101$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9fa097d1de474101$var$_callSuper(t, o, e) {
    return o = $9fa097d1de474101$var$_getPrototypeOf(o), $9fa097d1de474101$var$_possibleConstructorReturn(t, $9fa097d1de474101$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9fa097d1de474101$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9fa097d1de474101$var$_possibleConstructorReturn(self, call) {
    if (call && ($9fa097d1de474101$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9fa097d1de474101$var$_assertThisInitialized(self);
}
function $9fa097d1de474101$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9fa097d1de474101$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9fa097d1de474101$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9fa097d1de474101$var$_getPrototypeOf(o) {
    $9fa097d1de474101$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9fa097d1de474101$var$_getPrototypeOf(o);
}
function $9fa097d1de474101$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9fa097d1de474101$var$_setPrototypeOf(subClass, superClass);
}
function $9fa097d1de474101$var$_setPrototypeOf(o, p) {
    $9fa097d1de474101$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9fa097d1de474101$var$_setPrototypeOf(o, p);
}
function $9fa097d1de474101$var$_defineProperty(obj, key, value) {
    key = $9fa097d1de474101$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9fa097d1de474101$var$_toPropertyKey(t) {
    var i = $9fa097d1de474101$var$_toPrimitive(t, "string");
    return "symbol" == $9fa097d1de474101$var$_typeof(i) ? i : i + "";
}
function $9fa097d1de474101$var$_toPrimitive(t, r) {
    if ("object" != $9fa097d1de474101$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9fa097d1de474101$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9fa097d1de474101$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $9fa097d1de474101$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c818619936319da7$export$6fe33945eebf9ac8), props);
}
var $9fa097d1de474101$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $9fa097d1de474101$var$_classCallCheck(this, Tooltip);
        return $9fa097d1de474101$var$_callSuper(this, Tooltip, arguments);
    }
    $9fa097d1de474101$var$_inherits(Tooltip, _PureComponent);
    return $9fa097d1de474101$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $9df57fcd3e3e7338$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $9fa097d1de474101$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $769d2a0825780eed$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $9fa097d1de474101$var$renderContent(content, $9fa097d1de474101$var$_objectSpread($9fa097d1de474101$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$9fa097d1de474101$var$_defineProperty($9fa097d1de474101$export$28c660c63b792dea, "displayName", 'Tooltip');
$9fa097d1de474101$var$_defineProperty($9fa097d1de474101$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $7fPBF = parcelRequire("7fPBF");



function $22ef29953161e37f$var$_extends() {
    $22ef29953161e37f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22ef29953161e37f$var$_extends.apply(this, arguments);
}
var $22ef29953161e37f$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", $22ef29953161e37f$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, false), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $7fPBF = parcelRequire("7fPBF");








function $f1c27aa6db6af3a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1c27aa6db6af3a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1c27aa6db6af3a8$var$_typeof(o);
}
function $f1c27aa6db6af3a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1c27aa6db6af3a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1c27aa6db6af3a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f1c27aa6db6af3a8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1c27aa6db6af3a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1c27aa6db6af3a8$var$_defineProperty(obj, key, value) {
    key = $f1c27aa6db6af3a8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f1c27aa6db6af3a8$var$_toPropertyKey(t) {
    var i = $f1c27aa6db6af3a8$var$_toPrimitive(t, "string");
    return "symbol" == $f1c27aa6db6af3a8$var$_typeof(i) ? i : i + "";
}
function $f1c27aa6db6af3a8$var$_toPrimitive(t, r) {
    if ("object" != $f1c27aa6db6af3a8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f1c27aa6db6af3a8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f1c27aa6db6af3a8$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $f1c27aa6db6af3a8$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $f1c27aa6db6af3a8$var$PREFIX_LIST.reduce(function(res, entry) {
        return $f1c27aa6db6af3a8$var$_objectSpread($f1c27aa6db6af3a8$var$_objectSpread({}, res), {}, $f1c27aa6db6af3a8$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $292adb4d61b7aa4f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $292adb4d61b7aa4f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $292adb4d61b7aa4f$var$_typeof(o);
}
function $292adb4d61b7aa4f$var$_extends() {
    $292adb4d61b7aa4f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $292adb4d61b7aa4f$var$_extends.apply(this, arguments);
}
function $292adb4d61b7aa4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $292adb4d61b7aa4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $292adb4d61b7aa4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $292adb4d61b7aa4f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $292adb4d61b7aa4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $292adb4d61b7aa4f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $292adb4d61b7aa4f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $292adb4d61b7aa4f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $292adb4d61b7aa4f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $292adb4d61b7aa4f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $292adb4d61b7aa4f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $292adb4d61b7aa4f$var$_callSuper(t, o, e) {
    return o = $292adb4d61b7aa4f$var$_getPrototypeOf(o), $292adb4d61b7aa4f$var$_possibleConstructorReturn(t, $292adb4d61b7aa4f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $292adb4d61b7aa4f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $292adb4d61b7aa4f$var$_possibleConstructorReturn(self, call) {
    if (call && ($292adb4d61b7aa4f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $292adb4d61b7aa4f$var$_assertThisInitialized(self);
}
function $292adb4d61b7aa4f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $292adb4d61b7aa4f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($292adb4d61b7aa4f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $292adb4d61b7aa4f$var$_getPrototypeOf(o) {
    $292adb4d61b7aa4f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $292adb4d61b7aa4f$var$_getPrototypeOf(o);
}
function $292adb4d61b7aa4f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $292adb4d61b7aa4f$var$_setPrototypeOf(subClass, superClass);
}
function $292adb4d61b7aa4f$var$_setPrototypeOf(o, p) {
    $292adb4d61b7aa4f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $292adb4d61b7aa4f$var$_setPrototypeOf(o, p);
}
function $292adb4d61b7aa4f$var$_defineProperty(obj, key, value) {
    key = $292adb4d61b7aa4f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $292adb4d61b7aa4f$var$_toPropertyKey(t) {
    var i = $292adb4d61b7aa4f$var$_toPrimitive(t, "string");
    return "symbol" == $292adb4d61b7aa4f$var$_typeof(i) ? i : i + "";
}
function $292adb4d61b7aa4f$var$_toPrimitive(t, r) {
    if ("object" != $292adb4d61b7aa4f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $292adb4d61b7aa4f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $292adb4d61b7aa4f$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $88853d08cf75746a$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($746faafd58231d4f$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $292adb4d61b7aa4f$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $292adb4d61b7aa4f$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $292adb4d61b7aa4f$var$_classCallCheck(this, Brush);
        _this = $292adb4d61b7aa4f$var$_callSuper(this, Brush, [
            props
        ]);
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $292adb4d61b7aa4f$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $292adb4d61b7aa4f$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $292adb4d61b7aa4f$var$_inherits(Brush, _PureComponent);
    return $292adb4d61b7aa4f$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $292adb4d61b7aa4f$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($292adb4d61b7aa4f$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $7fPBF.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $292adb4d61b7aa4f$var$_objectSpread($292adb4d61b7aa4f$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $292adb4d61b7aa4f$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $292adb4d61b7aa4f$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.count(children) === 1;
                var style = (0, $f1c27aa6db6af3a8$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $292adb4d61b7aa4f$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $292adb4d61b7aa4f$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$export$59bc2e3533b384a0, "displayName", 'Brush');
$292adb4d61b7aa4f$var$_defineProperty($292adb4d61b7aa4f$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $7fPBF = parcelRequire("7fPBF");






var $bbc849e695f215a7$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $e61aa1d139b3436b$exports = {};
var $21a9c399fabc76fe$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $21a9c399fabc76fe$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $25e57808ab068dc5$exports) $25e57808ab068dc5$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$21a9c399fabc76fe$exports = $21a9c399fabc76fe$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $e61aa1d139b3436b$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bf70b66c162aef31$exports(iteratee, 3);
    $feac72adfe18f958$exports(object, function(value, key, object) {
        $21a9c399fabc76fe$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$e61aa1d139b3436b$exports = $e61aa1d139b3436b$var$mapValues;


var $0da8bb8451843eb0$exports = {};
var $6a0024f6b490a781$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $6a0024f6b490a781$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$6a0024f6b490a781$exports = $6a0024f6b490a781$var$arrayEvery;


var $67e7b433c1d91230$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $67e7b433c1d91230$var$baseEvery(collection, predicate) {
    var result = true;
    $7ebb68e7a3797e10$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$67e7b433c1d91230$exports = $67e7b433c1d91230$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $0da8bb8451843eb0$var$every(collection, predicate, guard) {
    var func = $579b9ba2588bb9de$exports(collection) ? $6a0024f6b490a781$exports : $67e7b433c1d91230$exports;
    if (guard && $18da533e307f2df0$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bf70b66c162aef31$exports(predicate, 3));
}
$0da8bb8451843eb0$exports = $0da8bb8451843eb0$var$every;






function $251e5258b398e2e1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $251e5258b398e2e1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $251e5258b398e2e1$var$_typeof(o);
}
function $251e5258b398e2e1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $251e5258b398e2e1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $251e5258b398e2e1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $251e5258b398e2e1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $251e5258b398e2e1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $251e5258b398e2e1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $251e5258b398e2e1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $251e5258b398e2e1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $251e5258b398e2e1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $251e5258b398e2e1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $251e5258b398e2e1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $251e5258b398e2e1$var$_defineProperty(obj, key, value) {
    key = $251e5258b398e2e1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $251e5258b398e2e1$var$_toPropertyKey(t) {
    var i = $251e5258b398e2e1$var$_toPrimitive(t, "string");
    return "symbol" == $251e5258b398e2e1$var$_typeof(i) ? i : i + "";
}
function $251e5258b398e2e1$var$_toPrimitive(t, r) {
    if ("object" != $251e5258b398e2e1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $251e5258b398e2e1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $251e5258b398e2e1$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $3cf1854128f2220f$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $3cf1854128f2220f$export$9d80152e23bae434)(scale);
        var ticks = (0, $3cf1854128f2220f$export$ac086aaa4358d590)(scale, $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, result), {}, $251e5258b398e2e1$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $251e5258b398e2e1$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $251e5258b398e2e1$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $251e5258b398e2e1$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $251e5258b398e2e1$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $251e5258b398e2e1$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $251e5258b398e2e1$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$251e5258b398e2e1$var$_defineProperty($251e5258b398e2e1$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $251e5258b398e2e1$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, res), {}, $251e5258b398e2e1$var$_defineProperty({}, key, $251e5258b398e2e1$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $251e5258b398e2e1$var$_objectSpread($251e5258b398e2e1$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($e61aa1d139b3436b$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($0da8bb8451843eb0$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $251e5258b398e2e1$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $251e5258b398e2e1$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $251e5258b398e2e1$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $f8879ac5aef728e5$var$_extends() {
    $f8879ac5aef728e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8879ac5aef728e5$var$_extends.apply(this, arguments);
}
function $f8879ac5aef728e5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f8879ac5aef728e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f8879ac5aef728e5$var$_typeof(o);
}
function $f8879ac5aef728e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8879ac5aef728e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8879ac5aef728e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f8879ac5aef728e5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8879ac5aef728e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8879ac5aef728e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f8879ac5aef728e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f8879ac5aef728e5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f8879ac5aef728e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f8879ac5aef728e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f8879ac5aef728e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f8879ac5aef728e5$var$_callSuper(t, o, e) {
    return o = $f8879ac5aef728e5$var$_getPrototypeOf(o), $f8879ac5aef728e5$var$_possibleConstructorReturn(t, $f8879ac5aef728e5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f8879ac5aef728e5$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f8879ac5aef728e5$var$_possibleConstructorReturn(self, call) {
    if (call && ($f8879ac5aef728e5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f8879ac5aef728e5$var$_assertThisInitialized(self);
}
function $f8879ac5aef728e5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f8879ac5aef728e5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f8879ac5aef728e5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f8879ac5aef728e5$var$_getPrototypeOf(o) {
    $f8879ac5aef728e5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f8879ac5aef728e5$var$_getPrototypeOf(o);
}
function $f8879ac5aef728e5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f8879ac5aef728e5$var$_setPrototypeOf(subClass, superClass);
}
function $f8879ac5aef728e5$var$_setPrototypeOf(o, p) {
    $f8879ac5aef728e5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f8879ac5aef728e5$var$_setPrototypeOf(o, p);
}
function $f8879ac5aef728e5$var$_defineProperty(obj, key, value) {
    key = $f8879ac5aef728e5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f8879ac5aef728e5$var$_toPropertyKey(t) {
    var i = $f8879ac5aef728e5$var$_toPrimitive(t, "string");
    return "symbol" == $f8879ac5aef728e5$var$_typeof(i) ? i : i + "";
}
function $f8879ac5aef728e5$var$_toPrimitive(t, r) {
    if ("object" != $f8879ac5aef728e5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f8879ac5aef728e5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f8879ac5aef728e5$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $f8879ac5aef728e5$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $f8879ac5aef728e5$var$_classCallCheck(this, ReferenceDot);
        return $f8879ac5aef728e5$var$_callSuper(this, ReferenceDot, arguments);
    }
    $f8879ac5aef728e5$var$_inherits(ReferenceDot, _React$Component);
    return $f8879ac5aef728e5$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x);
                var isY = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y);
                (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $f8879ac5aef728e5$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $f8879ac5aef728e5$var$_objectSpread($f8879ac5aef728e5$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f8879ac5aef728e5$var$_defineProperty($f8879ac5aef728e5$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$f8879ac5aef728e5$var$_defineProperty($f8879ac5aef728e5$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$f8879ac5aef728e5$var$_defineProperty($f8879ac5aef728e5$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), $f8879ac5aef728e5$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $7fPBF = parcelRequire("7fPBF");

var $80aaf1d1976e2382$exports = {};


var $6a0169940d676f74$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6a0169940d676f74$var$baseSome(collection, predicate) {
    var result;
    $7ebb68e7a3797e10$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$6a0169940d676f74$exports = $6a0169940d676f74$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $80aaf1d1976e2382$var$some(collection, predicate, guard) {
    var func = $579b9ba2588bb9de$exports(collection) ? $c264d15e7c8deb78$exports : $6a0169940d676f74$exports;
    if (guard && $18da533e307f2df0$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bf70b66c162aef31$exports(predicate, 3));
}
$80aaf1d1976e2382$exports = $80aaf1d1976e2382$var$some;











var $7fPBF = parcelRequire("7fPBF");

var $8bd234d452d44638$exports = {};
var $2fdbe5396c2972f7$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $2fdbe5396c2972f7$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$4506257970d5c979$exports(collection)) {
            var iteratee = $bf70b66c162aef31$exports(predicate, 3);
            collection = $0fce4239ee480ef0$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$2fdbe5396c2972f7$exports = $2fdbe5396c2972f7$var$createFind;


var $ecdaa0cd5b991459$exports = {};


var $e2aafdf5f9953a01$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $e2aafdf5f9953a01$var$toInteger(value) {
    var result = $118033994fa4fe34$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$e2aafdf5f9953a01$exports = $e2aafdf5f9953a01$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $ecdaa0cd5b991459$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ecdaa0cd5b991459$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $e2aafdf5f9953a01$exports(fromIndex);
    if (index < 0) index = $ecdaa0cd5b991459$var$nativeMax(length + index, 0);
    return $45fe5e20b6ff07af$exports(array, $bf70b66c162aef31$exports(predicate, 3), index);
}
$ecdaa0cd5b991459$exports = $ecdaa0cd5b991459$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $8bd234d452d44638$var$find = $2fdbe5396c2972f7$exports($ecdaa0cd5b991459$exports);
$8bd234d452d44638$exports = $8bd234d452d44638$var$find;




var $280df0a24c8adb37$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($5021746db8365e7e$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $d5acdec35ed0a35a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5acdec35ed0a35a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5acdec35ed0a35a$var$_typeof(o);
}
var $d5acdec35ed0a35a$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$482c85f2026f212e = /*#__PURE__*/ (0, $7fPBF.createContext)({});
var $d5acdec35ed0a35a$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $d5acdec35ed0a35a$export$b18854f928720bc8 = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $d5acdec35ed0a35a$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $d5acdec35ed0a35a$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $280df0a24c8adb37$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d5acdec35ed0a35a$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $d5acdec35ed0a35a$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$e42cfe3f3988c70f);
};
function $d5acdec35ed0a35a$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $d5acdec35ed0a35a$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $d5acdec35ed0a35a$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$92c2a2c8239475bf);
    return (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(xAxisMap);
};
var $d5acdec35ed0a35a$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$40ceabe61e17c4dc);
    return (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(yAxisMap);
};
var $d5acdec35ed0a35a$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($8bd234d452d44638$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0da8bb8451843eb0$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(yAxisMap);
};
var $d5acdec35ed0a35a$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $d5acdec35ed0a35a$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$29b7735f8b5653b2);
    return viewBox;
};
var $d5acdec35ed0a35a$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$482c85f2026f212e);
};
var $d5acdec35ed0a35a$export$8854f7ece606854b = function useChartWidth() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$3c3f0c9338cf7530);
};
var $d5acdec35ed0a35a$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $7fPBF.useContext)($d5acdec35ed0a35a$export$b18854f928720bc8);
};


function $bdc92f1f1adb58de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bdc92f1f1adb58de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bdc92f1f1adb58de$var$_typeof(o);
}
function $bdc92f1f1adb58de$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bdc92f1f1adb58de$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bdc92f1f1adb58de$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bdc92f1f1adb58de$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bdc92f1f1adb58de$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bdc92f1f1adb58de$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bdc92f1f1adb58de$var$_callSuper(t, o, e) {
    return o = $bdc92f1f1adb58de$var$_getPrototypeOf(o), $bdc92f1f1adb58de$var$_possibleConstructorReturn(t, $bdc92f1f1adb58de$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $bdc92f1f1adb58de$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $bdc92f1f1adb58de$var$_possibleConstructorReturn(self, call) {
    if (call && ($bdc92f1f1adb58de$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bdc92f1f1adb58de$var$_assertThisInitialized(self);
}
function $bdc92f1f1adb58de$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bdc92f1f1adb58de$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bdc92f1f1adb58de$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bdc92f1f1adb58de$var$_getPrototypeOf(o) {
    $bdc92f1f1adb58de$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bdc92f1f1adb58de$var$_getPrototypeOf(o);
}
function $bdc92f1f1adb58de$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bdc92f1f1adb58de$var$_setPrototypeOf(subClass, superClass);
}
function $bdc92f1f1adb58de$var$_setPrototypeOf(o, p) {
    $bdc92f1f1adb58de$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bdc92f1f1adb58de$var$_setPrototypeOf(o, p);
}
function $bdc92f1f1adb58de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bdc92f1f1adb58de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bdc92f1f1adb58de$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bdc92f1f1adb58de$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bdc92f1f1adb58de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bdc92f1f1adb58de$var$_defineProperty(obj, key, value) {
    key = $bdc92f1f1adb58de$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bdc92f1f1adb58de$var$_toPropertyKey(t) {
    var i = $bdc92f1f1adb58de$var$_toPrimitive(t, "string");
    return "symbol" == $bdc92f1f1adb58de$var$_typeof(i) ? i : i + "";
}
function $bdc92f1f1adb58de$var$_toPrimitive(t, r) {
    if ("object" != $bdc92f1f1adb58de$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bdc92f1f1adb58de$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bdc92f1f1adb58de$var$_slicedToArray(arr, i) {
    return $bdc92f1f1adb58de$var$_arrayWithHoles(arr) || $bdc92f1f1adb58de$var$_iterableToArrayLimit(arr, i) || $bdc92f1f1adb58de$var$_unsupportedIterableToArray(arr, i) || $bdc92f1f1adb58de$var$_nonIterableRest();
}
function $bdc92f1f1adb58de$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bdc92f1f1adb58de$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bdc92f1f1adb58de$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bdc92f1f1adb58de$var$_arrayLikeToArray(o, minLen);
}
function $bdc92f1f1adb58de$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bdc92f1f1adb58de$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bdc92f1f1adb58de$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bdc92f1f1adb58de$var$_extends() {
    $bdc92f1f1adb58de$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdc92f1f1adb58de$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $bdc92f1f1adb58de$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $bdc92f1f1adb58de$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $bdc92f1f1adb58de$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($80aaf1d1976e2382$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $bdc92f1f1adb58de$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $d5acdec35ed0a35a$export$71e825c43eae6ca6)();
    var xAxis = (0, $d5acdec35ed0a35a$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $d5acdec35ed0a35a$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $d5acdec35ed0a35a$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(fixedX);
    var isY = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $bdc92f1f1adb58de$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $bdc92f1f1adb58de$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $bdc92f1f1adb58de$var$_objectSpread($bdc92f1f1adb58de$var$_objectSpread({
        clipPath: clipPath
    }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $bdc92f1f1adb58de$var$renderLine(shape, lineProps), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(props, (0, $251e5258b398e2e1$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $bdc92f1f1adb58de$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $bdc92f1f1adb58de$var$_classCallCheck(this, ReferenceLine);
        return $bdc92f1f1adb58de$var$_callSuper(this, ReferenceLine, arguments);
    }
    $bdc92f1f1adb58de$var$_inherits(ReferenceLine, _React$Component);
    return $bdc92f1f1adb58de$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($bdc92f1f1adb58de$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$bdc92f1f1adb58de$var$_defineProperty($bdc92f1f1adb58de$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$bdc92f1f1adb58de$var$_defineProperty($bdc92f1f1adb58de$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $7fPBF = parcelRequire("7fPBF");










function $71c3f9de86e5dd82$var$_extends() {
    $71c3f9de86e5dd82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71c3f9de86e5dd82$var$_extends.apply(this, arguments);
}
function $71c3f9de86e5dd82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71c3f9de86e5dd82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71c3f9de86e5dd82$var$_typeof(o);
}
function $71c3f9de86e5dd82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71c3f9de86e5dd82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71c3f9de86e5dd82$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71c3f9de86e5dd82$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71c3f9de86e5dd82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71c3f9de86e5dd82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $71c3f9de86e5dd82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $71c3f9de86e5dd82$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $71c3f9de86e5dd82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $71c3f9de86e5dd82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $71c3f9de86e5dd82$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $71c3f9de86e5dd82$var$_callSuper(t, o, e) {
    return o = $71c3f9de86e5dd82$var$_getPrototypeOf(o), $71c3f9de86e5dd82$var$_possibleConstructorReturn(t, $71c3f9de86e5dd82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $71c3f9de86e5dd82$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $71c3f9de86e5dd82$var$_possibleConstructorReturn(self, call) {
    if (call && ($71c3f9de86e5dd82$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $71c3f9de86e5dd82$var$_assertThisInitialized(self);
}
function $71c3f9de86e5dd82$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $71c3f9de86e5dd82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($71c3f9de86e5dd82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $71c3f9de86e5dd82$var$_getPrototypeOf(o) {
    $71c3f9de86e5dd82$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $71c3f9de86e5dd82$var$_getPrototypeOf(o);
}
function $71c3f9de86e5dd82$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $71c3f9de86e5dd82$var$_setPrototypeOf(subClass, superClass);
}
function $71c3f9de86e5dd82$var$_setPrototypeOf(o, p) {
    $71c3f9de86e5dd82$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $71c3f9de86e5dd82$var$_setPrototypeOf(o, p);
}
function $71c3f9de86e5dd82$var$_defineProperty(obj, key, value) {
    key = $71c3f9de86e5dd82$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71c3f9de86e5dd82$var$_toPropertyKey(t) {
    var i = $71c3f9de86e5dd82$var$_toPrimitive(t, "string");
    return "symbol" == $71c3f9de86e5dd82$var$_typeof(i) ? i : i + "";
}
function $71c3f9de86e5dd82$var$_toPrimitive(t, r) {
    if ("object" != $71c3f9de86e5dd82$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $71c3f9de86e5dd82$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $71c3f9de86e5dd82$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $251e5258b398e2e1$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $bbc849e695f215a7$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $251e5258b398e2e1$export$c7964a5b9439ae62)(p1, p2);
};
var $71c3f9de86e5dd82$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $71c3f9de86e5dd82$var$_classCallCheck(this, ReferenceArea);
        return $71c3f9de86e5dd82$var$_callSuper(this, ReferenceArea, arguments);
    }
    $71c3f9de86e5dd82$var$_inherits(ReferenceArea, _React$Component);
    return $71c3f9de86e5dd82$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $ddf2636240ab70e2$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $71c3f9de86e5dd82$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $bbc849e695f215a7$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $71c3f9de86e5dd82$var$_objectSpread($71c3f9de86e5dd82$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$71c3f9de86e5dd82$var$_defineProperty($71c3f9de86e5dd82$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$71c3f9de86e5dd82$var$_defineProperty($71c3f9de86e5dd82$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$71c3f9de86e5dd82$var$_defineProperty($71c3f9de86e5dd82$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd9e03c5c06a0d41$export$4617fb02663045ef), $71c3f9de86e5dd82$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $0fbc7216156df216$var$_toConsumableArray(arr) {
    return $0fbc7216156df216$var$_arrayWithoutHoles(arr) || $0fbc7216156df216$var$_iterableToArray(arr) || $0fbc7216156df216$var$_unsupportedIterableToArray(arr) || $0fbc7216156df216$var$_nonIterableSpread();
}
function $0fbc7216156df216$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0fbc7216156df216$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0fbc7216156df216$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0fbc7216156df216$var$_arrayLikeToArray(o, minLen);
}
function $0fbc7216156df216$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0fbc7216156df216$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0fbc7216156df216$var$_arrayLikeToArray(arr);
}
function $0fbc7216156df216$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0fbc7216156df216$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $bdc92f1f1adb58de$export$b2f28e248e7838eb));
    var dots = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $f8879ac5aef728e5$export$aa7f0b0106bff39));
    var elements = [].concat($0fbc7216156df216$var$_toConsumableArray(lines), $0fbc7216156df216$var$_toConsumableArray(dots));
    var areas = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $71c3f9de86e5dd82$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $bbc849e695f215a7$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $bbc849e695f215a7$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[key1]) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $53c193f0ccf044aa$exports = {};
'use strict';
var $53c193f0ccf044aa$var$has = Object.prototype.hasOwnProperty, $53c193f0ccf044aa$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $53c193f0ccf044aa$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $53c193f0ccf044aa$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $53c193f0ccf044aa$var$Events().__proto__) $53c193f0ccf044aa$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $53c193f0ccf044aa$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $53c193f0ccf044aa$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $53c193f0ccf044aa$var$EE(fn, context || emitter, once), evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $53c193f0ccf044aa$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $53c193f0ccf044aa$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $53c193f0ccf044aa$var$EventEmitter() {
    this._events = new $53c193f0ccf044aa$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($53c193f0ccf044aa$var$has.call(events, name)) names.push($53c193f0ccf044aa$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $53c193f0ccf044aa$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $53c193f0ccf044aa$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $53c193f0ccf044aa$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $53c193f0ccf044aa$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $53c193f0ccf044aa$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $53c193f0ccf044aa$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $53c193f0ccf044aa$var$prefix ? $53c193f0ccf044aa$var$prefix + event : event;
        if (this._events[evt]) $53c193f0ccf044aa$var$clearEvent(this, evt);
    } else {
        this._events = new $53c193f0ccf044aa$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$53c193f0ccf044aa$var$EventEmitter.prototype.off = $53c193f0ccf044aa$var$EventEmitter.prototype.removeListener;
$53c193f0ccf044aa$var$EventEmitter.prototype.addListener = $53c193f0ccf044aa$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$53c193f0ccf044aa$var$EventEmitter.prefixed = $53c193f0ccf044aa$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$53c193f0ccf044aa$var$EventEmitter.EventEmitter = $53c193f0ccf044aa$var$EventEmitter;
$53c193f0ccf044aa$exports = $53c193f0ccf044aa$var$EventEmitter;


var $6164c1f84130ff0f$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($53c193f0ccf044aa$exports)))();
var $6164c1f84130ff0f$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $4171429008abae73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4171429008abae73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4171429008abae73$var$_typeof(o);
}
function $4171429008abae73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4171429008abae73$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4171429008abae73$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4171429008abae73$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4171429008abae73$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4171429008abae73$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4171429008abae73$var$_defineProperty(obj, key, value) {
    key = $4171429008abae73$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4171429008abae73$var$_toPropertyKey(t) {
    var i = $4171429008abae73$var$_toPrimitive(t, "string");
    return "symbol" == $4171429008abae73$var$_typeof(i) ? i : i + "";
}
function $4171429008abae73$var$_toPrimitive(t, r) {
    if ("object" != $4171429008abae73$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4171429008abae73$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4171429008abae73$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $4171429008abae73$var$_classCallCheck(this, AccessibilityManager);
        $4171429008abae73$var$_defineProperty(this, "activeIndex", 0);
        $4171429008abae73$var$_defineProperty(this, "coordinateList", []);
        $4171429008abae73$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $4171429008abae73$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $d741426732739030$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domainStart) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");







function $24f9e03e793c5e59$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24f9e03e793c5e59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24f9e03e793c5e59$var$_typeof(o);
}
function $24f9e03e793c5e59$var$_extends() {
    $24f9e03e793c5e59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24f9e03e793c5e59$var$_extends.apply(this, arguments);
}
function $24f9e03e793c5e59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24f9e03e793c5e59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24f9e03e793c5e59$var$ownKeys(Object(t), !0).forEach(function(r) {
            $24f9e03e793c5e59$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24f9e03e793c5e59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24f9e03e793c5e59$var$_defineProperty(obj, key, value) {
    key = $24f9e03e793c5e59$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24f9e03e793c5e59$var$_toPropertyKey(t) {
    var i = $24f9e03e793c5e59$var$_toPrimitive(t, "string");
    return "symbol" == $24f9e03e793c5e59$var$_typeof(i) ? i : i + "";
}
function $24f9e03e793c5e59$var$_toPrimitive(t, r) {
    if ("object" != $24f9e03e793c5e59$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $24f9e03e793c5e59$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $24f9e03e793c5e59$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $922af94be54ea802$exports.curveBasisClosed),
    curveBasisOpen: (0, $922af94be54ea802$exports.curveBasisOpen),
    curveBasis: (0, $922af94be54ea802$exports.curveBasis),
    curveBumpX: (0, $922af94be54ea802$exports.curveBumpX),
    curveBumpY: (0, $922af94be54ea802$exports.curveBumpY),
    curveLinearClosed: (0, $922af94be54ea802$exports.curveLinearClosed),
    curveLinear: (0, $922af94be54ea802$exports.curveLinear),
    curveMonotoneX: (0, $922af94be54ea802$exports.curveMonotoneX),
    curveMonotoneY: (0, $922af94be54ea802$exports.curveMonotoneY),
    curveNatural: (0, $922af94be54ea802$exports.curveNatural),
    curveStep: (0, $922af94be54ea802$exports.curveStep),
    curveStepAfter: (0, $922af94be54ea802$exports.curveStepAfter),
    curveStepBefore: (0, $922af94be54ea802$exports.curveStepBefore)
};
var $24f9e03e793c5e59$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $24f9e03e793c5e59$var$getX = function getX(p) {
    return p.x;
};
var $24f9e03e793c5e59$var$getY = function getY(p) {
    return p.y;
};
var $24f9e03e793c5e59$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($1557215ae053272d$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $24f9e03e793c5e59$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $24f9e03e793c5e59$var$CURVE_FACTORIES[name] || (0, $922af94be54ea802$exports.curveLinear);
};
var $24f9e03e793c5e59$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $24f9e03e793c5e59$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $24f9e03e793c5e59$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $24f9e03e793c5e59$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $24f9e03e793c5e59$var$_objectSpread($24f9e03e793c5e59$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $922af94be54ea802$exports.area)().y($24f9e03e793c5e59$var$getY).x1($24f9e03e793c5e59$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $922af94be54ea802$exports.area)().x($24f9e03e793c5e59$var$getX).y1($24f9e03e793c5e59$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($24f9e03e793c5e59$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $922af94be54ea802$exports.area)().y($24f9e03e793c5e59$var$getY).x1($24f9e03e793c5e59$var$getX).x0(baseLine);
    else if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $922af94be54ea802$exports.area)().x($24f9e03e793c5e59$var$getX).y1($24f9e03e793c5e59$var$getY).y0(baseLine);
    else lineFunction = (0, $922af94be54ea802$exports.line)().x($24f9e03e793c5e59$var$getX).y($24f9e03e793c5e59$var$getY);
    lineFunction.defined($24f9e03e793c5e59$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $24f9e03e793c5e59$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $24f9e03e793c5e59$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $24f9e03e793c5e59$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, false), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $7fPBF = parcelRequire("7fPBF");



function $4f194ae349c46227$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4f194ae349c46227$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4f194ae349c46227$var$_typeof(o);
}
var $4f194ae349c46227$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $4f194ae349c46227$var$_extends() {
    $4f194ae349c46227$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f194ae349c46227$var$_extends.apply(this, arguments);
}
function $4f194ae349c46227$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f194ae349c46227$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f194ae349c46227$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4f194ae349c46227$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f194ae349c46227$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f194ae349c46227$var$_defineProperty(obj, key, value) {
    key = $4f194ae349c46227$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f194ae349c46227$var$_toPropertyKey(t) {
    var i = $4f194ae349c46227$var$_toPrimitive(t, "string");
    return "symbol" == $4f194ae349c46227$var$_typeof(i) ? i : i + "";
}
function $4f194ae349c46227$var$_toPrimitive(t, r) {
    if ("object" != $4f194ae349c46227$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4f194ae349c46227$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4f194ae349c46227$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4f194ae349c46227$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4f194ae349c46227$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4f194ae349c46227$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $4f194ae349c46227$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $4f194ae349c46227$var$_objectWithoutProperties(_ref, $4f194ae349c46227$var$_excluded);
    var props = $4f194ae349c46227$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(top) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $4f194ae349c46227$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(props, true), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $4f194ae349c46227$var$getPath(x, y, width, height, top, left)
    }));
};


function $adddd1a311f8ef99$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $97c1bd3db26bd446$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $fbd7d93a2a8fab77$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $97c1bd3db26bd446$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $ec94bb69d25a9f22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec94bb69d25a9f22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec94bb69d25a9f22$var$_typeof(o);
}
function $ec94bb69d25a9f22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec94bb69d25a9f22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec94bb69d25a9f22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec94bb69d25a9f22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec94bb69d25a9f22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec94bb69d25a9f22$var$_defineProperty(obj, key, value) {
    key = $ec94bb69d25a9f22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec94bb69d25a9f22$var$_toPropertyKey(t) {
    var i = $ec94bb69d25a9f22$var$_toPrimitive(t, "string");
    return "symbol" == $ec94bb69d25a9f22$var$_typeof(i) ? i : i + "";
}
function $ec94bb69d25a9f22$var$_toPrimitive(t, r) {
    if ("object" != $ec94bb69d25a9f22$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ec94bb69d25a9f22$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec94bb69d25a9f22$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $4f194ae349c46227$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $adddd1a311f8ef99$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $dd9e03c5c06a0d41$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $97c1bd3db26bd446$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $dd92401041fdb928$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $fbd7d93a2a8fab77$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread($ec94bb69d25a9f22$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $7fPBF.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $7fPBF.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $7fPBF.createElement)(cursorComp, cursorProps);
}



var $331f71c4500fe679$var$_excluded = [
    "item"
], $331f71c4500fe679$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $331f71c4500fe679$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $331f71c4500fe679$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $331f71c4500fe679$var$_typeof(o);
}
function $331f71c4500fe679$var$_extends() {
    $331f71c4500fe679$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $331f71c4500fe679$var$_extends.apply(this, arguments);
}
function $331f71c4500fe679$var$_slicedToArray(arr, i) {
    return $331f71c4500fe679$var$_arrayWithHoles(arr) || $331f71c4500fe679$var$_iterableToArrayLimit(arr, i) || $331f71c4500fe679$var$_unsupportedIterableToArray(arr, i) || $331f71c4500fe679$var$_nonIterableRest();
}
function $331f71c4500fe679$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $331f71c4500fe679$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $331f71c4500fe679$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $331f71c4500fe679$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $331f71c4500fe679$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $331f71c4500fe679$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $331f71c4500fe679$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $331f71c4500fe679$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $331f71c4500fe679$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $331f71c4500fe679$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $331f71c4500fe679$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $331f71c4500fe679$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $331f71c4500fe679$var$_callSuper(t, o, e) {
    return o = $331f71c4500fe679$var$_getPrototypeOf(o), $331f71c4500fe679$var$_possibleConstructorReturn(t, $331f71c4500fe679$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $331f71c4500fe679$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $331f71c4500fe679$var$_possibleConstructorReturn(self, call) {
    if (call && ($331f71c4500fe679$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $331f71c4500fe679$var$_assertThisInitialized(self);
}
function $331f71c4500fe679$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $331f71c4500fe679$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($331f71c4500fe679$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $331f71c4500fe679$var$_getPrototypeOf(o) {
    $331f71c4500fe679$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $331f71c4500fe679$var$_getPrototypeOf(o);
}
function $331f71c4500fe679$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $331f71c4500fe679$var$_setPrototypeOf(subClass, superClass);
}
function $331f71c4500fe679$var$_setPrototypeOf(o, p) {
    $331f71c4500fe679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $331f71c4500fe679$var$_setPrototypeOf(o, p);
}
function $331f71c4500fe679$var$_toConsumableArray(arr) {
    return $331f71c4500fe679$var$_arrayWithoutHoles(arr) || $331f71c4500fe679$var$_iterableToArray(arr) || $331f71c4500fe679$var$_unsupportedIterableToArray(arr) || $331f71c4500fe679$var$_nonIterableSpread();
}
function $331f71c4500fe679$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $331f71c4500fe679$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $331f71c4500fe679$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $331f71c4500fe679$var$_arrayLikeToArray(o, minLen);
}
function $331f71c4500fe679$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $331f71c4500fe679$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $331f71c4500fe679$var$_arrayLikeToArray(arr);
}
function $331f71c4500fe679$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $331f71c4500fe679$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $331f71c4500fe679$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $331f71c4500fe679$var$ownKeys(Object(t), !0).forEach(function(r) {
            $331f71c4500fe679$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $331f71c4500fe679$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $331f71c4500fe679$var$_defineProperty(obj, key, value) {
    key = $331f71c4500fe679$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $331f71c4500fe679$var$_toPropertyKey(t) {
    var i = $331f71c4500fe679$var$_toPrimitive(t, "string");
    return "symbol" == $331f71c4500fe679$var$_typeof(i) ? i : i + "";
}
function $331f71c4500fe679$var$_toPrimitive(t, r) {
    if ("object" != $331f71c4500fe679$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $331f71c4500fe679$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $331f71c4500fe679$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $331f71c4500fe679$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $331f71c4500fe679$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $331f71c4500fe679$var$renderAsIs(element) {
    return element;
}
var $331f71c4500fe679$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $331f71c4500fe679$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, rangeObj), (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, rangeObj), (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $331f71c4500fe679$var$originCoordinate;
};
var $331f71c4500fe679$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($331f71c4500fe679$var$_toConsumableArray(result), $331f71c4500fe679$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dataStartIndex) && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $331f71c4500fe679$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $331f71c4500fe679$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $331f71c4500fe679$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($331f71c4500fe679$var$_toConsumableArray(result), [
            (0, $3cf1854128f2220f$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $331f71c4500fe679$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $331f71c4500fe679$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $3cf1854128f2220f$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $331f71c4500fe679$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $331f71c4500fe679$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $331f71c4500fe679$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $3cf1854128f2220f$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $d741426732739030$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $331f71c4500fe679$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $ddf2636240ab70e2$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($746faafd58231d4f$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $3cf1854128f2220f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($331f71c4500fe679$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $3cf1854128f2220f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entry) ? finalDomain : [].concat($331f71c4500fe679$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $3cf1854128f2220f$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3cf1854128f2220f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($746faafd58231d4f$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $3cf1854128f2220f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $3cf1854128f2220f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $331f71c4500fe679$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $3cf1854128f2220f$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $331f71c4500fe679$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($746faafd58231d4f$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $3cf1854128f2220f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $3cf1854128f2220f$export$a0bc8660980558a0)(originalDomain, (0, $3cf1854128f2220f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $0fbc7216156df216$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))($331f71c4500fe679$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $331f71c4500fe679$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $331f71c4500fe679$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $331f71c4500fe679$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $331f71c4500fe679$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $331f71c4500fe679$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $331f71c4500fe679$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $331f71c4500fe679$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $331f71c4500fe679$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
    var legendItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $559b693b6a1d5199$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $3cf1854128f2220f$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $331f71c4500fe679$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $331f71c4500fe679$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $331f71c4500fe679$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $331f71c4500fe679$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $331f71c4500fe679$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $3cf1854128f2220f$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $3cf1854128f2220f$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $331f71c4500fe679$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $3cf1854128f2220f$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $3cf1854128f2220f$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, pos), {}, {
                        position: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, composedFn($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_defineProperty($331f71c4500fe679$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $86b14aaa4b2f228f$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $86b14aaa4b2f228f$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $331f71c4500fe679$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $3cf1854128f2220f$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, result), {}, $331f71c4500fe679$var$_defineProperty({}, name, $331f71c4500fe679$var$getAxisMap(props, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $331f71c4500fe679$var$calculateOffset($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $331f71c4500fe679$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $331f71c4500fe679$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $331f71c4500fe679$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $331f71c4500fe679$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $331f71c4500fe679$var$_defineProperty(_this, "accessibilityManager", new (0, $4171429008abae73$export$a2c2de1efa8671eb)());
            $331f71c4500fe679$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($331f71c4500fe679$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $331f71c4500fe679$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $331f71c4500fe679$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $331f71c4500fe679$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $331f71c4500fe679$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $331f71c4500fe679$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $331f71c4500fe679$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $86b14aaa4b2f228f$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $331f71c4500fe679$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).emit((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($331f71c4500fe679$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $331f71c4500fe679$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $331f71c4500fe679$var$originCoordinate;
                    _this.setState($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ec94bb69d25a9f22$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $331f71c4500fe679$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $7bbd89b69def67ea$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $331f71c4500fe679$var$_objectWithoutProperties(props, $331f71c4500fe679$var$_excluded);
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(item, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $331f71c4500fe679$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(tooltipItem, {
                    viewBox: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $3cf1854128f2220f$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(activeDot, false)), (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $3cf1854128f2220f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $ddf2636240ab70e2$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($331f71c4500fe679$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $7fPBF.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $331f71c4500fe679$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $331f71c4500fe679$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                YAxis: {
                    handler: $331f71c4500fe679$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($932a0672a1772507$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $331f71c4500fe679$var$_inherits(CategoricalChartWrapper, _Component);
        return $331f71c4500fe679$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $331f71c4500fe679$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $86b14aaa4b2f228f$export$acdc716e08572f94)([
                        (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(prevProps.children, (0, $9fa097d1de474101$export$28c660c63b792dea))
                    ], [
                        (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(this.props.children, (0, $9fa097d1de474101$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(this.props.children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $5da910530c0379f8$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $331f71c4500fe679$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $ddf2636240ab70e2$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $2f494a175d2955a8$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $9fa097d1de474101$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $eb7294e7865e616e$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).on((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $6164c1f84130ff0f$export$9bcdfe5f29bb33).removeListener((0, $6164c1f84130ff0f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $86b14aaa4b2f228f$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $331f71c4500fe679$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, res), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $331f71c4500fe679$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, res), {}, $331f71c4500fe679$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $86b14aaa4b2f228f$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $dd9e03c5c06a0d41$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $2f494a175d2955a8$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $afd6034f160dea85$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $afd6034f160dea85$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $afd6034f160dea85$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $afd6034f160dea85$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $afd6034f160dea85$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $86b14aaa4b2f228f$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $331f71c4500fe679$var$_objectWithoutProperties(_this$props6, $331f71c4500fe679$var$_excluded2);
                    var attrs = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d5acdec35ed0a35a$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), $331f71c4500fe679$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $86b14aaa4b2f228f$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d5acdec35ed0a35a$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", $331f71c4500fe679$var$_extends({
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $331f71c4500fe679$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a2566a000284bc9$export$7b92b459e668cb21), $331f71c4500fe679$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $331f71c4500fe679$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $86b14aaa4b2f228f$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $7fPBF.Component));
    $331f71c4500fe679$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $331f71c4500fe679$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $331f71c4500fe679$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $331f71c4500fe679$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $331f71c4500fe679$export$e5182fb58612e577(nextProps);
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $331f71c4500fe679$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, $331f71c4500fe679$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $86b14aaa4b2f228f$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $86b14aaa4b2f228f$export$64c61536a2b72e0f)(children, (0, $292adb4d61b7aa4f$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($331f71c4500fe679$var$_objectSpread($331f71c4500fe679$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $331f71c4500fe679$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $7fPBF.isValidElement)(option)) dot = /*#__PURE__*/ (0, $7fPBF.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CategoricalChartWrapper, $331f71c4500fe679$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");















/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $8976e8413a7e39c4$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $7f161332c72a475b$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $251e5258b398e2e1$export$3ee78d51cffc2b68)(size, angle);
}
function $7f161332c72a475b$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $7f161332c72a475b$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $7f161332c72a475b$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $8976e8413a7e39c4$export$41514b9f058a6886)(ticks, interval + 1);
}




function $68a5c6e5e64af4f0$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $8976e8413a7e39c4$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $6cb6365b5eafdfd3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6cb6365b5eafdfd3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6cb6365b5eafdfd3$var$_typeof(o);
}
function $6cb6365b5eafdfd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cb6365b5eafdfd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cb6365b5eafdfd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6cb6365b5eafdfd3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cb6365b5eafdfd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6cb6365b5eafdfd3$var$_defineProperty(obj, key, value) {
    key = $6cb6365b5eafdfd3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6cb6365b5eafdfd3$var$_toPropertyKey(t) {
    var i = $6cb6365b5eafdfd3$var$_toPrimitive(t, "string");
    return "symbol" == $6cb6365b5eafdfd3$var$_typeof(i) ? i : i + "";
}
function $6cb6365b5eafdfd3$var$_toPrimitive(t, r) {
    if ("object" != $6cb6365b5eafdfd3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6cb6365b5eafdfd3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6cb6365b5eafdfd3$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $6cb6365b5eafdfd3$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $7f161332c72a475b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $6cb6365b5eafdfd3$var$_objectSpread($6cb6365b5eafdfd3$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $6cb6365b5eafdfd3$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(interval) || (0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr) return (0, $7f161332c72a475b$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $5da910530c0379f8$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $7f161332c72a475b$export$a1966f4ad955c82b)((0, $5da910530c0379f8$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5da910530c0379f8$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $ddf2636240ab70e2$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $7f161332c72a475b$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $68a5c6e5e64af4f0$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $6cb6365b5eafdfd3$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $6cb6365b5eafdfd3$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $4c100a780d8d6a10$var$_excluded = [
    "viewBox"
], $4c100a780d8d6a10$var$_excluded2 = [
    "viewBox"
], $4c100a780d8d6a10$var$_excluded3 = [
    "ticks"
];
function $4c100a780d8d6a10$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4c100a780d8d6a10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4c100a780d8d6a10$var$_typeof(o);
}
function $4c100a780d8d6a10$var$_extends() {
    $4c100a780d8d6a10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c100a780d8d6a10$var$_extends.apply(this, arguments);
}
function $4c100a780d8d6a10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c100a780d8d6a10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c100a780d8d6a10$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4c100a780d8d6a10$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c100a780d8d6a10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4c100a780d8d6a10$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4c100a780d8d6a10$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4c100a780d8d6a10$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4c100a780d8d6a10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4c100a780d8d6a10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4c100a780d8d6a10$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4c100a780d8d6a10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4c100a780d8d6a10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4c100a780d8d6a10$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4c100a780d8d6a10$var$_callSuper(t, o, e) {
    return o = $4c100a780d8d6a10$var$_getPrototypeOf(o), $4c100a780d8d6a10$var$_possibleConstructorReturn(t, $4c100a780d8d6a10$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $4c100a780d8d6a10$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $4c100a780d8d6a10$var$_possibleConstructorReturn(self, call) {
    if (call && ($4c100a780d8d6a10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c100a780d8d6a10$var$_assertThisInitialized(self);
}
function $4c100a780d8d6a10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4c100a780d8d6a10$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4c100a780d8d6a10$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4c100a780d8d6a10$var$_getPrototypeOf(o) {
    $4c100a780d8d6a10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4c100a780d8d6a10$var$_getPrototypeOf(o);
}
function $4c100a780d8d6a10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4c100a780d8d6a10$var$_setPrototypeOf(subClass, superClass);
}
function $4c100a780d8d6a10$var$_setPrototypeOf(o, p) {
    $4c100a780d8d6a10$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4c100a780d8d6a10$var$_setPrototypeOf(o, p);
}
function $4c100a780d8d6a10$var$_defineProperty(obj, key, value) {
    key = $4c100a780d8d6a10$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4c100a780d8d6a10$var$_toPropertyKey(t) {
    var i = $4c100a780d8d6a10$var$_toPrimitive(t, "string");
    return "symbol" == $4c100a780d8d6a10$var$_typeof(i) ? i : i + "";
}
function $4c100a780d8d6a10$var$_toPrimitive(t, r) {
    if ("object" != $4c100a780d8d6a10$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4c100a780d8d6a10$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4c100a780d8d6a10$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $4c100a780d8d6a10$var$_classCallCheck(this, CartesianAxis);
        _this = $4c100a780d8d6a10$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $4c100a780d8d6a10$var$_inherits(CartesianAxis, _Component);
    return $4c100a780d8d6a10$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $4c100a780d8d6a10$var$_objectWithoutProperties(_ref, $4c100a780d8d6a10$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $4c100a780d8d6a10$var$_objectWithoutProperties(_this$props, $4c100a780d8d6a10$var$_excluded2);
                return !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $12af98dbc8c7996a$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $4c100a780d8d6a10$var$_extends({}, props, {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread($4c100a780d8d6a10$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $4c100a780d8d6a10$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $4c100a780d8d6a10$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $4c100a780d8d6a10$var$_objectWithoutProperties(_this$props8, $4c100a780d8d6a10$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $4c100a780d8d6a10$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $7fPBF.Component));
$4c100a780d8d6a10$var$_defineProperty($4c100a780d8d6a10$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$4c100a780d8d6a10$var$_defineProperty($4c100a780d8d6a10$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $27e86c33407ed632$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $27e86c33407ed632$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $27e86c33407ed632$var$_typeof(o);
}
function $27e86c33407ed632$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27e86c33407ed632$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $27e86c33407ed632$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $27e86c33407ed632$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $27e86c33407ed632$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $27e86c33407ed632$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $27e86c33407ed632$var$_callSuper(t, o, e) {
    return o = $27e86c33407ed632$var$_getPrototypeOf(o), $27e86c33407ed632$var$_possibleConstructorReturn(t, $27e86c33407ed632$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $27e86c33407ed632$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $27e86c33407ed632$var$_possibleConstructorReturn(self, call) {
    if (call && ($27e86c33407ed632$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $27e86c33407ed632$var$_assertThisInitialized(self);
}
function $27e86c33407ed632$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $27e86c33407ed632$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($27e86c33407ed632$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $27e86c33407ed632$var$_getPrototypeOf(o) {
    $27e86c33407ed632$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $27e86c33407ed632$var$_getPrototypeOf(o);
}
function $27e86c33407ed632$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $27e86c33407ed632$var$_setPrototypeOf(subClass, superClass);
}
function $27e86c33407ed632$var$_setPrototypeOf(o, p) {
    $27e86c33407ed632$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $27e86c33407ed632$var$_setPrototypeOf(o, p);
}
function $27e86c33407ed632$var$_defineProperty(obj, key, value) {
    key = $27e86c33407ed632$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27e86c33407ed632$var$_toPropertyKey(t) {
    var i = $27e86c33407ed632$var$_toPrimitive(t, "string");
    return "symbol" == $27e86c33407ed632$var$_typeof(i) ? i : i + "";
}
function $27e86c33407ed632$var$_toPrimitive(t, r) {
    if ("object" != $27e86c33407ed632$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $27e86c33407ed632$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $27e86c33407ed632$var$_extends() {
    $27e86c33407ed632$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27e86c33407ed632$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $27e86c33407ed632$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var height = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var axisOptions = (0, $d5acdec35ed0a35a$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4c100a780d8d6a10$export$bdd99f2cdf352bae), $27e86c33407ed632$var$_extends({}, axisOptions, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $27e86c33407ed632$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $27e86c33407ed632$var$_classCallCheck(this, XAxis);
        return $27e86c33407ed632$var$_callSuper(this, XAxis, arguments);
    }
    $27e86c33407ed632$var$_inherits(XAxis, _React$Component);
    return $27e86c33407ed632$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($27e86c33407ed632$var$XAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$27e86c33407ed632$var$_defineProperty($27e86c33407ed632$export$ea77231de273b52d, "displayName", 'XAxis');
$27e86c33407ed632$var$_defineProperty($27e86c33407ed632$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $7fPBF = parcelRequire("7fPBF");




function $3a4baae21e40b313$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a4baae21e40b313$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a4baae21e40b313$var$_typeof(o);
}
function $3a4baae21e40b313$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a4baae21e40b313$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3a4baae21e40b313$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3a4baae21e40b313$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a4baae21e40b313$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a4baae21e40b313$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3a4baae21e40b313$var$_callSuper(t, o, e) {
    return o = $3a4baae21e40b313$var$_getPrototypeOf(o), $3a4baae21e40b313$var$_possibleConstructorReturn(t, $3a4baae21e40b313$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3a4baae21e40b313$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3a4baae21e40b313$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a4baae21e40b313$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3a4baae21e40b313$var$_assertThisInitialized(self);
}
function $3a4baae21e40b313$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a4baae21e40b313$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3a4baae21e40b313$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3a4baae21e40b313$var$_getPrototypeOf(o) {
    $3a4baae21e40b313$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a4baae21e40b313$var$_getPrototypeOf(o);
}
function $3a4baae21e40b313$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3a4baae21e40b313$var$_setPrototypeOf(subClass, superClass);
}
function $3a4baae21e40b313$var$_setPrototypeOf(o, p) {
    $3a4baae21e40b313$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a4baae21e40b313$var$_setPrototypeOf(o, p);
}
function $3a4baae21e40b313$var$_defineProperty(obj, key, value) {
    key = $3a4baae21e40b313$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a4baae21e40b313$var$_toPropertyKey(t) {
    var i = $3a4baae21e40b313$var$_toPrimitive(t, "string");
    return "symbol" == $3a4baae21e40b313$var$_typeof(i) ? i : i + "";
}
function $3a4baae21e40b313$var$_toPrimitive(t, r) {
    if ("object" != $3a4baae21e40b313$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3a4baae21e40b313$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3a4baae21e40b313$var$_extends() {
    $3a4baae21e40b313$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a4baae21e40b313$var$_extends.apply(this, arguments);
}
var $3a4baae21e40b313$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var height = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var axisOptions = (0, $d5acdec35ed0a35a$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4c100a780d8d6a10$export$bdd99f2cdf352bae), $3a4baae21e40b313$var$_extends({}, axisOptions, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $3a4baae21e40b313$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $3a4baae21e40b313$var$_classCallCheck(this, YAxis);
        return $3a4baae21e40b313$var$_callSuper(this, YAxis, arguments);
    }
    $3a4baae21e40b313$var$_inherits(YAxis, _React$Component);
    return $3a4baae21e40b313$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3a4baae21e40b313$var$YAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$3a4baae21e40b313$var$_defineProperty($3a4baae21e40b313$export$f96c4024c52de8f4, "displayName", 'YAxis');
$3a4baae21e40b313$var$_defineProperty($3a4baae21e40b313$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $01f31af77b77addd$export$94aefc399ef206a9 = (0, $331f71c4500fe679$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $27e86c33407ed632$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $3a4baae21e40b313$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $251e5258b398e2e1$export$ece7de1383db5ac)
});


var $7fPBF = parcelRequire("7fPBF");








var $6143e12f71339f62$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $6143e12f71339f62$var$_excluded2 = [
    "offset"
];
function $6143e12f71339f62$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6143e12f71339f62$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6143e12f71339f62$var$_typeof(o);
}
function $6143e12f71339f62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6143e12f71339f62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6143e12f71339f62$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6143e12f71339f62$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6143e12f71339f62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6143e12f71339f62$var$_defineProperty(obj, key, value) {
    key = $6143e12f71339f62$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6143e12f71339f62$var$_toPropertyKey(t) {
    var i = $6143e12f71339f62$var$_toPrimitive(t, "string");
    return "symbol" == $6143e12f71339f62$var$_typeof(i) ? i : i + "";
}
function $6143e12f71339f62$var$_toPrimitive(t, r) {
    if ("object" != $6143e12f71339f62$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6143e12f71339f62$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6143e12f71339f62$var$_extends() {
    $6143e12f71339f62$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6143e12f71339f62$var$_extends.apply(this, arguments);
}
function $6143e12f71339f62$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6143e12f71339f62$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6143e12f71339f62$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $6143e12f71339f62$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $6143e12f71339f62$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $6143e12f71339f62$var$_objectWithoutProperties(props, $6143e12f71339f62$var$_excluded);
        var _filterProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $6143e12f71339f62$var$_objectWithoutProperties(_filterProps, $6143e12f71339f62$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $6143e12f71339f62$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $6143e12f71339f62$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $6143e12f71339f62$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $6143e12f71339f62$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $6143e12f71339f62$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $6143e12f71339f62$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $6143e12f71339f62$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $6143e12f71339f62$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $3cf1854128f2220f$export$846dc5ac5fecff74)((0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, (0, $4c100a780d8d6a10$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $6143e12f71339f62$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $3cf1854128f2220f$export$846dc5ac5fecff74)((0, $6cb6365b5eafdfd3$export$3d27d42b1034de5c)($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, (0, $4c100a780d8d6a10$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $3cf1854128f2220f$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $6143e12f71339f62$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $6143e12f71339f62$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $d5acdec35ed0a35a$export$8854f7ece606854b)();
    var chartHeight = (0, $d5acdec35ed0a35a$export$369ae257969c6f9f)();
    var offset = (0, $d5acdec35ed0a35a$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $6143e12f71339f62$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $6143e12f71339f62$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $6143e12f71339f62$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $6143e12f71339f62$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $6143e12f71339f62$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $6143e12f71339f62$var$defaultProps.verticalFill,
        x: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $ddf2636240ab70e2$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $d5acdec35ed0a35a$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $d5acdec35ed0a35a$export$631ee617f1052e16)();
    if (!(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(x) || x !== +x || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $6143e12f71339f62$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $6143e12f71339f62$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($6143e12f71339f62$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $6143e12f71339f62$var$_objectSpread($6143e12f71339f62$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($6143e12f71339f62$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$HorizontalGridLines, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$VerticalGridLines, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$HorizontalStripes, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6143e12f71339f62$var$VerticalStripes, $6143e12f71339f62$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$6143e12f71339f62$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $7fPBF = parcelRequire("7fPBF");














var $f969ea45962ba143$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
], $f969ea45962ba143$var$_excluded2 = [
    "key"
];
function $f969ea45962ba143$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f969ea45962ba143$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f969ea45962ba143$var$_typeof(o);
}
function $f969ea45962ba143$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f969ea45962ba143$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f969ea45962ba143$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f969ea45962ba143$var$_extends() {
    $f969ea45962ba143$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f969ea45962ba143$var$_extends.apply(this, arguments);
}
function $f969ea45962ba143$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f969ea45962ba143$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f969ea45962ba143$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f969ea45962ba143$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f969ea45962ba143$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f969ea45962ba143$var$_toConsumableArray(arr) {
    return $f969ea45962ba143$var$_arrayWithoutHoles(arr) || $f969ea45962ba143$var$_iterableToArray(arr) || $f969ea45962ba143$var$_unsupportedIterableToArray(arr) || $f969ea45962ba143$var$_nonIterableSpread();
}
function $f969ea45962ba143$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f969ea45962ba143$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f969ea45962ba143$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f969ea45962ba143$var$_arrayLikeToArray(o, minLen);
}
function $f969ea45962ba143$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f969ea45962ba143$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f969ea45962ba143$var$_arrayLikeToArray(arr);
}
function $f969ea45962ba143$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f969ea45962ba143$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f969ea45962ba143$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f969ea45962ba143$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f969ea45962ba143$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f969ea45962ba143$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f969ea45962ba143$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f969ea45962ba143$var$_callSuper(t, o, e) {
    return o = $f969ea45962ba143$var$_getPrototypeOf(o), $f969ea45962ba143$var$_possibleConstructorReturn(t, $f969ea45962ba143$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f969ea45962ba143$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f969ea45962ba143$var$_possibleConstructorReturn(self, call) {
    if (call && ($f969ea45962ba143$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f969ea45962ba143$var$_assertThisInitialized(self);
}
function $f969ea45962ba143$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f969ea45962ba143$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f969ea45962ba143$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f969ea45962ba143$var$_getPrototypeOf(o) {
    $f969ea45962ba143$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f969ea45962ba143$var$_getPrototypeOf(o);
}
function $f969ea45962ba143$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f969ea45962ba143$var$_setPrototypeOf(subClass, superClass);
}
function $f969ea45962ba143$var$_setPrototypeOf(o, p) {
    $f969ea45962ba143$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f969ea45962ba143$var$_setPrototypeOf(o, p);
}
function $f969ea45962ba143$var$_defineProperty(obj, key, value) {
    key = $f969ea45962ba143$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f969ea45962ba143$var$_toPropertyKey(t) {
    var i = $f969ea45962ba143$var$_toPrimitive(t, "string");
    return "symbol" == $f969ea45962ba143$var$_typeof(i) ? i : i + "";
}
function $f969ea45962ba143$var$_toPrimitive(t, r) {
    if ("object" != $f969ea45962ba143$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f969ea45962ba143$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f969ea45962ba143$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    function Line() {
        var _this;
        $f969ea45962ba143$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $f969ea45962ba143$var$_callSuper(this, Line, [].concat(args));
        $f969ea45962ba143$var$_defineProperty(_this, "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $f969ea45962ba143$var$_defineProperty(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $f969ea45962ba143$var$_defineProperty(_this, "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($f969ea45962ba143$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($f969ea45962ba143$var$_toConsumableArray(Line.repeat(lines, count)), $f969ea45962ba143$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $f969ea45962ba143$var$_defineProperty(_this, "id", (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-line-'));
        $f969ea45962ba143$var$_defineProperty(_this, "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $f969ea45962ba143$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $f969ea45962ba143$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $f969ea45962ba143$var$_inherits(Line, _PureComponent);
    return $f969ea45962ba143$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $d05ab0383decc723$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $3cf1854128f2220f$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        value: entry.value,
                        dataKey: dataKey,
                        payload: entry.payload,
                        points: points
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $f969ea45962ba143$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $f969ea45962ba143$var$_objectWithoutProperties(_this$props3, $f969ea45962ba143$var$_excluded);
                var curveProps = $f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1), $f969ea45962ba143$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $f969ea45962ba143$var$_objectSpread($f969ea45962ba143$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $86b14aaa4b2f228f$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $acfa11ccf9405f16$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($f969ea45962ba143$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($f969ea45962ba143$var$_toConsumableArray(result), $f969ea45962ba143$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = $f969ea45962ba143$var$_objectWithoutProperties(props, $f969ea45962ba143$var$_excluded2);
                    var className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), $f969ea45962ba143$var$_extends({
                        key: key
                    }, dotProps, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$f969ea45962ba143$var$_defineProperty($f969ea45962ba143$export$17d680238e50603e, "displayName", 'Line');
$f969ea45962ba143$var$_defineProperty($f969ea45962ba143$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $f969ea45962ba143$var$_defineProperty($f969ea45962ba143$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $3cf1854128f2220f$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $3cf1854128f2220f$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $f969ea45962ba143$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ 




var $73fc4916f67614e1$export$54d0e8420ac838ac = (0, $331f71c4500fe679$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $f969ea45962ba143$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $27e86c33407ed632$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $3a4baae21e40b313$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $251e5258b398e2e1$export$ece7de1383db5ac)
});


var $7fPBF = parcelRequire("7fPBF");




















var $63b3d20e0a6452f7$var$_Pie;
function $63b3d20e0a6452f7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $63b3d20e0a6452f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $63b3d20e0a6452f7$var$_typeof(o);
}
function $63b3d20e0a6452f7$var$_extends() {
    $63b3d20e0a6452f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63b3d20e0a6452f7$var$_extends.apply(this, arguments);
}
function $63b3d20e0a6452f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63b3d20e0a6452f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63b3d20e0a6452f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $63b3d20e0a6452f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63b3d20e0a6452f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $63b3d20e0a6452f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $63b3d20e0a6452f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63b3d20e0a6452f7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63b3d20e0a6452f7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63b3d20e0a6452f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63b3d20e0a6452f7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63b3d20e0a6452f7$var$_callSuper(t, o, e) {
    return o = $63b3d20e0a6452f7$var$_getPrototypeOf(o), $63b3d20e0a6452f7$var$_possibleConstructorReturn(t, $63b3d20e0a6452f7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $63b3d20e0a6452f7$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $63b3d20e0a6452f7$var$_possibleConstructorReturn(self, call) {
    if (call && ($63b3d20e0a6452f7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $63b3d20e0a6452f7$var$_assertThisInitialized(self);
}
function $63b3d20e0a6452f7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $63b3d20e0a6452f7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($63b3d20e0a6452f7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $63b3d20e0a6452f7$var$_getPrototypeOf(o) {
    $63b3d20e0a6452f7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63b3d20e0a6452f7$var$_getPrototypeOf(o);
}
function $63b3d20e0a6452f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $63b3d20e0a6452f7$var$_setPrototypeOf(subClass, superClass);
}
function $63b3d20e0a6452f7$var$_setPrototypeOf(o, p) {
    $63b3d20e0a6452f7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63b3d20e0a6452f7$var$_setPrototypeOf(o, p);
}
function $63b3d20e0a6452f7$var$_defineProperty(obj, key, value) {
    key = $63b3d20e0a6452f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $63b3d20e0a6452f7$var$_toPropertyKey(t) {
    var i = $63b3d20e0a6452f7$var$_toPrimitive(t, "string");
    return "symbol" == $63b3d20e0a6452f7$var$_typeof(i) ? i : i + "";
}
function $63b3d20e0a6452f7$var$_toPrimitive(t, r) {
    if ("object" != $63b3d20e0a6452f7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $63b3d20e0a6452f7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $63b3d20e0a6452f7$export$2ae8800cf67c848c = /*#__PURE__*/ function(_PureComponent) {
    function Pie(props) {
        var _this;
        $63b3d20e0a6452f7$var$_classCallCheck(this, Pie);
        _this = $63b3d20e0a6452f7$var$_callSuper(this, Pie, [
            props
        ]);
        $63b3d20e0a6452f7$var$_defineProperty(_this, "pieRef", null);
        $63b3d20e0a6452f7$var$_defineProperty(_this, "sectorRefs", []);
        $63b3d20e0a6452f7$var$_defineProperty(_this, "id", (0, $ddf2636240ab70e2$export$8b15d37bc3f197d4)('recharts-pie-'));
        $63b3d20e0a6452f7$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $63b3d20e0a6452f7$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    $63b3d20e0a6452f7$var$_inherits(Pie, _PureComponent);
    return $63b3d20e0a6452f7$var$_createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customLabelProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(label, false);
                var customLabelLineProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ]
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(valueKey)) realDataKey = 'value';
                    else if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps, 'line'), Pie.renderLabelItem(label, labelProps, (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $63b3d20e0a6452f7$var$_extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afd6034f160dea85$export$6428a7f2611ef1fa), $63b3d20e0a6452f7$var$_extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36c7fa330327890a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, $ddf2636240ab70e2$export$d871d53bd7eeb390)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cx) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(cy) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(innerRadius) || !(0, $ddf2636240ab70e2$export$7e4aa119212bc614)(outerRadius)) return null;
                var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-pie', className);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, $acfa11ccf9405f16$export$835fcf23ab7bf88).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props, key) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) return option(props);
                var className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $24f9e03e793c5e59$export$b0e83c3ef8d2db1), $63b3d20e0a6452f7$var$_extends({}, props, {
                    key: key,
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                var label = value;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(label)) return label;
                }
                var className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-pie-label-text', typeof option !== 'boolean' && !(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option) ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $63b3d20e0a6452f7$var$_extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$63b3d20e0a6452f7$var$_Pie = $63b3d20e0a6452f7$export$2ae8800cf67c848c;
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "displayName", 'Pie');
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, $bdfd77d06577c8ff$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, $ddf2636240ab70e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "getRealPieData", function(itemProps) {
    var data = itemProps.data, children = itemProps.children;
    var presentationProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(itemProps, false);
    var cells = (0, $86b14aaa4b2f228f$export$fdd5e64c0e8495bb)(children, (0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea));
    if (data && data.length) return data.map(function(entry, index) {
        return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "parseCoordinateOfPie", function(itemProps, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $2f494a175d2955a8$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(itemProps.cx, width, width / 2);
    var cy = top + (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(itemProps.cy, height, height / 2);
    var innerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(itemProps.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, $ddf2636240ab70e2$export$476354dbf49bdff6)(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
$63b3d20e0a6452f7$var$_defineProperty($63b3d20e0a6452f7$export$2ae8800cf67c848c, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var itemProps = item.type.defaultProps !== undefined ? $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var pieData = $63b3d20e0a6452f7$var$_Pie.getRealPieData(itemProps);
    if (!pieData || !pieData.length) return null;
    var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
    var minAngle = Math.abs(itemProps.minAngle);
    var coordinate = $63b3d20e0a6452f7$var$_Pie.parseCoordinateOfPie(itemProps, offset);
    var deltaAngle = $63b3d20e0a6452f7$var$_Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(valueKey)) {
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($a32d359663840a54$exports)))(dataKey)) {
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0);
        return result + ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey, 0);
            var name = (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, nameKey, i);
            var percent = ((0, $ddf2636240ab70e2$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, $3cf1854128f2220f$export$f97fc4a450f29a)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, $ddf2636240ab70e2$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return $63b3d20e0a6452f7$var$_objectSpread($63b3d20e0a6452f7$var$_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

/**
 * @fileOverview Pie Chart
 */ 

var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");


var $9c4bfeb35f4f0d0a$var$_excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function $9c4bfeb35f4f0d0a$var$_extends() {
    $9c4bfeb35f4f0d0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c4bfeb35f4f0d0a$var$_extends.apply(this, arguments);
}
function $9c4bfeb35f4f0d0a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9c4bfeb35f4f0d0a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9c4bfeb35f4f0d0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9c4bfeb35f4f0d0a$var$_toConsumableArray(arr) {
    return $9c4bfeb35f4f0d0a$var$_arrayWithoutHoles(arr) || $9c4bfeb35f4f0d0a$var$_iterableToArray(arr) || $9c4bfeb35f4f0d0a$var$_unsupportedIterableToArray(arr) || $9c4bfeb35f4f0d0a$var$_nonIterableSpread();
}
function $9c4bfeb35f4f0d0a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9c4bfeb35f4f0d0a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(o, minLen);
}
function $9c4bfeb35f4f0d0a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9c4bfeb35f4f0d0a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(arr);
}
function $9c4bfeb35f4f0d0a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9c4bfeb35f4f0d0a$var$isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var $9c4bfeb35f4f0d0a$var$getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if ($9c4bfeb35f4f0d0a$var$isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if ($9c4bfeb35f4f0d0a$var$isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var $9c4bfeb35f4f0d0a$var$getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = $9c4bfeb35f4f0d0a$var$getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat($9c4bfeb35f4f0d0a$var$_toConsumableArray(res), $9c4bfeb35f4f0d0a$var$_toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var $9c4bfeb35f4f0d0a$var$getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat($9c4bfeb35f4f0d0a$var$getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var $9c4bfeb35f4f0d0a$export$7d31b617c820d435 = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = $9c4bfeb35f4f0d0a$var$_objectWithoutProperties(props, $9c4bfeb35f4f0d0a$var$_excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = $9c4bfeb35f4f0d0a$var$getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = $9c4bfeb35f4f0d0a$var$getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", $9c4bfeb35f4f0d0a$var$_extends({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};






function $1e217e5600ea734c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e217e5600ea734c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e217e5600ea734c$var$_typeof(o);
}
function $1e217e5600ea734c$var$_extends() {
    $1e217e5600ea734c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e217e5600ea734c$var$_extends.apply(this, arguments);
}
function $1e217e5600ea734c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e217e5600ea734c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e217e5600ea734c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1e217e5600ea734c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e217e5600ea734c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1e217e5600ea734c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1e217e5600ea734c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1e217e5600ea734c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1e217e5600ea734c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1e217e5600ea734c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1e217e5600ea734c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1e217e5600ea734c$var$_callSuper(t, o, e) {
    return o = $1e217e5600ea734c$var$_getPrototypeOf(o), $1e217e5600ea734c$var$_possibleConstructorReturn(t, $1e217e5600ea734c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1e217e5600ea734c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1e217e5600ea734c$var$_possibleConstructorReturn(self, call) {
    if (call && ($1e217e5600ea734c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1e217e5600ea734c$var$_assertThisInitialized(self);
}
function $1e217e5600ea734c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1e217e5600ea734c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1e217e5600ea734c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1e217e5600ea734c$var$_getPrototypeOf(o) {
    $1e217e5600ea734c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1e217e5600ea734c$var$_getPrototypeOf(o);
}
function $1e217e5600ea734c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1e217e5600ea734c$var$_setPrototypeOf(subClass, superClass);
}
function $1e217e5600ea734c$var$_setPrototypeOf(o, p) {
    $1e217e5600ea734c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1e217e5600ea734c$var$_setPrototypeOf(o, p);
}
function $1e217e5600ea734c$var$_defineProperty(obj, key, value) {
    key = $1e217e5600ea734c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e217e5600ea734c$var$_toPropertyKey(t) {
    var i = $1e217e5600ea734c$var$_toPrimitive(t, "string");
    return "symbol" == $1e217e5600ea734c$var$_typeof(i) ? i : i + "";
}
function $1e217e5600ea734c$var$_toPrimitive(t, r) {
    if ("object" != $1e217e5600ea734c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1e217e5600ea734c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1e217e5600ea734c$var$RADIAN = Math.PI / 180;
var $1e217e5600ea734c$var$eps = 1e-5;
var $1e217e5600ea734c$export$67d930e793705898 = /*#__PURE__*/ function(_PureComponent) {
    function PolarAngleAxis() {
        $1e217e5600ea734c$var$_classCallCheck(this, PolarAngleAxis);
        return $1e217e5600ea734c$var$_callSuper(this, PolarAngleAxis, arguments);
    }
    $1e217e5600ea734c$var$_inherits(PolarAngleAxis, _PureComponent);
    return $1e217e5600ea734c$var$_createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, data.coordinate);
                var p2 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * $1e217e5600ea734c$var$RADIAN);
                var textAnchor;
                if (cos > $1e217e5600ea734c$var$eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -$1e217e5600ea734c$var$eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $22ef29953161e37f$export$d046b3c4a416f60d), $1e217e5600ea734c$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9c4bfeb35f4f0d0a$export$7d31b617c820d435), $1e217e5600ea734c$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = $1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread($1e217e5600ea734c$var$_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $1e217e5600ea734c$var$_extends({
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polar-angle-axis-tick', (0, $2f494a175d2955a8$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $1e217e5600ea734c$var$_extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polar-angle-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $1e217e5600ea734c$var$_extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "displayName", 'PolarAngleAxis');
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "axisType", 'angleAxis');
$1e217e5600ea734c$var$_defineProperty($1e217e5600ea734c$export$67d930e793705898, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});



var $7fPBF = parcelRequire("7fPBF");
var $5e6832f9efcce0c0$exports = {};



/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $5e6832f9efcce0c0$var$maxBy(array, iteratee) {
    return array && array.length ? $89ecae80ebf99b3b$exports(array, $bf70b66c162aef31$exports(iteratee, 2), $7625ba1fc4678500$exports) : undefined;
}
$5e6832f9efcce0c0$exports = $5e6832f9efcce0c0$var$maxBy;


var $7820584274307a56$exports = {};



/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $7820584274307a56$var$minBy(array, iteratee) {
    return array && array.length ? $89ecae80ebf99b3b$exports(array, $bf70b66c162aef31$exports(iteratee, 2), $d278bc77a5870dce$exports) : undefined;
}
$7820584274307a56$exports = $7820584274307a56$var$minBy;










var $943b9fbe5f81a613$var$_excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], $943b9fbe5f81a613$var$_excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function $943b9fbe5f81a613$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $943b9fbe5f81a613$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $943b9fbe5f81a613$var$_typeof(o);
}
function $943b9fbe5f81a613$var$_extends() {
    $943b9fbe5f81a613$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $943b9fbe5f81a613$var$_extends.apply(this, arguments);
}
function $943b9fbe5f81a613$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $943b9fbe5f81a613$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $943b9fbe5f81a613$var$ownKeys(Object(t), !0).forEach(function(r) {
            $943b9fbe5f81a613$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $943b9fbe5f81a613$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $943b9fbe5f81a613$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $943b9fbe5f81a613$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $943b9fbe5f81a613$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $943b9fbe5f81a613$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $943b9fbe5f81a613$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $943b9fbe5f81a613$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $943b9fbe5f81a613$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $943b9fbe5f81a613$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $943b9fbe5f81a613$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $943b9fbe5f81a613$var$_callSuper(t, o, e) {
    return o = $943b9fbe5f81a613$var$_getPrototypeOf(o), $943b9fbe5f81a613$var$_possibleConstructorReturn(t, $943b9fbe5f81a613$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $943b9fbe5f81a613$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $943b9fbe5f81a613$var$_possibleConstructorReturn(self, call) {
    if (call && ($943b9fbe5f81a613$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $943b9fbe5f81a613$var$_assertThisInitialized(self);
}
function $943b9fbe5f81a613$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $943b9fbe5f81a613$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($943b9fbe5f81a613$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $943b9fbe5f81a613$var$_getPrototypeOf(o) {
    $943b9fbe5f81a613$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $943b9fbe5f81a613$var$_getPrototypeOf(o);
}
function $943b9fbe5f81a613$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $943b9fbe5f81a613$var$_setPrototypeOf(subClass, superClass);
}
function $943b9fbe5f81a613$var$_setPrototypeOf(o, p) {
    $943b9fbe5f81a613$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $943b9fbe5f81a613$var$_setPrototypeOf(o, p);
}
function $943b9fbe5f81a613$var$_defineProperty(obj, key, value) {
    key = $943b9fbe5f81a613$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $943b9fbe5f81a613$var$_toPropertyKey(t) {
    var i = $943b9fbe5f81a613$var$_toPrimitive(t, "string");
    return "symbol" == $943b9fbe5f81a613$var$_typeof(i) ? i : i + "";
}
function $943b9fbe5f81a613$var$_toPrimitive(t, r) {
    if ("object" != $943b9fbe5f81a613$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $943b9fbe5f81a613$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $943b9fbe5f81a613$export$d2607afddf4df58d = /*#__PURE__*/ function(_PureComponent) {
    function PolarRadiusAxis() {
        $943b9fbe5f81a613$var$_classCallCheck(this, PolarRadiusAxis);
        return $943b9fbe5f81a613$var$_callSuper(this, PolarRadiusAxis, arguments);
    }
    $943b9fbe5f81a613$var$_inherits(PolarRadiusAxis, _PureComponent);
    return $943b9fbe5f81a613$var$_createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($5e6832f9efcce0c0$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($7820584274307a56$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = $943b9fbe5f81a613$var$_objectWithoutProperties(_this$props3, $943b9fbe5f81a613$var$_excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, extent[0], angle);
                var point1 = (0, $2f494a175d2955a8$export$5c9a959bb3fc7749)(cx, cy, extent[1], angle);
                var props = $943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread({}, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false)), {}, {
                    fill: 'none'
                }, (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("line", $943b9fbe5f81a613$var$_extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = $943b9fbe5f81a613$var$_objectWithoutProperties(_this$props4, $943b9fbe5f81a613$var$_excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(others, false);
                var customTickProps = (0, $86b14aaa4b2f228f$export$d697c39a2985a4c)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = $943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread($943b9fbe5f81a613$var$_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), $943b9fbe5f81a613$var$_extends({
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polar-radius-axis-tick', (0, $2f494a175d2955a8$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $eb7294e7865e616e$export$ca62be0d67a3158c)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $96829a30e4c93428$export$936d0764594b6eb3), {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-polar-radius-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, $41cf002e3fba69c7$export$b04be29aa201d4f5).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $94f8473029f59671$export$5f1af8db9871e1d6), $943b9fbe5f81a613$var$_extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $7fPBF.PureComponent));
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "displayName", 'PolarRadiusAxis');
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "axisType", 'radiusAxis');
$943b9fbe5f81a613$var$_defineProperty($943b9fbe5f81a613$export$d2607afddf4df58d, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});




var $0d06d88eccf60657$export$b99d3348f709c998 = (0, $331f71c4500fe679$export$77871aede60e6838)({
    chartName: 'PieChart',
    GraphicalChild: (0, $63b3d20e0a6452f7$export$2ae8800cf67c848c),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, $1e217e5600ea734c$export$67d930e793705898)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, $943b9fbe5f81a613$export$d2607afddf4df58d)
        }
    ],
    formatAxisMap: (0, $2f494a175d2955a8$export$ece7de1383db5ac),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});



var $7fPBF = parcelRequire("7fPBF");




function $6ceca7e94c1e5e4b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6ceca7e94c1e5e4b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ceca7e94c1e5e4b$var$_typeof(o);
}
function $6ceca7e94c1e5e4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ceca7e94c1e5e4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ceca7e94c1e5e4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6ceca7e94c1e5e4b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ceca7e94c1e5e4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6ceca7e94c1e5e4b$var$_defineProperty(obj, key, value) {
    key = $6ceca7e94c1e5e4b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ceca7e94c1e5e4b$var$_toPropertyKey(t) {
    var i = $6ceca7e94c1e5e4b$var$_toPrimitive(t, "string");
    return "symbol" == $6ceca7e94c1e5e4b$var$_typeof(i) ? i : i + "";
}
function $6ceca7e94c1e5e4b$var$_toPrimitive(t, r) {
    if ("object" != $6ceca7e94c1e5e4b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6ceca7e94c1e5e4b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6ceca7e94c1e5e4b$var$_slicedToArray(arr, i) {
    return $6ceca7e94c1e5e4b$var$_arrayWithHoles(arr) || $6ceca7e94c1e5e4b$var$_iterableToArrayLimit(arr, i) || $6ceca7e94c1e5e4b$var$_unsupportedIterableToArray(arr, i) || $6ceca7e94c1e5e4b$var$_nonIterableRest();
}
function $6ceca7e94c1e5e4b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ceca7e94c1e5e4b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ceca7e94c1e5e4b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ceca7e94c1e5e4b$var$_arrayLikeToArray(o, minLen);
}
function $6ceca7e94c1e5e4b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ceca7e94c1e5e4b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6ceca7e94c1e5e4b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6ceca7e94c1e5e4b$export$e60a4704009a0009 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $7fPBF.useRef)(null);
    var onResizeRef = (0, $7fPBF.useRef)();
    onResizeRef.current = onResize;
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $7fPBF.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $6ceca7e94c1e5e4b$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $7fPBF.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $7fPBF.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($932a0672a1772507$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $7fPBF.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)((0, $ddf2636240ab70e2$export$e50269385c77c348)(width) || (0, $ddf2636240ab70e2$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $ddf2636240ab70e2$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $ddf2636240ab70e2$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $7e4f89fa33734bf7$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $86b14aaa4b2f228f$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(child)) return /*#__PURE__*/ (0, $7fPBF.cloneElement)(child, $6ceca7e94c1e5e4b$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $6ceca7e94c1e5e4b$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $6ceca7e94c1e5e4b$var$_objectSpread($6ceca7e94c1e5e4b$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});



var $30837778e10d6a05$exports = {};

$parcel$export($30837778e10d6a05$exports, "backButton", function () { return $30837778e10d6a05$export$8d6d009d1f06226e; }, function (v) { return $30837778e10d6a05$export$8d6d009d1f06226e = v; });
$parcel$export($30837778e10d6a05$exports, "chartCard", function () { return $30837778e10d6a05$export$3087b27c0e8901f6; }, function (v) { return $30837778e10d6a05$export$3087b27c0e8901f6 = v; });
$parcel$export($30837778e10d6a05$exports, "chartContainer", function () { return $30837778e10d6a05$export$2b53d53e423cdab9; }, function (v) { return $30837778e10d6a05$export$2b53d53e423cdab9 = v; });
$parcel$export($30837778e10d6a05$exports, "chartGrid", function () { return $30837778e10d6a05$export$101de3493d7fac5f; }, function (v) { return $30837778e10d6a05$export$101de3493d7fac5f = v; });
$parcel$export($30837778e10d6a05$exports, "chartTitle", function () { return $30837778e10d6a05$export$c7a81636263a7a13; }, function (v) { return $30837778e10d6a05$export$c7a81636263a7a13 = v; });
$parcel$export($30837778e10d6a05$exports, "container", function () { return $30837778e10d6a05$export$34e0f9847d4c02dd; }, function (v) { return $30837778e10d6a05$export$34e0f9847d4c02dd = v; });
$parcel$export($30837778e10d6a05$exports, "content", function () { return $30837778e10d6a05$export$a7db06668cad9adb; }, function (v) { return $30837778e10d6a05$export$a7db06668cad9adb = v; });
$parcel$export($30837778e10d6a05$exports, "dataTable", function () { return $30837778e10d6a05$export$f71ce0a5ddbe8fa0; }, function (v) { return $30837778e10d6a05$export$f71ce0a5ddbe8fa0 = v; });
$parcel$export($30837778e10d6a05$exports, "dateRangeSelect", function () { return $30837778e10d6a05$export$4c4b1d91b4957191; }, function (v) { return $30837778e10d6a05$export$4c4b1d91b4957191 = v; });
$parcel$export($30837778e10d6a05$exports, "dateRangeSelector", function () { return $30837778e10d6a05$export$20f95bc510dcf079; }, function (v) { return $30837778e10d6a05$export$20f95bc510dcf079 = v; });
$parcel$export($30837778e10d6a05$exports, "filterSection", function () { return $30837778e10d6a05$export$5b26fc7e638ec99f; }, function (v) { return $30837778e10d6a05$export$5b26fc7e638ec99f = v; });
$parcel$export($30837778e10d6a05$exports, "loadingSpinner", function () { return $30837778e10d6a05$export$deaa9e6d912ce6c6; }, function (v) { return $30837778e10d6a05$export$deaa9e6d912ce6c6 = v; });
$parcel$export($30837778e10d6a05$exports, "loadingState", function () { return $30837778e10d6a05$export$d4777e60655a088c; }, function (v) { return $30837778e10d6a05$export$d4777e60655a088c = v; });
$parcel$export($30837778e10d6a05$exports, "metricCard", function () { return $30837778e10d6a05$export$daae893090f199a8; }, function (v) { return $30837778e10d6a05$export$daae893090f199a8 = v; });
$parcel$export($30837778e10d6a05$exports, "metricTitle", function () { return $30837778e10d6a05$export$4533bbca15276c3f; }, function (v) { return $30837778e10d6a05$export$4533bbca15276c3f = v; });
$parcel$export($30837778e10d6a05$exports, "metricValue", function () { return $30837778e10d6a05$export$6b8b8b1bcd04343; }, function (v) { return $30837778e10d6a05$export$6b8b8b1bcd04343 = v; });
$parcel$export($30837778e10d6a05$exports, "metricsGrid", function () { return $30837778e10d6a05$export$ff8f16205cd2dd01; }, function (v) { return $30837778e10d6a05$export$ff8f16205cd2dd01 = v; });
$parcel$export($30837778e10d6a05$exports, "noDataMessage", function () { return $30837778e10d6a05$export$1b511e8ee555918c; }, function (v) { return $30837778e10d6a05$export$1b511e8ee555918c = v; });
$parcel$export($30837778e10d6a05$exports, "pageHeader", function () { return $30837778e10d6a05$export$4cf1388ef83aed25; }, function (v) { return $30837778e10d6a05$export$4cf1388ef83aed25 = v; });
$parcel$export($30837778e10d6a05$exports, "spin", function () { return $30837778e10d6a05$export$c82e186cf428d56d; }, function (v) { return $30837778e10d6a05$export$c82e186cf428d56d = v; });
$parcel$export($30837778e10d6a05$exports, "tableCard", function () { return $30837778e10d6a05$export$d1371cad47245a25; }, function (v) { return $30837778e10d6a05$export$d1371cad47245a25 = v; });
var $30837778e10d6a05$export$8d6d009d1f06226e;
var $30837778e10d6a05$export$3087b27c0e8901f6;
var $30837778e10d6a05$export$2b53d53e423cdab9;
var $30837778e10d6a05$export$101de3493d7fac5f;
var $30837778e10d6a05$export$c7a81636263a7a13;
var $30837778e10d6a05$export$34e0f9847d4c02dd;
var $30837778e10d6a05$export$a7db06668cad9adb;
var $30837778e10d6a05$export$f71ce0a5ddbe8fa0;
var $30837778e10d6a05$export$4c4b1d91b4957191;
var $30837778e10d6a05$export$20f95bc510dcf079;
var $30837778e10d6a05$export$5b26fc7e638ec99f;
var $30837778e10d6a05$export$deaa9e6d912ce6c6;
var $30837778e10d6a05$export$d4777e60655a088c;
var $30837778e10d6a05$export$daae893090f199a8;
var $30837778e10d6a05$export$4533bbca15276c3f;
var $30837778e10d6a05$export$6b8b8b1bcd04343;
var $30837778e10d6a05$export$ff8f16205cd2dd01;
var $30837778e10d6a05$export$1b511e8ee555918c;
var $30837778e10d6a05$export$4cf1388ef83aed25;
var $30837778e10d6a05$export$c82e186cf428d56d;
var $30837778e10d6a05$export$d1371cad47245a25;
$30837778e10d6a05$export$8d6d009d1f06226e = `dQBtzG_backButton`;
$30837778e10d6a05$export$3087b27c0e8901f6 = `dQBtzG_chartCard`;
$30837778e10d6a05$export$2b53d53e423cdab9 = `dQBtzG_chartContainer`;
$30837778e10d6a05$export$101de3493d7fac5f = `dQBtzG_chartGrid`;
$30837778e10d6a05$export$c7a81636263a7a13 = `dQBtzG_chartTitle`;
$30837778e10d6a05$export$34e0f9847d4c02dd = `dQBtzG_container`;
$30837778e10d6a05$export$a7db06668cad9adb = `dQBtzG_content`;
$30837778e10d6a05$export$f71ce0a5ddbe8fa0 = `dQBtzG_dataTable`;
$30837778e10d6a05$export$4c4b1d91b4957191 = `dQBtzG_dateRangeSelect`;
$30837778e10d6a05$export$20f95bc510dcf079 = `dQBtzG_dateRangeSelector`;
$30837778e10d6a05$export$5b26fc7e638ec99f = `dQBtzG_filterSection`;
$30837778e10d6a05$export$deaa9e6d912ce6c6 = `dQBtzG_loadingSpinner`;
$30837778e10d6a05$export$d4777e60655a088c = `dQBtzG_loadingState`;
$30837778e10d6a05$export$daae893090f199a8 = `dQBtzG_metricCard`;
$30837778e10d6a05$export$4533bbca15276c3f = `dQBtzG_metricTitle`;
$30837778e10d6a05$export$6b8b8b1bcd04343 = `dQBtzG_metricValue`;
$30837778e10d6a05$export$ff8f16205cd2dd01 = `dQBtzG_metricsGrid`;
$30837778e10d6a05$export$1b511e8ee555918c = `dQBtzG_noDataMessage`;
$30837778e10d6a05$export$4cf1388ef83aed25 = `dQBtzG_pageHeader`;
$30837778e10d6a05$export$c82e186cf428d56d = `dQBtzG_spin`;
$30837778e10d6a05$export$c82e186cf428d56d;
$30837778e10d6a05$export$d1371cad47245a25 = `dQBtzG_tableCard`;


function $28f3d16ba8adf793$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [dateRange, setDateRange] = (0, $7fPBF.useState)('week'); // week, month, year
    const [metrics, setMetrics] = (0, $7fPBF.useState)({
        totalOrders: 0,
        totalRevenue: 0,
        avgOrderValue: 0,
        topItems: [],
        ordersByDay: [],
        revenueByDay: [],
        ordersByStatus: [],
        hourlyDistribution: []
    });
    (0, $7fPBF.useEffect)(()=>{
        fetchRestaurantData();
        fetchAnalyticsData();
    }, [
        restaurantId,
        dateRange
    ]);
    const fetchRestaurantData = async ()=>{
        try {
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('*').eq('id', restaurantId).single();
            if (error) throw error;
            setRestaurant(data);
        } catch (error) {
            console.error('Error fetching restaurant:', error);
        }
    };
    const fetchAnalyticsData = async ()=>{
        setLoading(true);
        try {
            // Set date range for query
            const now = new Date();
            let startDate;
            switch(dateRange){
                case 'week':
                    startDate = new Date(now);
                    startDate.setDate(now.getDate() - 7);
                    break;
                case 'month':
                    startDate = new Date(now);
                    startDate.setMonth(now.getMonth() - 1);
                    break;
                case 'year':
                    startDate = new Date(now);
                    startDate.setFullYear(now.getFullYear() - 1);
                    break;
                default:
                    startDate = new Date(now);
                    startDate.setDate(now.getDate() - 7);
            }
            const startDateStr = startDate.toISOString();
            // Fetch total orders and revenue
            const { data: ordersData, error: ordersError } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('orders').select(`
          id,
          total_amount,
          status,
          created_at,
          order_items (
            id,
            menu_item_id,
            menu_item_name,
            price,
            quantity
          )
        `).eq('restaurant_id', restaurantId).gte('created_at', startDateStr).order('created_at', {
                ascending: false
            });
            if (ordersError) throw ordersError;
            // Calculate basic metrics
            const totalOrders = ordersData.length;
            const totalRevenue = ordersData.reduce((sum, order)=>sum + order.total_amount, 0);
            const avgOrderValue = totalOrders > 0 ? totalRevenue / totalOrders : 0;
            // Process orders by day
            const ordersByDayMap = {};
            const revenueByDayMap = {};
            // Process orders by status
            const statusCounts = {
                'new': 0,
                'preparing': 0,
                'ready': 0,
                'completed': 0,
                'cancelled': 0
            };
            // Process hourly distribution
            const hourlyDistribution = Array(24).fill(0);
            // Process top items
            const itemsMap = {};
            // Populate data structures
            ordersData.forEach((order)=>{
                // Process by day
                const date = new Date(order.created_at).toLocaleDateString();
                ordersByDayMap[date] = (ordersByDayMap[date] || 0) + 1;
                revenueByDayMap[date] = (revenueByDayMap[date] || 0) + order.total_amount;
                // Process by status
                if (statusCounts[order.status] !== undefined) statusCounts[order.status]++;
                // Process by hour
                const hour = new Date(order.created_at).getHours();
                hourlyDistribution[hour]++;
                // Process items
                order.order_items.forEach((item)=>{
                    const itemId = item.menu_item_id;
                    if (!itemsMap[itemId]) itemsMap[itemId] = {
                        id: itemId,
                        name: item.menu_item_name,
                        quantity: 0,
                        revenue: 0
                    };
                    itemsMap[itemId].quantity += item.quantity;
                    itemsMap[itemId].revenue += item.price * item.quantity;
                });
            });
            // Format data for charts
            const ordersByDay = Object.entries(ordersByDayMap).map(([date, count])=>({
                    date: date,
                    orders: count
                })).sort((a, b)=>new Date(a.date) - new Date(b.date));
            const revenueByDay = Object.entries(revenueByDayMap).map(([date, amount])=>({
                    date: date,
                    revenue: parseFloat(amount.toFixed(2))
                })).sort((a, b)=>new Date(a.date) - new Date(b.date));
            const ordersByStatus = Object.entries(statusCounts).map(([status, count])=>({
                    status: status,
                    count: count
                }));
            const hourlyData = hourlyDistribution.map((count, hour)=>({
                    hour: `${hour}:00`,
                    orders: count
                }));
            // Get top items
            const topItems = Object.values(itemsMap).sort((a, b)=>b.revenue - a.revenue).slice(0, 10);
            setMetrics({
                totalOrders: totalOrders,
                totalRevenue: totalRevenue,
                avgOrderValue: avgOrderValue,
                topItems: topItems,
                ordersByDay: ordersByDay,
                revenueByDay: revenueByDay,
                ordersByStatus: ordersByStatus,
                hourlyDistribution: hourlyData
            });
        } catch (error) {
            console.error('Error fetching analytics data:', error);
        } finally{
            setLoading(false);
        }
    };
    // Colors for charts
    const COLORS = [
        '#0088FE',
        '#00C49F',
        '#FFBB28',
        '#FF8042',
        '#8884d8'
    ];
    const STATUS_COLORS = {
        'new': '#3498db',
        'preparing': '#f39c12',
        'ready': '#2ecc71',
        'completed': '#27ae60',
        'cancelled': '#e74c3c'
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).content,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).pageHeader,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                            children: restaurant?.name || 'Analytics'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            onClick: ()=>navigate(`/dashboard`),
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).backButton,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$7d058c8fc42b3484), {
                                    size: 16
                                }),
                                " Back to Dashboard"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).filterSection,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).dateRangeSelector,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$10d5cacd9501bbfa), {
                                size: 16
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                value: dateRange,
                                onChange: (e)=>setDateRange(e.target.value),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).dateRangeSelect,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: "week",
                                        children: "Last 7 Days"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: "month",
                                        children: "Last 30 Days"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: "year",
                                        children: "Last Year"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).loadingState,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).loadingSpinner
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Loading analytics data..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricsGrid,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricTitle,
                                            children: "Total Orders"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricValue,
                                            children: metrics.totalOrders
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricTitle,
                                            children: "Total Revenue"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricValue,
                                            children: [
                                                "$",
                                                metrics.totalRevenue.toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricTitle,
                                            children: "Average Order Value"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).metricValue,
                                            children: [
                                                "$",
                                                metrics.avgOrderValue.toFixed(2)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartGrid,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartTitle,
                                            children: "Orders by Day"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartContainer,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                                                width: "100%",
                                                height: 250,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $73fc4916f67614e1$export$54d0e8420ac838ac), {
                                                    data: metrics.ordersByDay,
                                                    margin: {
                                                        top: 5,
                                                        right: 20,
                                                        left: 0,
                                                        bottom: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6143e12f71339f62$export$6440e27b9f186856), {
                                                            strokeDasharray: "3 3"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e86c33407ed632$export$ea77231de273b52d), {
                                                            dataKey: "date"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a4baae21e40b313$export$f96c4024c52de8f4), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $559b693b6a1d5199$export$ed247974535929c7), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f969ea45962ba143$export$17d680238e50603e), {
                                                            type: "monotone",
                                                            dataKey: "orders",
                                                            stroke: "#635BFF",
                                                            strokeWidth: 2,
                                                            activeDot: {
                                                                r: 8
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartTitle,
                                            children: "Revenue by Day"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartContainer,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                                                width: "100%",
                                                height: 250,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $01f31af77b77addd$export$94aefc399ef206a9), {
                                                    data: metrics.revenueByDay,
                                                    margin: {
                                                        top: 5,
                                                        right: 20,
                                                        left: 0,
                                                        bottom: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6143e12f71339f62$export$6440e27b9f186856), {
                                                            strokeDasharray: "3 3"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e86c33407ed632$export$ea77231de273b52d), {
                                                            dataKey: "date"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a4baae21e40b313$export$f96c4024c52de8f4), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {
                                                            formatter: (value)=>[
                                                                    `$${value}`,
                                                                    'Revenue'
                                                                ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $559b693b6a1d5199$export$ed247974535929c7), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1), {
                                                            dataKey: "revenue",
                                                            fill: "#48BB78"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartTitle,
                                            children: "Orders by Status"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartContainer,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                                                width: "100%",
                                                height: 250,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0d06d88eccf60657$export$b99d3348f709c998), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63b3d20e0a6452f7$export$2ae8800cf67c848c), {
                                                            data: metrics.ordersByStatus,
                                                            cx: "50%",
                                                            cy: "50%",
                                                            labelLine: false,
                                                            label: ({ name: name, percent: percent })=>`${name} (${(percent * 100).toFixed(0)}%)`,
                                                            outerRadius: 80,
                                                            fill: "#8884d8",
                                                            dataKey: "count",
                                                            nameKey: "status",
                                                            children: metrics.ordersByStatus.map((entry, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $979e4bae4ee44f07$export$f6f0c3fe4ec306ea), {
                                                                    fill: STATUS_COLORS[entry.status] || COLORS[index % COLORS.length]
                                                                }, `cell-${index}`))
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $559b693b6a1d5199$export$ed247974535929c7), {})
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartCard,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartTitle,
                                            children: "Orders by Hour"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartContainer,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ceca7e94c1e5e4b$export$e60a4704009a0009), {
                                                width: "100%",
                                                height: 250,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $01f31af77b77addd$export$94aefc399ef206a9), {
                                                    data: metrics.hourlyDistribution,
                                                    margin: {
                                                        top: 5,
                                                        right: 20,
                                                        left: 0,
                                                        bottom: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6143e12f71339f62$export$6440e27b9f186856), {
                                                            strokeDasharray: "3 3"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e86c33407ed632$export$ea77231de273b52d), {
                                                            dataKey: "hour"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a4baae21e40b313$export$f96c4024c52de8f4), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9fa097d1de474101$export$28c660c63b792dea), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $559b693b6a1d5199$export$ed247974535929c7), {}),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22b628c8ce89e32e$export$bbc6c6369b38e3d1), {
                                                            dataKey: "orders",
                                                            fill: "#8884d8"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).tableCard,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).chartTitle,
                                    children: "Top Selling Items"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).dataTable,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                        children: "Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                        children: "Quantity Sold"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                                        children: "Revenue"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tbody", {
                                            children: [
                                                metrics.topItems.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                                children: item.quantity
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("td", {
                                                                children: [
                                                                    "$",
                                                                    item.revenue.toFixed(2)
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)),
                                                metrics.topItems.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                        colSpan: "3",
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($30837778e10d6a05$exports))).noDataMessage,
                                                        children: "No items sold in this period"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $7fPBF = parcelRequire("7fPBF");
var $3005b431b4c01473$exports = {};

$parcel$export($3005b431b4c01473$exports, "create", function () { return $3005b431b4c01473$export$185802fd694ee1f5; }, function (v) { return $3005b431b4c01473$export$185802fd694ee1f5 = v; });
$parcel$export($3005b431b4c01473$exports, "toCanvas", function () { return $3005b431b4c01473$export$f87f6982d1fd4f81; }, function (v) { return $3005b431b4c01473$export$f87f6982d1fd4f81 = v; });
$parcel$export($3005b431b4c01473$exports, "toDataURL", function () { return $3005b431b4c01473$export$723e4939e5a27c8; }, function (v) { return $3005b431b4c01473$export$723e4939e5a27c8 = v; });
$parcel$export($3005b431b4c01473$exports, "toString", function () { return $3005b431b4c01473$export$f84e8e69fd4488a5; }, function (v) { return $3005b431b4c01473$export$f84e8e69fd4488a5 = v; });
var $3005b431b4c01473$export$185802fd694ee1f5;
var $3005b431b4c01473$export$f87f6982d1fd4f81;
var $3005b431b4c01473$export$723e4939e5a27c8;
// only svg for now.
var $3005b431b4c01473$export$f84e8e69fd4488a5;
var $b8da48502615d980$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$b8da48502615d980$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $729d51a35e4acbcc$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $22f91d550c64949a$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $22f91d550c64949a$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $22f91d550c64949a$export$ed1d66da50968976;
var $22f91d550c64949a$export$6733b14783f975c2;
var $22f91d550c64949a$export$ce5b1274f8597fa0;
var $22f91d550c64949a$export$43dd553ecded716d;
let $22f91d550c64949a$var$toSJISFunction;
const $22f91d550c64949a$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$22f91d550c64949a$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$22f91d550c64949a$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $22f91d550c64949a$var$CODEWORDS_COUNT[version];
};
$22f91d550c64949a$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$22f91d550c64949a$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $22f91d550c64949a$var$toSJISFunction = f;
};
$22f91d550c64949a$export$ce5b1274f8597fa0 = function() {
    return typeof $22f91d550c64949a$var$toSJISFunction !== 'undefined';
};
$22f91d550c64949a$export$43dd553ecded716d = function toSJIS(kanji) {
    return $22f91d550c64949a$var$toSJISFunction(kanji);
};


var $0a555a17fbec1e4a$export$61196ced6d74a310;
var $0a555a17fbec1e4a$export$3a1a48c8f6ef640e;
var $0a555a17fbec1e4a$export$3722cfe417b6ed86;
var $0a555a17fbec1e4a$export$7f8ddf7c7c20b3cd;
var $0a555a17fbec1e4a$export$1ea939691cdc45b8;
var $0a555a17fbec1e4a$export$6788812c4e6611e6;
$0a555a17fbec1e4a$export$61196ced6d74a310 = {
    bit: 1
};
$0a555a17fbec1e4a$export$3a1a48c8f6ef640e = {
    bit: 0
};
$0a555a17fbec1e4a$export$3722cfe417b6ed86 = {
    bit: 3
};
$0a555a17fbec1e4a$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $0a555a17fbec1e4a$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $0a555a17fbec1e4a$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $0a555a17fbec1e4a$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $0a555a17fbec1e4a$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $0a555a17fbec1e4a$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$0a555a17fbec1e4a$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$0a555a17fbec1e4a$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0a555a17fbec1e4a$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0a555a17fbec1e4a$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $87149374becaffbe$exports = {};
function $87149374becaffbe$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$87149374becaffbe$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$87149374becaffbe$exports = $87149374becaffbe$var$BitBuffer;


var $99759d2ee57df356$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $99759d2ee57df356$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $99759d2ee57df356$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $99759d2ee57df356$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $99759d2ee57df356$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $99759d2ee57df356$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$99759d2ee57df356$exports = $99759d2ee57df356$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $22333b593ea441ee$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $22333b593ea441ee$export$c39457c570f2b189;

var $22333b593ea441ee$require$getSymbolSize = $22f91d550c64949a$export$8d4a06d3facd414b;
$22333b593ea441ee$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $22333b593ea441ee$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$22333b593ea441ee$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $22333b593ea441ee$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c7b05e3917c66d7a$export$c39457c570f2b189;

var $c7b05e3917c66d7a$require$getSymbolSize = $22f91d550c64949a$export$8d4a06d3facd414b;
const $c7b05e3917c66d7a$var$FINDER_PATTERN_SIZE = 7;
$c7b05e3917c66d7a$export$c39457c570f2b189 = function getPositions(version) {
    const size = $c7b05e3917c66d7a$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $c7b05e3917c66d7a$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $c7b05e3917c66d7a$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $04bb1066476205b1$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $04bb1066476205b1$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $04bb1066476205b1$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $04bb1066476205b1$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $04bb1066476205b1$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $04bb1066476205b1$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $04bb1066476205b1$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $04bb1066476205b1$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $04bb1066476205b1$export$fe9625aaceb0e563;
$04bb1066476205b1$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $04bb1066476205b1$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$04bb1066476205b1$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$04bb1066476205b1$export$6788812c4e6611e6 = function from(value) {
    return $04bb1066476205b1$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$04bb1066476205b1$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $04bb1066476205b1$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $04bb1066476205b1$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $04bb1066476205b1$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $04bb1066476205b1$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$04bb1066476205b1$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $04bb1066476205b1$var$PenaltyScores.N2;
};
$04bb1066476205b1$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $04bb1066476205b1$var$PenaltyScores.N3;
};
$04bb1066476205b1$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $04bb1066476205b1$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $04bb1066476205b1$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $04bb1066476205b1$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$04bb1066476205b1$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $04bb1066476205b1$var$getMaskAt(pattern, row, col));
    }
};
$04bb1066476205b1$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($04bb1066476205b1$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $04bb1066476205b1$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $04bb1066476205b1$export$a5fd3a02c14d0b3e(data) + $04bb1066476205b1$export$9a9385107a518e46(data) + $04bb1066476205b1$export$ade754353f0dc75e(data) + $04bb1066476205b1$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $04bb1066476205b1$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $8bb4dd3327968297$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $8bb4dd3327968297$export$683d1b3e8a1a8438;

const $8bb4dd3327968297$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $8bb4dd3327968297$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$8bb4dd3327968297$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0a555a17fbec1e4a$export$61196ced6d74a310:
            return $8bb4dd3327968297$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $0a555a17fbec1e4a$export$3a1a48c8f6ef640e:
            return $8bb4dd3327968297$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $0a555a17fbec1e4a$export$3722cfe417b6ed86:
            return $8bb4dd3327968297$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $0a555a17fbec1e4a$export$7f8ddf7c7c20b3cd:
            return $8bb4dd3327968297$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$8bb4dd3327968297$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0a555a17fbec1e4a$export$61196ced6d74a310:
            return $8bb4dd3327968297$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $0a555a17fbec1e4a$export$3a1a48c8f6ef640e:
            return $8bb4dd3327968297$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $0a555a17fbec1e4a$export$3722cfe417b6ed86:
            return $8bb4dd3327968297$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $0a555a17fbec1e4a$export$7f8ddf7c7c20b3cd:
            return $8bb4dd3327968297$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $fb27a33895d8c74d$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $d59881497ceb62d5$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $d59881497ceb62d5$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $d59881497ceb62d5$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $0d61bbf648ace560$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $0d61bbf648ace560$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $0d61bbf648ace560$export$6e3a27864ab166fe;
const $0d61bbf648ace560$var$EXP_TABLE = new Uint8Array(512);
const $0d61bbf648ace560$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $0d61bbf648ace560$var$EXP_TABLE[i] = x;
        $0d61bbf648ace560$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$0d61bbf648ace560$var$EXP_TABLE[i] = $0d61bbf648ace560$var$EXP_TABLE[i - 255];
})();
$0d61bbf648ace560$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $0d61bbf648ace560$var$LOG_TABLE[n];
};
$0d61bbf648ace560$export$b310ec824aaee37f = function exp(n) {
    return $0d61bbf648ace560$var$EXP_TABLE[n];
};
$0d61bbf648ace560$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $0d61bbf648ace560$var$EXP_TABLE[$0d61bbf648ace560$var$LOG_TABLE[x] + $0d61bbf648ace560$var$LOG_TABLE[y]];
};


$d59881497ceb62d5$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $0d61bbf648ace560$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$d59881497ceb62d5$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $0d61bbf648ace560$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$d59881497ceb62d5$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $d59881497ceb62d5$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $0d61bbf648ace560$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $fb27a33895d8c74d$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $fb27a33895d8c74d$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $d59881497ceb62d5$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $fb27a33895d8c74d$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $d59881497ceb62d5$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$fb27a33895d8c74d$exports = $fb27a33895d8c74d$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $cc0fab567fd5b7e7$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $cc0fab567fd5b7e7$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $cc0fab567fd5b7e7$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $cc0fab567fd5b7e7$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $d9bf0082b0bde95f$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $d9bf0082b0bde95f$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $d9bf0082b0bde95f$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $d9bf0082b0bde95f$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $d9bf0082b0bde95f$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $d9bf0082b0bde95f$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $d9bf0082b0bde95f$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $d9bf0082b0bde95f$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $d9bf0082b0bde95f$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7e7c991b4b39c2e5$export$1ea939691cdc45b8;
$7e7c991b4b39c2e5$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $45f39f0d5a31f40f$export$a4d452c2363c8e12;
var $45f39f0d5a31f40f$export$9df7c29d562bab83;
var $45f39f0d5a31f40f$export$8f4bf8f7eb581284;
var $45f39f0d5a31f40f$export$4d318981b5a83836;
var $45f39f0d5a31f40f$export$376a9ed239d6c1c8;
var $45f39f0d5a31f40f$export$175f16aef75a4569;
var $45f39f0d5a31f40f$export$50b7f9bf92c74274;
var $45f39f0d5a31f40f$export$4ba5f52893b4ac97;
const $45f39f0d5a31f40f$var$numeric = '[0-9]+';
const $45f39f0d5a31f40f$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $45f39f0d5a31f40f$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$45f39f0d5a31f40f$var$kanji = $45f39f0d5a31f40f$var$kanji.replace(/u/g, '\\u');
const $45f39f0d5a31f40f$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $45f39f0d5a31f40f$var$kanji + ')(?:.|[\r\n]))+';
$45f39f0d5a31f40f$export$a4d452c2363c8e12 = new RegExp($45f39f0d5a31f40f$var$kanji, 'g');
$45f39f0d5a31f40f$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$45f39f0d5a31f40f$export$8f4bf8f7eb581284 = new RegExp($45f39f0d5a31f40f$var$byte, 'g');
$45f39f0d5a31f40f$export$4d318981b5a83836 = new RegExp($45f39f0d5a31f40f$var$numeric, 'g');
$45f39f0d5a31f40f$export$376a9ed239d6c1c8 = new RegExp($45f39f0d5a31f40f$var$alphanumeric, 'g');
const $45f39f0d5a31f40f$var$TEST_KANJI = new RegExp('^' + $45f39f0d5a31f40f$var$kanji + '$');
const $45f39f0d5a31f40f$var$TEST_NUMERIC = new RegExp('^' + $45f39f0d5a31f40f$var$numeric + '$');
const $45f39f0d5a31f40f$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$45f39f0d5a31f40f$export$175f16aef75a4569 = function testKanji(str) {
    return $45f39f0d5a31f40f$var$TEST_KANJI.test(str);
};
$45f39f0d5a31f40f$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $45f39f0d5a31f40f$var$TEST_NUMERIC.test(str);
};
$45f39f0d5a31f40f$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $45f39f0d5a31f40f$var$TEST_ALPHANUMERIC.test(str);
};


$d9bf0082b0bde95f$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$d9bf0082b0bde95f$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$d9bf0082b0bde95f$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$d9bf0082b0bde95f$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$d9bf0082b0bde95f$export$bb410559a65d3418 = {
    bit: -1
};
$d9bf0082b0bde95f$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$7e7c991b4b39c2e5$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$d9bf0082b0bde95f$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($45f39f0d5a31f40f$export$50b7f9bf92c74274(dataStr)) return $d9bf0082b0bde95f$export$4d318981b5a83836;
    else if ($45f39f0d5a31f40f$export$4ba5f52893b4ac97(dataStr)) return $d9bf0082b0bde95f$export$376a9ed239d6c1c8;
    else if ($45f39f0d5a31f40f$export$175f16aef75a4569(dataStr)) return $d9bf0082b0bde95f$export$a4d452c2363c8e12;
    else return $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
};
$d9bf0082b0bde95f$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$d9bf0082b0bde95f$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $d9bf0082b0bde95f$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $d9bf0082b0bde95f$export$4d318981b5a83836;
        case 'alphanumeric':
            return $d9bf0082b0bde95f$export$376a9ed239d6c1c8;
        case 'kanji':
            return $d9bf0082b0bde95f$export$a4d452c2363c8e12;
        case 'byte':
            return $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$d9bf0082b0bde95f$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d9bf0082b0bde95f$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d9bf0082b0bde95f$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $cc0fab567fd5b7e7$var$G18 = 7973;
const $cc0fab567fd5b7e7$var$G18_BCH = $22f91d550c64949a$export$ed1d66da50968976($cc0fab567fd5b7e7$var$G18);
function $cc0fab567fd5b7e7$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $cc0fab567fd5b7e7$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $cc0fab567fd5b7e7$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $d9bf0082b0bde95f$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $cc0fab567fd5b7e7$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $cc0fab567fd5b7e7$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $cc0fab567fd5b7e7$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $cc0fab567fd5b7e7$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $cc0fab567fd5b7e7$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $d9bf0082b0bde95f$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$cc0fab567fd5b7e7$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7e7c991b4b39c2e5$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$cc0fab567fd5b7e7$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7e7c991b4b39c2e5$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $22f91d550c64949a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $8bb4dd3327968297$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $d9bf0082b0bde95f$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $cc0fab567fd5b7e7$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $d9bf0082b0bde95f$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $d9bf0082b0bde95f$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $d9bf0082b0bde95f$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $d9bf0082b0bde95f$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$cc0fab567fd5b7e7$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $0a555a17fbec1e4a$export$6788812c4e6611e6(errorCorrectionLevel, $0a555a17fbec1e4a$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $cc0fab567fd5b7e7$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $cc0fab567fd5b7e7$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$cc0fab567fd5b7e7$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7e7c991b4b39c2e5$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($22f91d550c64949a$export$ed1d66da50968976(d) - $cc0fab567fd5b7e7$var$G18_BCH >= 0)d ^= $cc0fab567fd5b7e7$var$G18 << $22f91d550c64949a$export$ed1d66da50968976(d) - $cc0fab567fd5b7e7$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $c4875a75ce741fb4$export$eee5438974ef6f0e;

const $c4875a75ce741fb4$var$G15 = 1335;
const $c4875a75ce741fb4$var$G15_MASK = 21522;
const $c4875a75ce741fb4$var$G15_BCH = $22f91d550c64949a$export$ed1d66da50968976($c4875a75ce741fb4$var$G15);
$c4875a75ce741fb4$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($22f91d550c64949a$export$ed1d66da50968976(d) - $c4875a75ce741fb4$var$G15_BCH >= 0)d ^= $c4875a75ce741fb4$var$G15 << $22f91d550c64949a$export$ed1d66da50968976(d) - $c4875a75ce741fb4$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $c4875a75ce741fb4$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $bc2e1bdfbb53846e$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $bc2e1bdfbb53846e$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $bc2e1bdfbb53846e$export$89ab1afb9839589b;

var $3e3505f79d2a0684$exports = {};

function $3e3505f79d2a0684$var$NumericData(data) {
    this.mode = $d9bf0082b0bde95f$export$4d318981b5a83836;
    this.data = data.toString();
}
$3e3505f79d2a0684$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$3e3505f79d2a0684$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$3e3505f79d2a0684$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $3e3505f79d2a0684$var$NumericData.getBitsLength(this.data.length);
};
$3e3505f79d2a0684$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$3e3505f79d2a0684$exports = $3e3505f79d2a0684$var$NumericData;


var $4154c8dd9fe738b1$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $4154c8dd9fe738b1$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $4154c8dd9fe738b1$var$AlphanumericData(data) {
    this.mode = $d9bf0082b0bde95f$export$376a9ed239d6c1c8;
    this.data = data;
}
$4154c8dd9fe738b1$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$4154c8dd9fe738b1$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4154c8dd9fe738b1$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $4154c8dd9fe738b1$var$AlphanumericData.getBitsLength(this.data.length);
};
$4154c8dd9fe738b1$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $4154c8dd9fe738b1$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $4154c8dd9fe738b1$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($4154c8dd9fe738b1$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$4154c8dd9fe738b1$exports = $4154c8dd9fe738b1$var$AlphanumericData;


var $18f8dbe24350d530$exports = {};

function $18f8dbe24350d530$var$ByteData(data) {
    this.mode = $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$18f8dbe24350d530$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$18f8dbe24350d530$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$18f8dbe24350d530$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $18f8dbe24350d530$var$ByteData.getBitsLength(this.data.length);
};
$18f8dbe24350d530$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$18f8dbe24350d530$exports = $18f8dbe24350d530$var$ByteData;


var $40b304792b96faee$exports = {};


function $40b304792b96faee$var$KanjiData(data) {
    this.mode = $d9bf0082b0bde95f$export$a4d452c2363c8e12;
    this.data = data;
}
$40b304792b96faee$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$40b304792b96faee$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$40b304792b96faee$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $40b304792b96faee$var$KanjiData.getBitsLength(this.data.length);
};
$40b304792b96faee$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $22f91d550c64949a$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$40b304792b96faee$exports = $40b304792b96faee$var$KanjiData;




var $430b2437dff8d008$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $430b2437dff8d008$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $430b2437dff8d008$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $430b2437dff8d008$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $430b2437dff8d008$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $430b2437dff8d008$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$430b2437dff8d008$exports = $430b2437dff8d008$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $bc2e1bdfbb53846e$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $bc2e1bdfbb53846e$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $bc2e1bdfbb53846e$var$getSegmentsFromString(dataStr) {
    const numSegs = $bc2e1bdfbb53846e$var$getSegments($45f39f0d5a31f40f$export$4d318981b5a83836, $d9bf0082b0bde95f$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $bc2e1bdfbb53846e$var$getSegments($45f39f0d5a31f40f$export$376a9ed239d6c1c8, $d9bf0082b0bde95f$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($22f91d550c64949a$export$ce5b1274f8597fa0()) {
        byteSegs = $bc2e1bdfbb53846e$var$getSegments($45f39f0d5a31f40f$export$8f4bf8f7eb581284, $d9bf0082b0bde95f$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $bc2e1bdfbb53846e$var$getSegments($45f39f0d5a31f40f$export$a4d452c2363c8e12, $d9bf0082b0bde95f$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $bc2e1bdfbb53846e$var$getSegments($45f39f0d5a31f40f$export$9df7c29d562bab83, $d9bf0082b0bde95f$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $bc2e1bdfbb53846e$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $d9bf0082b0bde95f$export$4d318981b5a83836:
            return $3e3505f79d2a0684$exports.getBitsLength(length);
        case $d9bf0082b0bde95f$export$376a9ed239d6c1c8:
            return $4154c8dd9fe738b1$exports.getBitsLength(length);
        case $d9bf0082b0bde95f$export$a4d452c2363c8e12:
            return $40b304792b96faee$exports.getBitsLength(length);
        case $d9bf0082b0bde95f$export$8f4bf8f7eb581284:
            return $18f8dbe24350d530$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $bc2e1bdfbb53846e$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $bc2e1bdfbb53846e$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $d9bf0082b0bde95f$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $d9bf0082b0bde95f$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $d9bf0082b0bde95f$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $d9bf0082b0bde95f$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $d9bf0082b0bde95f$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $d9bf0082b0bde95f$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $d9bf0082b0bde95f$export$8f4bf8f7eb581284,
                        length: $bc2e1bdfbb53846e$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $d9bf0082b0bde95f$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $d9bf0082b0bde95f$export$8f4bf8f7eb581284,
                        length: $bc2e1bdfbb53846e$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $bc2e1bdfbb53846e$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $bc2e1bdfbb53846e$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $bc2e1bdfbb53846e$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $bc2e1bdfbb53846e$var$getSegmentBitsLength(node.length, node.mode) + 4 + $d9bf0082b0bde95f$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $bc2e1bdfbb53846e$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $d9bf0082b0bde95f$export$1bd4c93ffb42e55e(data);
    mode = $d9bf0082b0bde95f$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $d9bf0082b0bde95f$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $d9bf0082b0bde95f$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $d9bf0082b0bde95f$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $d9bf0082b0bde95f$export$a4d452c2363c8e12 && !$22f91d550c64949a$export$ce5b1274f8597fa0()) mode = $d9bf0082b0bde95f$export$8f4bf8f7eb581284;
    switch(mode){
        case $d9bf0082b0bde95f$export$4d318981b5a83836:
            return new $3e3505f79d2a0684$exports(data);
        case $d9bf0082b0bde95f$export$376a9ed239d6c1c8:
            return new $4154c8dd9fe738b1$exports(data);
        case $d9bf0082b0bde95f$export$a4d452c2363c8e12:
            return new $40b304792b96faee$exports(data);
        case $d9bf0082b0bde95f$export$8f4bf8f7eb581284:
            return new $18f8dbe24350d530$exports(data);
    }
}
$bc2e1bdfbb53846e$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($bc2e1bdfbb53846e$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($bc2e1bdfbb53846e$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$bc2e1bdfbb53846e$export$3004f64547af360e = function fromString(data, version) {
    const segs = $bc2e1bdfbb53846e$var$getSegmentsFromString(data, $22f91d550c64949a$export$ce5b1274f8597fa0());
    const nodes = $bc2e1bdfbb53846e$var$buildNodes(segs);
    const graph = $bc2e1bdfbb53846e$var$buildGraph(nodes, version);
    const path = $430b2437dff8d008$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $bc2e1bdfbb53846e$export$571d59b505e6bb4e($bc2e1bdfbb53846e$var$mergeSegments(optimizedSegs));
};
$bc2e1bdfbb53846e$export$89ab1afb9839589b = function rawSplit(data) {
    return $bc2e1bdfbb53846e$export$571d59b505e6bb4e($bc2e1bdfbb53846e$var$getSegmentsFromString(data, $22f91d550c64949a$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $729d51a35e4acbcc$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $c7b05e3917c66d7a$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $729d51a35e4acbcc$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $729d51a35e4acbcc$var$setupAlignmentPattern(matrix, version) {
    const pos = $22333b593ea441ee$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $729d51a35e4acbcc$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $cc0fab567fd5b7e7$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $729d51a35e4acbcc$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $c4875a75ce741fb4$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $729d51a35e4acbcc$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $729d51a35e4acbcc$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $87149374becaffbe$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $d9bf0082b0bde95f$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $22f91d550c64949a$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $8bb4dd3327968297$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $729d51a35e4acbcc$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $729d51a35e4acbcc$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $22f91d550c64949a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $8bb4dd3327968297$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $8bb4dd3327968297$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $fb27a33895d8c74d$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $729d51a35e4acbcc$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $bc2e1bdfbb53846e$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $bc2e1bdfbb53846e$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $cc0fab567fd5b7e7$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $bc2e1bdfbb53846e$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $cc0fab567fd5b7e7$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $729d51a35e4acbcc$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $22f91d550c64949a$export$8d4a06d3facd414b(version);
    const modules = new $99759d2ee57df356$exports(moduleCount);
    // Add function modules
    $729d51a35e4acbcc$var$setupFinderPattern(modules, version);
    $729d51a35e4acbcc$var$setupTimingPattern(modules);
    $729d51a35e4acbcc$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $729d51a35e4acbcc$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $729d51a35e4acbcc$var$setupVersionInfo(modules, version);
    // Add data codewords
    $729d51a35e4acbcc$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $04bb1066476205b1$export$fe9625aaceb0e563(modules, $729d51a35e4acbcc$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $04bb1066476205b1$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $729d51a35e4acbcc$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$729d51a35e4acbcc$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $0a555a17fbec1e4a$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $0a555a17fbec1e4a$export$6788812c4e6611e6(options.errorCorrectionLevel, $0a555a17fbec1e4a$export$3a1a48c8f6ef640e);
        version = $cc0fab567fd5b7e7$export$6788812c4e6611e6(options.version);
        mask = $04bb1066476205b1$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $22f91d550c64949a$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $729d51a35e4acbcc$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $9f8c29174aa577e0$export$b3890eb0ae9dca99;
var $9f8c29174aa577e0$export$c3e5526bbaf70a25;
var $f8cdba6b0555bafc$export$d2312e68e1f5ad00;
var $f8cdba6b0555bafc$export$5cdac61cf538712e;
var $f8cdba6b0555bafc$export$c3a1a1f268a8142b;
var $f8cdba6b0555bafc$export$83136f57c739c5f3;
function $f8cdba6b0555bafc$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$f8cdba6b0555bafc$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $f8cdba6b0555bafc$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $f8cdba6b0555bafc$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$f8cdba6b0555bafc$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$f8cdba6b0555bafc$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $f8cdba6b0555bafc$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$f8cdba6b0555bafc$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $f8cdba6b0555bafc$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $9f8c29174aa577e0$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $9f8c29174aa577e0$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$9f8c29174aa577e0$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $9f8c29174aa577e0$var$getCanvasElement();
    opts = $f8cdba6b0555bafc$export$d2312e68e1f5ad00(opts);
    const size = $f8cdba6b0555bafc$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $f8cdba6b0555bafc$export$83136f57c739c5f3(image.data, qrData, opts);
    $9f8c29174aa577e0$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$9f8c29174aa577e0$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $9f8c29174aa577e0$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $8357fafd1f2f5ffb$export$b3890eb0ae9dca99;

function $8357fafd1f2f5ffb$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $8357fafd1f2f5ffb$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $8357fafd1f2f5ffb$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $8357fafd1f2f5ffb$var$svgCmd('M', col + margin, 0.5 + row + margin) : $8357fafd1f2f5ffb$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $8357fafd1f2f5ffb$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$8357fafd1f2f5ffb$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $f8cdba6b0555bafc$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $8357fafd1f2f5ffb$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $8357fafd1f2f5ffb$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $8357fafd1f2f5ffb$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $3005b431b4c01473$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$b8da48502615d980$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $729d51a35e4acbcc$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $729d51a35e4acbcc$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$3005b431b4c01473$export$185802fd694ee1f5 = $729d51a35e4acbcc$export$185802fd694ee1f5;
$3005b431b4c01473$export$f87f6982d1fd4f81 = $3005b431b4c01473$var$renderCanvas.bind(null, $9f8c29174aa577e0$export$b3890eb0ae9dca99);
$3005b431b4c01473$export$723e4939e5a27c8 = $3005b431b4c01473$var$renderCanvas.bind(null, $9f8c29174aa577e0$export$c3e5526bbaf70a25);
$3005b431b4c01473$export$f84e8e69fd4488a5 = $3005b431b4c01473$var$renderCanvas.bind(null, function(data, _, opts) {
    return $8357fafd1f2f5ffb$export$b3890eb0ae9dca99(data, opts);
});


var $4790ed25bc1bcdfa$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($4790ed25bc1bcdfa$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $4790ed25bc1bcdfa$exports = g;
});






var $ab615db7276ca298$exports = {};

$parcel$export($ab615db7276ca298$exports, "container", function () { return $ab615db7276ca298$export$34e0f9847d4c02dd; }, function (v) { return $ab615db7276ca298$export$34e0f9847d4c02dd = v; });
$parcel$export($ab615db7276ca298$exports, "content", function () { return $ab615db7276ca298$export$a7db06668cad9adb; }, function (v) { return $ab615db7276ca298$export$a7db06668cad9adb = v; });
$parcel$export($ab615db7276ca298$exports, "downloadButton", function () { return $ab615db7276ca298$export$aca573ffb875f084; }, function (v) { return $ab615db7276ca298$export$aca573ffb875f084 = v; });
$parcel$export($ab615db7276ca298$exports, "formGroup", function () { return $ab615db7276ca298$export$d2297815c52203ee; }, function (v) { return $ab615db7276ca298$export$d2297815c52203ee = v; });
$parcel$export($ab615db7276ca298$exports, "header", function () { return $ab615db7276ca298$export$38e42c68cf43b5d4; }, function (v) { return $ab615db7276ca298$export$38e42c68cf43b5d4 = v; });
$parcel$export($ab615db7276ca298$exports, "headerContent", function () { return $ab615db7276ca298$export$838c0e7679321ff3; }, function (v) { return $ab615db7276ca298$export$838c0e7679321ff3 = v; });
$parcel$export($ab615db7276ca298$exports, "headerRow", function () { return $ab615db7276ca298$export$faed4863136ce212; }, function (v) { return $ab615db7276ca298$export$faed4863136ce212 = v; });
$parcel$export($ab615db7276ca298$exports, "helpText", function () { return $ab615db7276ca298$export$431a3b688422af44; }, function (v) { return $ab615db7276ca298$export$431a3b688422af44 = v; });
$parcel$export($ab615db7276ca298$exports, "input", function () { return $ab615db7276ca298$export$b7e3ae3d7c15e42e; }, function (v) { return $ab615db7276ca298$export$b7e3ae3d7c15e42e = v; });
$parcel$export($ab615db7276ca298$exports, "instructions", function () { return $ab615db7276ca298$export$21ba78b50397401d; }, function (v) { return $ab615db7276ca298$export$21ba78b50397401d = v; });
$parcel$export($ab615db7276ca298$exports, "loadingContainer", function () { return $ab615db7276ca298$export$7acf0aff43f729a5; }, function (v) { return $ab615db7276ca298$export$7acf0aff43f729a5 = v; });
$parcel$export($ab615db7276ca298$exports, "loadingSpinner", function () { return $ab615db7276ca298$export$deaa9e6d912ce6c6; }, function (v) { return $ab615db7276ca298$export$deaa9e6d912ce6c6 = v; });
$parcel$export($ab615db7276ca298$exports, "logo", function () { return $ab615db7276ca298$export$db3c28d99448dcff; }, function (v) { return $ab615db7276ca298$export$db3c28d99448dcff = v; });
$parcel$export($ab615db7276ca298$exports, "logoContainer", function () { return $ab615db7276ca298$export$a1fe6a2d7788354f; }, function (v) { return $ab615db7276ca298$export$a1fe6a2d7788354f = v; });
$parcel$export($ab615db7276ca298$exports, "qrCode", function () { return $ab615db7276ca298$export$b60d6dac5af5488; }, function (v) { return $ab615db7276ca298$export$b60d6dac5af5488 = v; });
$parcel$export($ab615db7276ca298$exports, "qrCodeSection", function () { return $ab615db7276ca298$export$cfa25c6fd6c55fdb; }, function (v) { return $ab615db7276ca298$export$cfa25c6fd6c55fdb = v; });
$parcel$export($ab615db7276ca298$exports, "qrCodeWrapper", function () { return $ab615db7276ca298$export$80cd4513e0fa67d5; }, function (v) { return $ab615db7276ca298$export$80cd4513e0fa67d5 = v; });
$parcel$export($ab615db7276ca298$exports, "qrFormSection", function () { return $ab615db7276ca298$export$c75efa05eaa8ee2f; }, function (v) { return $ab615db7276ca298$export$c75efa05eaa8ee2f = v; });
$parcel$export($ab615db7276ca298$exports, "qrInfo", function () { return $ab615db7276ca298$export$892588c2336edb0e; }, function (v) { return $ab615db7276ca298$export$892588c2336edb0e = v; });
$parcel$export($ab615db7276ca298$exports, "restaurantDescription", function () { return $ab615db7276ca298$export$1c047df2f393edd8; }, function (v) { return $ab615db7276ca298$export$1c047df2f393edd8 = v; });
$parcel$export($ab615db7276ca298$exports, "secondaryButton", function () { return $ab615db7276ca298$export$130dd2cd4186e923; }, function (v) { return $ab615db7276ca298$export$130dd2cd4186e923 = v; });
$parcel$export($ab615db7276ca298$exports, "spin", function () { return $ab615db7276ca298$export$c82e186cf428d56d; }, function (v) { return $ab615db7276ca298$export$c82e186cf428d56d = v; });
var $ab615db7276ca298$export$34e0f9847d4c02dd;
var $ab615db7276ca298$export$a7db06668cad9adb;
var $ab615db7276ca298$export$aca573ffb875f084;
var $ab615db7276ca298$export$d2297815c52203ee;
var $ab615db7276ca298$export$38e42c68cf43b5d4;
var $ab615db7276ca298$export$838c0e7679321ff3;
var $ab615db7276ca298$export$faed4863136ce212;
var $ab615db7276ca298$export$431a3b688422af44;
var $ab615db7276ca298$export$b7e3ae3d7c15e42e;
var $ab615db7276ca298$export$21ba78b50397401d;
var $ab615db7276ca298$export$7acf0aff43f729a5;
var $ab615db7276ca298$export$deaa9e6d912ce6c6;
var $ab615db7276ca298$export$db3c28d99448dcff;
var $ab615db7276ca298$export$a1fe6a2d7788354f;
var $ab615db7276ca298$export$b60d6dac5af5488;
var $ab615db7276ca298$export$cfa25c6fd6c55fdb;
var $ab615db7276ca298$export$80cd4513e0fa67d5;
var $ab615db7276ca298$export$c75efa05eaa8ee2f;
var $ab615db7276ca298$export$892588c2336edb0e;
var $ab615db7276ca298$export$1c047df2f393edd8;
var $ab615db7276ca298$export$130dd2cd4186e923;
var $ab615db7276ca298$export$c82e186cf428d56d;
$ab615db7276ca298$export$34e0f9847d4c02dd = `Up0lWq_container`;
$ab615db7276ca298$export$a7db06668cad9adb = `Up0lWq_content`;
$ab615db7276ca298$export$aca573ffb875f084 = `Up0lWq_downloadButton`;
$ab615db7276ca298$export$d2297815c52203ee = `Up0lWq_formGroup`;
$ab615db7276ca298$export$38e42c68cf43b5d4 = `Up0lWq_header`;
$ab615db7276ca298$export$838c0e7679321ff3 = `Up0lWq_headerContent`;
$ab615db7276ca298$export$faed4863136ce212 = `Up0lWq_headerRow`;
$ab615db7276ca298$export$431a3b688422af44 = `Up0lWq_helpText`;
$ab615db7276ca298$export$b7e3ae3d7c15e42e = `Up0lWq_input`;
$ab615db7276ca298$export$21ba78b50397401d = `Up0lWq_instructions`;
$ab615db7276ca298$export$7acf0aff43f729a5 = `Up0lWq_loadingContainer`;
$ab615db7276ca298$export$deaa9e6d912ce6c6 = `Up0lWq_loadingSpinner`;
$ab615db7276ca298$export$db3c28d99448dcff = `Up0lWq_logo`;
$ab615db7276ca298$export$a1fe6a2d7788354f = `Up0lWq_logoContainer`;
$ab615db7276ca298$export$b60d6dac5af5488 = `Up0lWq_qrCode`;
$ab615db7276ca298$export$cfa25c6fd6c55fdb = `Up0lWq_qrCodeSection`;
$ab615db7276ca298$export$80cd4513e0fa67d5 = `Up0lWq_qrCodeWrapper`;
$ab615db7276ca298$export$c75efa05eaa8ee2f = `Up0lWq_qrFormSection`;
$ab615db7276ca298$export$892588c2336edb0e = `Up0lWq_qrInfo`;
$ab615db7276ca298$export$1c047df2f393edd8 = `Up0lWq_restaurantDescription`;
$ab615db7276ca298$export$130dd2cd4186e923 = `Up0lWq_secondaryButton`;
$ab615db7276ca298$export$c82e186cf428d56d = `Up0lWq_spin`;
$ab615db7276ca298$export$c82e186cf428d56d;


function $7eab70ac025bc537$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [qrUrl, setQrUrl] = (0, $7fPBF.useState)('');
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [tableNumber, setTableNumber] = (0, $7fPBF.useState)('');
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    // Add state for color customization
    const [fgColor, setFgColor] = (0, $7fPBF.useState)('#000000'); // Default: black
    const [bgColor, setBgColor] = (0, $7fPBF.useState)('#ffffff'); // Default: white
    (0, $7fPBF.useEffect)(()=>{
        const loadRestaurant = async ()=>{
            try {
                setLoading(true);
                const data = await (0, $928974befe8c4d00$export$daaa569a989b1b6)(restaurantId);
                setRestaurant(data);
            } catch (error) {
                console.error('Error loading restaurant:', error);
            } finally{
                setLoading(false);
            }
        };
        loadRestaurant();
    }, [
        restaurantId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (restaurant) generateQRCode();
    }, [
        restaurant,
        tableNumber,
        fgColor,
        bgColor
    ]); // Re-generate when colors change
    const generateQRCode = async ()=>{
        try {
            const deployedUrl = "https://qrbutlernew.onrender.com";
            // Construct the full menu URL with restaurant ID and optional table parameter
            const menuUrl = `${deployedUrl}/menu/${restaurantId}${tableNumber ? `?table=${tableNumber}` : ''}`;
            // Add debug logging
            console.log('Generated QR URL:', menuUrl);
            const qrCodeDataUrl = await (0, (/*@__PURE__*/$parcel$interopDefault($3005b431b4c01473$exports))).toDataURL(menuUrl, {
                width: 300,
                margin: 2,
                color: {
                    dark: fgColor,
                    light: bgColor // Use customizable background color
                }
            });
            setQrUrl(qrCodeDataUrl);
        } catch (error) {
            console.error('Error generating QR code:', error);
        }
    };
    const downloadQRCode = ()=>{
        if (qrUrl) {
            const fileName = `menu-qr-${restaurant.name}${tableNumber ? `-table-${tableNumber}` : ''}.png`;
            (0, $4790ed25bc1bcdfa$exports.saveAs)(qrUrl, fileName);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).loadingContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).loadingSpinner
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Loading restaurant data..."
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).content,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).pageHeader,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                            children: restaurant?.name || 'QR Code Generator'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            onClick: ()=>navigate('/dashboard'),
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).backButton,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$7d058c8fc42b3484), {
                                    size: 16
                                }),
                                " Back to Dashboard"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).qrFormSection,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            children: "Generate Menu QR Codes"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Create custom QR codes for tables or specific locations."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).formGroup,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "tableNumber",
                                    children: "Table or Location Number (optional)"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "tableNumber",
                                    type: "text",
                                    value: tableNumber,
                                    onChange: (e)=>setTableNumber(e.target.value),
                                    placeholder: "e.g. 12, Room 301",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).input
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).helpText,
                                    children: "Leave blank to create a general menu QR code"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorOptions,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "fgColor",
                                            children: "QR Code Color"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorPickerGroup,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    id: "fgColor",
                                                    type: "color",
                                                    value: fgColor,
                                                    onChange: (e)=>setFgColor(e.target.value),
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorPicker
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorValue,
                                                    children: fgColor
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).formGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "bgColor",
                                            children: "Background Color"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorPickerGroup,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    id: "bgColor",
                                                    type: "color",
                                                    value: bgColor,
                                                    onChange: (e)=>setBgColor(e.target.value),
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorPicker
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).colorValue,
                                                    children: bgColor
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                qrUrl && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).qrCodeSection,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).qrCodeWrapper,
                            style: {
                                backgroundColor: bgColor
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: qrUrl,
                                    alt: "Menu QR Code",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).qrCode
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).qrInfo,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                    children: "Restaurant:"
                                                }),
                                                " ",
                                                restaurant?.name
                                            ]
                                        }),
                                        tableNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                    children: "Table/Location:"
                                                }),
                                                " ",
                                                tableNumber
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            onClick: downloadQRCode,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).downloadButton,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$d455598edb9cdf88), {
                                    size: 18
                                }),
                                " Download QR Code"
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($ab615db7276ca298$exports))).instructions,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    children: "How to use"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ol", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            children: "Download this QR code"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            children: "Print and place it on your restaurant tables"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            children: "Customers can scan it to access your digital menu"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $7fPBF = parcelRequire("7fPBF");



var $aa270308d16c6651$exports = {};

$parcel$export($aa270308d16c6651$exports, "active", function () { return $aa270308d16c6651$export$89da14300d534261; }, function (v) { return $aa270308d16c6651$export$89da14300d534261 = v; });
$parcel$export($aa270308d16c6651$exports, "addToCartButton", function () { return $aa270308d16c6651$export$f214a38a866efa81; }, function (v) { return $aa270308d16c6651$export$f214a38a866efa81 = v; });
$parcel$export($aa270308d16c6651$exports, "backButton", function () { return $aa270308d16c6651$export$8d6d009d1f06226e; }, function (v) { return $aa270308d16c6651$export$8d6d009d1f06226e = v; });
$parcel$export($aa270308d16c6651$exports, "cartButton", function () { return $aa270308d16c6651$export$7861863ea30be33c; }, function (v) { return $aa270308d16c6651$export$7861863ea30be33c = v; });
$parcel$export($aa270308d16c6651$exports, "cartCount", function () { return $aa270308d16c6651$export$40bdde043bbd9702; }, function (v) { return $aa270308d16c6651$export$40bdde043bbd9702 = v; });
$parcel$export($aa270308d16c6651$exports, "categoriesNav", function () { return $aa270308d16c6651$export$ab954c89300c1913; }, function (v) { return $aa270308d16c6651$export$ab954c89300c1913 = v; });
$parcel$export($aa270308d16c6651$exports, "categoryButton", function () { return $aa270308d16c6651$export$c25848e2ce95826e; }, function (v) { return $aa270308d16c6651$export$c25848e2ce95826e = v; });
$parcel$export($aa270308d16c6651$exports, "categoryTitle", function () { return $aa270308d16c6651$export$fc6e89e9bf9f348b; }, function (v) { return $aa270308d16c6651$export$fc6e89e9bf9f348b = v; });
$parcel$export($aa270308d16c6651$exports, "centeredLogoContainer", function () { return $aa270308d16c6651$export$d817a9ab6e015035; }, function (v) { return $aa270308d16c6651$export$d817a9ab6e015035 = v; });
$parcel$export($aa270308d16c6651$exports, "errorContainer", function () { return $aa270308d16c6651$export$9d33ba969f9b84f1; }, function (v) { return $aa270308d16c6651$export$9d33ba969f9b84f1 = v; });
$parcel$export($aa270308d16c6651$exports, "header", function () { return $aa270308d16c6651$export$38e42c68cf43b5d4; }, function (v) { return $aa270308d16c6651$export$38e42c68cf43b5d4 = v; });
$parcel$export($aa270308d16c6651$exports, "headerContent", function () { return $aa270308d16c6651$export$838c0e7679321ff3; }, function (v) { return $aa270308d16c6651$export$838c0e7679321ff3 = v; });
$parcel$export($aa270308d16c6651$exports, "headerRow", function () { return $aa270308d16c6651$export$faed4863136ce212; }, function (v) { return $aa270308d16c6651$export$faed4863136ce212 = v; });
$parcel$export($aa270308d16c6651$exports, "itemActions", function () { return $aa270308d16c6651$export$5beac7a6fdd6ba9b; }, function (v) { return $aa270308d16c6651$export$5beac7a6fdd6ba9b = v; });
$parcel$export($aa270308d16c6651$exports, "itemContent", function () { return $aa270308d16c6651$export$f8739a5f2ddf37fe; }, function (v) { return $aa270308d16c6651$export$f8739a5f2ddf37fe = v; });
$parcel$export($aa270308d16c6651$exports, "itemDescription", function () { return $aa270308d16c6651$export$83f977f6e7592cb4; }, function (v) { return $aa270308d16c6651$export$83f977f6e7592cb4 = v; });
$parcel$export($aa270308d16c6651$exports, "itemInfo", function () { return $aa270308d16c6651$export$27342a7eec9ada32; }, function (v) { return $aa270308d16c6651$export$27342a7eec9ada32 = v; });
$parcel$export($aa270308d16c6651$exports, "itemName", function () { return $aa270308d16c6651$export$65720846c1412ab5; }, function (v) { return $aa270308d16c6651$export$65720846c1412ab5 = v; });
$parcel$export($aa270308d16c6651$exports, "itemPrice", function () { return $aa270308d16c6651$export$d467ea200e9afb9d; }, function (v) { return $aa270308d16c6651$export$d467ea200e9afb9d = v; });
$parcel$export($aa270308d16c6651$exports, "loadingContainer", function () { return $aa270308d16c6651$export$7acf0aff43f729a5; }, function (v) { return $aa270308d16c6651$export$7acf0aff43f729a5 = v; });
$parcel$export($aa270308d16c6651$exports, "loadingSpinner", function () { return $aa270308d16c6651$export$deaa9e6d912ce6c6; }, function (v) { return $aa270308d16c6651$export$deaa9e6d912ce6c6 = v; });
$parcel$export($aa270308d16c6651$exports, "logo", function () { return $aa270308d16c6651$export$db3c28d99448dcff; }, function (v) { return $aa270308d16c6651$export$db3c28d99448dcff = v; });
$parcel$export($aa270308d16c6651$exports, "logoContainer", function () { return $aa270308d16c6651$export$a1fe6a2d7788354f; }, function (v) { return $aa270308d16c6651$export$a1fe6a2d7788354f = v; });
$parcel$export($aa270308d16c6651$exports, "menuContainer", function () { return $aa270308d16c6651$export$8ef325e9124f92b2; }, function (v) { return $aa270308d16c6651$export$8ef325e9124f92b2 = v; });
$parcel$export($aa270308d16c6651$exports, "menuContent", function () { return $aa270308d16c6651$export$c565a4df7e025845; }, function (v) { return $aa270308d16c6651$export$c565a4df7e025845 = v; });
$parcel$export($aa270308d16c6651$exports, "menuItem", function () { return $aa270308d16c6651$export$c176f998e71d0f08; }, function (v) { return $aa270308d16c6651$export$c176f998e71d0f08 = v; });
$parcel$export($aa270308d16c6651$exports, "menuItemImage", function () { return $aa270308d16c6651$export$3b84cd9f74f016f2; }, function (v) { return $aa270308d16c6651$export$3b84cd9f74f016f2 = v; });
$parcel$export($aa270308d16c6651$exports, "menuItemImageContainer", function () { return $aa270308d16c6651$export$564c781ea5c682cc; }, function (v) { return $aa270308d16c6651$export$564c781ea5c682cc = v; });
$parcel$export($aa270308d16c6651$exports, "menuSection", function () { return $aa270308d16c6651$export$95e0837a3419f5c1; }, function (v) { return $aa270308d16c6651$export$95e0837a3419f5c1 = v; });
$parcel$export($aa270308d16c6651$exports, "noItems", function () { return $aa270308d16c6651$export$62bd5d1d7d32b664; }, function (v) { return $aa270308d16c6651$export$62bd5d1d7d32b664 = v; });
$parcel$export($aa270308d16c6651$exports, "quantity", function () { return $aa270308d16c6651$export$82dd68b83a44b253; }, function (v) { return $aa270308d16c6651$export$82dd68b83a44b253 = v; });
$parcel$export($aa270308d16c6651$exports, "quantityButton", function () { return $aa270308d16c6651$export$dabbe56297534b0; }, function (v) { return $aa270308d16c6651$export$dabbe56297534b0 = v; });
$parcel$export($aa270308d16c6651$exports, "quantityControl", function () { return $aa270308d16c6651$export$e8b7ee30acddcafb; }, function (v) { return $aa270308d16c6651$export$e8b7ee30acddcafb = v; });
$parcel$export($aa270308d16c6651$exports, "restaurantDescription", function () { return $aa270308d16c6651$export$1c047df2f393edd8; }, function (v) { return $aa270308d16c6651$export$1c047df2f393edd8 = v; });
$parcel$export($aa270308d16c6651$exports, "restaurantLogo", function () { return $aa270308d16c6651$export$da60b3e97a03444; }, function (v) { return $aa270308d16c6651$export$da60b3e97a03444 = v; });
$parcel$export($aa270308d16c6651$exports, "restaurantName", function () { return $aa270308d16c6651$export$1467a66621ac6d71; }, function (v) { return $aa270308d16c6651$export$1467a66621ac6d71 = v; });
$parcel$export($aa270308d16c6651$exports, "retryButton", function () { return $aa270308d16c6651$export$2e85e6a48fc253cd; }, function (v) { return $aa270308d16c6651$export$2e85e6a48fc253cd = v; });
$parcel$export($aa270308d16c6651$exports, "spin", function () { return $aa270308d16c6651$export$c82e186cf428d56d; }, function (v) { return $aa270308d16c6651$export$c82e186cf428d56d = v; });
$parcel$export($aa270308d16c6651$exports, "tableInfo", function () { return $aa270308d16c6651$export$4baa842b2b8365a2; }, function (v) { return $aa270308d16c6651$export$4baa842b2b8365a2 = v; });
var $aa270308d16c6651$export$89da14300d534261;
var $aa270308d16c6651$export$f214a38a866efa81;
var $aa270308d16c6651$export$8d6d009d1f06226e;
var $aa270308d16c6651$export$7861863ea30be33c;
var $aa270308d16c6651$export$40bdde043bbd9702;
var $aa270308d16c6651$export$ab954c89300c1913;
var $aa270308d16c6651$export$c25848e2ce95826e;
var $aa270308d16c6651$export$fc6e89e9bf9f348b;
var $aa270308d16c6651$export$d817a9ab6e015035;
var $aa270308d16c6651$export$9d33ba969f9b84f1;
var $aa270308d16c6651$export$38e42c68cf43b5d4;
var $aa270308d16c6651$export$838c0e7679321ff3;
var $aa270308d16c6651$export$faed4863136ce212;
var $aa270308d16c6651$export$5beac7a6fdd6ba9b;
var $aa270308d16c6651$export$f8739a5f2ddf37fe;
var $aa270308d16c6651$export$83f977f6e7592cb4;
var $aa270308d16c6651$export$27342a7eec9ada32;
var $aa270308d16c6651$export$65720846c1412ab5;
var $aa270308d16c6651$export$d467ea200e9afb9d;
var $aa270308d16c6651$export$7acf0aff43f729a5;
var $aa270308d16c6651$export$deaa9e6d912ce6c6;
var $aa270308d16c6651$export$db3c28d99448dcff;
var $aa270308d16c6651$export$a1fe6a2d7788354f;
var $aa270308d16c6651$export$8ef325e9124f92b2;
var $aa270308d16c6651$export$c565a4df7e025845;
var $aa270308d16c6651$export$c176f998e71d0f08;
var $aa270308d16c6651$export$3b84cd9f74f016f2;
var $aa270308d16c6651$export$564c781ea5c682cc;
var $aa270308d16c6651$export$95e0837a3419f5c1;
var $aa270308d16c6651$export$62bd5d1d7d32b664;
var $aa270308d16c6651$export$82dd68b83a44b253;
var $aa270308d16c6651$export$dabbe56297534b0;
var $aa270308d16c6651$export$e8b7ee30acddcafb;
var $aa270308d16c6651$export$1c047df2f393edd8;
var $aa270308d16c6651$export$da60b3e97a03444;
var $aa270308d16c6651$export$1467a66621ac6d71;
var $aa270308d16c6651$export$2e85e6a48fc253cd;
var $aa270308d16c6651$export$c82e186cf428d56d;
var $aa270308d16c6651$export$4baa842b2b8365a2;
$aa270308d16c6651$export$89da14300d534261 = `rFt63W_active`;
$aa270308d16c6651$export$f214a38a866efa81 = `rFt63W_addToCartButton`;
$aa270308d16c6651$export$8d6d009d1f06226e = `rFt63W_backButton`;
$aa270308d16c6651$export$7861863ea30be33c = `rFt63W_cartButton`;
$aa270308d16c6651$export$40bdde043bbd9702 = `rFt63W_cartCount`;
$aa270308d16c6651$export$ab954c89300c1913 = `rFt63W_categoriesNav`;
$aa270308d16c6651$export$c25848e2ce95826e = `rFt63W_categoryButton`;
$aa270308d16c6651$export$fc6e89e9bf9f348b = `rFt63W_categoryTitle`;
$aa270308d16c6651$export$d817a9ab6e015035 = `rFt63W_centeredLogoContainer`;
$aa270308d16c6651$export$9d33ba969f9b84f1 = `rFt63W_errorContainer`;
$aa270308d16c6651$export$38e42c68cf43b5d4 = `rFt63W_header`;
$aa270308d16c6651$export$838c0e7679321ff3 = `rFt63W_headerContent`;
$aa270308d16c6651$export$faed4863136ce212 = `rFt63W_headerRow`;
$aa270308d16c6651$export$5beac7a6fdd6ba9b = `rFt63W_itemActions`;
$aa270308d16c6651$export$f8739a5f2ddf37fe = `rFt63W_itemContent`;
$aa270308d16c6651$export$83f977f6e7592cb4 = `rFt63W_itemDescription`;
$aa270308d16c6651$export$27342a7eec9ada32 = `rFt63W_itemInfo`;
$aa270308d16c6651$export$65720846c1412ab5 = `rFt63W_itemName`;
$aa270308d16c6651$export$d467ea200e9afb9d = `rFt63W_itemPrice`;
$aa270308d16c6651$export$7acf0aff43f729a5 = `rFt63W_loadingContainer`;
$aa270308d16c6651$export$deaa9e6d912ce6c6 = `rFt63W_loadingSpinner`;
$aa270308d16c6651$export$db3c28d99448dcff = `rFt63W_logo`;
$aa270308d16c6651$export$a1fe6a2d7788354f = `rFt63W_logoContainer`;
$aa270308d16c6651$export$8ef325e9124f92b2 = `rFt63W_menuContainer`;
$aa270308d16c6651$export$c565a4df7e025845 = `rFt63W_menuContent`;
$aa270308d16c6651$export$c176f998e71d0f08 = `rFt63W_menuItem`;
$aa270308d16c6651$export$3b84cd9f74f016f2 = `rFt63W_menuItemImage`;
$aa270308d16c6651$export$564c781ea5c682cc = `rFt63W_menuItemImageContainer`;
$aa270308d16c6651$export$95e0837a3419f5c1 = `rFt63W_menuSection`;
$aa270308d16c6651$export$62bd5d1d7d32b664 = `rFt63W_noItems`;
$aa270308d16c6651$export$82dd68b83a44b253 = `rFt63W_quantity`;
$aa270308d16c6651$export$dabbe56297534b0 = `rFt63W_quantityButton`;
$aa270308d16c6651$export$e8b7ee30acddcafb = `rFt63W_quantityControl`;
$aa270308d16c6651$export$1c047df2f393edd8 = `rFt63W_restaurantDescription`;
$aa270308d16c6651$export$da60b3e97a03444 = `rFt63W_restaurantLogo`;
$aa270308d16c6651$export$1467a66621ac6d71 = `rFt63W_restaurantName`;
$aa270308d16c6651$export$2e85e6a48fc253cd = `rFt63W_retryButton`;
$aa270308d16c6651$export$c82e186cf428d56d = `rFt63W_spin`;
$aa270308d16c6651$export$c82e186cf428d56d;
$aa270308d16c6651$export$4baa842b2b8365a2 = `rFt63W_tableInfo`;



function $29396d0e80697ab9$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [categories, setCategories] = (0, $7fPBF.useState)([]);
    const [activeCategory, setActiveCategory] = (0, $7fPBF.useState)(null);
    const [cart, setCart] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Extract table parameter from URL query string
    const tableNumber = new URLSearchParams(location.search).get('table');
    (0, $7fPBF.useEffect)(()=>{
        const loadMenu = async ()=>{
            try {
                console.log('Loading menu for restaurant:', restaurantId);
                setLoading(true);
                setError(null);
                // Load restaurant and menu data in parallel
                const [restaurantData, menuData] = await Promise.all([
                    (0, $928974befe8c4d00$export$daaa569a989b1b6)(restaurantId),
                    (0, $928974befe8c4d00$export$33128913ed9fcff9)(restaurantId)
                ]);
                console.log('Restaurant data:', restaurantData);
                console.log('Menu data:', menuData);
                if (!restaurantData) throw new Error('Restaurant not found');
                setRestaurant(restaurantData);
                setCategories(menuData);
                // Set first category as active if available
                if (menuData && menuData.length > 0) setActiveCategory(menuData[0].id);
                // Load cart from localStorage
                const savedCart = localStorage.getItem(`cart-${restaurantId}`);
                if (savedCart) setCart(JSON.parse(savedCart));
                // Handle table number - if no table number in URL, clear any stored table number
                if (!tableNumber) localStorage.removeItem(`table-${restaurantId}`);
            } catch (err) {
                console.error('Error loading menu:', err);
                setError(err.message || 'Failed to load menu');
            } finally{
                setLoading(false);
            }
        };
        loadMenu();
    }, [
        restaurantId,
        location.search,
        tableNumber
    ]);
    const addToCart = (item)=>{
        setCart((prevCart)=>{
            const existingItem = prevCart.find((cartItem)=>cartItem.id === item.id);
            let newCart;
            if (existingItem) newCart = prevCart.map((cartItem)=>cartItem.id === item.id ? {
                    ...cartItem,
                    quantity: cartItem.quantity + 1
                } : cartItem);
            else newCart = [
                ...prevCart,
                {
                    ...item,
                    quantity: 1
                }
            ];
            localStorage.setItem(`cart-${restaurantId}`, JSON.stringify(newCart));
            return newCart;
        });
    };
    const removeFromCart = (itemId)=>{
        setCart((prevCart)=>{
            const newCart = prevCart.map((item)=>item.id === itemId ? {
                    ...item,
                    quantity: Math.max(0, item.quantity - 1)
                } : item).filter((item)=>item.quantity > 0);
            localStorage.setItem(`cart-${restaurantId}`, JSON.stringify(newCart));
            return newCart;
        });
    };
    const getItemQuantity = (itemId)=>{
        const item = cart.find((item)=>item.id === itemId);
        return item ? item.quantity : 0;
    };
    const getTotalItems = ()=>{
        return cart.reduce((sum, item)=>sum + item.quantity, 0);
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).loadingContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).loadingSpinner
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Loading menu..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).errorContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                children: "Error Loading Menu"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: ()=>window.location.reload(),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).retryButton,
                children: "Try Again"
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("header", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).header,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).headerContent,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).headerRow,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).logoContainer,
                                children: [
                                    restaurant?.logo_url ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: restaurant.logo_url,
                                        alt: restaurant.name,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).restaurantLogo
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {
                                        color: "white",
                                        size: "large"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).restaurantName,
                                        children: restaurant?.name
                                    })
                                ]
                            })
                        }),
                        tableNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).tableInfo,
                            children: [
                                "Table ",
                                tableNumber
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuContent,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).categoriesNav,
                        children: categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: ()=>setActiveCategory(category.id),
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).categoryButton} ${activeCategory === category.id ? (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).active : ''}`,
                                children: category.name
                            }, category.id))
                    }),
                    categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuSection,
                            style: {
                                display: activeCategory === category.id ? 'block' : 'none'
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).categoryTitle,
                                    children: category.name
                                }),
                                category.menu_items?.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).noItems,
                                    children: "No items in this category"
                                }) : category.menu_items?.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuItem,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemContent,
                                                children: [
                                                    item.image_url && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuItemImageContainer,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                            src: item.image_url,
                                                            alt: item.name,
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).menuItemImage
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemInfo,
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemName,
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemDescription,
                                                                children: item.description
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemPrice,
                                                                children: [
                                                                    "$",
                                                                    item.price.toFixed(2)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).itemActions,
                                                children: getItemQuantity(item.id) > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).quantityControl,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).quantityButton,
                                                            onClick: ()=>removeFromCart(item.id),
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$6a0f8a0147922bb7), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).quantity,
                                                            children: getItemQuantity(item.id)
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).quantityButton,
                                                            onClick: ()=>addToCart(item),
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {})
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).addToCartButton,
                                                    onClick: ()=>addToCart(item),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$689fe09b4199e823), {}),
                                                        " Add to Cart"
                                                    ]
                                                })
                                            })
                                        ]
                                    }, item.id))
                            ]
                        }, category.id))
                ]
            }),
            cart.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).cartButton,
                onClick: ()=>navigate(`/cart/${restaurantId}`, {
                        state: {
                            tableNumber: tableNumber
                        }
                    }),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $224220bec829c8cd$export$9a07702d62565b4e), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($aa270308d16c6651$exports))).cartCount,
                        children: getTotalItems()
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");


var $4a625f307b4b2607$exports = {};

$parcel$export($4a625f307b4b2607$exports, "actionButton", function () { return $4a625f307b4b2607$export$a75c7ea49564edd7; }, function (v) { return $4a625f307b4b2607$export$a75c7ea49564edd7 = v; });
$parcel$export($4a625f307b4b2607$exports, "banner", function () { return $4a625f307b4b2607$export$bb5ee47d9ea2348e; }, function (v) { return $4a625f307b4b2607$export$bb5ee47d9ea2348e = v; });
$parcel$export($4a625f307b4b2607$exports, "cartItem", function () { return $4a625f307b4b2607$export$2d46a809d3129e48; }, function (v) { return $4a625f307b4b2607$export$2d46a809d3129e48 = v; });
$parcel$export($4a625f307b4b2607$exports, "cartSection", function () { return $4a625f307b4b2607$export$64b1c18799dc825a; }, function (v) { return $4a625f307b4b2607$export$64b1c18799dc825a = v; });
$parcel$export($4a625f307b4b2607$exports, "cartSummary", function () { return $4a625f307b4b2607$export$38dbabca159bb6b7; }, function (v) { return $4a625f307b4b2607$export$38dbabca159bb6b7 = v; });
$parcel$export($4a625f307b4b2607$exports, "container", function () { return $4a625f307b4b2607$export$34e0f9847d4c02dd; }, function (v) { return $4a625f307b4b2607$export$34e0f9847d4c02dd = v; });
$parcel$export($4a625f307b4b2607$exports, "content", function () { return $4a625f307b4b2607$export$a7db06668cad9adb; }, function (v) { return $4a625f307b4b2607$export$a7db06668cad9adb = v; });
$parcel$export($4a625f307b4b2607$exports, "customerInfoSection", function () { return $4a625f307b4b2607$export$9998cf16623d549c; }, function (v) { return $4a625f307b4b2607$export$9998cf16623d549c = v; });
$parcel$export($4a625f307b4b2607$exports, "emptyCart", function () { return $4a625f307b4b2607$export$499eb6fc472e9275; }, function (v) { return $4a625f307b4b2607$export$499eb6fc472e9275 = v; });
$parcel$export($4a625f307b4b2607$exports, "formGroup", function () { return $4a625f307b4b2607$export$d2297815c52203ee; }, function (v) { return $4a625f307b4b2607$export$d2297815c52203ee = v; });
$parcel$export($4a625f307b4b2607$exports, "itemControls", function () { return $4a625f307b4b2607$export$2f0d46cd43f693a1; }, function (v) { return $4a625f307b4b2607$export$2f0d46cd43f693a1 = v; });
$parcel$export($4a625f307b4b2607$exports, "itemDetails", function () { return $4a625f307b4b2607$export$cc0b09c3267aae84; }, function (v) { return $4a625f307b4b2607$export$cc0b09c3267aae84 = v; });
$parcel$export($4a625f307b4b2607$exports, "itemName", function () { return $4a625f307b4b2607$export$65720846c1412ab5; }, function (v) { return $4a625f307b4b2607$export$65720846c1412ab5 = v; });
$parcel$export($4a625f307b4b2607$exports, "itemPrice", function () { return $4a625f307b4b2607$export$d467ea200e9afb9d; }, function (v) { return $4a625f307b4b2607$export$d467ea200e9afb9d = v; });
$parcel$export($4a625f307b4b2607$exports, "modificationIndicator", function () { return $4a625f307b4b2607$export$a2ec05a547fb95e9; }, function (v) { return $4a625f307b4b2607$export$a2ec05a547fb95e9 = v; });
$parcel$export($4a625f307b4b2607$exports, "primaryButton", function () { return $4a625f307b4b2607$export$41c1085b355ecc97; }, function (v) { return $4a625f307b4b2607$export$41c1085b355ecc97 = v; });
$parcel$export($4a625f307b4b2607$exports, "quantity", function () { return $4a625f307b4b2607$export$82dd68b83a44b253; }, function (v) { return $4a625f307b4b2607$export$82dd68b83a44b253 = v; });
$parcel$export($4a625f307b4b2607$exports, "quantityButton", function () { return $4a625f307b4b2607$export$dabbe56297534b0; }, function (v) { return $4a625f307b4b2607$export$dabbe56297534b0 = v; });
$parcel$export($4a625f307b4b2607$exports, "quantityControl", function () { return $4a625f307b4b2607$export$e8b7ee30acddcafb; }, function (v) { return $4a625f307b4b2607$export$e8b7ee30acddcafb = v; });
$parcel$export($4a625f307b4b2607$exports, "quantityDisplay", function () { return $4a625f307b4b2607$export$52692be51288d03e; }, function (v) { return $4a625f307b4b2607$export$52692be51288d03e = v; });
$parcel$export($4a625f307b4b2607$exports, "removeButton", function () { return $4a625f307b4b2607$export$8d776830dbcce823; }, function (v) { return $4a625f307b4b2607$export$8d776830dbcce823 = v; });
$parcel$export($4a625f307b4b2607$exports, "returnLink", function () { return $4a625f307b4b2607$export$ed0d14b0a52926e8; }, function (v) { return $4a625f307b4b2607$export$ed0d14b0a52926e8 = v; });
$parcel$export($4a625f307b4b2607$exports, "sectionHeader", function () { return $4a625f307b4b2607$export$562e61a0817eb32e; }, function (v) { return $4a625f307b4b2607$export$562e61a0817eb32e = v; });
$parcel$export($4a625f307b4b2607$exports, "specialInstructionsContainer", function () { return $4a625f307b4b2607$export$765d28250654cf0a; }, function (v) { return $4a625f307b4b2607$export$765d28250654cf0a = v; });
$parcel$export($4a625f307b4b2607$exports, "specialInstructionsInput", function () { return $4a625f307b4b2607$export$9ecd76422dcb5654; }, function (v) { return $4a625f307b4b2607$export$9ecd76422dcb5654 = v; });
$parcel$export($4a625f307b4b2607$exports, "summaryRow", function () { return $4a625f307b4b2607$export$41bdc12d2d25233b; }, function (v) { return $4a625f307b4b2607$export$41bdc12d2d25233b = v; });
$parcel$export($4a625f307b4b2607$exports, "totalRow", function () { return $4a625f307b4b2607$export$25439473a16ba657; }, function (v) { return $4a625f307b4b2607$export$25439473a16ba657 = v; });
var $4a625f307b4b2607$export$a75c7ea49564edd7;
var $4a625f307b4b2607$export$bb5ee47d9ea2348e;
var $4a625f307b4b2607$export$2d46a809d3129e48;
var $4a625f307b4b2607$export$64b1c18799dc825a;
var $4a625f307b4b2607$export$38dbabca159bb6b7;
var $4a625f307b4b2607$export$34e0f9847d4c02dd;
var $4a625f307b4b2607$export$a7db06668cad9adb;
var $4a625f307b4b2607$export$9998cf16623d549c;
var $4a625f307b4b2607$export$499eb6fc472e9275;
var $4a625f307b4b2607$export$d2297815c52203ee;
var $4a625f307b4b2607$export$2f0d46cd43f693a1;
var $4a625f307b4b2607$export$cc0b09c3267aae84;
var $4a625f307b4b2607$export$65720846c1412ab5;
var $4a625f307b4b2607$export$d467ea200e9afb9d;
var $4a625f307b4b2607$export$a2ec05a547fb95e9;
var $4a625f307b4b2607$export$41c1085b355ecc97;
var $4a625f307b4b2607$export$82dd68b83a44b253;
var $4a625f307b4b2607$export$dabbe56297534b0;
var $4a625f307b4b2607$export$e8b7ee30acddcafb;
var $4a625f307b4b2607$export$52692be51288d03e;
var $4a625f307b4b2607$export$8d776830dbcce823;
var $4a625f307b4b2607$export$ed0d14b0a52926e8;
var $4a625f307b4b2607$export$562e61a0817eb32e;
var $4a625f307b4b2607$export$765d28250654cf0a;
var $4a625f307b4b2607$export$9ecd76422dcb5654;
var $4a625f307b4b2607$export$41bdc12d2d25233b;
var $4a625f307b4b2607$export$25439473a16ba657;
$4a625f307b4b2607$export$a75c7ea49564edd7 = `O_DNFa_actionButton`;
$4a625f307b4b2607$export$bb5ee47d9ea2348e = `O_DNFa_banner`;
$4a625f307b4b2607$export$2d46a809d3129e48 = `O_DNFa_cartItem`;
$4a625f307b4b2607$export$64b1c18799dc825a = `O_DNFa_cartSection`;
$4a625f307b4b2607$export$38dbabca159bb6b7 = `O_DNFa_cartSummary`;
$4a625f307b4b2607$export$34e0f9847d4c02dd = `O_DNFa_container`;
$4a625f307b4b2607$export$a7db06668cad9adb = `O_DNFa_content`;
$4a625f307b4b2607$export$9998cf16623d549c = `O_DNFa_customerInfoSection`;
$4a625f307b4b2607$export$499eb6fc472e9275 = `O_DNFa_emptyCart`;
$4a625f307b4b2607$export$d2297815c52203ee = `O_DNFa_formGroup`;
$4a625f307b4b2607$export$2f0d46cd43f693a1 = `O_DNFa_itemControls`;
$4a625f307b4b2607$export$cc0b09c3267aae84 = `O_DNFa_itemDetails`;
$4a625f307b4b2607$export$65720846c1412ab5 = `O_DNFa_itemName`;
$4a625f307b4b2607$export$d467ea200e9afb9d = `O_DNFa_itemPrice`;
$4a625f307b4b2607$export$a2ec05a547fb95e9 = `O_DNFa_modificationIndicator`;
$4a625f307b4b2607$export$41c1085b355ecc97 = `O_DNFa_primaryButton`;
$4a625f307b4b2607$export$82dd68b83a44b253 = `O_DNFa_quantity`;
$4a625f307b4b2607$export$dabbe56297534b0 = `O_DNFa_quantityButton`;
$4a625f307b4b2607$export$e8b7ee30acddcafb = `O_DNFa_quantityControl`;
$4a625f307b4b2607$export$52692be51288d03e = `O_DNFa_quantityDisplay`;
$4a625f307b4b2607$export$8d776830dbcce823 = `O_DNFa_removeButton`;
$4a625f307b4b2607$export$ed0d14b0a52926e8 = `O_DNFa_returnLink`;
$4a625f307b4b2607$export$562e61a0817eb32e = `O_DNFa_sectionHeader`;
$4a625f307b4b2607$export$765d28250654cf0a = `O_DNFa_specialInstructionsContainer`;
$4a625f307b4b2607$export$9ecd76422dcb5654 = `O_DNFa_specialInstructionsInput`;
$4a625f307b4b2607$export$41bdc12d2d25233b = `O_DNFa_summaryRow`;
$4a625f307b4b2607$export$25439473a16ba657 = `O_DNFa_totalRow`;


var $8cef0388ffbd38bf$exports = {};

$parcel$export($8cef0388ffbd38bf$exports, "card", function () { return $8cef0388ffbd38bf$export$aa3e815946b80764; }, function (v) { return $8cef0388ffbd38bf$export$aa3e815946b80764 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "contentContainer", function () { return $8cef0388ffbd38bf$export$8f981dffec84ba52; }, function (v) { return $8cef0388ffbd38bf$export$8f981dffec84ba52 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "gridContainer", function () { return $8cef0388ffbd38bf$export$711e2b273dbb00ac; }, function (v) { return $8cef0388ffbd38bf$export$711e2b273dbb00ac = v; });
$parcel$export($8cef0388ffbd38bf$exports, "headerContent", function () { return $8cef0388ffbd38bf$export$838c0e7679321ff3; }, function (v) { return $8cef0388ffbd38bf$export$838c0e7679321ff3 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "headerRow", function () { return $8cef0388ffbd38bf$export$faed4863136ce212; }, function (v) { return $8cef0388ffbd38bf$export$faed4863136ce212 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "pageContainer", function () { return $8cef0388ffbd38bf$export$9bfd64464b8f45a7; }, function (v) { return $8cef0388ffbd38bf$export$9bfd64464b8f45a7 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "pageHeader", function () { return $8cef0388ffbd38bf$export$4cf1388ef83aed25; }, function (v) { return $8cef0388ffbd38bf$export$4cf1388ef83aed25 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "primaryButton", function () { return $8cef0388ffbd38bf$export$41c1085b355ecc97; }, function (v) { return $8cef0388ffbd38bf$export$41c1085b355ecc97 = v; });
$parcel$export($8cef0388ffbd38bf$exports, "secondaryButton", function () { return $8cef0388ffbd38bf$export$130dd2cd4186e923; }, function (v) { return $8cef0388ffbd38bf$export$130dd2cd4186e923 = v; });
var $8cef0388ffbd38bf$export$aa3e815946b80764;
var $8cef0388ffbd38bf$export$8f981dffec84ba52;
var $8cef0388ffbd38bf$export$711e2b273dbb00ac;
var $8cef0388ffbd38bf$export$838c0e7679321ff3;
var $8cef0388ffbd38bf$export$faed4863136ce212;
var $8cef0388ffbd38bf$export$9bfd64464b8f45a7;
var $8cef0388ffbd38bf$export$4cf1388ef83aed25;
var $8cef0388ffbd38bf$export$41c1085b355ecc97;
var $8cef0388ffbd38bf$export$130dd2cd4186e923;
$8cef0388ffbd38bf$export$aa3e815946b80764 = `o7lr3a_card`;
$8cef0388ffbd38bf$export$8f981dffec84ba52 = `o7lr3a_contentContainer`;
$8cef0388ffbd38bf$export$711e2b273dbb00ac = `o7lr3a_gridContainer`;
$8cef0388ffbd38bf$export$838c0e7679321ff3 = `o7lr3a_headerContent`;
$8cef0388ffbd38bf$export$faed4863136ce212 = `o7lr3a_headerRow`;
$8cef0388ffbd38bf$export$9bfd64464b8f45a7 = `o7lr3a_pageContainer`;
$8cef0388ffbd38bf$export$4cf1388ef83aed25 = `o7lr3a_pageHeader`;
$8cef0388ffbd38bf$export$41c1085b355ecc97 = `o7lr3a_primaryButton`;
$8cef0388ffbd38bf$export$130dd2cd4186e923 = `o7lr3a_secondaryButton`;



function $98bf67c3eb3c7952$export$2e2bcd8739ae039() {
    const { restaurantId: restaurantId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [cart, setCart] = (0, $7fPBF.useState)([]);
    const [restaurant, setRestaurant] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [submitting, setSubmitting] = (0, $7fPBF.useState)(false);
    const [customerInfo, setCustomerInfo] = (0, $7fPBF.useState)({
        name: '',
        email: '',
        specialInstructions: ''
    });
    // Get table number from URL parameter first, then location state
    const urlTableParam = new URLSearchParams(location.search).get('table');
    const tableNumber = urlTableParam || location.state?.tableNumber || null;
    // This effect loads the restaurant and cart data on component mount
    (0, $7fPBF.useEffect)(()=>{
        const fetchRestaurant = async ()=>{
            try {
                const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('restaurants').select('*').eq('id', restaurantId).single();
                if (error) throw error;
                setRestaurant(data);
                // Load cart from localStorage
                const savedCart = localStorage.getItem(`cart-${restaurantId}`);
                if (savedCart) {
                    const parsedCart = JSON.parse(savedCart);
                    setCart(parsedCart);
                    // Only load customer info if cart has items
                    if (parsedCart.length > 0) {
                        const savedCustomerInfo = localStorage.getItem(`customer-info-${restaurantId}`);
                        if (savedCustomerInfo) setCustomerInfo(JSON.parse(savedCustomerInfo));
                    } else // Clear customer info for empty carts
                    localStorage.removeItem(`customer-info-${restaurantId}`);
                }
            } catch (error) {
                console.error('Error fetching restaurant:', error);
            } finally{
                setLoading(false);
            }
        };
        fetchRestaurant();
    }, [
        restaurantId
    ]);
    const removeItem = (itemId)=>{
        const updatedCart = cart.filter((item)=>item.id !== itemId);
        setCart(updatedCart);
        localStorage.setItem(`cart-${restaurantId}`, JSON.stringify(updatedCart));
        // If cart becomes empty, also clear customer info
        if (updatedCart.length === 0) {
            localStorage.removeItem(`customer-info-${restaurantId}`);
            setCustomerInfo({
                name: '',
                email: '',
                specialInstructions: ''
            });
        }
    };
    const updateQuantity = (itemId, newQuantity)=>{
        if (newQuantity < 1) return;
        const updatedCart = cart.map((item)=>item.id === itemId ? {
                ...item,
                quantity: newQuantity
            } : item);
        setCart(updatedCart);
        localStorage.setItem(`cart-${restaurantId}`, JSON.stringify(updatedCart));
    };
    // Update special instructions for a specific item
    const updateItemInstructions = (itemId, instructions)=>{
        const updatedCart = cart.map((item)=>item.id === itemId ? {
                ...item,
                specialInstructions: instructions
            } : item);
        setCart(updatedCart);
        localStorage.setItem(`cart-${restaurantId}`, JSON.stringify(updatedCart));
    };
    const calculateSubtotal = ()=>{
        return cart.reduce((sum, item)=>sum + item.price * item.quantity, 0);
    };
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setCustomerInfo((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    // Clear the entire cart
    const clearCart = ()=>{
        setCart([]);
        localStorage.removeItem(`cart-${restaurantId}`);
        localStorage.removeItem(`customer-info-${restaurantId}`);
        setCustomerInfo({
            name: '',
            email: '',
            specialInstructions: ''
        });
    };
    const handleCheckout = async (e)=>{
        e.preventDefault();
        // Prevent double submission
        if (submitting) return;
        setSubmitting(true);
        // Save customer info to localStorage only if the order is proceeding
        localStorage.setItem(`customer-info-${restaurantId}`, JSON.stringify(customerInfo));
        try {
            console.log("Cart item example:", cart[0]); // Log the structure of an item to verify it has name
            console.log("Creating order with data:", {
                restaurant_id: restaurantId,
                customer_name: customerInfo.name,
                customer_email: customerInfo.email,
                special_instructions: customerInfo.specialInstructions,
                table_number: tableNumber,
                total_amount: calculateSubtotal(),
                items: cart
            });
            // Send the order to the server endpoint instead of direct Supabase access
            const response = await fetch('/api/orders', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    restaurant_id: restaurantId,
                    customer_name: customerInfo.name,
                    customer_email: customerInfo.email || null,
                    special_instructions: customerInfo.specialInstructions || null,
                    table_number: tableNumber || null,
                    total_amount: calculateSubtotal(),
                    items: cart
                })
            });
            // Log full response for debugging
            console.log("Server response status:", response.status);
            if (!response.ok) {
                const errorData = await response.json();
                console.error("Error response data:", errorData);
                throw new Error(errorData.error || 'Failed to create order');
            }
            const orderData = await response.json();
            console.log("Order created successfully:", orderData);
            // Handle successful order creation
            handleOrderSuccess(orderData);
        } catch (error) {
            console.error('Error creating order:', error);
            alert(`There was a problem creating your order: ${error.message}`);
        } finally{
            setSubmitting(false);
        }
    };
    // Handle successful order creation
    const handleOrderSuccess = (orderData)=>{
        // Clear cart and customer info after successful order creation
        localStorage.removeItem(`cart-${restaurantId}`);
        localStorage.removeItem(`customer-info-${restaurantId}`);
        // Navigate to checkout with the orderId and table parameter if available
        if (orderData && orderData.id) {
            console.log(`Navigating to checkout with order ID: ${orderData.id}`);
            navigate(`/checkout/${orderData.id}${tableNumber ? `?table=${tableNumber}` : ''}`);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8cef0388ffbd38bf$exports))).pageContainer,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).loadingContainer,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).loadingSpinner
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: "Loading..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8cef0388ffbd38bf$exports))).pageContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).banner,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                        children: [
                            "Your Order from ",
                            restaurant.name
                        ]
                    }),
                    tableNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).tableInfo,
                        children: [
                            "Table: ",
                            tableNumber
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).content,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                        to: `/menu/${restaurantId}${tableNumber ? `?table=${tableNumber}` : ''}`,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).returnLink,
                        children: "\u2190 Back to Menu"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).cartSection,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).sectionHeader,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        children: "Order Items"
                                    }),
                                    cart.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        onClick: clearCart,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).clearCartButton,
                                        children: "Clear Cart"
                                    })
                                ]
                            }),
                            cart.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).emptyCart,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Your cart is empty"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                        to: `/menu/${restaurantId}${tableNumber ? `?table=${tableNumber}` : ''}`,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).browseMenuLink,
                                        children: "Browse the menu"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).itemsList,
                                children: [
                                    cart.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).cartItem,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).itemDetails,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).itemName,
                                                            children: item.name
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).itemPrice,
                                                            children: [
                                                                "$",
                                                                (item.price * item.quantity).toFixed(2)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).specialInstructionsContainer,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).specialInstructionsInput,
                                                        placeholder: "Special instructions for this item...",
                                                        value: item.specialInstructions || "",
                                                        onChange: (e)=>updateItemInstructions(item.id, e.target.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).itemControls,
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).quantityControl,
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    onClick: ()=>updateQuantity(item.id, item.quantity - 1),
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).quantityButton,
                                                                    children: "-"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).quantity,
                                                                    children: item.quantity
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    onClick: ()=>updateQuantity(item.id, item.quantity + 1),
                                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).quantityButton,
                                                                    children: "+"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            onClick: ()=>removeItem(item.id),
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).removeButton,
                                                            children: "Remove"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.id)),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).subtotal,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: "Subtotal:"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    "$",
                                                    calculateSubtotal().toFixed(2)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleCheckout,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).checkoutForm,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).sectionHeader,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    children: "Customer Information"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "name",
                                        children: "Name *"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        id: "name",
                                        type: "text",
                                        name: "name",
                                        value: customerInfo.name,
                                        onChange: handleInputChange,
                                        required: true,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "email",
                                        children: "Email (optional)"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        id: "email",
                                        type: "email",
                                        name: "email",
                                        value: customerInfo.email,
                                        onChange: handleInputChange,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).formGroup,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "specialInstructions",
                                        children: "Special Instructions for Entire Order (optional)"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                        id: "specialInstructions",
                                        name: "specialInstructions",
                                        value: customerInfo.specialInstructions,
                                        onChange: handleInputChange,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).textarea
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "submit",
                                disabled: cart.length === 0 || !customerInfo.name || submitting,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a625f307b4b2607$exports))).primaryButton,
                                children: submitting ? 'Processing...' : 'Proceed to Payment'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");

var $42e487d2a1927298$exports = {};

(function(global, factory) {
    factory($42e487d2a1927298$exports, (parcelRequire("7fPBF")));
})($42e487d2a1927298$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "3.6.0"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "3.6.0",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded$1 = [
        "on",
        "session"
    ];
    var CheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CheckoutSdkContext.displayName = 'CheckoutSdkContext';
    var parseCheckoutSdkContext = function parseCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CheckoutProvider> provider."));
        return ctx;
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    var extractCheckoutContextValue = function extractCheckoutContextValue(checkoutSdk, sessionState) {
        if (!checkoutSdk) return null;
        checkoutSdk.on;
        checkoutSdk.session;
        var actions = _objectWithoutProperties(checkoutSdk, _excluded$1);
        if (!sessionState) return Object.assign(checkoutSdk.session(), actions);
        return Object.assign(sessionState, actions);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CheckoutProvider = function CheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                checkoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, checkoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.checkoutSdk) return ctx;
                return {
                    stripe: stripe,
                    checkoutSdk: checkoutSdk
                };
            });
        }; // Ref used to avoid calling initCheckout multiple times when options changes
        var initCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCheckoutCalledRef.current = true;
                    stripe.initCheckout(options).then(function(checkoutSdk) {
                        if (checkoutSdk) {
                            safeSetContext(stripe, checkoutSdk);
                            checkoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCheckoutCalledRef.current) {
                initCheckoutCalledRef.current = true;
                parsed.stripe.initCheckout(options).then(function(checkoutSdk) {
                    if (checkoutSdk) {
                        safeSetContext(parsed.stripe, checkoutSdk);
                        checkoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.checkoutSdk) return;
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.checkoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.checkoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var checkoutContextValue = React.useMemo(function() {
            return extractCheckoutContextValue(ctx.checkoutSdk, session);
        }, [
            ctx.checkoutSdk,
            session
        ]);
        if (!ctx.checkoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CheckoutContext.Provider, {
            value: checkoutContextValue
        }, children));
    };
    CheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            fetchClientSecret: PropTypes.func.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCheckoutSdkContextWithUseCase = function useCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CheckoutSdkContext);
        return parseCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCheckoutSdkContextWithUseCase = function useElementsOrCheckoutSdkContextWithUseCase(useCaseString) {
        var checkoutSdkContext = React.useContext(CheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (checkoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
        if (checkoutSdkContext) return parseCheckoutSdkContext(checkoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCheckout = function useCheckout() {
        // ensure it's in CheckoutProvider
        useCheckoutSdkContextWithUseCase('calls useCheckout()');
        var ctx = React.useContext(CheckoutContext);
        if (!ctx) throw new Error('Could not find Checkout Context; You need to wrap the part of your app that calls useCheckout() in an <CheckoutProvider> provider.');
        return ctx;
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutSdk = 'checkoutSdk' in ctx ? ctx.checkoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) switch(type){
                        case 'payment':
                            newElement = checkoutSdk.createPaymentElement(options);
                            break;
                        case 'address':
                            if ('mode' in options) {
                                var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                                else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                                else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                            } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                            break;
                        case 'expressCheckout':
                            newElement = checkoutSdk.createExpressCheckoutElement(options);
                            break;
                        case 'currencySelector':
                            newElement = checkoutSdk.createCurrencySelectorElement();
                            break;
                        default:
                            throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                    }
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CheckoutProvider = CheckoutProvider;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCheckout = useCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});


var $d9bed5b8db1491ea$var$RELEASE_TRAIN = 'basil';
var $d9bed5b8db1491ea$var$runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var $d9bed5b8db1491ea$var$ORIGIN = 'https://js.stripe.com';
var $d9bed5b8db1491ea$var$STRIPE_JS_URL = "".concat($d9bed5b8db1491ea$var$ORIGIN, "/").concat($d9bed5b8db1491ea$var$RELEASE_TRAIN, "/stripe.js");
var $d9bed5b8db1491ea$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $d9bed5b8db1491ea$var$STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var $d9bed5b8db1491ea$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $d9bed5b8db1491ea$var$isStripeJSURL = function isStripeJSURL(url) {
    return $d9bed5b8db1491ea$var$V3_URL_REGEX.test(url) || $d9bed5b8db1491ea$var$STRIPE_JS_URL_REGEX.test(url);
};
var $d9bed5b8db1491ea$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($d9bed5b8db1491ea$var$ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$d9bed5b8db1491ea$var$isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var $d9bed5b8db1491ea$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($d9bed5b8db1491ea$var$STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $d9bed5b8db1491ea$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "7.0.0",
        startTime: startTime
    });
};
var $d9bed5b8db1491ea$var$stripePromise$1 = null;
var $d9bed5b8db1491ea$var$onErrorListener = null;
var $d9bed5b8db1491ea$var$onLoadListener = null;
var $d9bed5b8db1491ea$var$onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var $d9bed5b8db1491ea$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $d9bed5b8db1491ea$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($d9bed5b8db1491ea$var$stripePromise$1 !== null) return $d9bed5b8db1491ea$var$stripePromise$1;
    $d9bed5b8db1491ea$var$stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($d9bed5b8db1491ea$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $d9bed5b8db1491ea$var$findScript();
            if (script && params) console.warn($d9bed5b8db1491ea$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $d9bed5b8db1491ea$var$injectScript(params);
            else if (script && $d9bed5b8db1491ea$var$onLoadListener !== null && $d9bed5b8db1491ea$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $d9bed5b8db1491ea$var$onLoadListener);
                script.removeEventListener('error', $d9bed5b8db1491ea$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $d9bed5b8db1491ea$var$injectScript(params);
            }
            $d9bed5b8db1491ea$var$onLoadListener = $d9bed5b8db1491ea$var$onLoad(resolve, reject);
            $d9bed5b8db1491ea$var$onErrorListener = $d9bed5b8db1491ea$var$onError(reject);
            script.addEventListener('load', $d9bed5b8db1491ea$var$onLoadListener);
            script.addEventListener('error', $d9bed5b8db1491ea$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $d9bed5b8db1491ea$var$stripePromise$1["catch"](function(error) {
        $d9bed5b8db1491ea$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var $d9bed5b8db1491ea$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = $d9bed5b8db1491ea$var$runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = $d9bed5b8db1491ea$var$RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("7.0.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    $d9bed5b8db1491ea$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $d9bed5b8db1491ea$var$stripePromise;
var $d9bed5b8db1491ea$var$loadCalled = false;
var $d9bed5b8db1491ea$var$getStripePromise = function getStripePromise() {
    if ($d9bed5b8db1491ea$var$stripePromise) return $d9bed5b8db1491ea$var$stripePromise;
    $d9bed5b8db1491ea$var$stripePromise = $d9bed5b8db1491ea$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $d9bed5b8db1491ea$var$stripePromise = null;
        return Promise.reject(error);
    });
    return $d9bed5b8db1491ea$var$stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $d9bed5b8db1491ea$var$getStripePromise();
})["catch"](function(error) {
    if (!$d9bed5b8db1491ea$var$loadCalled) console.warn(error);
});
var $d9bed5b8db1491ea$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $d9bed5b8db1491ea$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $d9bed5b8db1491ea$var$getStripePromise().then(function(maybeStripe) {
        return $d9bed5b8db1491ea$var$initStripe(maybeStripe, args, startTime);
    });
};




var $6d860e32ad69c596$exports = {};

$parcel$export($6d860e32ad69c596$exports, "cardElementContainer", function () { return $6d860e32ad69c596$export$32acf5097804d011; }, function (v) { return $6d860e32ad69c596$export$32acf5097804d011 = v; });
$parcel$export($6d860e32ad69c596$exports, "cardLabel", function () { return $6d860e32ad69c596$export$ea13bfdfd2a19a02; }, function (v) { return $6d860e32ad69c596$export$ea13bfdfd2a19a02 = v; });
$parcel$export($6d860e32ad69c596$exports, "checkoutForm", function () { return $6d860e32ad69c596$export$fa28842d74ff969e; }, function (v) { return $6d860e32ad69c596$export$fa28842d74ff969e = v; });
$parcel$export($6d860e32ad69c596$exports, "checkoutHeader", function () { return $6d860e32ad69c596$export$1dda85f6800efcca; }, function (v) { return $6d860e32ad69c596$export$1dda85f6800efcca = v; });
$parcel$export($6d860e32ad69c596$exports, "errorContainer", function () { return $6d860e32ad69c596$export$9d33ba969f9b84f1; }, function (v) { return $6d860e32ad69c596$export$9d33ba969f9b84f1 = v; });
$parcel$export($6d860e32ad69c596$exports, "errorMessage", function () { return $6d860e32ad69c596$export$493b5823483d2c4e; }, function (v) { return $6d860e32ad69c596$export$493b5823483d2c4e = v; });
$parcel$export($6d860e32ad69c596$exports, "formGroup", function () { return $6d860e32ad69c596$export$d2297815c52203ee; }, function (v) { return $6d860e32ad69c596$export$d2297815c52203ee = v; });
$parcel$export($6d860e32ad69c596$exports, "itemDetails", function () { return $6d860e32ad69c596$export$cc0b09c3267aae84; }, function (v) { return $6d860e32ad69c596$export$cc0b09c3267aae84 = v; });
$parcel$export($6d860e32ad69c596$exports, "itemName", function () { return $6d860e32ad69c596$export$65720846c1412ab5; }, function (v) { return $6d860e32ad69c596$export$65720846c1412ab5 = v; });
$parcel$export($6d860e32ad69c596$exports, "itemPrice", function () { return $6d860e32ad69c596$export$d467ea200e9afb9d; }, function (v) { return $6d860e32ad69c596$export$d467ea200e9afb9d = v; });
$parcel$export($6d860e32ad69c596$exports, "itemQuantity", function () { return $6d860e32ad69c596$export$189cf77755084f31; }, function (v) { return $6d860e32ad69c596$export$189cf77755084f31 = v; });
$parcel$export($6d860e32ad69c596$exports, "itemsList", function () { return $6d860e32ad69c596$export$4404fe00b6941209; }, function (v) { return $6d860e32ad69c596$export$4404fe00b6941209 = v; });
$parcel$export($6d860e32ad69c596$exports, "loadingContainer", function () { return $6d860e32ad69c596$export$7acf0aff43f729a5; }, function (v) { return $6d860e32ad69c596$export$7acf0aff43f729a5 = v; });
$parcel$export($6d860e32ad69c596$exports, "loadingSpinner", function () { return $6d860e32ad69c596$export$deaa9e6d912ce6c6; }, function (v) { return $6d860e32ad69c596$export$deaa9e6d912ce6c6 = v; });
$parcel$export($6d860e32ad69c596$exports, "orderItem", function () { return $6d860e32ad69c596$export$20ac01fe5d166671; }, function (v) { return $6d860e32ad69c596$export$20ac01fe5d166671 = v; });
$parcel$export($6d860e32ad69c596$exports, "orderItems", function () { return $6d860e32ad69c596$export$4ee1a71f58c398dc; }, function (v) { return $6d860e32ad69c596$export$4ee1a71f58c398dc = v; });
$parcel$export($6d860e32ad69c596$exports, "orderSummaryCard", function () { return $6d860e32ad69c596$export$fef32cf7052280f8; }, function (v) { return $6d860e32ad69c596$export$fef32cf7052280f8 = v; });
$parcel$export($6d860e32ad69c596$exports, "orderTotal", function () { return $6d860e32ad69c596$export$c3c2dc880887c924; }, function (v) { return $6d860e32ad69c596$export$c3c2dc880887c924 = v; });
$parcel$export($6d860e32ad69c596$exports, "payButton", function () { return $6d860e32ad69c596$export$40e5bb4e8d1653e2; }, function (v) { return $6d860e32ad69c596$export$40e5bb4e8d1653e2 = v; });
$parcel$export($6d860e32ad69c596$exports, "paymentSection", function () { return $6d860e32ad69c596$export$8ae897fe1c0279f0; }, function (v) { return $6d860e32ad69c596$export$8ae897fe1c0279f0 = v; });
$parcel$export($6d860e32ad69c596$exports, "restaurantInfo", function () { return $6d860e32ad69c596$export$2a4ad556c615c924; }, function (v) { return $6d860e32ad69c596$export$2a4ad556c615c924 = v; });
$parcel$export($6d860e32ad69c596$exports, "returnButton", function () { return $6d860e32ad69c596$export$9c018f28cf8b4ba8; }, function (v) { return $6d860e32ad69c596$export$9c018f28cf8b4ba8 = v; });
$parcel$export($6d860e32ad69c596$exports, "spin", function () { return $6d860e32ad69c596$export$c82e186cf428d56d; }, function (v) { return $6d860e32ad69c596$export$c82e186cf428d56d = v; });
$parcel$export($6d860e32ad69c596$exports, "spinner", function () { return $6d860e32ad69c596$export$641374ffb95bc399; }, function (v) { return $6d860e32ad69c596$export$641374ffb95bc399 = v; });
$parcel$export($6d860e32ad69c596$exports, "successMessage", function () { return $6d860e32ad69c596$export$9aa03815f960d3f0; }, function (v) { return $6d860e32ad69c596$export$9aa03815f960d3f0 = v; });
var $6d860e32ad69c596$export$32acf5097804d011;
var $6d860e32ad69c596$export$ea13bfdfd2a19a02;
var $6d860e32ad69c596$export$fa28842d74ff969e;
var $6d860e32ad69c596$export$1dda85f6800efcca;
var $6d860e32ad69c596$export$9d33ba969f9b84f1;
var $6d860e32ad69c596$export$493b5823483d2c4e;
var $6d860e32ad69c596$export$d2297815c52203ee;
var $6d860e32ad69c596$export$cc0b09c3267aae84;
var $6d860e32ad69c596$export$65720846c1412ab5;
var $6d860e32ad69c596$export$d467ea200e9afb9d;
var $6d860e32ad69c596$export$189cf77755084f31;
var $6d860e32ad69c596$export$4404fe00b6941209;
var $6d860e32ad69c596$export$7acf0aff43f729a5;
var $6d860e32ad69c596$export$deaa9e6d912ce6c6;
var $6d860e32ad69c596$export$20ac01fe5d166671;
var $6d860e32ad69c596$export$4ee1a71f58c398dc;
var $6d860e32ad69c596$export$fef32cf7052280f8;
var $6d860e32ad69c596$export$c3c2dc880887c924;
var $6d860e32ad69c596$export$40e5bb4e8d1653e2;
var $6d860e32ad69c596$export$8ae897fe1c0279f0;
var $6d860e32ad69c596$export$2a4ad556c615c924;
var $6d860e32ad69c596$export$9c018f28cf8b4ba8;
var $6d860e32ad69c596$export$c82e186cf428d56d;
var $6d860e32ad69c596$export$641374ffb95bc399;
var $6d860e32ad69c596$export$9aa03815f960d3f0;
$6d860e32ad69c596$export$32acf5097804d011 = `O7dXIq_cardElementContainer`;
$6d860e32ad69c596$export$ea13bfdfd2a19a02 = `O7dXIq_cardLabel`;
$6d860e32ad69c596$export$fa28842d74ff969e = `O7dXIq_checkoutForm`;
$6d860e32ad69c596$export$1dda85f6800efcca = `O7dXIq_checkoutHeader`;
$6d860e32ad69c596$export$9d33ba969f9b84f1 = `O7dXIq_errorContainer`;
$6d860e32ad69c596$export$493b5823483d2c4e = `O7dXIq_errorMessage`;
$6d860e32ad69c596$export$d2297815c52203ee = `O7dXIq_formGroup`;
$6d860e32ad69c596$export$cc0b09c3267aae84 = `O7dXIq_itemDetails`;
$6d860e32ad69c596$export$65720846c1412ab5 = `O7dXIq_itemName`;
$6d860e32ad69c596$export$d467ea200e9afb9d = `O7dXIq_itemPrice`;
$6d860e32ad69c596$export$189cf77755084f31 = `O7dXIq_itemQuantity`;
$6d860e32ad69c596$export$4404fe00b6941209 = `O7dXIq_itemsList`;
$6d860e32ad69c596$export$7acf0aff43f729a5 = `O7dXIq_loadingContainer`;
$6d860e32ad69c596$export$deaa9e6d912ce6c6 = `O7dXIq_loadingSpinner`;
$6d860e32ad69c596$export$20ac01fe5d166671 = `O7dXIq_orderItem`;
$6d860e32ad69c596$export$4ee1a71f58c398dc = `O7dXIq_orderItems`;
$6d860e32ad69c596$export$fef32cf7052280f8 = `O7dXIq_orderSummaryCard`;
$6d860e32ad69c596$export$c3c2dc880887c924 = `O7dXIq_orderTotal`;
$6d860e32ad69c596$export$40e5bb4e8d1653e2 = `O7dXIq_payButton`;
$6d860e32ad69c596$export$8ae897fe1c0279f0 = `O7dXIq_paymentSection`;
$6d860e32ad69c596$export$2a4ad556c615c924 = `O7dXIq_restaurantInfo`;
$6d860e32ad69c596$export$9c018f28cf8b4ba8 = `O7dXIq_returnButton`;
$6d860e32ad69c596$export$c82e186cf428d56d = `O7dXIq_spin`;
$6d860e32ad69c596$export$c82e186cf428d56d;
$6d860e32ad69c596$export$641374ffb95bc399 = `O7dXIq_spinner`;
$6d860e32ad69c596$export$9aa03815f960d3f0 = `O7dXIq_successMessage`;




// CheckoutForm component
const $8c1642a4f6fdcc11$var$CheckoutForm = ({ orderId: orderId, totalAmount: totalAmount, restaurantId: restaurantId, onSuccess: onSuccess, stripeAccount: stripeAccount })=>{
    const stripe = (0, $42e487d2a1927298$exports.useStripe)();
    const elements = (0, $42e487d2a1927298$exports.useElements)();
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [succeeded, setSucceeded] = (0, $7fPBF.useState)(false);
    const [tipAmount, setTipAmount] = (0, $7fPBF.useState)(0);
    const [customTipMode, setCustomTipMode] = (0, $7fPBF.useState)(false);
    // Calculate total with tip
    const totalWithTip = parseFloat(totalAmount) + parseFloat(tipAmount || 0);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!stripe || !elements) return;
        setLoading(true);
        setError(null);
        try {
            // Create a payment intent on the server
            const response = await fetch('/create-payment-intent', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    amount: totalAmount,
                    orderId: orderId,
                    tipAmount: tipAmount
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Payment failed');
            }
            const data = await response.json();
            console.log("Payment intent created, clientSecret received:", data.clientSecret);
            console.log("stripeAccount for direct charges:", data.stripeAccount);
            // For Direct Charges: confirmCardPayment WITHOUT stripeAccount parameter
            // because we initialized Stripe with the connected account
            const result = await stripe.confirmCardPayment(data.clientSecret, {
                payment_method: {
                    card: elements.getElement((0, $42e487d2a1927298$exports.CardElement))
                }
            });
            console.log("Payment confirmation result:", result);
            if (result.error) {
                console.error("Payment error:", result.error);
                throw new Error(result.error.message);
            }
            if (result.paymentIntent.status === 'succeeded') {
                console.log('Payment succeeded!');
                await fetch('/api/confirm-payment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orderId: orderId,
                        tipAmount: tipAmount
                    })
                });
                setSucceeded(true);
                setLoading(false);
                onSuccess(tipAmount);
            }
        } catch (err) {
            console.error('Payment confirmation error:', err);
            setError(err.message);
            setLoading(false);
        }
    };
    const cardElementOptions = {
        style: {
            base: {
                fontSize: '16px',
                color: '#424770',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#9e2146'
            }
        }
    };
    const handleTipSelection = (percentage)=>{
        setCustomTipMode(false);
        const tipValue = percentage / 100 * totalAmount;
        setTipAmount(parseFloat(tipValue.toFixed(2)));
    };
    const handleCustomTipChange = (e)=>{
        const value = e.target.value;
        if (value === '' || !isNaN(value) && parseFloat(value) >= 0) setTipAmount(value === '' ? 0 : parseFloat(value));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).checkoutForm,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).sectionTitle,
                children: "Payment Information"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipSection,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        children: "Add a tip"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipOptions,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipButton} ${tipAmount === parseFloat((totalAmount * 0.15).toFixed(2)) ? (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).selected : ''}`,
                                onClick: ()=>handleTipSelection(15),
                                children: [
                                    "15% ($",
                                    (totalAmount * 0.15).toFixed(2),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipButton} ${tipAmount === parseFloat((totalAmount * 0.18).toFixed(2)) ? (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).selected : ''}`,
                                onClick: ()=>handleTipSelection(18),
                                children: [
                                    "18% ($",
                                    (totalAmount * 0.18).toFixed(2),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipButton} ${tipAmount === parseFloat((totalAmount * 0.20).toFixed(2)) ? (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).selected : ''}`,
                                onClick: ()=>handleTipSelection(20),
                                children: [
                                    "20% ($",
                                    (totalAmount * 0.20).toFixed(2),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipButton} ${customTipMode ? (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).selected : ''}`,
                                onClick: ()=>setCustomTipMode(true),
                                children: "Custom"
                            })
                        ]
                    }),
                    customTipMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).customTipInput,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            children: [
                                "Custom tip amount:",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).currencyInput,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: "$"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            type: "number",
                                            min: "0",
                                            step: "0.01",
                                            value: tipAmount,
                                            onChange: handleCustomTipChange,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tipAmountInput
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).cardElementContainer,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e487d2a1927298$exports.CardElement), {
                    options: cardElementOptions
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).orderSummary,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).summaryRow,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Subtotal:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    "$",
                                    totalAmount.toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).summaryRow,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Tip:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    "$",
                                    parseFloat(tipAmount).toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).summaryRow} ${(0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).totalRow}`,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Total:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    "$",
                                    totalWithTip.toFixed(2)
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).errorMessage,
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "submit",
                disabled: !stripe || loading || succeeded,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).payButton,
                children: loading ? 'Processing...' : `Pay $${totalWithTip.toFixed(2)}`
            }),
            succeeded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).successMessage,
                children: "Payment successful! Redirecting to confirmation page..."
            })
        ]
    });
};
// Main CheckoutPage component
const $8c1642a4f6fdcc11$var$CheckoutPage = ()=>{
    const { orderId: orderId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [order, setOrder] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [stripeAccount, setStripeAccount] = (0, $7fPBF.useState)(null);
    const [stripePromise, setStripePromise] = (0, $7fPBF.useState)(null);
    const urlTableParam = new URLSearchParams(location.search).get('table');
    const tableNumber = urlTableParam || null;
    (0, $7fPBF.useEffect)(()=>{
        const fetchOrder = async ()=>{
            try {
                const response = await fetch('/api/get-order', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orderId: orderId
                    })
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to load order details');
                }
                const orderData = await response.json();
                setOrder(orderData);
                // Get the restaurant's Stripe account
                const { data: userProfile } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).from('user_profiles').select('stripe_connect_id').eq('user_id', orderData.restaurants.user_id).single();
                if (userProfile?.stripe_connect_id) {
                    setStripeAccount(userProfile.stripe_connect_id);
                    // Initialize Stripe with the connected account for direct charges
                    const stripe = (0, $d9bed5b8db1491ea$export$de80f7562c3fd6b1)("pk_test_51Qnw0bLRgAnTrbIfqD46euOjpLVgEpSAmMYgvjMHIo2aGGRV3xAZzBimbh6XyRkDZPfq90eZFhQPE5Qgw035iEZf002IXFyUj3", {
                        stripeAccount: userProfile.stripe_connect_id
                    });
                    setStripePromise(stripe);
                }
            } catch (err) {
                console.error('Error fetching order:', err);
                setError(err.message);
            } finally{
                setLoading(false);
            }
        };
        fetchOrder();
    }, [
        orderId
    ]);
    const handlePaymentSuccess = (tipAmount)=>{
        setTimeout(()=>{
            navigate(`/payment-success/${orderId}`);
        }, 1500);
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).loadingContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).loadingSpinner
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Loading payment details..."
            })
        ]
    });
    if (error || !order || !stripePromise) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).errorContainer,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: "Error Loading Checkout"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: error || 'Order not found or payment system unavailable'
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: ()=>navigate('/'),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).returnButton,
                children: "Return to Home"
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).checkoutPage,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).checkoutHeader,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    children: "Complete Your Order"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).orderSummaryCard,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Order Summary"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).restaurantInfo,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: order.restaurants?.name || 'Restaurant'
                            }),
                            tableNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).tableNumber,
                                children: [
                                    "Table ",
                                    tableNumber
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).orderItems,
                        children: order.order_items.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).orderItem,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).itemInfo,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).itemQuantity,
                                                children: [
                                                    item.quantity,
                                                    "x"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).itemName,
                                                children: item.menu_item_name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).itemPrice,
                                        children: [
                                            "$",
                                            (item.price * item.quantity).toFixed(2)
                                        ]
                                    })
                                ]
                            }, item.id))
                    }),
                    order.special_instructions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).specialInstructions,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                children: "Special Instructions:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: order.special_instructions
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6d860e32ad69c596$exports))).paymentContainer,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e487d2a1927298$exports.Elements), {
                    stripe: stripePromise,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8c1642a4f6fdcc11$var$CheckoutForm, {
                        orderId: orderId,
                        totalAmount: order.total_amount,
                        restaurantId: order.restaurant_id,
                        onSuccess: handlePaymentSuccess,
                        stripeAccount: stripeAccount
                    })
                })
            })
        ]
    });
};
var $8c1642a4f6fdcc11$export$2e2bcd8739ae039 = $8c1642a4f6fdcc11$var$CheckoutPage;




var $7fPBF = parcelRequire("7fPBF");

var $24839970ccb405cd$exports = {};

$parcel$export($24839970ccb405cd$exports, "actions", function () { return $24839970ccb405cd$export$e324594224ef24da; }, function (v) { return $24839970ccb405cd$export$e324594224ef24da = v; });
$parcel$export($24839970ccb405cd$exports, "button", function () { return $24839970ccb405cd$export$2ba01fb71ed41cb6; }, function (v) { return $24839970ccb405cd$export$2ba01fb71ed41cb6 = v; });
$parcel$export($24839970ccb405cd$exports, "card", function () { return $24839970ccb405cd$export$aa3e815946b80764; }, function (v) { return $24839970ccb405cd$export$aa3e815946b80764 = v; });
$parcel$export($24839970ccb405cd$exports, "checkmark", function () { return $24839970ccb405cd$export$292abbf31ed842a; }, function (v) { return $24839970ccb405cd$export$292abbf31ed842a = v; });
$parcel$export($24839970ccb405cd$exports, "checkmarkCircle", function () { return $24839970ccb405cd$export$a18791290b0860d8; }, function (v) { return $24839970ccb405cd$export$a18791290b0860d8 = v; });
$parcel$export($24839970ccb405cd$exports, "container", function () { return $24839970ccb405cd$export$34e0f9847d4c02dd; }, function (v) { return $24839970ccb405cd$export$34e0f9847d4c02dd = v; });
$parcel$export($24839970ccb405cd$exports, "message", function () { return $24839970ccb405cd$export$a8ecead220dd38a6; }, function (v) { return $24839970ccb405cd$export$a8ecead220dd38a6 = v; });
$parcel$export($24839970ccb405cd$exports, "orderDetails", function () { return $24839970ccb405cd$export$f4a3f69a19bda341; }, function (v) { return $24839970ccb405cd$export$f4a3f69a19bda341 = v; });
$parcel$export($24839970ccb405cd$exports, "scaleIn", function () { return $24839970ccb405cd$export$a387806435075175; }, function (v) { return $24839970ccb405cd$export$a387806435075175 = v; });
$parcel$export($24839970ccb405cd$exports, "title", function () { return $24839970ccb405cd$export$fb184b623420d9be; }, function (v) { return $24839970ccb405cd$export$fb184b623420d9be = v; });
var $24839970ccb405cd$export$e324594224ef24da;
var $24839970ccb405cd$export$2ba01fb71ed41cb6;
var $24839970ccb405cd$export$aa3e815946b80764;
var $24839970ccb405cd$export$292abbf31ed842a;
var $24839970ccb405cd$export$a18791290b0860d8;
var $24839970ccb405cd$export$34e0f9847d4c02dd;
var $24839970ccb405cd$export$a8ecead220dd38a6;
var $24839970ccb405cd$export$f4a3f69a19bda341;
var $24839970ccb405cd$export$a387806435075175;
var $24839970ccb405cd$export$fb184b623420d9be;
$24839970ccb405cd$export$e324594224ef24da = `OEz4kq_actions`;
$24839970ccb405cd$export$2ba01fb71ed41cb6 = `OEz4kq_button`;
$24839970ccb405cd$export$aa3e815946b80764 = `OEz4kq_card`;
$24839970ccb405cd$export$292abbf31ed842a = `OEz4kq_checkmark`;
$24839970ccb405cd$export$a18791290b0860d8 = `OEz4kq_checkmarkCircle`;
$24839970ccb405cd$export$34e0f9847d4c02dd = `OEz4kq_container`;
$24839970ccb405cd$export$a8ecead220dd38a6 = `OEz4kq_message`;
$24839970ccb405cd$export$f4a3f69a19bda341 = `OEz4kq_orderDetails`;
$24839970ccb405cd$export$a387806435075175 = `OEz4kq_scaleIn`;
$24839970ccb405cd$export$a387806435075175;
$24839970ccb405cd$export$fb184b623420d9be = `OEz4kq_title`;


const $2fb37a9be6209fdd$var$PaymentSuccessPage = ()=>{
    const { orderId: orderId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [order, setOrder] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        const fetchOrderDetails = async ()=>{
            try {
                const response = await fetch('/api/get-order', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orderId: orderId
                    })
                });
                if (response.ok) {
                    const data = await response.json();
                    setOrder(data);
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
            } finally{
                setLoading(false);
            }
        };
        if (orderId) fetchOrderDetails();
    }, [
        orderId
    ]);
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).container,
        children: "Loading order details..."
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).card,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).checkmarkCircle,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).checkmark,
                        children: "\u2713"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).title,
                    children: "Payment Successful"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).message,
                    children: "Thank you for your order! Your payment has been processed successfully."
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).orderDetails,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                            children: [
                                "Order #",
                                orderId.slice(-6)
                            ]
                        }),
                        order && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Subtotal:"
                                        }),
                                        " $",
                                        parseFloat(order.total_amount).toFixed(2)
                                    ]
                                }),
                                order.tip_amount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Tip:"
                                        }),
                                        " $",
                                        parseFloat(order.tip_amount).toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Total:"
                                        }),
                                        " $",
                                        (parseFloat(order.total_amount) + parseFloat(order.tip_amount || 0)).toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Order Status:"
                                        }),
                                        " ",
                                        order.status
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Order Time:"
                                        }),
                                        " ",
                                        new Date(order.created_at).toLocaleString()
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).actions,
                    children: order && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                        to: `/menu/${order.restaurant_id}`,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($24839970ccb405cd$exports))).button,
                        children: "Return to Menu"
                    })
                })
            ]
        })
    });
};
var $2fb37a9be6209fdd$export$2e2bcd8739ae039 = $2fb37a9be6209fdd$var$PaymentSuccessPage;




var $7fPBF = parcelRequire("7fPBF");



const $c2ed85289fcfd631$var$PasswordReset = ()=>{
    const [email, setEmail] = (0, $7fPBF.useState)('');
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [message, setMessage] = (0, $7fPBF.useState)('');
    const [error, setError] = (0, $7fPBF.useState)('');
    const handlePasswordReset = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const { data: data, error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.resetPasswordForEmail(email, {
                redirectTo: `https://qrbutlernew.onrender.com/reset-password-confirm`
            });
            if (error) throw error;
            setMessage('Check your email for the password reset link');
        } catch (error) {
            setError(error.message || 'An error occurred while sending the password reset link');
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: $3e72fbf05f9c11e7$export$8e5abf1bd3c2f426,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: $3e72fbf05f9c11e7$export$935b30ea6eeec3be,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: $3e72fbf05f9c11e7$export$a3b7721557df7601,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            children: "Reset Your Password"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Enter your email to receive a password reset link"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    onSubmit: handlePasswordReset,
                    className: $3e72fbf05f9c11e7$export$714e9b412011a758,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: $3e72fbf05f9c11e7$export$d2297815c52203ee,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "email",
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true,
                                    placeholder: "your@email.com"
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $3e72fbf05f9c11e7$export$d6f5363164931430,
                            children: error
                        }),
                        message && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $3e72fbf05f9c11e7$export$132a926ccc3d5388,
                            children: message
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            className: $3e72fbf05f9c11e7$export$2dfc706f5cf3324e,
                            disabled: loading,
                            children: loading ? 'Sending...' : 'Send Reset Link'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $3e72fbf05f9c11e7$export$7b13c61120c28603,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: "Back to Login"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c2ed85289fcfd631$export$2e2bcd8739ae039 = $c2ed85289fcfd631$var$PasswordReset;




var $7fPBF = parcelRequire("7fPBF");




const $8d061cc391d6cd1f$var$ResetPasswordConfirm = ()=>{
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const [confirmPassword, setConfirmPassword] = (0, $7fPBF.useState)('');
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [message, setMessage] = (0, $7fPBF.useState)('');
    const [error, setError] = (0, $7fPBF.useState)('');
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        // Handle the auth callback
        const handleAuthCallback = async ()=>{
            try {
                // Check if we have the required URL parameters
                const accessToken = searchParams.get('access_token');
                const refreshToken = searchParams.get('refresh_token');
                const type = searchParams.get('type');
                if (type === 'recovery' && accessToken && refreshToken) {
                    // Set the session with the tokens from the URL
                    const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.setSession({
                        access_token: accessToken,
                        refresh_token: refreshToken
                    });
                    if (error) {
                        console.error('Error setting session:', error);
                        setError('Invalid or expired reset link');
                        return;
                    }
                    console.log('Session set successfully for password reset');
                } else {
                    // If no proper parameters, check if we already have a session
                    const { data: { session: session } } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.getSession();
                    if (!session) {
                        setError('Invalid or expired reset link');
                        setTimeout(()=>navigate('/login'), 3000);
                    }
                }
            } catch (error) {
                console.error('Error in auth callback:', error);
                setError('Something went wrong. Please try again.');
            }
        };
        handleAuthCallback();
    }, [
        searchParams,
        navigate
    ]);
    const handlePasswordUpdate = async (e)=>{
        e.preventDefault();
        if (password !== confirmPassword) return setError("Passwords don't match");
        if (password.length < 6) return setError("Password should be at least 6 characters");
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const { error: error } = await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.updateUser({
                password: password
            });
            if (error) throw error;
            setMessage('Password updated successfully! Redirecting to login...');
            // Sign out and redirect to login
            setTimeout(async ()=>{
                await (0, $ca7b91da655d9662$export$a0b632a28672d3c0).auth.signOut();
                navigate('/login');
            }, 2000);
        } catch (error) {
            console.error('Password update error:', error);
            setError(error.message || 'Failed to update password');
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: $3e72fbf05f9c11e7$export$8e5abf1bd3c2f426,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: $3e72fbf05f9c11e7$export$935b30ea6eeec3be,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: $3e72fbf05f9c11e7$export$a3b7721557df7601,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            children: "Set New Password"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Enter your new password below"
                        })
                    ]
                }),
                error && !password ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: $3e72fbf05f9c11e7$export$d6f5363164931430,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: error
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            onClick: ()=>navigate('/password-reset'),
                            className: $3e72fbf05f9c11e7$export$2dfc706f5cf3324e,
                            children: "Request New Reset Link"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    onSubmit: handlePasswordUpdate,
                    className: $3e72fbf05f9c11e7$export$714e9b412011a758,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: $3e72fbf05f9c11e7$export$d2297815c52203ee,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: "New Password"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "password",
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    required: true,
                                    placeholder: "New password",
                                    minLength: 6
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: $3e72fbf05f9c11e7$export$d2297815c52203ee,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "confirmPassword",
                                    children: "Confirm New Password"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "confirmPassword",
                                    type: "password",
                                    value: confirmPassword,
                                    onChange: (e)=>setConfirmPassword(e.target.value),
                                    required: true,
                                    placeholder: "Confirm new password",
                                    minLength: 6
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $3e72fbf05f9c11e7$export$d6f5363164931430,
                            children: error
                        }),
                        message && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $3e72fbf05f9c11e7$export$132a926ccc3d5388,
                            children: message
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            className: $3e72fbf05f9c11e7$export$2dfc706f5cf3324e,
                            disabled: loading,
                            children: loading ? 'Updating...' : 'Update Password'
                        })
                    ]
                })
            ]
        })
    });
};
var $8d061cc391d6cd1f$export$2e2bcd8739ae039 = $8d061cc391d6cd1f$var$ResetPasswordConfirm;


// src/components/ProtectedRoute.jsx

parcelRequire("7fPBF");


function $537cd1bfe5554ff2$export$2e2bcd8739ae039({ children: children }) {
    const { user: user, loading: loading } = (0, $fa441f73aa1797a9$export$1d39dc5b47e56ff0)();
    // Show loading state while auth is being checked
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: "Loading..."
    });
    // Redirect to login if not authenticated
    if (!user) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/login"
    });
    return children;
}



parcelRequire("7fPBF");


var $1a9fd3c4ce614d03$export$8d6d009d1f06226e;
var $1a9fd3c4ce614d03$export$ff6e116295a0f641;
var $1a9fd3c4ce614d03$export$34e0f9847d4c02dd;
var $1a9fd3c4ce614d03$export$a7db06668cad9adb;
var $1a9fd3c4ce614d03$export$adb608be33961c98;
var $1a9fd3c4ce614d03$export$38e42c68cf43b5d4;
var $1a9fd3c4ce614d03$export$c60d1a715a48771d;
var $1a9fd3c4ce614d03$export$fe2e36411d703b3d;
$1a9fd3c4ce614d03$export$8d6d009d1f06226e = `l-htCW_backButton`;
$1a9fd3c4ce614d03$export$ff6e116295a0f641 = `l-htCW_contactInfo`;
$1a9fd3c4ce614d03$export$34e0f9847d4c02dd = `l-htCW_container`;
$1a9fd3c4ce614d03$export$a7db06668cad9adb = `l-htCW_content`;
$1a9fd3c4ce614d03$export$adb608be33961c98 = `l-htCW_footer`;
$1a9fd3c4ce614d03$export$38e42c68cf43b5d4 = `l-htCW_header`;
$1a9fd3c4ce614d03$export$c60d1a715a48771d = `l-htCW_lastUpdated`;
$1a9fd3c4ce614d03$export$fe2e36411d703b3d = `l-htCW_section`;


const $fb96436a784744e1$var$TermsOfService = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: $1a9fd3c4ce614d03$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: $1a9fd3c4ce614d03$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a939115c3410dd$export$2e2bcd8739ae039), {
                    linkTo: "/"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: $1a9fd3c4ce614d03$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: $1a9fd3c4ce614d03$export$c60d1a715a48771d,
                        children: [
                            "Last updated: ",
                            new Date().toLocaleDateString()
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "1. Acceptance of Terms"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: 'By accessing and using QR Butler ("Service", "Platform"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "2. Description of Service"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "QR Butler is a digital ordering platform that enables restaurants to create digital menus accessible via QR codes, process customer orders, and manage payments. Our service includes:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "QR code menu generation and management"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Digital menu creation and customization"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Order processing and payment collection"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Restaurant dashboard and analytics"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Customer ordering interface"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "3. User Accounts and Registration"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "3.1 Restaurant Accounts"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "To use our service as a restaurant, you must register for an account and provide accurate, complete information. You are responsible for safeguarding your account credentials and for all activities under your account."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "3.2 Stripe Connect Integration"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Restaurant accounts must connect to Stripe to process payments. You agree to comply with Stripe's terms of service and acknowledge that payment processing is subject to Stripe's policies and procedures."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "3.3 Customer Use"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Customers may place orders without creating an account. By placing an order, customers agree to these terms and provide accurate information for order fulfillment."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "4. Fees and Payment"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "4.1 Platform Fees"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "QR Butler charges a 6% platform fee on each completed transaction. This fee is automatically deducted from the payment before transfer to the restaurant's connected Stripe account."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "4.2 Payment Processing"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "All payments are processed through Stripe. Payment processing fees charged by Stripe are separate from our platform fee. Refunds and chargebacks are handled according to Stripe's policies."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "4.3 Fee Changes"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "We reserve the right to modify our fee structure with 30 days written notice to registered restaurant users."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "5. Restaurant Responsibilities"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "As a restaurant using our platform, you agree to:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Provide accurate menu information, pricing, and availability"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Fulfill orders in a timely manner according to your stated preparation times"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Maintain food safety and quality standards"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Comply with all applicable local, state, and federal regulations"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Handle customer service issues professionally"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Update menu items and availability as needed"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "6. Customer Responsibilities"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "As a customer using our platform, you agree to:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Provide accurate contact and payment information"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Be available to receive your order at the designated location"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Comply with restaurant policies and local laws"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Not abuse or misuse the ordering system"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "7. Prohibited Uses"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "You may not use our service:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "For any unlawful purpose or to solicit others to perform unlawful acts"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "To infringe upon or violate our intellectual property rights or the intellectual property rights of others"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "To submit false or misleading information"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "To upload or transmit viruses or any other type of malicious code"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "8. Intellectual Property Rights"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "The service and its original content, features, and functionality are and will remain the exclusive property of QR Butler and its licensors. The service is protected by copyright, trademark, and other laws."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "9. Privacy Policy"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use our service. By using our service, you agree to the collection and use of information in accordance with our Privacy Policy."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "10. Service Availability"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "We strive to maintain high service availability but cannot guarantee uninterrupted service. We reserve the right to:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Modify or discontinue the service with reasonable notice"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Refuse service to anyone for any reason at any time"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: "Suspend accounts that violate these terms"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "11. Limitation of Liability"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "QR Butler shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "12. Indemnification"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "You agree to defend, indemnify, and hold harmless QR Butler from and against any claims, damages, obligations, losses, liabilities, costs, and expenses (including but not limited to attorney's fees) arising from your use of the service or violation of these terms."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "13. Termination"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the service will cease immediately."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "14. Governing Law"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "These Terms shall be interpreted and governed by the laws of [Your State/Province], without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "15. Changes to Terms"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: $1a9fd3c4ce614d03$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "16. Contact Information"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "If you have any questions about these Terms of Service, please contact us at:"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: $1a9fd3c4ce614d03$export$ff6e116295a0f641,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                children: "Email:"
                                            }),
                                            " support@qrbutler.com"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                children: "Address:"
                                            }),
                                            " [Your Business Address]"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $1a9fd3c4ce614d03$export$adb608be33961c98,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: $1a9fd3c4ce614d03$export$8d6d009d1f06226e,
                            children: "\u2190 Back to Home"
                        })
                    })
                ]
            })
        ]
    });
};
var $fb96436a784744e1$export$2e2bcd8739ae039 = $fb96436a784744e1$var$TermsOfService;



function $7203b2e3a16473fb$var$App() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa441f73aa1797a9$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44bf71e6667174d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                        className: "main-content",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11bf3e2e75c24a58$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/login",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3d38facbb4779e40$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/signup",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27921cfa64cacaa7$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/dashboard",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8db6b399d1a9b013$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/restaurant/new",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afd6521b42f78544$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/restaurant/:restaurantId/menu",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4341799d4cdbebad$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/restaurant/:restaurantId/orders",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bef01aa08265719$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/restaurant/:restaurantId/qr",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7eab70ac025bc537$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/restaurant/:restaurantId/analytics",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28f3d16ba8adf793$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/refresh/:connectedAccountId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42de0d503777469a$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/return/:connectedAccountId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cd1bfe5554ff2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ccf711b7896eefe$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/password-reset",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2ed85289fcfd631$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/reset-password-confirm",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d061cc391d6cd1f$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/terms",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb96436a784744e1$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/menu/:restaurantId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29396d0e80697ab9$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/cart/:restaurantId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98bf67c3eb3c7952$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/checkout/:orderId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c1642a4f6fdcc11$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "/payment-success/:orderId",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fb37a9be6209fdd$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        style: {
                                            padding: "20px",
                                            textAlign: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                                children: "404 - Page Not Found"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "The page you're looking for doesn't exist."
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                onClick: ()=>window.location.href = "/",
                                                children: "Return to Home"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d17877a8c203f8b6$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
var $7203b2e3a16473fb$export$2e2bcd8739ae039 = $7203b2e3a16473fb$var$App;


document.body.classList.remove('dark-theme');
document.documentElement.classList.add('light-theme');
const $4a5191623062d5ff$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)(document.getElementById("root"));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7203b2e3a16473fb$export$2e2bcd8739ae039), {})); // Remove the call to initializeSchema


//# sourceMappingURL=public.81f0cfa9.js.map
